import React, { memo, forwardRef, useRef, useImperativeHandle, useEffect, createContext, useContext, useMemo, useCallback, useState, createElement } from 'react';
import { PROPS_TYPES as PROPS_TYPES$1, getStore, useSelector, changeLayer, renameLayers, createLayers, copyLayers, useOperate, isEqualKey, getSelectedNode, clearSelectedStatus, selectComponent, nodeScrollIntoView, ROOT, copyComponent, deleteComponent, usePrevious as usePrevious$1, isContainer, getComponentConfig, onLayoutSortChange, onDragBrickTree, deleteLayers, undo, redo, useZoom, setDragSource, getBrickdConfig, changeProps, changeSeniorProps, getSelector, getIframe, initPageBrickdState, ZoomProvider, BrickProvider, BrickDesignCanvas } from '@brickd/canvas';
import { BrickStore, useResize, Direction, useDragMove, useForceRender } from '@brickd/hooks';
import { map, isEqual, each, get, keys, isEmpty, isArray, merge } from 'lodash';
import Collapse, { Panel } from 'rc-collapse';
import SortableJS from 'sortablejs';
import Tabs, { TabPane } from 'rc-tabs';
import Form, { Field } from 'rc-field-form';
import AceEditor from 'react-ace';
import Json5 from 'json5';
import Switch from 'rc-switch';

function styleInject(css, ref) {
  if (ref === void 0) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') {
    return;
  }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css_248z = ".index_container__2xNNA {\n  position: fixed;\n  top: 10px;\n  right: 20px;\n  display: flex;\n}\n.index_container__2xNNA .index_icon__ugqrV {\n  width: 35px;\n  height: 35px;\n  border-radius: 35px;\n  overflow: hidden;\n  border-width: 1px;\n  border-style: solid;\n  margin-left: 5px;\n  box-shadow: -2px 4px 5px 3px rgba(0, 0, 0, 0.15);\n}\n";
var styles = {"container":"index_container__2xNNA","icon":"index_icon__ugqrV"};
styleInject(css_248z);

var css_248z$1 = ".index_avatar-icon__3ba1g {\n  width: 100%;\n  height: 100%;\n}\n";
var styles$1 = {"avatar-icon":"index_avatar-icon__3ba1g"};
styleInject(css_248z$1);

function Avatar(props) {
    const { icon, iconClass, ...rest } = props;
    return (React.createElement("div", Object.assign({}, rest),
        React.createElement("img", { src: icon, className: `${styles$1['avatar-icon']} ${iconClass}`, alt: '' })));
}
var Avatar$1 = memo(Avatar);

const colors = ['#FF7F50', '#6495ED', '#DC143C', '#9932CC'];
function Users(props) {
    const { users, ...rest } = props;
    return (React.createElement("div", Object.assign({ className: styles['container'] }, rest), map(users, (user, index) => {
        const { id, img } = user;
        return (React.createElement(Avatar$1, { style: { borderColor: colors[index] }, className: styles['icon'], icon: img, key: id }));
    })));
}
var Users$1 = memo(Users);

var css_248z$2 = ".index_rotate180__1k2t_ {\n  transform: rotate(180deg);\n}\n.index_rotate90__2re2S {\n  transform: rotate(90deg);\n}\n.index_icon-container__2ko0L {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 40px;\n  height: 39px;\n  cursor: pointer;\n}\n.index_icon-container__2ko0L .index_icon-class__33IA5 {\n  width: 14px;\n  height: 14px;\n  user-select: none;\n}\n.index_icon-Menu__3CuKY {\n  width: 45px;\n  height: 35px;\n  border-radius: 8px;\n  background-color: #ffffff;\n  margin-right: 5px;\n  box-shadow: 3px 4px 5px 3px rgba(0, 0, 0, 0.15);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  cursor: pointer;\n}\n.index_icon-Menu__3CuKY .index_icon-class__33IA5 {\n  width: 20px;\n  height: 20px;\n}\n.index_tabs-container__Mvn29 .rc-tabs-tab {\n  font-size: 12px;\n  font-weight: bold;\n  color: #aaa;\n}\n.index_tabs-container__Mvn29 .rc-tabs-tab-active {\n  color: #333;\n}\n.index_tabs-container__Mvn29 .rc-tabs-ink-bar {\n  background-color: #333333;\n  height: 2px !important;\n}\n.index_tabs-container__Mvn29 .rc-tabs-nav-operations {\n  display: none !important;\n}\n.index_tabs-container__Mvn29 .rc-tabs-nav-measure-ping-top::before,\n.index_tabs-container__Mvn29 .rc-tabs-nav-wrap-ping-top::before,\n.index_tabs-container__Mvn29 .rc-tabs-nav-measure-ping-bottom::after,\n.index_tabs-container__Mvn29 .rc-tabs-nav-wrap-ping-bottom::after {\n  border: 0 !important;\n}\n.index_tabs-container__Mvn29 .rc-tabs-nav-operations {\n  display: none !important;\n}\n.index_common-input__3hX9R {\n  padding: 0;\n  border: none;\n  text-align: left;\n  outline: none;\n  white-space: normal;\n  word-wrap: break-word;\n  word-break: break-all;\n  resize: none;\n  width: 100%;\n  color: rgba(0, 0, 0, 0.8);\n  font-family: PingFangSC-Medium, PingFang SC;\n}\n.index_common-input__3hX9R::placeholder {\n  font-weight: 400;\n  font-family: PingFangSC-Regular, PingFang SC;\n  color: rgba(0, 0, 0, 0.3);\n}\n.index_top-left-bar__2onqM {\n  position: fixed;\n  display: flex;\n  top: 10px;\n  left: 20px;\n  z-index: 0;\n}\n";
var styles$2 = {"rotate180":"index_rotate180__1k2t_","rotate90":"index_rotate90__2re2S","icon-container":"index_icon-container__2ko0L","icon-class":"index_icon-class__33IA5","icon-Menu":"index_icon-Menu__3CuKY","tabs-container":"index_tabs-container__Mvn29","common-input":"index_common-input__3hX9R","top-left-bar":"index_top-left-bar__2onqM"};
styleInject(css_248z$2);

var css_248z$3 = ".index_rotate180__3RTpf {\n  transform: rotate(180deg);\n}\n.index_rotate90__23nct {\n  transform: rotate(90deg);\n  pointer-events: none;\n  transition: none;\n  cursor: auto;\n}\n.index_icon-container__3GUXn {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 40px;\n  height: 39px;\n  cursor: pointer;\n}\n.index_icon-container__3GUXn .index_icon-class__1tCrN {\n  width: 14px;\n  height: 14px;\n  user-select: none;\n}\n.index_icon-Menu__1zoCg {\n  width: 45px;\n  height: 35px;\n  border-radius: 8px;\n  background-color: #ffffff;\n  margin-right: 5px;\n  box-shadow: 3px 4px 5px 3px rgba(0, 0, 0, 0.15);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  cursor: pointer;\n}\n.index_icon-Menu__1zoCg .index_icon-class__1tCrN {\n  width: 20px;\n  height: 20px;\n}\n.index_tabs-container__2xZPK .rc-tabs-tab {\n  font-size: 12px;\n  font-weight: bold;\n  color: #aaa;\n}\n.index_tabs-container__2xZPK .rc-tabs-tab-active {\n  color: #333;\n}\n.index_tabs-container__2xZPK .rc-tabs-ink-bar {\n  background-color: #333333;\n  height: 2px !important;\n}\n.index_tabs-container__2xZPK .rc-tabs-nav-operations {\n  display: none !important;\n}\n.index_tabs-container__2xZPK .rc-tabs-nav-measure-ping-top::before,\n.index_tabs-container__2xZPK .rc-tabs-nav-wrap-ping-top::before,\n.index_tabs-container__2xZPK .rc-tabs-nav-measure-ping-bottom::after,\n.index_tabs-container__2xZPK .rc-tabs-nav-wrap-ping-bottom::after {\n  border: 0 !important;\n}\n.index_tabs-container__2xZPK .rc-tabs-nav-operations {\n  display: none !important;\n}\n.index_tabs-container__2xZPK .rc-tabs-nav-measure-ping-left::before,\n.index_tabs-container__2xZPK .rc-tabs-nav-wrap-ping-left::before {\n  border-left-width: 0px;\n}\n.index_common-input__deM29 {\n  padding: 0;\n  border: none;\n  text-align: left;\n  outline: none;\n  white-space: normal;\n  word-wrap: break-word;\n  word-break: break-all;\n  resize: none;\n  width: 100%;\n  color: rgba(0, 0, 0, 0.8);\n  font-family: PingFangSC-Medium, PingFang SC;\n}\n.index_common-input__deM29::placeholder {\n  font-weight: 400;\n  font-family: PingFangSC-Regular, PingFang SC;\n  color: rgba(0, 0, 0, 0.3);\n}\n.index_container__3Wsc7 {\n  display: flex;\n  flex-direction: column;\n  top: 70px;\n  left: 235px;\n  width: 212px;\n  max-height: calc(100vh - 150px);\n  border-radius: 8px;\n}\n.index_page-container__32VGY {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  border-top: 1px solid #f2f2f2;\n  border-bottom: 1px solid #f2f2f2;\n}\n.index_page-container__32VGY .index_page-content__17dvs {\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n  overflow: auto;\n  background-color: #f7f7f7;\n}\n.index_page-container__32VGY .index_layer-item__t_Nm6 {\n  display: flex;\n  align-items: center;\n  min-height: 30px;\n  padding-left: 16px;\n  padding-right: 8px;\n}\n.index_page-container__32VGY .index_layer-item__t_Nm6 .index_right-icon__Y1c5t {\n  width: 8px;\n  height: 8px;\n  margin-right: 8px;\n}\n.index_page-container__32VGY .index_layer-item__t_Nm6 .index_layer-text__2eXvU {\n  display: flex;\n  flex: 1;\n  align-items: center;\n  height: 100%;\n  color: #333;\n  font-size: 12px;\n}\n.index_page-container__32VGY .index_layer-item__t_Nm6 .index_hover-icon__1ALxT {\n  display: none;\n}\n.index_page-container__32VGY .index_layer-item__t_Nm6 .index_icon-size__1H_8H {\n  width: 10px;\n  height: 10px;\n}\n.index_page-container__32VGY .index_layer-item__t_Nm6:hover {\n  background-color: #dedee4;\n}\n.index_page-container__32VGY .index_layer-item__t_Nm6:hover .index_hover-icon__1ALxT {\n  display: flex;\n  width: 20px;\n  height: 20px;\n}\n.index_header-container__3sgp9 {\n  display: flex;\n  height: 40px;\n  align-items: center;\n  justify-content: space-between;\n  background-color: #f7f7f7;\n  font-size: 12px;\n  padding-left: 18px;\n  padding-right: 5px;\n  user-select: none;\n}\n.index_header-container__3sgp9 .index_header-name__2mnty {\n  font-weight: bold;\n}\n.index_header-container__3sgp9 .index_header-right__29IAF {\n  display: flex;\n  align-items: center;\n}\n.index_header-container__3sgp9 .index_header-right__29IAF .index_add-icon__2HpRb {\n  width: 24px;\n  height: 24px;\n  cursor: pointer;\n  border-radius: 3px;\n  user-select: none;\n}\n.index_header-container__3sgp9 .index_header-right__29IAF .index_add-icon__2HpRb:hover {\n  background-color: #dedee4;\n}\n";
var styles$3 = {"rotate180":"index_rotate180__3RTpf","rotate90":"index_rotate90__23nct","icon-container":"index_icon-container__3GUXn","icon-class":"index_icon-class__1tCrN","icon-Menu":"index_icon-Menu__1zoCg","tabs-container":"index_tabs-container__2xZPK","common-input":"index_common-input__deM29","container":"index_container__3Wsc7","page-container":"index_page-container__32VGY","page-content":"index_page-content__17dvs","layer-item":"index_layer-item__t_Nm6","right-icon":"index_right-icon__Y1c5t","layer-text":"index_layer-text__2eXvU","hover-icon":"index_hover-icon__1ALxT","icon-size":"index_icon-size__1H_8H","header-container":"index_header-container__3sgp9","header-name":"index_header-name__2mnty","header-right":"index_header-right__29IAF","add-icon":"index_add-icon__2HpRb"};
styleInject(css_248z$3);

var css_248z$4 = ".index_container__CSjn1 {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n";
var styles$4 = {"container":"index_container__CSjn1"};
styleInject(css_248z$4);

function Icon(props, ref) {
    const { icon, iconClass, className, ...rest } = props;
    const divRef = useRef();
    useImperativeHandle(ref, () => divRef.current, []);
    return (React.createElement("div", Object.assign({ ref: divRef, className: `${styles$4['container']} ${className}` }, rest),
        React.createElement("img", { draggable: false, className: iconClass, src: icon })));
}
var Icon$1 = memo(forwardRef(Icon));

const img = "data:image/svg+xml,%3csvg class='svg' width='6' height='6' viewBox='0 0 6 6' xmlns='http://www.w3.org/2000/svg'%3e%3cpath d='M3 5l3-4H0l3 4z' fill-rule='nonzero' fill-opacity='1' fill='black' stroke='none'%3e%3c/path%3e%3c/svg%3e";

const img$1 = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' class='sc-gKckTs hSDKox svg-icon icon close isLeft' viewBox='0 0 14 14' aria-hidden='true'%3e%3cpath d='M1 1l12 12m0-12L1 13' stroke='%23333' fill='none' fill-rule='evenodd' stroke-linecap='round'%3e%3c/path%3e%3c/svg%3e";

const img$2 = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' class='sc-gKckTs hSDKox svg-icon icon mode' viewBox='0 0 13 13' aria-hidden='true'%3e%3cg transform='translate(0 .5)' fill='%23333' fill-rule='evenodd'%3e%3crect width='2' height='2' rx='1'%3e%3c/rect%3e%3crect y='5' width='2' height='2' rx='1'%3e%3c/rect%3e%3crect y='10' width='2' height='2' rx='1'%3e%3c/rect%3e%3cpath d='M13 1a.5.5 0 01-.5.5h-8a.5.5 0 010-1h8a.5.5 0 01.5.5zM13 6a.5.5 0 01-.5.5h-8a.5.5 0 010-1h8a.5.5 0 01.5.5zM13 11a.5.5 0 01-.5.5h-8a.5.5 0 110-1h8a.5.5 0 01.5.5z' fill-rule='nonzero'%3e%3c/path%3e%3c/g%3e%3c/svg%3e";

const img$3 = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' class='sc-gKckTs hSDKox svg-icon icon mode' viewBox='0 0 12 12' aria-hidden='true'%3e%3cg stroke='%23333' fill='none' fill-rule='evenodd'%3e%3crect x='.5' y='.5' width='4.5' height='4.5' rx='1'%3e%3c/rect%3e%3crect x='7' y='.5' width='4.5' height='4.5' rx='1'%3e%3c/rect%3e%3crect x='7' y='7' width='4.5' height='4.5' rx='1'%3e%3c/rect%3e%3crect x='.5' y='7' width='4.5' height='4.5' rx='1'%3e%3c/rect%3e%3c/g%3e%3c/svg%3e";

const img$4 = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' class='sc-gKckTs hSDKox svg-icon icon search' viewBox='0 0 13 13' aria-hidden='true'%3e%3cg stroke='%23666' stroke-width='1.1' fill='none' fill-rule='evenodd'%3e%3ccircle cx='5.5' cy='5.5' r='4.95'%3e%3c/circle%3e%3cpath stroke-linecap='round' d='M10.248 10.099l1.65 1.65'%3e%3c/path%3e%3c/g%3e%3c/svg%3e";

const img$5 = "data:image/svg+xml,%3c%3fxml version='1.0' standalone='no'%3f%3e%3c!DOCTYPE svg PUBLIC '-//W3C//DTD SVG 1.1//EN' 'http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd'%3e%3csvg t='1623581238550' class='icon' viewBox='0 0 1024 1024' version='1.1' xmlns='http://www.w3.org/2000/svg' p-id='3266' width='16' height='16' xmlns:xlink='http://www.w3.org/1999/xlink'%3e%3cdefs%3e%3cstyle type='text/css'%3e%3c/style%3e%3c/defs%3e%3cpath d='M834 128H602c-33.137 0-60 26.863-60 60v110c0 33.137 26.863 60 60 60h232c33.137 0 60-26.863 60-60V188c0-33.137-26.863-60-60-60z m0 170H602V188h232v110zM422 128H190c-33.137 0-60 26.863-60 60v644c0 33.137 26.863 60 60 60h232c33.137 0 60-26.863 60-60V188c0-33.137-26.863-60-60-60z m0 704H190V188h232v644zM834 418H602c-33.137 0-60 26.863-60 60v354c0 33.137 26.863 60 60 60h232c33.137 0 60-26.863 60-60V478c0-33.137-26.863-60-60-60z m0 414H602V478h232v354z' p-id='3267'%3e%3c/path%3e%3c/svg%3e";

const img$6 = "data:image/svg+xml,%3csvg width='11' height='10' xmlns='http://www.w3.org/2000/svg'%3e%3cpath d='M5.75 0a.5.5 0 01.5.5v4h4a.5.5 0 110 1h-4v4a.5.5 0 01-1 0V5.499l-4 .001a.5.5 0 010-1l4-.001V.5a.5.5 0 01.5-.5z' fill='%23333' fill-rule='nonzero'%3e%3c/path%3e%3c/svg%3e";

const img$7 = "data:image/svg+xml,%3csvg class='svg' width='8' height='8' viewBox='0 0 8 8' xmlns='http://www.w3.org/2000/svg'%3e%3cpath d='M1.176 2.824L3.06 4.706 6.824.941 8 2.118 3.059 7.059 0 4l1.176-1.176z' fill-rule='evenodd' fill-opacity='1' fill='black' stroke='none'%3e%3c/path%3e%3c/svg%3e";

const img$8 = "data:image/svg+xml,%3c%3fxml version='1.0' standalone='no'%3f%3e%3c!DOCTYPE svg PUBLIC '-//W3C//DTD SVG 1.1//EN' 'http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd'%3e%3csvg t='1624114192964' class='icon' viewBox='0 0 1024 1024' version='1.1' xmlns='http://www.w3.org/2000/svg' p-id='5609' width='12' height='12' xmlns:xlink='http://www.w3.org/1999/xlink'%3e%3cdefs%3e%3cstyle type='text/css'%3e%3c/style%3e%3c/defs%3e%3cpath d='M804.864 731.136V73.728c0-40.448-32.768-73.216-73.216-73.216H74.24C34.304 0.512 1.536 33.28 1.536 73.728v657.408c0 40.448 32.768 73.216 73.216 73.216H732.16c39.936-0.512 72.704-33.28 72.704-73.216z m-145.92 0H147.456c-40.448 0-73.216-32.768-73.216-73.216V146.432c0-40.448 32.768-73.216 73.216-73.216h511.488c40.448 0 73.216 32.768 73.216 73.216v511.488c-0.512 40.448-33.28 73.216-73.216 73.216z m291.84-511.488h-73.216v73.216c40.448 0 73.216 32.768 73.216 73.216v511.488c0 40.448-32.768 73.216-73.216 73.216H366.592c-40.448 0-73.216-32.768-73.216-73.216H220.672v73.216c0 40.448 32.768 73.216 73.216 73.216h657.408c40.448 0 73.216-32.768 73.216-73.216V292.864c-0.512-40.448-33.28-73.216-73.728-73.216z' fill='' p-id='5610'%3e%3c/path%3e%3c/svg%3e";

const img$9 = "data:image/svg+xml,%3c%3fxml version='1.0' standalone='no'%3f%3e%3c!DOCTYPE svg PUBLIC '-//W3C//DTD SVG 1.1//EN' 'http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd'%3e%3csvg t='1624113139736' class='icon' viewBox='0 0 1024 1024' version='1.1' xmlns='http://www.w3.org/2000/svg' p-id='4018' width='12' height='12' xmlns:xlink='http://www.w3.org/1999/xlink'%3e%3cdefs%3e%3cstyle type='text/css'%3e%3c/style%3e%3c/defs%3e%3cpath d='M799.232 874.432a62.464 62.464 0 0 1-62.4 62.4h-449.6a62.464 62.464 0 0 1-62.4-62.4v-662.4h574.4v662.4z m-449.6-774.4c0-7.232 5.568-12.8 12.8-12.8H662.4c7.232 0 12.8 5.568 12.8 12.8V137.6H349.632v-37.568z m636.8 37.568h-236.8v-37.568c0-48-39.232-87.232-87.232-87.232H362.432c-48 0-87.232 39.232-87.232 87.232V137.6H37.632a37.568 37.568 0 1 0 0 75.2h112v661.632a137.6 137.6 0 0 0 137.6 137.6h449.6a137.6 137.6 0 0 0 137.6-137.6v-662.4h112A37.568 37.568 0 0 0 1024 174.4a36.864 36.864 0 0 0-37.568-36.8zM512 824a37.568 37.568 0 0 0 37.632-37.568v-400a37.568 37.568 0 1 0-75.2 0v400C474.432 807.232 491.2 824 512 824z m-175.168 0a37.568 37.568 0 0 0 37.568-37.568v-400a37.568 37.568 0 1 0-75.2 0v400A38.592 38.592 0 0 0 336.832 824z m350.4 0a37.568 37.568 0 0 0 37.568-37.568v-400a37.568 37.568 0 1 0-75.2 0v400c0 20.8 16.832 37.568 37.632 37.568z' fill='black' p-id='4019'%3e%3c/path%3e%3c/svg%3e";

const img$a = "data:image/svg+xml,%3c%3fxml version='1.0' standalone='no'%3f%3e%3c!DOCTYPE svg PUBLIC '-//W3C//DTD SVG 1.1//EN' 'http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd'%3e%3csvg t='1624116057017' class='icon' viewBox='0 0 1024 1024' version='1.1' xmlns='http://www.w3.org/2000/svg' p-id='6473' width='32' height='32' xmlns:xlink='http://www.w3.org/1999/xlink'%3e%3cdefs%3e%3cstyle type='text/css'%3e%3c/style%3e%3c/defs%3e%3cpath d='M0 512a512 512 0 1 0 1024 0A512 512 0 0 0 0 512z' fill='%23FAAF46' p-id='6474'%3e%3c/path%3e%3cpath d='M512 853.312c-51.2 0-85.312-34.112-85.312-85.312 0-51.2 34.112-85.312 85.312-85.312 51.2 0 85.312 34.112 85.312 85.312 0 51.2-34.112 85.312-85.312 85.312z m0-256C460.8 597.312 426.688 563.2 426.688 512V256c0-51.2 34.112-85.312 85.312-85.312 51.2 0 85.312 34.112 85.312 85.312v256c0 51.2-34.112 85.312-85.312 85.312z' fill='white' p-id='6475'%3e%3c/path%3e%3c/svg%3e";

const img$b = "data:image/svg+xml,%3csvg class='svg' width='16' height='16' viewBox='0 0 16 16' xmlns='http://www.w3.org/2000/svg'%3e%3cpath d='M8 10c1.105 0 2-.895 2-2 0-1.105-.895-2-2-2-1.104 0-2 .895-2 2 0 1.105.896 2 2 2z' fill-rule='nonzero' fill-opacity='1' fill='black' stroke='none'%3e%3c/path%3e%3cpath d='M8 4c2.878 0 5.378 1.621 6.635 4-1.257 2.379-3.757 4-6.635 4-2.878 0-5.377-1.621-6.635-4C2.623 5.621 5.122 4 8 4zm0 7c-2.3 0-4.322-1.194-5.478-3C3.678 6.194 5.7 5 8 5c2.3 0 4.322 1.194 5.479 3C12.322 9.806 10.3 11 8 11z' fill-rule='evenodd' fill-opacity='1' fill='black' stroke='none'%3e%3c/path%3e%3c/svg%3e";

const img$c = "data:image/svg+xml,%3c%3fxml version='1.0' standalone='no'%3f%3e%3c!DOCTYPE svg PUBLIC '-//W3C//DTD SVG 1.1//EN' 'http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd'%3e%3csvg t='1624204055244' class='icon' viewBox='0 0 1024 1024' version='1.1' xmlns='http://www.w3.org/2000/svg' p-id='3471' width='13' height='13' xmlns:xlink='http://www.w3.org/1999/xlink'%3e%3cdefs%3e%3cstyle type='text/css'%3e%3c/style%3e%3c/defs%3e%3cpath d='M278.016 523.008c0-41.6-33.44-75.008-75.008-75.008A74.816 74.816 0 0 0 128 523.008c0 41.6 33.44 75.008 75.008 75.008 41.6 0 75.008-33.44 75.008-75.008z m150.016 0c0 41.6 33.44 75.008 75.008 75.008 41.6 0 75.008-33.44 75.008-75.008 0-41.6-33.44-75.008-75.008-75.008a74.816 74.816 0 0 0-75.008 75.008z m300.032 0c0 41.6 33.44 75.008 75.008 75.008 41.6 0 75.008-33.44 75.008-75.008 0-41.6-33.44-75.008-75.008-75.008a75.104 75.104 0 0 0-75.008 75.008z' p-id='3472'%3e%3c/path%3e%3c/svg%3e";

const img$d = "data:image/svg+xml,%3c%3fxml version='1.0' standalone='no'%3f%3e%3c!DOCTYPE svg PUBLIC '-//W3C//DTD SVG 1.1//EN' 'http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd'%3e%3csvg t='1624619289355' class='icon' viewBox='0 0 1024 1024' version='1.1' xmlns='http://www.w3.org/2000/svg' p-id='2482' width='32' height='32' xmlns:xlink='http://www.w3.org/1999/xlink'%3e%3cdefs%3e%3cstyle type='text/css'%3e%3c/style%3e%3c/defs%3e%3cpath d='M138.24 311.04l363.52 197.546667a21.76 21.76 0 0 0 20.48 0l363.52-197.546667a18.773333 18.773333 0 0 0-2.133333-34.56L520.106667 128a21.333333 21.333333 0 0 0-16.213334 0L140.373333 276.48a18.773333 18.773333 0 0 0-2.133333 34.56z' p-id='2483' fill='black'%3e%3c/path%3e%3cpath d='M883.626667 454.826667l-78.08-33.28-283.306667 154.026666a21.76 21.76 0 0 1-20.48 0L218.453333 421.546667l-78.08 33.28a20.48 20.48 0 0 0 0 36.266666l363.52 209.066667a19.626667 19.626667 0 0 0 20.48 0l363.52-209.066667a20.48 20.48 0 0 0-4.266666-36.266666z' p-id='2484' fill='black'%3e%3c/path%3e%3cpath d='M883.626667 644.266667l-66.56-29.013334-294.826667 160.426667a21.76 21.76 0 0 1-20.48 0l-294.826667-160.426667-66.56 29.013334a20.906667 20.906667 0 0 0 0 37.12l363.52 213.333333a21.76 21.76 0 0 0 20.48 0l363.52-213.333333a20.906667 20.906667 0 0 0-4.266666-37.12z' p-id='2485' fill='black'%3e%3c/path%3e%3c/svg%3e";

const img$e = "data:image/svg+xml,%3c%3fxml version='1.0' standalone='no'%3f%3e%3c!DOCTYPE svg PUBLIC '-//W3C//DTD SVG 1.1//EN' 'http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd'%3e%3csvg t='1624626635802' class='icon' viewBox='0 0 1024 1024' version='1.1' xmlns='http://www.w3.org/2000/svg' p-id='4541' xmlns:xlink='http://www.w3.org/1999/xlink' width='32' height='32'%3e%3cdefs%3e%3cstyle type='text/css'%3e%3c/style%3e%3c/defs%3e%3cpath d='M512 62.1C263.9 62.1 62.1 263.9 62.1 512c0 248.1 201.8 449.9 449.9 449.9 248.1 0 449.9-201.8 449.9-449.9 0-248.1-201.8-449.9-449.9-449.9z m0 825.8c-207.3 0-375.9-168.6-375.9-375.9 0-207.3 168.6-375.9 375.9-375.9 207.3 0 375.9 168.6 375.9 375.9 0 207.3-168.6 375.9-375.9 375.9z' p-id='4542'%3e%3c/path%3e%3cpath d='M701.8 324.7c-14.4-14.4-37.9-14.4-52.3 0l-137 137-137-137c-14.4-14.4-37.9-14.4-52.3 0-14.4 14.4-14.4 37.9 0 52.3l137 137-137 137c-14.4 14.4-14.4 37.9 0 52.3 7.2 7.2 16.7 10.8 26.2 10.8s18.9-3.6 26.2-10.8l137-137 137 137c7.2 7.2 16.7 10.8 26.2 10.8s18.9-3.6 26.2-10.8c14.4-14.4 14.4-37.9 0-52.3L565 514l137-137c14.3-14.4 14.3-37.8-0.2-52.3z' p-id='4543'%3e%3c/path%3e%3c/svg%3e";

const img$f = "data:image/svg+xml,%3c%3fxml version='1.0' standalone='no'%3f%3e%3c!DOCTYPE svg PUBLIC '-//W3C//DTD SVG 1.1//EN' 'http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd'%3e%3csvg t='1624631799481' class='icon' viewBox='0 0 1024 1024' version='1.1' xmlns='http://www.w3.org/2000/svg' p-id='67119' width='16' height='16' xmlns:xlink='http://www.w3.org/1999/xlink'%3e%3cdefs%3e%3cstyle type='text/css'%3e%3c/style%3e%3c/defs%3e%3cpath d='M914.3 437.4c26.9 34.4 40.4 74.2 40.4 119.3 0 34.4-7.9 66.1-23.7 95-15.8 29-37.4 51.8-64.8 68.5-27.4 16.7-57.3 25-89.8 25H263.8c-36.2 0-69.6-9.6-100.3-28.7-30.6-19.2-55-44.9-73.1-77.3-18.1-32.4-27.2-67.8-27.2-106.1 0-46.2 12.5-87.4 37.6-123.7s57.1-61.9 96.1-76.6V321c0-42.2 10-81.5 29.9-117.9 20-36.3 47.1-65 81.5-86.2 34.4-21.1 71.7-31.7 112.1-31.7s77.8 10.8 112.1 32.4c34.4 21.6 61.3 50.1 80.8 85.4 22.3-15.7 46.9-23.6 73.8-23.6 37.1 0 68.7 13.8 94.7 41.2 26 27.5 39 60.9 39 100.2 0 17.7-2.8 34.9-8.4 51.6 41 9.1 74.9 30.7 101.9 65z m-282.8 39.8c-3.7-9.8-10.7-14.7-20.9-14.7h-90.5v-165c0-6.9-2.1-12.5-6.3-16.9-4.2-4.4-9.5-6.6-16-6.6h-66.9c-6.5 0-11.8 2.2-16 6.6-4.2 4.4-6.3 10.1-6.3 16.9v165h-90.5c-10.2 0-17.2 4.9-20.9 14.7-3.7 9.8-2.3 18.2 4.2 25L449 658.4c3.7 3.9 8.8 5.9 15.3 5.9s11.6-2 15.3-5.9l147.6-156.2c6.6-6.8 8-15.2 4.3-25z' p-id='67120'%3e%3c/path%3e%3c/svg%3e";

const img$g = "data:image/svg+xml,%3c%3fxml version='1.0' standalone='no'%3f%3e%3c!DOCTYPE svg PUBLIC '-//W3C//DTD SVG 1.1//EN' 'http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd'%3e%3csvg t='1624631885795' class='icon' viewBox='0 0 1024 1024' version='1.1' xmlns='http://www.w3.org/2000/svg' p-id='68659' xmlns:xlink='http://www.w3.org/1999/xlink' width='16' height='16'%3e%3cdefs%3e%3cstyle type='text/css'%3e%3c/style%3e%3c/defs%3e%3cpath d='M866.30182 474.87s-7.17-234-199.38-280.5S382.09182 348.7 380.18182 354.43s-11.34 3.12-11.34 3.12c-15.36-14.44-83.11-47.6-154.3-5.08s-45.36 123.27-45.36 123.27-105.43-8.49-159.5 152.94C-44.30818 790.26 145.11182 836 145.11182 836h318V664.16h-73.56v-0.29a6.48 6.48 0 0 1-3.66-11.9L516.20182 516.08a9.64 9.64 0 0 1 15 0.36l129.35 134.81a4.28 4.28 0 0 1 0.66 0.58l1.24 1.3h-0.44a6.81 6.81 0 0 1 1.1 3.56 7.42 7.42 0 0 1-7.46 7.4c-0.15 0-0.15-0.14-0.3-0.14v0.29H585.30182v171.88h288.6s137.62-34.18 149.76-175.12C1035.95182 520.14 866.30182 474.87 866.30182 474.87z' p-id='68660' fill='black'%3e%3c/path%3e%3c/svg%3e";

const img$h = "data:image/svg+xml,%3c%3fxml version='1.0' standalone='no'%3f%3e%3c!DOCTYPE svg PUBLIC '-//W3C//DTD SVG 1.1//EN' 'http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd'%3e%3csvg t='1624664604813' class='icon' viewBox='0 0 1024 1024' version='1.1' xmlns='http://www.w3.org/2000/svg' p-id='8674' xmlns:xlink='http://www.w3.org/1999/xlink' width='16' height='16'%3e%3cdefs%3e%3cstyle type='text/css'%3e%3c/style%3e%3c/defs%3e%3cpath d='M418.450286 480.768h-217.965715A53.979429 53.979429 0 0 1 146.285714 426.569143v-217.6a53.979429 53.979429 0 0 1 54.198857-54.052572h217.965715a53.979429 53.979429 0 0 1 54.198857 54.198858v217.563428a54.235429 54.235429 0 0 1-54.198857 54.089143z' fill='black' p-id='8675'%3e%3c/path%3e%3cpath d='M899.364571 356.571429l-153.965714 153.965714a54.857143 54.857143 0 0 1-77.165714 0l-153.6-153.965714a54.308571 54.308571 0 0 1 0-77.165715l153.6-153.6a54.308571 54.308571 0 0 1 77.165714 0l153.965714 153.6a54.528 54.528 0 0 1 0.365715 76.8v0.365715z' fill='black' p-id='8676'%3e%3c/path%3e%3cpath d='M418.450286 878.445714h-217.965715A54.235429 54.235429 0 0 1 146.285714 824.32v-218.038857a54.235429 54.235429 0 0 1 54.198857-54.198857h217.965715a54.235429 54.235429 0 0 1 54.198857 54.198857v218.038857a54.235429 54.235429 0 0 1-54.198857 54.125714z' fill='black' p-id='8677'%3e%3c/path%3e%3cpath d='M815.835429 878.445714h-217.6a54.308571 54.308571 0 0 1-54.564572-54.125714v-218.038857a54.454857 54.454857 0 0 1 54.198857-54.198857h217.965715a53.979429 53.979429 0 0 1 54.198857 54.198857v218.038857a54.235429 54.235429 0 0 1-54.198857 54.125714z' fill='black' p-id='8678'%3e%3c/path%3e%3c/svg%3e";

const img$i = "data:image/svg+xml,%3c%3fxml version='1.0' standalone='no'%3f%3e%3c!DOCTYPE svg PUBLIC '-//W3C//DTD SVG 1.1//EN' 'http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd'%3e%3csvg t='1624665003191' class='icon' viewBox='0 0 1024 1024' version='1.1' xmlns='http://www.w3.org/2000/svg' p-id='17267' xmlns:xlink='http://www.w3.org/1999/xlink' width='16' height='16'%3e%3cdefs%3e%3cstyle type='text/css'%3e%3c/style%3e%3c/defs%3e%3cpath d='M970.048 269.504l-458.048 269.44L53.888 269.504h916.16z m0 0H53.888L512 0zM53.888 431.168l377.28 215.552V1024L53.888 808.448z m916.224 0v377.28L592.832 1024v-377.28l377.216-215.552z' p-id='17268' fill='black'%3e%3c/path%3e%3c/svg%3e";

const img$j = "data:image/svg+xml,%3c%3fxml version='1.0' standalone='no'%3f%3e%3c!DOCTYPE svg PUBLIC '-//W3C//DTD SVG 1.1//EN' 'http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd'%3e%3csvg t='1624668212654' class='icon' viewBox='0 0 1024 1024' version='1.1' xmlns='http://www.w3.org/2000/svg' p-id='20168' xmlns:xlink='http://www.w3.org/1999/xlink' width='16' height='16'%3e%3cdefs%3e%3cstyle type='text/css'%3e%3c/style%3e%3c/defs%3e%3cpath d='M817.160653 547.502585c-7.897877 10.666944-17.22122 19.808138-27.236318 27.155477-23.044856 30.860868-55.980989 46.862307-85.193311 37.252439-40.36636-13.19144-58.056254-69.6585-39.551808-126.168538 5.801123-17.730826 14.696724-33.019021 25.120121-45.690622l68.296479-160.400177 0 0 28.1532-66.138326C702.105221 127.526465 570.499857 75.352175 391.930879 103.842043 0.249175 166.337399-120.567471 645.520993 133.605416 870.5317c237.84706 210.568786 362.612645 67.13605 452.772061-92.173283 10.19827-18.006096 34.361599-28.570709 54.962799-26.371624 65.568345 6.961552 199.881376-0.387833 246.417249-164.80858 13.027711-46.067198 15.97995-96.67276 9.100262-147.349953L817.160653 547.502585zM231.521492 341.331969c44.886303 0 81.263815 36.377512 81.263815 81.233116 0 44.87607-36.377512 81.253582-81.263815 81.253582-44.865837 0-81.263815-36.377512-81.263815-81.253582C150.257677 377.709481 186.654632 341.331969 231.521492 341.331969zM184.639742 713.206558c-44.845371 0-81.243349-36.377512-81.243349-81.222883 0-44.865837 36.357046-81.262792 81.243349-81.262792 44.886303 0 81.243349 36.377512 81.243349 81.262792C265.883091 676.829046 229.526045 713.206558 184.639742 713.206558zM344.01252 875.704512c-44.86686 0-81.244372-36.357046-81.244372-81.222883 0-44.877093 36.377512-81.254605 81.244372-81.254605 44.906769 0 81.262792 36.377512 81.262792 81.254605C425.275311 839.347466 388.919289 875.704512 344.01252 875.704512zM409.641239 363.216395c-44.86686 0-81.263815-36.367279-81.263815-81.253582 0-44.855604 36.396955-81.233116 81.263815-81.233116 44.865837 0 81.263815 36.377512 81.263815 81.233116C490.906078 326.849116 454.528566 363.216395 409.641239 363.216395z' p-id='20169' fill='black'%3e%3c/path%3e%3cpath d='M939.422208 62.690808c-52.601009 3.399423-92.052532 54.331419-92.052532 54.331419l0.448208 0.224104c-2.218528 2.168386-4.397147 4.477988-6.432503 6.921643-35.787064 42.667775-30.209022 106.251929 12.458753 142.03797 42.666752 35.787064 106.240673 30.229488 142.027737-12.44852 12.967336-15.440667 20.418029-33.680077 22.738887-52.336996l0.040932 0.020466c19.379373-91.65549-20.397562-153.529699-20.397562-153.529699S992.02424 59.291384 939.422208 62.690808z' p-id='20170' fill='black'%3e%3c/path%3e%3cpath d='M707.154213 575.859423c19.826558 11.541871 52.764738-1.912559 73.568553-30.02585l96.979752-131.004683c-45.171806-10.382465-85.660962-38.371936-111.717408-60.245106-2.402723-2.035356-4.702092-4.000104-6.880711-5.913687l-63.003939 148.043754C682.399413 528.877389 687.346075 564.340065 707.154213 575.859423z' p-id='20171' fill='black'%3e%3c/path%3e%3cpath d='M844.235288 277.646508c-16.000416-13.425777-27.400047-30.260188-34.198893-48.560996l-28.947286 68.012c25.567305 25.455765 81.650625 69.731154 132.724861 68.998467l52.887534-71.411423C927.209048 312.192302 879.471814 307.235406 844.235288 277.646508z' p-id='20172' fill='black'%3e%3c/path%3e%3c/svg%3e";

const img$k = "data:image/svg+xml,%3c%3fxml version='1.0' standalone='no'%3f%3e%3c!DOCTYPE svg PUBLIC '-//W3C//DTD SVG 1.1//EN' 'http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd'%3e%3csvg t='1624677499468' class='icon' viewBox='0 0 1024 1024' version='1.1' xmlns='http://www.w3.org/2000/svg' p-id='13723' xmlns:xlink='http://www.w3.org/1999/xlink' width='16' height='16'%3e%3cdefs%3e%3cstyle type='text/css'%3e%3c/style%3e%3c/defs%3e%3cpath d='M615.5 291.8V85.3L1024 451.5 615.5 817.7V596.3c-113.8 0-464.2 0-615.5 342.4v-38.1c0-152.2 151.3-641.2 615.5-608.8z' fill='black' p-id='13724'%3e%3c/path%3e%3c/svg%3e";

const img$l = "data:image/svg+xml,%3c%3fxml version='1.0' standalone='no'%3f%3e%3c!DOCTYPE svg PUBLIC '-//W3C//DTD SVG 1.1//EN' 'http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd'%3e%3csvg t='1624677462230' class='icon' viewBox='0 0 1228 1024' version='1.1' xmlns='http://www.w3.org/2000/svg' p-id='11575' xmlns:xlink='http://www.w3.org/1999/xlink' width='19.1875' height='16'%3e%3cdefs%3e%3cstyle type='text/css'%3e%3c/style%3e%3c/defs%3e%3cpath d='M477.851921 273.061752V0L0 477.876497l477.851921 477.851921V675.834593c341.333333 0 580.28387 109.239446 750.938249 348.165407-68.271582-341.333333-273.061752-682.666667-750.938249-750.938248z' p-id='11576' fill='black'%3e%3c/path%3e%3c/svg%3e";

const img$m = "data:image/svg+xml,%3c%3fxml version='1.0' standalone='no'%3f%3e%3c!DOCTYPE svg PUBLIC '-//W3C//DTD SVG 1.1//EN' 'http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd'%3e%3csvg t='1624679072414' class='icon' viewBox='0 0 1028 1024' version='1.1' xmlns='http://www.w3.org/2000/svg' p-id='14571' xmlns:xlink='http://www.w3.org/1999/xlink' width='16.0625' height='16'%3e%3cdefs%3e%3cstyle type='text/css'%3e%3c/style%3e%3c/defs%3e%3cpath d='M1005.380997 921.484532l-145.146866-145.083178a480.787055 480.787055 0 1 0-84.387714 84.196647l145.146867 145.146867a59.612754 59.612754 0 1 0 84.324025-84.260336zM95.140093 483.050556A387.610282 387.610282 0 1 1 482.750375 870.53346a387.992415 387.992415 0 0 1-387.610282-387.482904z m548.934114-45.601209H528.351584V321.726724a45.60121 45.60121 0 0 0-91.202419 0V437.449347H321.426542a45.60121 45.60121 0 0 0 0 91.202419h116.041067v115.722622a45.60121 45.60121 0 0 0 91.202419 0V528.651766h115.722623a45.60121 45.60121 0 0 0 0-91.202419z m0 0' fill='black' p-id='14572'%3e%3c/path%3e%3c/svg%3e";

const img$n = "data:image/svg+xml,%3c%3fxml version='1.0' standalone='no'%3f%3e%3c!DOCTYPE svg PUBLIC '-//W3C//DTD SVG 1.1//EN' 'http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd'%3e%3csvg t='1624679112900' class='icon' viewBox='0 0 1024 1024' version='1.1' xmlns='http://www.w3.org/2000/svg' p-id='15432' xmlns:xlink='http://www.w3.org/1999/xlink' width='16' height='16'%3e%3cdefs%3e%3cstyle type='text/css'%3e%3c/style%3e%3c/defs%3e%3cpath d='M928.4096 901.632l-120.5248-163.328a429.7728 429.7728 0 0 0 130.048-308.7872C937.984 192.3072 747.1104 0 511.6416 0c-235.52 0-426.3936 192.3072-426.3936 429.5168 0 237.1584 190.8736 429.4656 426.3936 429.4656 56.832 0 111.0528-11.2128 160.6656-31.5392l124.2112 168.3968c17.6128 23.9104 51.5584 29.184 75.8784 11.8272l43.9808-31.4368c24.2176-17.3056 29.6448-50.7392 12.032-74.5984z m-416.768-149.8112c-176.9472 0-320.4096-144.3328-320.4096-322.4064 0-178.0224 143.4624-322.4064 320.4096-322.4064 177.0496 0 320.512 144.3328 320.512 322.4064 0 178.0736-143.5136 322.4064-320.512 322.4064z' p-id='15433' fill='black'%3e%3c/path%3e%3cpath d='M742.4 435.2c0 30.6176-28.8256 55.4496-64.4096 55.4496H346.0096C310.4256 490.6496 281.6 465.8176 281.6 435.2s28.8256-55.4496 64.4096-55.4496h331.9808c35.584 0 64.4096 24.832 64.4096 55.4496z' p-id='15434' fill='black'%3e%3c/path%3e%3c/svg%3e";

const img$o = "data:image/svg+xml,%3c%3fxml version='1.0' standalone='no'%3f%3e%3c!DOCTYPE svg PUBLIC '-//W3C//DTD SVG 1.1//EN' 'http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd'%3e%3csvg t='1624679234140' class='icon' viewBox='0 0 1024 1024' version='1.1' xmlns='http://www.w3.org/2000/svg' p-id='23787' xmlns:xlink='http://www.w3.org/1999/xlink' width='16' height='16'%3e%3cdefs%3e%3cstyle type='text/css'%3e%3c/style%3e%3c/defs%3e%3cpath d='M591.104 164.437333l268.458667 268.458667A21.333333 21.333333 0 0 0 896 417.834667V170.666667a42.666667 42.666667 0 0 0-42.666667-42.666667h-247.168a21.333333 21.333333 0 0 0-15.061333 36.437333z' fill='black' p-id='23788'%3e%3c/path%3e%3cpath d='M274.048 695.722667l422.4-422.4a42.666667 42.666667 0 1 1 60.288 60.373333l-422.4 422.4a42.666667 42.666667 0 0 1-60.288-60.373333z' fill='black' p-id='23789'%3e%3c/path%3e%3cpath d='M591.104 859.562667l268.458667-268.458667a21.333333 21.333333 0 0 1 36.437333 15.061333V853.333333a42.666667 42.666667 0 0 1-42.666667 42.666667h-247.168a21.333333 21.333333 0 0 1-15.061333-36.437333zM432.896 164.437333l-268.458667 268.458667A21.333333 21.333333 0 0 1 128 417.834667V170.666667a42.666667 42.666667 0 0 1 42.666667-42.666667h247.168a21.333333 21.333333 0 0 1 15.061333 36.437333z' fill='black' p-id='23790'%3e%3c/path%3e%3cpath d='M432.896 859.562667l-268.458667-268.458667a21.333333 21.333333 0 0 0-36.437333 15.061333V853.333333a42.666667 42.666667 0 0 0 42.666667 42.666667h247.168a21.333333 21.333333 0 0 0 15.061333-36.437333z' fill='black' p-id='23791'%3e%3c/path%3e%3c/svg%3e";

const img$p = "data:image/svg+xml,%3c%3fxml version='1.0' standalone='no'%3f%3e%3c!DOCTYPE svg PUBLIC '-//W3C//DTD SVG 1.1//EN' 'http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd'%3e%3csvg t='1624683581642' class='icon' viewBox='0 0 1024 1024' version='1.1' xmlns='http://www.w3.org/2000/svg' p-id='25797' xmlns:xlink='http://www.w3.org/1999/xlink' width='16' height='16'%3e%3cdefs%3e%3cstyle type='text/css'%3e%3c/style%3e%3c/defs%3e%3cpath d='M227.555556 85.333333v321.649778C227.555556 433.550222 253.013333 455.111111 284.444444 455.111111h455.111112c31.431111 0 56.888889-21.560889 56.888888-48.128V85.333333a142.222222 142.222222 0 0 1 142.222223 142.222223v568.888888a142.222222 142.222222 0 0 1-142.222223 142.222223H227.555556a142.222222 142.222222 0 0 1-142.222223-142.222223V227.555556a142.222222 142.222222 0 0 1 142.222223-142.222223z m56.888888 0h455.111112v312.888889H284.444444V85.333333z m369.777778 113.777778a28.444444 28.444444 0 0 0-28.444444 28.444445v85.333333a28.444444 28.444444 0 0 0 56.888889 0V227.555556a28.444444 28.444444 0 0 0-28.444445-28.444445z' p-id='25798' fill='black'%3e%3c/path%3e%3c/svg%3e";

const img$q = "data:image/svg+xml,%3csvg class='svg' width='8' height='7' viewBox='0 0 8 7' xmlns='http://www.w3.org/2000/svg'%3e%3cpath d='M3.646 5.354l-3-3 .708-.708L4 4.293l2.646-2.647.708.708-3 3L4 5.707l-.354-.353z' fill-rule='evenodd' fill-opacity='1' fill='black' stroke='none'%3e%3c/path%3e%3c/svg%3e";

const img$r = "data:image/svg+xml,%3c%3fxml version='1.0' standalone='no'%3f%3e%3c!DOCTYPE svg PUBLIC '-//W3C//DTD SVG 1.1//EN' 'http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd'%3e%3csvg t='1668786593271' class='icon' viewBox='0 0 1024 1024' version='1.1' xmlns='http://www.w3.org/2000/svg' p-id='2801' width='64' height='64' xmlns:xlink='http://www.w3.org/1999/xlink'%3e%3cpath d='M158.165333 499.498667A42.496 42.496 0 0 0 170.666667 469.333333V256a42.666667 42.666667 0 0 1 42.666666-42.666667 42.666667 42.666667 0 0 0 0-85.333333C142.762667 128 85.333333 185.429333 85.333333 256v195.669333l-30.165333 30.165334a42.666667 42.666667 0 0 0 0 60.330666l30.165333 30.165334V768c0 70.570667 57.429333 128 128 128a42.666667 42.666667 0 0 0 0-85.333333 42.666667 42.666667 0 0 1-42.666666-42.666667v-213.333333a42.496 42.496 0 0 0-12.501334-30.165334L145.664 512l12.501333-12.501333zM978.090667 495.658667a42.709333 42.709333 0 0 0-9.258667-13.824L938.666667 451.669333V256c0-70.570667-57.429333-128-128-128a42.666667 42.666667 0 1 0 0 85.333333 42.666667 42.666667 0 0 1 42.666666 42.666667v213.333333a42.581333 42.581333 0 0 0 12.501334 30.165334l12.501333 12.501333-12.501333 12.501333A42.496 42.496 0 0 0 853.333333 554.666667v213.333333a42.666667 42.666667 0 0 1-42.666666 42.666667 42.666667 42.666667 0 1 0 0 85.333333c70.570667 0 128-57.429333 128-128v-195.669333l30.165333-30.165334a42.709333 42.709333 0 0 0 9.258667-46.506666zM669.738667 225.450667a42.752 42.752 0 0 0-69.546667 14.762666l-255.829333 512a42.624 42.624 0 0 0 23.893333 55.424 42.922667 42.922667 0 0 0 55.552-23.765333l255.786667-512a42.538667 42.538667 0 0 0-9.813334-46.421333z' p-id='2802'%3e%3c/path%3e%3c/svg%3e";

const img$s = "data:image/svg+xml,%3c%3fxml version='1.0' standalone='no'%3f%3e%3c!DOCTYPE svg PUBLIC '-//W3C//DTD SVG 1.1//EN' 'http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd'%3e%3csvg t='1668786776572' class='icon' viewBox='0 0 1026 1024' version='1.1' xmlns='http://www.w3.org/2000/svg' p-id='4667' xmlns:xlink='http://www.w3.org/1999/xlink' width='64.125' height='64'%3e%3cpath d='M384.216363 59.877205c19.260501 0 34.92837 15.667869 34.928369 34.92837v289.40649c0 19.260501-15.667869 34.92837-34.928369 34.92837h-289.406491c-19.260501 0-34.92837-15.667869-34.928369-34.92837v-289.40649c0-19.260501 15.667869-34.92837 34.928369-34.92837h289.406491m0-59.877205h-289.406491c-52.392554 0-94.805575 42.41302-94.805574 94.805575v289.40649c0 52.392554 42.41302 94.805575 94.805574 94.805575h289.406491c52.392554 0 94.805575-42.41302 94.805574-94.805575v-289.40649c0-52.392554-42.41302-94.805575-94.805574-94.805575zM386.312065 604.859565c19.260501 0 34.92837 15.667869 34.92837 34.92837v289.40649c0 19.260501-15.667869 34.92837-34.92837 34.92837H96.905575c-19.260501 0-34.92837-15.667869-34.92837-34.92837V639.787935c0-19.260501 15.667869-34.92837 34.92837-34.92837h289.40649m0-59.877205H96.905575c-52.392554 0-94.805575 42.41302-94.805575 94.805575v289.40649c0 52.392554 42.41302 94.805575 94.805575 94.805575h289.40649c52.392554 0 94.805575-42.41302 94.805575-94.805575V639.787935c0-52.392554-42.41302-94.805575-94.805575-94.805575zM929.198723 604.859565c19.260501 0 34.92837 15.667869 34.92837 34.92837v289.40649c0 19.260501-15.667869 34.92837-34.92837 34.92837H639.792233c-19.260501 0-34.92837-15.667869-34.92837-34.92837V639.787935c0-19.260501 15.667869-34.92837 34.92837-34.92837h289.40649m0-59.877205H639.792233c-52.392554 0-94.805575 42.41302-94.805575 94.805575v289.40649c0 52.392554 42.41302 94.805575 94.805575 94.805575h289.40649c52.392554 0 94.805575-42.41302 94.805575-94.805575V639.787935c0-52.392554-42.41302-94.805575-94.805575-94.805575zM876.806169 278.229412c-4.590586-8.283013-13.07319-13.372576-22.254361-13.172985l-25.846994 0.598772c0.299386-67.561446 7.085469-148.794854 125.742131-218.950979l1.397135-0.798363 1.097748-1.097749c4.790176-4.889972 6.386902-11.57626 3.892019-17.56398-2.594679-6.087516-9.081376-10.07933-16.06705-9.979534h-0.997954l-0.997953 0.199591c-58.48007 10.179125-108.976513 27.942696-150.191989 52.891531-34.628984 20.957022-62.970861 47.103401-84.127473 77.740571-33.132053 47.801969-41.315271 94.805575-43.011792 121.051749l-29.539422 0.598772c-11.077283 0.199591-20.757431 5.887925-25.747198 15.168892-4.790176 8.981581-4.191404 19.759478 1.596726 28.142287l0.299386 0.498976 100.294318 133.925349c7.28506 9.280967 18.362343 14.470325 30.537375 14.270734 7.983627-0.199591 15.468278-2.594679 21.755384-6.985674 3.293246-2.295293 6.386902-5.189358 8.981581-8.5824l101.591658-138.216548 0.19959-0.498977c5.887925-8.981581 6.486697-20.158659 1.397135-29.240035z' p-id='4668' fill='black'%3e%3c/path%3e%3cpath d='M742.082458 462.252022c-11.975441 0-22.952929-5.289153-30.138193-14.470324L611.649946 313.856349l-0.299386-0.498976c-5.887925-8.582399-6.486697-19.559887-1.596725-28.641263 5.189358-9.480557 14.969301-15.268687 26.146379-15.368483l29.040445-0.598772c1.696521-24.549654 9.480557-72.551213 43.011792-120.852159 21.256408-30.736965 49.598285-56.883345 84.327064-77.840366 41.215476-24.948835 91.811714-42.712406 150.391579-52.891531l0.997954-0.199591h1.097749c7.185265-0.199591 13.871552 3.991814 16.566026 10.27892 2.494884 5.98772 0.997953 12.973394-3.991813 18.062957l-1.197544 1.197544-1.397135 0.798363c-114.864438 67.960628-125.143358 144.902836-125.442745 218.052821l25.348017-0.598772c9.181171-0.199591 17.963161 4.989767 22.653543 13.372576 5.089562 9.181171 4.590586 20.657636-1.397135 29.739012l-0.199591 0.399181-101.691453 138.216548c-2.494884 3.293246-5.588539 6.187311-9.081376 8.682195-6.386902 4.49079-14.071143 6.885879-22.05477 7.085469h-0.798363zM945.265773 17.763571h-1.397134l-0.898159 0.19959C884.49041 28.042491 833.993967 45.806062 792.878287 70.655102c-34.529188 20.857226-62.77127 47.003606-84.027678 77.640776-33.63103 48.500536-41.315271 96.502095-42.911997 120.852158v0.498977l-29.938602 0.598772c-10.877692 0.099795-20.35825 5.688334-25.348017 14.869506-4.690381 8.78199-4.091609 19.360296 1.596725 27.64331l0.299386 0.498976L712.742627 447.182926c7.185265 9.181171 18.062957 14.270734 30.138194 14.071143 7.784037-0.199591 15.168892-2.494884 21.455998-6.885879 3.492837-2.395088 6.386902-5.289153 8.881785-8.482604l101.591658-138.216548 0.199591-0.399181c5.78813-8.881785 6.287107-19.859273 1.397135-28.741059-4.590586-8.183218-12.873599-13.07319-21.755385-12.873599l-26.34597 0.598772v-0.498976c0.199591-32.633077 1.696521-70.655102 18.561934-108.776923 18.961115-42.911997 54.089075-79.137706 107.479582-110.673034l1.29734-0.798362 1.097749-1.097749c4.690381-4.790176 6.187311-11.276874 3.792223-16.965208-2.594679-5.78813-8.582399-9.680148-15.268688-9.680148z' p-id='4669' fill='black'%3e%3c/path%3e%3c/svg%3e";

const img$t = "data:image/svg+xml,%3c%3fxml version='1.0' standalone='no'%3f%3e%3c!DOCTYPE svg PUBLIC '-//W3C//DTD SVG 1.1//EN' 'http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd'%3e%3csvg t='1668848339975' class='icon' viewBox='0 0 1365 1024' version='1.1' xmlns='http://www.w3.org/2000/svg' p-id='2797' xmlns:xlink='http://www.w3.org/1999/xlink' width='85.3125' height='64'%3e%3cpath d='M1140.982158 0C1171.511117 0 1196.259731 24.748613 1196.259731 55.277574L1196.259731 481.802069C1196.259731 512.331031 1171.511117 537.079644 1140.982158 537.079644 1110.453196 537.079644 1085.704583 512.331031 1085.704583 481.802069L1085.704583 55.277574 1140.982158 110.555148 707.290659 110.555148C676.761697 110.555148 652.013084 85.806535 652.013084 55.277574 652.013084 24.748613 676.761697 0 707.290659 0L1140.982158 0ZM223.896216 1024.028434C193.367257 1024.028434 168.618642 999.279821 168.618642 968.75086L168.618642 542.226364C168.618642 511.697403 193.367257 486.94879 223.896216 486.94879 254.425178 486.94879 279.17379 511.697403 279.17379 542.226364L279.17379 968.75086 223.896216 913.473286 657.587715 913.473286C688.116677 913.473286 712.865289 938.221898 712.865289 968.75086 712.865289 999.279821 688.116677 1024.028434 657.587715 1024.028434L223.896216 1024.028434Z' p-id='2798' fill='white'%3e%3c/path%3e%3c/svg%3e";

const img$u = "data:image/svg+xml,%3c%3fxml version='1.0' standalone='no'%3f%3e%3c!DOCTYPE svg PUBLIC '-//W3C//DTD SVG 1.1//EN' 'http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd'%3e%3csvg t='1668849712740' class='icon' viewBox='0 0 1024 1024' version='1.1' xmlns='http://www.w3.org/2000/svg' p-id='3888' xmlns:xlink='http://www.w3.org/1999/xlink' width='64' height='64'%3e%3cpath d='M449.92 543.36C449.92 520.96 431.36 512 410.24 512L97.92 512c-17.92 0-32 14.08-32 32 0 17.92 14.08 32 32 32l242.56 0-267.52 267.52c-12.16 12.16-12.16 31.36 0 43.52 12.16 12.16 31.36 12.16 43.52 0l269.44-269.44 0 246.4c0 17.92 14.08 32 32 32 17.92 0 32-14.08 32-32l0-320M865.92 384 622.72 384l267.52-267.52c12.16-12.16 12.16-31.36 0-43.52-12.16-12.16-31.36-12.16-43.52 0L577.92 342.4 577.92 96C577.92 78.08 563.2 64 545.92 64c-17.92 0-32 14.08-32 32l0 320c0 0.64 0.64 1.28 0.64 1.92 0 8.32 2.56 16.64 8.96 22.4C531.2 448.64 542.72 451.2 552.96 448l312.32 0c17.92 0 32-14.08 32-32C897.92 398.08 883.2 384 865.92 384z' p-id='3889' fill='white'%3e%3c/path%3e%3c/svg%3e";

var css_248z$5 = ".index_container__9QMUX {\n  position: relative;\n}\n.index_container__9QMUX .index_resize-top__23Jo9 {\n  width: 100%;\n  height: 3px;\n  top: 0px;\n  z-index: 9999;\n  position: absolute;\n  cursor: row-resize;\n}\n.index_container__9QMUX .index_resize-bottom__3x2iE {\n  width: 100%;\n  height: 3px;\n  bottom: 0px;\n  z-index: 9999;\n  position: absolute;\n  cursor: row-resize;\n}\n.index_container__9QMUX .index_resize-left__2T4ax {\n  width: 3px;\n  height: 100%;\n  left: 0px;\n  z-index: 9999;\n  position: absolute;\n  cursor: col-resize;\n}\n.index_container__9QMUX .index_resize-right__3pAM8 {\n  width: 3px;\n  height: 100%;\n  right: 0px;\n  z-index: 9999;\n  position: absolute;\n  cursor: col-resize;\n}\n.index_container__9QMUX .index_resize-topLeft__1CIoV {\n  width: 4px;\n  height: 4px;\n  top: 3px;\n  left: 3px;\n  z-index: 10000;\n  position: absolute;\n  cursor: nw-resize;\n}\n.index_container__9QMUX .index_resize-topRight__2Vck_ {\n  width: 4px;\n  height: 4px;\n  top: 3px;\n  right: 3px;\n  z-index: 10000;\n  position: absolute;\n  cursor: ne-resize;\n}\n.index_container__9QMUX .index_resize-bottomLeft__2l1wG {\n  width: 4px;\n  height: 4px;\n  bottom: 3px;\n  left: 3px;\n  z-index: 10000;\n  position: absolute;\n  cursor: sw-resize;\n}\n.index_container__9QMUX .index_resize-bottomRight__2hjG6 {\n  width: 4px;\n  height: 4px;\n  bottom: 3px;\n  right: 3px;\n  z-index: 10000;\n  position: absolute;\n  cursor: se-resize;\n}\n";
var styles$5 = {"container":"index_container__9QMUX","resize-top":"index_resize-top__23Jo9","resize-bottom":"index_resize-bottom__3x2iE","resize-left":"index_resize-left__2T4ax","resize-right":"index_resize-right__3pAM8","resize-topLeft":"index_resize-topLeft__1CIoV","resize-topRight":"index_resize-topRight__2Vck_","resize-bottomLeft":"index_resize-bottomLeft__2l1wG","resize-bottomRight":"index_resize-bottomRight__2hjG6"};
styleInject(css_248z$5);

/**
 * 检验是否为合法表达式
 */
const expressionRex = /^\$\{.+\}$/;
function usePrevious(value) {
    const ref = useRef();
    useEffect(() => {
        ref.current = value;
    });
    return ref.current;
}
/**
 * form 方法受控组件减少不必要渲染
 * @param prevProps
 * @param nextProps
 */
const propsAreEqual = (prevProps, nextProps) => isEqual(prevProps.value, nextProps.value);
const ANIMATION_YES = 'all 200ms';
const getValueType = (v) => {
    if (typeof v === 'string') {
        return PROPS_TYPES$1.string;
    }
    else if (typeof v === 'number') {
        return PROPS_TYPES$1.number;
    }
    else if (typeof v === 'boolean') {
        return PROPS_TYPES$1.boolean;
    }
    else if (Array.isArray(v)) {
        if (v.some((sv) => typeof sv === 'string')) {
            return PROPS_TYPES$1.stringArray;
        }
        else if (v.some((sv) => typeof sv === 'number')) {
            return PROPS_TYPES$1.numberArray;
        }
        else {
            return PROPS_TYPES$1.objectArray;
        }
    }
    else {
        return PROPS_TYPES$1.object;
    }
};
/**
 * 拆分属性配置信息
 * 将普通属性与事件属性拆分
 * @param propsConfig
 */
const splitPropsConfig = (propsConfig, childNodes) => {
    const firstConfig = {
        style: {
            type: PROPS_TYPES$1.style,
            label: '样式',
            formItemProps: {
                mode: 'json5'
            },
        },
        className: {
            type: PROPS_TYPES$1.string,
            label: "类",
        }
    };
    const secondConfig = {};
    each(propsConfig, (config, key) => {
        const { type } = config;
        if (Array.isArray(childNodes)
            && childNodes.length && key === 'children'
            || get(childNodes, key, []).length
            || get(firstConfig, key)) {
            return;
        }
        switch (type) {
            case PROPS_TYPES$1.function:
                secondConfig[key] = config;
                break;
            case PROPS_TYPES$1.style:
                config.formItemProps = { mode: 'json5' };
            default:
                firstConfig[key] = config;
        }
    });
    return { firstConfig, secondConfig };
};

const PanelActiveContext = createContext({});
function PanelActive(props) {
    const { children } = props;
    const store = useRef(new BrickStore({})).current;
    return React.createElement(PanelActiveContext.Provider, { value: store }, children);
}
function handleStates(state, key) {
    for (const k of Object.keys(state)) {
        if (state[k]) {
            state[k] = false;
            break;
        }
    }
    state[key] = true;
    return { ...state };
}
function useActiveParent(keys, targetRef) {
    const store = useContext(PanelActiveContext);
    useEffect(() => {
        return store.subscribe(() => {
            const state = store.getPageState();
            console.log('useEffect>>>>>>', state);
            for (const k of keys) {
                if (state[k]) {
                    console.log('state>>>>>>', state[k]);
                    return targetRef.current.style.zIndex = '10000';
                }
                targetRef.current.style.zIndex = '0';
            }
        });
    });
}
function useActive(key, targetRef) {
    const store = useContext(PanelActiveContext);
    const prevStatus = usePrevious(get(store.getPageState(), key));
    useEffect(() => {
        const unSubscribe = store.subscribe(() => {
            const status = get(store.getPageState(), key);
            if (prevStatus !== status) {
                // eslint-disable-next-line no-empty
                if (status) {
                    targetRef.current.style.zIndex = '1000';
                }
                else {
                    targetRef.current.style.zIndex = '0';
                }
            }
        });
        return unSubscribe;
    }, [prevStatus]);
    const setActive = () => {
        const states = store.getPageState();
        store.setPageState(handleStates(states, key), true);
    };
    return setActive;
}

function Resizeable(props, ref) {
    const { children, left = true, right = true, top = true, bottom = true, topLeft = true, topRight = true, bottomLeft = true, bottomRight = true, className, defaultHeight, defaultWidth, activeKey, setCursor = (s) => s, ...rest } = props;
    const originSizeRef = useRef({
        isResize: false,
        width: defaultWidth,
        height: defaultHeight,
    });
    const resizeDivRef = useRef();
    const setActive = useActive(activeKey, resizeDivRef);
    const { onResizeStart, onResize, onResizeEnd } = useResize(resizeDivRef);
    const defaultSize = useMemo(() => {
        const style = {};
        if (defaultWidth) {
            style.width = defaultWidth;
        }
        if (defaultHeight) {
            style.height = defaultWidth;
        }
        return style;
    }, []);
    const onFocus = (event) => {
        event.stopPropagation();
        setActive();
    };
    const changeFold = useCallback((params) => {
        const { isHeight, isWidth, widthTarget, heightTarget } = params;
        const { height, width } = originSizeRef.current;
        if (isHeight || heightTarget !== undefined) {
            resizeDivRef.current.style.height = `${heightTarget !== undefined ? heightTarget : height}px`;
        }
        if (isWidth || widthTarget !== undefined) {
            resizeDivRef.current.style.width = `${widthTarget !== undefined ? widthTarget : width}px`;
        }
        resizeDivRef.current.style.transition = ANIMATION_YES;
    }, []);
    useImperativeHandle(ref, () => ({
        changeFold,
        onResize,
        onResizeEnd,
        target: resizeDivRef.current,
    }));
    const onMouseDown = useCallback((event) => {
        props.onResizeStart && props.onResizeStart(event);
    }, []);
    const topResize = useCallback((event) => {
        onResizeStart(event, Direction.top);
        setCursor('row-resize');
        onMouseDown(event);
    }, []);
    const bottomResize = useCallback((event) => {
        onResizeStart(event, Direction.bottom);
        setCursor('row-resize');
        onMouseDown(event);
    }, []);
    const leftResize = useCallback((event) => {
        onResizeStart(event, Direction.left);
        setCursor('col-resize');
        onMouseDown(event);
    }, []);
    const rightResize = useCallback((event) => {
        onResizeStart(event, Direction.right);
        setCursor('col-resize');
        onMouseDown(event);
    }, []);
    const topRightResize = useCallback((event) => {
        onResizeStart(event, Direction.topRight);
        setCursor('ne-resize');
        onMouseDown(event);
    }, []);
    const bottomRightResize = useCallback((event) => {
        onResizeStart(event, Direction.bottomRight);
        setCursor('se-resize');
        onMouseDown(event);
    }, []);
    const topLeftResize = useCallback((event) => {
        onResizeStart(event, Direction.topLeft);
        setCursor('nw-resize');
        onMouseDown(event);
    }, []);
    const bottomLeftResize = useCallback((event) => {
        onResizeStart(event, Direction.bottomLeft);
        setCursor('sw-resize');
        onMouseDown(event);
    }, []);
    return (React.createElement("div", Object.assign({ className: `${styles$5['container']} ${className}`, style: defaultSize }, rest, { onFocus: onFocus, ref: resizeDivRef }),
        children,
        left && (React.createElement("div", { className: styles$5['resize-left'], onMouseDown: leftResize })),
        right && (React.createElement("div", { className: styles$5['resize-right'], onMouseDown: rightResize })),
        top && React.createElement("div", { className: styles$5['resize-top'], onMouseDown: topResize }),
        bottom && (React.createElement("div", { className: styles$5['resize-bottom'], onMouseDown: bottomResize })),
        topLeft && (React.createElement("div", { className: styles$5['resize-topLeft'], onMouseDown: topLeftResize })),
        topRight && (React.createElement("div", { className: styles$5['resize-topRight'], onMouseDown: topRightResize })),
        bottomLeft && (React.createElement("div", { className: styles$5['resize-bottomLeft'], onMouseDown: bottomLeftResize })),
        bottomRight && (React.createElement("div", { className: styles$5['resize-bottomRight'], onMouseDown: bottomRightResize }))));
}
var Resizeable$1 = memo(forwardRef(Resizeable));

const LayerItem = function (props) {
    const { layerName, onDelete } = props;
    const { layerName: selectLayerName } = useSelector(['layerName'], undefined, undefined, true);
    // const renameLayer=()=>{
    //
    // }
    const changeLayerName = useCallback(() => {
        if (selectLayerName !== layerName)
            changeLayer({ layerName });
    }, [selectLayerName]);
    const changeEdit = useCallback((event) => {
        event.stopPropagation();
        const target = event.target;
        target.contentEditable = 'true';
        target.focus();
    }, []);
    const onBlur = useCallback((event) => {
        event.stopPropagation();
        const target = event.target;
        renameLayers({
            newLayerName: target.textContent,
            prevLayerName: layerName,
        });
        target.contentEditable = 'false';
    }, []);
    const copyPage = (e) => {
        e.stopPropagation();
        copyLayers({ layerName });
    };
    const deletePage = (e) => {
        e.stopPropagation();
        onDelete(layerName);
    };
    const isSelected = selectLayerName === layerName;
    return (React.createElement("div", { onClick: changeLayerName, className: styles$3['layer-item'] },
        React.createElement("img", { alt: "", style: { visibility: isSelected ? 'visible' : 'hidden' }, src: img$7, className: styles$3['right-icon'] }),
        React.createElement("div", { onBlur: onBlur, onDoubleClick: changeEdit, style: { fontWeight: isSelected ? 500 : 400 }, className: styles$3['layer-text'] }, layerName),
        React.createElement(Icon$1, { onClick: copyPage, icon: img$8, iconClass: styles$3['icon-size'], className: styles$3['hover-icon'] }),
        React.createElement(Icon$1, { onClick: deletePage, icon: img$9, iconClass: styles$3['icon-size'], className: styles$3['hover-icon'] })));
};
function Pages(props) {
    const { onDelete } = props;
    const [isFold, setIsFold] = useState(false);
    const brickdStore = useRef(getStore()).current;
    const { layerName } = useSelector(['layerName'], undefined, undefined, true);
    const [layers, setLayers] = useState([]);
    const resizeRef = useRef();
    useEffect(() => {
        const layers = keys(brickdStore.getState());
        layers.shift();
        setLayers(layers);
        addEventListener('mousemove', resizeRef.current.onResize);
        addEventListener('mouseup', resizeRef.current.onResizeEnd);
        return () => {
            removeEventListener('mousemove', resizeRef.current.onResize);
            removeEventListener('mouseup', resizeRef.current.onResizeEnd);
        };
    }, []);
    useEffect(() => {
        function checkForUpdates() {
            const newLayers = keys(brickdStore.getState());
            newLayers.shift();
            if (!isEqual(newLayers, layers)) {
                setLayers(newLayers);
            }
        }
        return brickdStore.subscribe(checkForUpdates);
    }, [layers, setLayers]);
    const changeFold = useCallback(() => {
        if (!isFold) {
            resizeRef.current.changeFold({ heightTarget: 40 });
        }
        else {
            resizeRef.current.changeFold({ isHeight: true });
        }
        setIsFold(!isFold);
    }, [isFold, setIsFold]);
    const createPage = () => {
        createLayers({ layerName: 'Layer' + layers.length });
    };
    return (React.createElement(Resizeable$1, { ref: resizeRef, minHeight: 40, defaultHeight: 100, bottomLeft: false, bottomRight: false, topLeft: false, topRight: false, top: false, left: false, right: false, className: styles$3['page-container'] },
        React.createElement("div", { className: styles$3['header-container'] },
            React.createElement("span", { className: styles$3['header-name'] }, layerName),
            React.createElement("div", { className: styles$3['header-right'] },
                React.createElement("span", { style: { marginRight: 10 } }, `${layers.indexOf(layerName) + 1}/${layers.length}`),
                React.createElement(Icon$1, { onClick: createPage, icon: img$6, className: styles$3['add-icon'] }),
                React.createElement(Icon$1, { onClick: changeFold, icon: img, className: `${styles$3['add-icon']} ${!isFold && styles$3['rotate180']}` }))),
        React.createElement("div", { className: styles$3['page-content'] }, map(layers, (v) => (React.createElement(LayerItem, { onDelete: onDelete, layers: layers, layerName: v, key: v }))))));
}
var Pages$1 = memo(Pages);

/**
 * 属性类型定义
 */

var PROPS_TYPES;

(function (PROPS_TYPES) {
  PROPS_TYPES["object"] = "object";
  PROPS_TYPES["objectArray"] = "objectArray";
  PROPS_TYPES["function"] = "function";
  PROPS_TYPES["number"] = "number";
  PROPS_TYPES["numberArray"] = "numberArray";
  PROPS_TYPES["string"] = "string";
  PROPS_TYPES["stringArray"] = "stringArray";
  PROPS_TYPES["enum"] = "enum";
  PROPS_TYPES["json"] = "json";
  PROPS_TYPES["boolean"] = "boolean";
  PROPS_TYPES["style"] = "style";
  PROPS_TYPES["cssClass"] = "cssClass";
})(PROPS_TYPES || (PROPS_TYPES = {}));

var NODE_PROPS_TYPES;

(function (NODE_PROPS_TYPES) {
  NODE_PROPS_TYPES["reactNode"] = "reactNode";
  NODE_PROPS_TYPES["functionReactNode"] = "functionReactNode";
})(NODE_PROPS_TYPES || (NODE_PROPS_TYPES = {}));
/**
 * 新拖拽 Key
 */

let NEW_DRAG_KEY = null;

const setNewDragKey = key => NEW_DRAG_KEY = key;

var css_248z$6 = ".index_rotate180__a0_Ip {\n  transform: rotate(180deg);\n}\n.index_rotate90__157Z2 {\n  transform: rotate(90deg);\n  pointer-events: none;\n  transition: none;\n  cursor: auto;\n}\n.index_icon-container__3T_1X {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 40px;\n  height: 39px;\n  cursor: pointer;\n}\n.index_icon-container__3T_1X .index_icon-class__1jbip {\n  width: 14px;\n  height: 14px;\n  user-select: none;\n}\n.index_icon-Menu__2VzrQ {\n  width: 45px;\n  height: 35px;\n  border-radius: 8px;\n  background-color: #ffffff;\n  margin-right: 5px;\n  box-shadow: 3px 4px 5px 3px rgba(0, 0, 0, 0.15);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  cursor: pointer;\n}\n.index_icon-Menu__2VzrQ .index_icon-class__1jbip {\n  width: 20px;\n  height: 20px;\n}\n.index_tabs-container__30jsh .rc-tabs-tab {\n  font-size: 12px;\n  font-weight: bold;\n  color: #aaa;\n}\n.index_tabs-container__30jsh .rc-tabs-tab-active {\n  color: #333;\n}\n.index_tabs-container__30jsh .rc-tabs-ink-bar {\n  background-color: #333333;\n  height: 2px !important;\n}\n.index_tabs-container__30jsh .rc-tabs-nav-operations {\n  display: none !important;\n}\n.index_tabs-container__30jsh .rc-tabs-nav-measure-ping-top::before,\n.index_tabs-container__30jsh .rc-tabs-nav-wrap-ping-top::before,\n.index_tabs-container__30jsh .rc-tabs-nav-measure-ping-bottom::after,\n.index_tabs-container__30jsh .rc-tabs-nav-wrap-ping-bottom::after {\n  border: 0 !important;\n}\n.index_tabs-container__30jsh .rc-tabs-nav-operations {\n  display: none !important;\n}\n.index_tabs-container__30jsh .rc-tabs-nav-measure-ping-left::before,\n.index_tabs-container__30jsh .rc-tabs-nav-wrap-ping-left::before {\n  border-left-width: 0px;\n}\n.index_common-input__1EQKX {\n  padding: 0;\n  border: none;\n  text-align: left;\n  outline: none;\n  white-space: normal;\n  word-wrap: break-word;\n  word-break: break-all;\n  resize: none;\n  width: 100%;\n  color: rgba(0, 0, 0, 0.8);\n  font-family: PingFangSC-Medium, PingFang SC;\n}\n.index_common-input__1EQKX::placeholder {\n  font-weight: 400;\n  font-family: PingFangSC-Regular, PingFang SC;\n  color: rgba(0, 0, 0, 0.3);\n}\n.index_sort-container__17Pjv {\n  display: flex;\n  overflow: auto;\n  background: #fff;\n  flex: 1;\n}\n.index_sort-container__17Pjv .index_sort-able__1S1uj {\n  display: flex;\n  flex: 1;\n  flex-direction: column;\n}\n.index_sort-container__17Pjv .index_sort-item__1WRM8 {\n  position: relative;\n  display: flex;\n  flex: 1;\n  flex-direction: column;\n}\n.index_sort-container__17Pjv .rc-collapse-content {\n  padding: 0;\n}\n.index_sort-container__17Pjv .rc-collapse-content > .rc-collapse-content-box {\n  margin-bottom: 0;\n  margin-top: 0;\n}\n.index_sort-container__17Pjv .index_fold-panel-header__E7t_s {\n  padding: 0 !important;\n}\n.index_header-container__1uEN5 {\n  display: flex;\n  height: 30px;\n  font-size: 12px;\n  justify-content: space-between;\n  align-items: center;\n}\n.index_header-container__1uEN5 .index_item-icon__e8kM0 {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  visibility: hidden;\n  width: 25px;\n  height: 25px;\n}\n.index_header-container__1uEN5:hover {\n  background-color: #f1f1f1;\n}\n.index_header-container__1uEN5:hover .index_item-icon__e8kM0 {\n  visibility: visible;\n}\n.index_item-background__kzSEH {\n  background-color: #d9d9d9;\n}\n.index_triangle__2AhRf {\n  width: 20px;\n  height: 30px;\n  transition: all 0.2s;\n  cursor: pointer;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n.index_layout-icon__3h7Sn {\n  height: 12px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding-right: 5px;\n}\n.index_visible-icon__UEvhL {\n  visibility: visible;\n}\n.index_hidden-icon__3iu7j {\n  visibility: hidden;\n}\n";
var styles$6 = {"rotate180":"index_rotate180__a0_Ip","rotate90":"index_rotate90__157Z2","icon-container":"index_icon-container__3T_1X","icon-class":"index_icon-class__1jbip","icon-Menu":"index_icon-Menu__2VzrQ","tabs-container":"index_tabs-container__30jsh","common-input":"index_common-input__1EQKX","sort-container":"index_sort-container__17Pjv","sort-able":"index_sort-able__1S1uj","sort-item":"index_sort-item__1WRM8","fold-panel-header":"index_fold-panel-header__E7t_s","header-container":"index_header-container__1uEN5","item-icon":"index_item-icon__e8kM0","item-background":"index_item-background__kzSEH","triangle":"index_triangle__2AhRf","layout-icon":"index_layout-icon__3h7Sn","visible-icon":"index_visible-icon__UEvhL","hidden-icon":"index_hidden-icon__3iu7j"};
styleInject(css_248z$6);

var css_248z$7 = ".index_rotate180__1YkBJ {\n  transform: rotate(180deg);\n}\n.index_rotate90__VycEu {\n  transform: rotate(90deg);\n}\n.index_icon-container__10hpE {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 40px;\n  height: 39px;\n  cursor: pointer;\n}\n.index_icon-container__10hpE .index_icon-class__ig72D {\n  width: 14px;\n  height: 14px;\n  user-select: none;\n}\n.index_icon-Menu__1QpHO {\n  width: 45px;\n  height: 35px;\n  border-radius: 8px;\n  background-color: #ffffff;\n  margin-right: 5px;\n  box-shadow: 3px 4px 5px 3px rgba(0, 0, 0, 0.15);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  cursor: pointer;\n}\n.index_icon-Menu__1QpHO .index_icon-class__ig72D {\n  width: 20px;\n  height: 20px;\n}\n.index_tabs-container__38Ihx .rc-tabs-tab {\n  font-size: 12px;\n  font-weight: bold;\n  color: #aaa;\n}\n.index_tabs-container__38Ihx .rc-tabs-tab-active {\n  color: #333;\n}\n.index_tabs-container__38Ihx .rc-tabs-ink-bar {\n  background-color: #333333;\n  height: 2px !important;\n}\n.index_tabs-container__38Ihx .rc-tabs-nav-operations {\n  display: none !important;\n}\n.index_tabs-container__38Ihx .rc-tabs-nav-measure-ping-top::before,\n.index_tabs-container__38Ihx .rc-tabs-nav-wrap-ping-top::before,\n.index_tabs-container__38Ihx .rc-tabs-nav-measure-ping-bottom::after,\n.index_tabs-container__38Ihx .rc-tabs-nav-wrap-ping-bottom::after {\n  border: 0 !important;\n}\n.index_tabs-container__38Ihx .rc-tabs-nav-operations {\n  display: none !important;\n}\n.index_common-input__1ryvz {\n  padding: 0;\n  border: none;\n  text-align: left;\n  outline: none;\n  white-space: normal;\n  word-wrap: break-word;\n  word-break: break-all;\n  resize: none;\n  width: 100%;\n  color: rgba(0, 0, 0, 0.8);\n  font-family: PingFangSC-Medium, PingFang SC;\n}\n.index_common-input__1ryvz::placeholder {\n  font-weight: 400;\n  font-family: PingFangSC-Regular, PingFang SC;\n  color: rgba(0, 0, 0, 0.3);\n}\n.index_checkbox-container__3RXDk {\n  width: 28px;\n  height: 28px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 4px;\n  cursor: pointer;\n  border: 1px solid transparent;\n}\n.index_checkbox-container__3RXDk:hover {\n  background-color: #dedee4;\n}\n.index_checkbox-container__3RXDk .index_icon__1rOqF {\n  width: 12px;\n  height: 12px;\n}\n";
var styles$7 = {"rotate180":"index_rotate180__1YkBJ","rotate90":"index_rotate90__VycEu","icon-container":"index_icon-container__10hpE","icon-class":"index_icon-class__ig72D","icon-Menu":"index_icon-Menu__1QpHO","tabs-container":"index_tabs-container__38Ihx","common-input":"index_common-input__1ryvz","checkbox-container":"index_checkbox-container__3RXDk","icon":"index_icon__1rOqF"};
styleInject(css_248z$7);

function Checkbox(props) {
    const { uncheckedIcon = img$2, checkedIcon = img$3, onChange, iconClass, className, ...rest } = props;
    const [isChecked, setIsChecked] = useState(false);
    const changeChecked = () => {
        setIsChecked(!isChecked);
        onChange && onChange(!isChecked);
    };
    return (React.createElement("div", Object.assign({ onClick: changeChecked, className: `${styles$7['checkbox-container']} ${className}` }, rest),
        React.createElement("img", { src: isChecked ? checkedIcon : uncheckedIcon, className: `${styles$7['icon']} ${iconClass}` })));
}
var Checkbox$1 = memo(Checkbox);

const selectedColor = '#5E96FF';
const unSelectedColor = '#555555';
const selectedBGColor = '#F2F2F2';
const hoveredBGColor = '#F1F1F1';
function Header(props) {
    const { specialProps, propName, specialProps: { key, parentPropName, parentKey }, setIsUnfold, isUnfold, componentName, hasChildNodes, } = props;
    const { getOperateState, setOperateState, setSubscribe, } = useOperate();
    const { selectedInfo } = useSelector(['selectedInfo']);
    const { propName: selectedPropName, selectedKey } = selectedInfo || {};
    const sortItemKey = propName ? `${key}${propName}` : key;
    const isSelected = isEqualKey(sortItemKey, selectedPropName ? `${selectedKey}${selectedPropName}` : selectedKey);
    const [isHovered, setIsHovered] = useState(false);
    // const isHovered = isEqualKey(sortItemKey, hoverKey);
    const color = isSelected ? selectedColor : unSelectedColor;
    // const lockNode = (event: React.MouseEvent) => {
    //   event.stopPropagation();
    // };
    const changeStatus = () => {
        const { operateHoverKey } = getOperateState();
        setIsHovered(isEqualKey(sortItemKey, operateHoverKey));
    };
    useEffect(() => {
        const unSubscribe = setSubscribe(changeStatus);
        return unSubscribe;
    });
    // const onCloseEye = useCallback(() => {
    //   executeKeyListener(key);
    // }, []);
    return (React.createElement("div", { style: isSelected || isHovered
            ? {
                backgroundColor: (isSelected && selectedBGColor) ||
                    (isHovered && hoveredBGColor),
            }
            : {}, className: styles$6['header-container'], onMouseLeave: () => isHovered && setOperateState({ hoverNode: null, operateHoverKey: null }), onMouseOver: () => {
            !isSelected &&
                setOperateState({
                    hoverNode: getSelectedNode(key),
                    operateHoverKey: key,
                });
        } },
        React.createElement("div", { onClick: (event) => {
                event.stopPropagation();
                if (isSelected) {
                    clearSelectedStatus();
                    setOperateState({ selectedNode: null, operateSelectedKey: null });
                }
                else {
                    const selectedNode = getSelectedNode(key);
                    selectComponent({ ...specialProps, propName });
                    nodeScrollIntoView(selectedNode);
                    setOperateState({
                        selectedNode,
                        operateSelectedKey: key,
                    });
                }
            }, style: { display: 'flex', flex: 1, alignItems: 'center', color } },
            React.createElement(Icon$1, { className: `${styles$6.triangle} ${isUnfold && styles$6.rotate180}`, icon: img, iconClass: styles$6[hasChildNodes ? 'visible-icon' : 'hidden-icon'], onClick: (event) => {
                    event.stopPropagation();
                    setIsUnfold(!isUnfold);
                } }),
            React.createElement(Icon$1, { className: styles$6['layout-icon'], style: { color }, icon: img$5 }),
            componentName),
        !propName && key !== ROOT && React.createElement(Checkbox$1, { onChange: () => copyComponent({ key, parentKey, parentPropName }), checkedIcon: img$8, uncheckedIcon: img$8, className: styles$6['item-icon'] }),
        !propName && React.createElement(Checkbox$1, { onChange: () => deleteComponent({ key, parentKey, parentPropName }), checkedIcon: img$9, uncheckedIcon: img$9, className: styles$6['item-icon'] }),
        React.createElement(Icon$1, { icon: img$c, className: styles$6['item-icon'] })));
}
var Header$1 = memo(Header);

/**
 * 渲染子组件或者属性节点
 * @returns {Array|*}
 */
function renderSortTree(props, isUnfold, componentName, nodePropsConfig, childNodes) {
    const { specialProps, propName, nodeProps } = props;
    if (isArray(childNodes) || (!childNodes && !nodePropsConfig)) {
        return (React.createElement(SortTree$1, { isFold: !isUnfold, childNodes: childNodes ? childNodes : [], propName: propName, specialProps: specialProps, nodeProps: nodeProps, componentName: componentName }));
    }
    /**
     * 处理属性节点子组件
     */
    return map(nodePropsConfig, (nodeProps, propName) => {
        return (React.createElement(SortItem, Object.assign({}, props, { propChildNodes: get(childNodes, propName, []), specialProps: specialProps, propName: propName, key: propName, nodeProps: nodeProps })));
    });
}
function SortItem(props) {
    const { specialProps, specialProps: { key, parentPropName, parentKey }, isFold, propName, propChildNodes, } = props;
    const { selectedInfo, pageConfig } = useSelector([
        'selectedInfo',
        'pageConfig',
    ]);
    const { domTreeKeys: nextSDTKeys } = selectedInfo || {};
    const vDom = pageConfig[key];
    const { childNodes: vDomChildNodes, componentName } = vDom || {};
    const childNodes = propChildNodes || vDomChildNodes;
    const [isUnfold, setIsUnfold] = useState(isEmpty(childNodes));
    // 保存子组件dom
    const prevChildNodes = usePrevious$1(childNodes);
    const prevSDTKeys = usePrevious$1(nextSDTKeys);
    //新添加组件展开
    useEffect(() => {
        if (!isUnfold && prevChildNodes && !isEqual(prevChildNodes, childNodes)) {
            setIsUnfold(true);
        }
    }, [prevChildNodes, childNodes, isUnfold, setIsUnfold]);
    // 父节点折叠当前节点是展开的就折叠当前节点
    useEffect(() => {
        if (isFold && isUnfold)
            setIsUnfold(false);
    }, [isFold, isUnfold]);
    useEffect(() => {
        if (!isEqual(prevSDTKeys, nextSDTKeys) &&
            nextSDTKeys &&
            isUnfold &&
            !nextSDTKeys.includes(key)) {
            setIsUnfold(false);
        }
    }, [prevSDTKeys, nextSDTKeys, isUnfold]);
    if (!componentName)
        return null;
    if (!isEqual(prevSDTKeys, nextSDTKeys) &&
        nextSDTKeys &&
        !isUnfold &&
        nextSDTKeys.includes(key)) {
        setIsUnfold(true);
    }
    const isContainerComponent = isContainer(componentName);
    const { fatherNodesRule, nodePropsConfig } = getComponentConfig(componentName);
    return (React.createElement("div", { className: styles$6['sort-item'], id: key, "data-special": JSON.stringify({ key, parentPropName, parentKey }), "data-farules": fatherNodesRule && JSON.stringify(fatherNodesRule), "data-name": componentName },
        React.createElement(Header$1, { isUnfold: isUnfold, specialProps: specialProps, propName: propName, setIsUnfold: setIsUnfold, hasChildNodes: !isEmpty(childNodes), componentName: propName || componentName }),
        isContainerComponent && (React.createElement(Collapse, { activeKey: isUnfold || isEmpty(childNodes) ? '1' : '2', style: { backgroundColor: '#fff', border: 0, marginLeft: 20 } },
            React.createElement(Panel, { headerClass: styles$6['fold-panel-header'], showArrow: false, key: "1", style: { border: 0, padding: 0 } }, renderSortTree(props, isUnfold, componentName, nodePropsConfig, childNodes))))));
}
var SortItem$1 = memo(SortItem);

const store = {
    nextSibling: null,
    activeComponent: null,
};
function Sortable(props, ref) {
    const { options = {}, onSortEnd, onChange, onEnd, ...rest } = props;
    const sortRef = useRef();
    useImperativeHandle(ref, () => sortRef.current);
    useEffect(() => {
        ['onChoose', 'onAdd', 'onUpdate', 'onChange', 'onEnd'].forEach((name) => {
            const eventHandler = options[name];
            options[name] = (...params) => {
                const [evt] = params;
                if (name === 'onChoose') {
                    store.nextSibling = evt.item.nextElementSibling;
                    store.activeComponent = sortRef.current;
                }
                else if ((name === 'onAdd' || name === 'onUpdate') && onSortEnd) {
                    const items = sortable.toArray();
                    const referenceNode = store.nextSibling && store.nextSibling.parentNode !== null
                        ? store.nextSibling
                        : null;
                    evt.from.insertBefore(evt.item, referenceNode);
                    onSortEnd && onSortEnd(items, evt);
                }
                else if (name === 'onChange') {
                    const items = sortable.toArray();
                    onChange && onChange(items, evt);
                }
                else if (name === 'onEnd') {
                    onEnd && onEnd();
                }
                if (evt.type === 'move') {
                    const [evt, originalEvent] = params;
                    return eventHandler ? eventHandler(evt, originalEvent) : true;
                }
                setTimeout(() => {
                    eventHandler && eventHandler(evt);
                }, 0);
            };
        });
        const sortable = SortableJS.create(sortRef.current, options);
        return () => {
            sortable.destroy();
        };
    }, []);
    return React.createElement("div", Object.assign({}, rest, { ref: sortRef }));
}
var ReactSortable = memo(forwardRef(Sortable));

/**
 * 渲染排序节点
 * @param key
 * @param props
 */
function renderSortItems(key, props) {
    const { isFold, propName: parentPropName, specialProps: { domTreeKeys = [], key: parentKey }, } = props;
    return (React.createElement(SortItem$1, { isFold: isFold, key: key, specialProps: {
            domTreeKeys: [...domTreeKeys, key],
            key,
            parentKey,
            parentPropName,
        } }));
}
const putItem = (c, props) => {
    const { childNodes = [], nodeProps, componentName } = props;
    const fatherNodesRule = c.dataset.farules;
    const dragName = c.dataset.name;
    if (fatherNodesRule && !JSON.parse(fatherNodesRule).include(componentName))
        return false;
    if (nodeProps) {
        if (nodeProps.isOnlyNode && childNodes.length === 1)
            return false;
        if (nodeProps.childNodesRule) {
            return nodeProps.childNodesRule.includes(dragName);
        }
    }
    return true;
};
function SortTree(props) {
    const { childNodes, disabled, specialProps: { key }, propName, } = props;
    const { setOperateState } = useOperate();
    /**
     * 拖拽排序
     * @param sortKeys
     * @param evt
     * @param props
     */
    const layoutSortChange = useCallback(function (sortKeys, evt) {
        /**
         * 获取拖住节点的信息
         * @type {any}
         */
        const dragInfo = JSON.parse(evt.clone.dataset.special);
        onLayoutSortChange({
            sortKeys,
            parentKey: key,
            parentPropName: propName,
            dragInfo,
        });
        setOperateState({ dropNode: null, isDropAble: false });
        setNewDragKey(null);
    }, []);
    const onChange = useCallback(function (sortKeys, evt) {
        /**
         * 获取拖住节点的信息
         * @type {any}
         */
        const dragInfo = JSON.parse(evt.clone.dataset.special);
        setNewDragKey(dragInfo.key);
        onDragBrickTree(dragInfo.key, sortKeys, key, setOperateState, propName);
    }, []);
    const onEnd = () => {
        setOperateState({ dropNode: null, isDropAble: null });
    };
    return (React.createElement(ReactSortable, { className: styles$6['sort-able'], options: {
            group: {
                name: 'nested',
                put: (a, b, c) => putItem(c, props),
            },
            animation: 200,
            disabled,
            dataIdAttr: 'id',
            ghostClass: styles$6['item-background'],
            swapThreshold: 0.5,
        }, onSortEnd: layoutSortChange, onChange: onChange, onEnd: onEnd }, map(childNodes, (key) => renderSortItems(key, props))));
}
var SortTree$1 = memo(SortTree);

function BrickTree() {
    const { pageConfig } = useSelector(['pageConfig'], (prevState, nextState) => {
        const { pageConfig } = nextState;
        return !!(!prevState.pageConfig[ROOT] && pageConfig[ROOT]);
    });
    const { setOperateState } = useOperate();
    const onMouseLeave = useCallback((e) => {
        e.stopPropagation();
        setOperateState({ operateHoverKey: null, hoverNode: null });
    }, []);
    if (!pageConfig[ROOT])
        return null;
    return (React.createElement("div", { onMouseLeave: onMouseLeave, onWheel: (event) => event.stopPropagation(), className: styles$6['sort-container'] },
        React.createElement(SortTree$1, { disabled: true, childNodes: [ROOT], specialProps: { key: ROOT, domTreeKeys: [], parentKey: '' }, componentName: '' })));
}
var BrickTree$1 = memo(BrickTree);

var css_248z$8 = ".index_rotate180__iMM_o {\n  transform: rotate(180deg);\n}\n.index_rotate90__342rA {\n  transform: rotate(90deg);\n}\n.index_icon-container__1bcbq {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 40px;\n  height: 39px;\n  cursor: pointer;\n}\n.index_icon-container__1bcbq .index_icon-class__3PY5B {\n  width: 14px;\n  height: 14px;\n  user-select: none;\n}\n.index_icon-Menu__k_QIJ {\n  width: 45px;\n  height: 35px;\n  border-radius: 8px;\n  background-color: #ffffff;\n  margin-right: 5px;\n  box-shadow: 3px 4px 5px 3px rgba(0, 0, 0, 0.15);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  cursor: pointer;\n}\n.index_icon-Menu__k_QIJ .index_icon-class__3PY5B {\n  width: 20px;\n  height: 20px;\n}\n.index_tabs-container__1sCci .rc-tabs-tab {\n  font-size: 12px;\n  font-weight: bold;\n  color: #aaa;\n}\n.index_tabs-container__1sCci .rc-tabs-tab-active {\n  color: #333;\n}\n.index_tabs-container__1sCci .rc-tabs-ink-bar {\n  background-color: #333333;\n  height: 2px !important;\n}\n.index_tabs-container__1sCci .rc-tabs-nav-operations {\n  display: none !important;\n}\n.index_tabs-container__1sCci .rc-tabs-nav-measure-ping-top::before,\n.index_tabs-container__1sCci .rc-tabs-nav-wrap-ping-top::before,\n.index_tabs-container__1sCci .rc-tabs-nav-measure-ping-bottom::after,\n.index_tabs-container__1sCci .rc-tabs-nav-wrap-ping-bottom::after {\n  border: 0 !important;\n}\n.index_tabs-container__1sCci .rc-tabs-nav-operations {\n  display: none !important;\n}\n.index_common-input__CZjWL {\n  padding: 0;\n  border: none;\n  text-align: left;\n  outline: none;\n  white-space: normal;\n  word-wrap: break-word;\n  word-break: break-all;\n  resize: none;\n  width: 100%;\n  color: rgba(0, 0, 0, 0.8);\n  font-family: PingFangSC-Medium, PingFang SC;\n}\n.index_common-input__CZjWL::placeholder {\n  font-weight: 400;\n  font-family: PingFangSC-Regular, PingFang SC;\n  color: rgba(0, 0, 0, 0.3);\n}\n.index_container__2pbv- {\n  position: absolute;\n  align-self: center;\n  justify-content: center;\n  top: 80px;\n  width: 180px;\n  z-index: 10000;\n  display: flex;\n  flex-direction: column;\n  border-radius: 10px;\n  background-color: #fff;\n  overflow: hidden;\n  box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.2);\n}\n.index_container__2pbv- .index_title-container__dfk55 {\n  height: 35px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n.index_container__2pbv- .index_title-container__dfk55 .index_icon__2WZtl {\n  width: 12px;\n  height: 12px;\n}\n.index_container__2pbv- .index_title-container__dfk55 .index_title__1I5_D {\n  margin-left: 8px;\n  font-size: 14px;\n  color: #333;\n}\n.index_container__2pbv- .index_content__27DNl {\n  font-size: 13px;\n  color: #333;\n  margin-bottom: 5px;\n  text-align: center;\n}\n.index_container__2pbv- .index_btn-container__3zVqy {\n  height: 35px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n.index_container__2pbv- .index_btn-container__3zVqy .index_btn-cancel__2oj5- {\n  height: 25px;\n  width: 56px;\n  font-size: 12px;\n  border-radius: 15px;\n  border: 1px solid #bcbcbc;\n  margin-right: 10px;\n  cursor: pointer;\n}\n.index_container__2pbv- .index_btn-container__3zVqy .index_btn-confirm__3UTDF {\n  height: 25px;\n  width: 56px;\n  font-size: 12px;\n  color: #fff;\n  border-radius: 15px;\n  border-width: 0;\n  background-color: red;\n  cursor: pointer;\n}\n";
var styles$8 = {"rotate180":"index_rotate180__iMM_o","rotate90":"index_rotate90__342rA","icon-container":"index_icon-container__1bcbq","icon-class":"index_icon-class__3PY5B","icon-Menu":"index_icon-Menu__k_QIJ","tabs-container":"index_tabs-container__1sCci","common-input":"index_common-input__CZjWL","container":"index_container__2pbv-","title-container":"index_title-container__dfk55","icon":"index_icon__2WZtl","title":"index_title__1I5_D","content":"index_content__27DNl","btn-container":"index_btn-container__3zVqy","btn-cancel":"index_btn-cancel__2oj5-","btn-confirm":"index_btn-confirm__3UTDF"};
styleInject(css_248z$8);

function Tips(props) {
    const { icon, tipTitle, tip, confirmText, cancelText, cancelCallBack, confirmCallBack, visible, } = props;
    return (React.createElement("div", { style: { display: visible ? 'flex' : 'none' }, className: styles$8['container'] },
        React.createElement("div", { className: styles$8['title-container'] },
            React.createElement(Icon$1, { iconClass: styles$8['icon'], icon: icon }),
            React.createElement("span", { className: styles$8['title'] }, tipTitle)),
        React.createElement("span", { className: styles$8['content'] }, tip),
        React.createElement("div", { className: styles$8['btn-container'] },
            cancelText && (React.createElement("button", { className: styles$8['btn-cancel'], onClick: cancelCallBack }, cancelText)),
            confirmText && (React.createElement("button", { className: styles$8['btn-confirm'], onClick: confirmCallBack }, confirmText)))));
}
var Tips$1 = memo(Tips);

var css_248z$9 = ".index_rotate180__2wIRc {\n  transform: rotate(180deg);\n}\n.index_rotate90__1H3jl {\n  transform: rotate(90deg);\n}\n.index_icon-container__7joHr {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 40px;\n  height: 39px;\n  cursor: pointer;\n}\n.index_icon-container__7joHr .index_icon-class__tG_Pt {\n  width: 14px;\n  height: 14px;\n  user-select: none;\n}\n.index_icon-Menu__xNdsd {\n  width: 45px;\n  height: 35px;\n  border-radius: 8px;\n  background-color: #ffffff;\n  margin-right: 5px;\n  box-shadow: 3px 4px 5px 3px rgba(0, 0, 0, 0.15);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  cursor: pointer;\n}\n.index_icon-Menu__xNdsd .index_icon-class__tG_Pt {\n  width: 20px;\n  height: 20px;\n}\n.index_tabs-container__3siXm .rc-tabs-tab {\n  font-size: 12px;\n  font-weight: bold;\n  color: #aaa;\n}\n.index_tabs-container__3siXm .rc-tabs-tab-active {\n  color: #333;\n}\n.index_tabs-container__3siXm .rc-tabs-ink-bar {\n  background-color: #333333;\n  height: 2px !important;\n}\n.index_tabs-container__3siXm .rc-tabs-nav-operations {\n  display: none !important;\n}\n.index_tabs-container__3siXm .rc-tabs-nav-measure-ping-top::before,\n.index_tabs-container__3siXm .rc-tabs-nav-wrap-ping-top::before,\n.index_tabs-container__3siXm .rc-tabs-nav-measure-ping-bottom::after,\n.index_tabs-container__3siXm .rc-tabs-nav-wrap-ping-bottom::after {\n  border: 0 !important;\n}\n.index_tabs-container__3siXm .rc-tabs-nav-operations {\n  display: none !important;\n}\n.index_common-input__1fiC3 {\n  padding: 0;\n  border: none;\n  text-align: left;\n  outline: none;\n  white-space: normal;\n  word-wrap: break-word;\n  word-break: break-all;\n  resize: none;\n  width: 100%;\n  color: rgba(0, 0, 0, 0.8);\n  font-family: PingFangSC-Medium, PingFang SC;\n}\n.index_common-input__1fiC3::placeholder {\n  font-weight: 400;\n  font-family: PingFangSC-Regular, PingFang SC;\n  color: rgba(0, 0, 0, 0.3);\n}\n.index_container__SOU74 {\n  position: fixed;\n  user-select: none;\n  background-color: #fff;\n  overflow: hidden;\n  box-shadow: -2px 4px 5px 3px rgba(0, 0, 0, 0.15);\n}\n.index_container__SOU74 .index_bar__2X14O {\n  display: flex;\n  height: 38px;\n  justify-content: center;\n  align-items: center;\n  cursor: move;\n  user-select: none;\n}\n.index_container__SOU74 .index_bar__2X14O span {\n  position: absolute;\n  left: 16px;\n  font-size: 14px;\n  font-weight: bold;\n  color: #333;\n}\n.index_icon-container1__2dP4F {\n  position: absolute;\n  right: 0;\n}\n";
var styles$9 = {"rotate180":"index_rotate180__2wIRc","rotate90":"index_rotate90__1H3jl","icon-container":"index_icon-container__7joHr","icon-class":"index_icon-class__tG_Pt","icon-Menu":"index_icon-Menu__xNdsd","tabs-container":"index_tabs-container__3siXm","common-input":"index_common-input__1fiC3","container":"index_container__SOU74","bar":"index_bar__2X14O","icon-container1":"index_icon-container1__2dP4F"};
styleInject(css_248z$9);

var css_248z$a = ".index_placeholder-border__14fqv {\n  display: none;\n  top: 0;\n  left: 0;\n  position: fixed;\n  width: 100vw;\n  height: 100vh;\n  cursor: move;\n}\n";
var styles$a = {"placeholder-border":"index_placeholder-border__14fqv"};
styleInject(css_248z$a);

const DragContext = createContext(null);
const DragProvider = (props) => {
    return React.createElement(DragContext.Provider, Object.assign({}, props));
};
function useDragChange() {
    return useContext(DragContext);
}

function DragAndResize(props, ref) {
    const { onDragMoveEnd } = props;
    const moveDivRef = useRef({
        target: null,
        changeFold: (_) => _,
    });
    const getTarget = useCallback(() => moveDivRef.current.target, []);
    const [isDrag, setIsDrag] = useState(false);
    const [cursor, setCursor] = useState('move');
    const { onMove, onMoveEnd, onMoveStart } = useDragMove(getTarget);
    useImperativeHandle(ref, () => ({
        onMoveStart: (event) => {
            onMoveStart(event);
            setIsDrag(true);
        },
        ...moveDivRef.current,
    }), [onMoveStart]);
    const onMouseMove = (event) => {
        onMove(event);
        moveDivRef.current.onResize(event);
    };
    const onMouseUp = (event) => {
        setIsDrag(false);
        onMoveEnd(event);
        moveDivRef.current.onResizeEnd();
        moveDivRef.current.target.style.pointerEvents = 'auto';
        setCursor('move');
        onDragMoveEnd && onDragMoveEnd();
    };
    const onResizeStart = () => {
        setIsDrag(true);
        moveDivRef.current.target.style.pointerEvents = 'none';
    };
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { onMouseUp: onMouseUp, onMouseMove: onMouseMove, style: { display: isDrag ? 'flex' : 'none', cursor }, className: styles$a['placeholder-border'] }),
        React.createElement(DragProvider, { value: isDrag },
            React.createElement(Resizeable$1, Object.assign({ onResizeStart: onResizeStart, setCursor: setCursor }, props, { ref: moveDivRef })))));
}
var DragAndResize$1 = memo(forwardRef(DragAndResize));

var css_248z$b = ".global_rotate180__1lXiW {\n  transform: rotate(180deg);\n}\n.global_rotate90__RQCQC {\n  transform: rotate(90deg);\n  pointer-events: none;\n  transition: none;\n  cursor: auto;\n}\n.global_icon-container__RuqBC {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 40px;\n  height: 39px;\n  cursor: pointer;\n}\n.global_icon-container__RuqBC .global_icon-class__yuf8k {\n  width: 14px;\n  height: 14px;\n  user-select: none;\n}\n.global_icon-Menu__2wwy1 {\n  width: 45px;\n  height: 35px;\n  border-radius: 8px;\n  background-color: #ffffff;\n  margin-right: 5px;\n  box-shadow: 3px 4px 5px 3px rgba(0, 0, 0, 0.15);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  cursor: pointer;\n}\n.global_icon-Menu__2wwy1 .global_icon-class__yuf8k {\n  width: 20px;\n  height: 20px;\n}\n.global_tabs-container__16ciQ .rc-tabs-tab {\n  font-size: 12px;\n  font-weight: bold;\n  color: #aaa;\n}\n.global_tabs-container__16ciQ .rc-tabs-tab-active {\n  color: #333;\n}\n.global_tabs-container__16ciQ .rc-tabs-ink-bar {\n  background-color: #333333;\n  height: 2px !important;\n}\n.global_tabs-container__16ciQ .rc-tabs-nav-operations {\n  display: none !important;\n}\n.global_tabs-container__16ciQ .rc-tabs-nav-measure-ping-top::before,\n.global_tabs-container__16ciQ .rc-tabs-nav-wrap-ping-top::before,\n.global_tabs-container__16ciQ .rc-tabs-nav-measure-ping-bottom::after,\n.global_tabs-container__16ciQ .rc-tabs-nav-wrap-ping-bottom::after {\n  border: 0 !important;\n}\n.global_tabs-container__16ciQ .rc-tabs-nav-operations {\n  display: none !important;\n}\n.global_tabs-container__16ciQ .rc-tabs-nav-measure-ping-left::before,\n.global_tabs-container__16ciQ .rc-tabs-nav-wrap-ping-left::before {\n  border-left-width: 0px;\n}\n.global_common-input__3Ujg1 {\n  padding: 0;\n  border: none;\n  text-align: left;\n  outline: none;\n  white-space: normal;\n  word-wrap: break-word;\n  word-break: break-all;\n  resize: none;\n  width: 100%;\n  color: rgba(0, 0, 0, 0.8);\n  font-family: PingFangSC-Medium, PingFang SC;\n}\n.global_common-input__3Ujg1::placeholder {\n  font-weight: 400;\n  font-family: PingFangSC-Regular, PingFang SC;\n  color: rgba(0, 0, 0, 0.3);\n}\n";
var styles$b = {"rotate180":"global_rotate180__1lXiW","rotate90":"global_rotate90__RQCQC","icon-container":"global_icon-container__RuqBC","icon-class":"global_icon-class__yuf8k","icon-Menu":"global_icon-Menu__2wwy1","tabs-container":"global_tabs-container__16ciQ","common-input":"global_common-input__3Ujg1"};
styleInject(css_248z$b);

function BarButton(props, ref) {
    const { icon, dragResizeRef, onCheckChange, children, defaultShow = true, checkboxClass, defaultPosition, checkedIcon = icon, uncheckedIcon = icon, iconClass } = props;
    const originPositionRef = useRef({});
    const iconRef = useRef();
    const [isChecked, setIsChecked] = useState(defaultShow);
    useImperativeHandle(ref, () => ({ closePanel: onChangeMax }));
    const prevDefaultPosition = usePrevious(defaultPosition);
    const getOriginPosition = useCallback(() => {
        const { left, top, width, height, } = iconRef.current.getBoundingClientRect();
        originPositionRef.current.targetLeft = left + 'px';
        originPositionRef.current.targetTop = top + 'px';
        originPositionRef.current.targetWidth = width + 'px';
        originPositionRef.current.targetHeight = height + 'px';
    }, []);
    useEffect(() => {
        if (!defaultShow) {
            dragResizeRef.current.target.style.visibility = 'hidden';
        }
    }, []);
    useEffect(() => {
        if (!isEmpty(defaultPosition)) {
            const { top, left, width, height } = defaultPosition;
            originPositionRef.current.targetLeft = left + 'px';
            originPositionRef.current.targetTop = top + 'px';
            originPositionRef.current.targetWidth = width + 'px';
            originPositionRef.current.targetHeight = height + 'px';
            return;
        }
        getOriginPosition();
        addEventListener('resize', getOriginPosition);
        return () => {
            removeEventListener('resize', getOriginPosition);
        };
    }, [isEqual(defaultPosition, prevDefaultPosition), originPositionRef]);
    const closePanel = useCallback(() => {
        const { target } = dragResizeRef.current;
        const { top, left, width, height } = getComputedStyle(target);
        const { targetTop, targetLeft, targetHeight, targetWidth, } = originPositionRef.current;
        merge(originPositionRef.current, { top, left, width, height });
        target.style.cssText = `top:${targetTop};left:${targetLeft};width:${targetWidth};height:${targetHeight};transition:all 500ms;`;
        target.style.visibility = 'hidden';
    }, []);
    const onChangeMax = useCallback((event) => {
        event.stopPropagation && event.stopPropagation();
        const target = dragResizeRef.current.target;
        if (isChecked) {
            closePanel();
        }
        else {
            const { top, left, width, height } = originPositionRef.current;
            target.style.cssText = `top:${top};left:${left};width:${width};height:${height};transition:all 500ms;visibility:visible;`;
        }
        setIsChecked(!isChecked);
        onCheckChange && onCheckChange(!isChecked);
    }, [setIsChecked, isChecked]);
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { ref: iconRef, onClick: onChangeMax, className: `${styles$b['icon-Menu']} ${checkboxClass}` },
            React.createElement("img", { src: isChecked ? uncheckedIcon : checkedIcon, className: `${styles$b['icon-class']} ${iconClass}` })),
        children));
}
var BarButton$1 = memo(forwardRef(BarButton));

function DragResizeBar(props) {
    const { children, title, className, icon, barStyle, ...rest } = props;
    const dragResizeRef = useRef();
    const barButtonRef = useRef();
    const onClick = useCallback((e) => {
        e.stopPropagation();
        barButtonRef.current.closePanel(e);
    }, []);
    const onMoveStart = useCallback((event) => {
        dragResizeRef.current.onMoveStart(event);
    }, []);
    return (React.createElement(BarButton$1, Object.assign({ icon: icon, dragResizeRef: dragResizeRef, ref: barButtonRef }, rest),
        React.createElement(DragAndResize$1, Object.assign({ onWheel: (event) => event.stopPropagation(), className: `${styles$9['container']} ${className}` }, rest, { ref: dragResizeRef }),
            React.createElement("div", { onMouseDown: onMoveStart, style: barStyle, className: styles$9['bar'] },
                React.createElement("span", null, title),
                React.createElement(Icon$1, { onMouseDown: (event) => event.stopPropagation(), onClick: onClick, icon: img$e, className: `${styles$9['icon-container']} ${styles$9['icon-container1']}`, iconClass: styles$9['icon-class'] })),
            children)));
}
var DragResizeBar$1 = memo(DragResizeBar);

function Layers() {
    const [visible, setVisible] = useState(false);
    const deleteLayerName = useRef();
    const confirmDelete = () => {
        deleteLayers({ layerName: deleteLayerName.current });
        setVisible(!visible);
    };
    const cancelDelete = () => {
        setVisible(!visible);
        deleteLayerName.current = undefined;
    };
    const onDelete = (layerName) => {
        deleteLayerName.current = layerName;
        setVisible(!visible);
    };
    return (React.createElement(DragResizeBar$1, { title: 'Layers', className: styles$3['container'], minWidth: 212, icon: img$d, key: 'Layers' },
        React.createElement(Pages$1, { onDelete: onDelete }),
        React.createElement(BrickTree$1, null),
        React.createElement(Tips$1, { icon: img$a, tip: '删除不可逆', tipTitle: '注意', cancelText: '取消', cancelCallBack: cancelDelete, confirmCallBack: confirmDelete, confirmText: '确定', visible: visible })));
}
var Layers$1 = memo(Layers);

var css_248z$c = ".index_rotate180__2X1Qn {\n  transform: rotate(180deg);\n}\n.index_rotate90__3Qtzr {\n  transform: rotate(90deg);\n}\n.index_icon-container__poIEV {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 40px;\n  height: 39px;\n  cursor: pointer;\n}\n.index_icon-container__poIEV .index_icon-class__1FdUt {\n  width: 14px;\n  height: 14px;\n  user-select: none;\n}\n.index_icon-Menu__8p5rH {\n  width: 45px;\n  height: 35px;\n  border-radius: 8px;\n  background-color: #ffffff;\n  margin-right: 5px;\n  box-shadow: 3px 4px 5px 3px rgba(0, 0, 0, 0.15);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  cursor: pointer;\n}\n.index_icon-Menu__8p5rH .index_icon-class__1FdUt {\n  width: 20px;\n  height: 20px;\n}\n.index_tabs-container__gGfcs .rc-tabs-tab {\n  font-size: 12px;\n  font-weight: bold;\n  color: #aaa;\n}\n.index_tabs-container__gGfcs .rc-tabs-tab-active {\n  color: #333;\n}\n.index_tabs-container__gGfcs .rc-tabs-ink-bar {\n  background-color: #333333;\n  height: 2px !important;\n}\n.index_tabs-container__gGfcs .rc-tabs-nav-operations {\n  display: none !important;\n}\n.index_tabs-container__gGfcs .rc-tabs-nav-measure-ping-top::before,\n.index_tabs-container__gGfcs .rc-tabs-nav-wrap-ping-top::before,\n.index_tabs-container__gGfcs .rc-tabs-nav-measure-ping-bottom::after,\n.index_tabs-container__gGfcs .rc-tabs-nav-wrap-ping-bottom::after {\n  border: 0 !important;\n}\n.index_tabs-container__gGfcs .rc-tabs-nav-operations {\n  display: none !important;\n}\n.index_common-input__2r3fm {\n  padding: 0;\n  border: none;\n  text-align: left;\n  outline: none;\n  white-space: normal;\n  word-wrap: break-word;\n  word-break: break-all;\n  resize: none;\n  width: 100%;\n  color: rgba(0, 0, 0, 0.8);\n  font-family: PingFangSC-Medium, PingFang SC;\n}\n.index_common-input__2r3fm::placeholder {\n  font-weight: 400;\n  font-family: PingFangSC-Regular, PingFang SC;\n  color: rgba(0, 0, 0, 0.3);\n}\n.index_panel-container__3zHnO {\n  display: flex;\n  position: fixed !important;\n  flex-direction: column;\n  align-items: center;\n  top: 70px;\n  height: calc(100vh - 150px);\n  width: 212px;\n  border-radius: 8px;\n  user-select: none;\n  background-color: #fff;\n  overflow: hidden;\n  box-shadow: 3px 4px 5px 3px rgba(0, 0, 0, 0.15);\n}\n.index_panel-container__3zHnO .index_brickd-tabs__2zYa0 {\n  display: flex;\n  width: 100%;\n}\n.index_panel-container__3zHnO .index_brickd-tabs__2zYa0 .rc-tabs-tab {\n  font-size: 12px;\n  font-weight: bold;\n  color: #aaa;\n}\n.index_panel-container__3zHnO .index_brickd-tabs__2zYa0 .rc-tabs-tab-active {\n  color: #333;\n}\n.index_panel-container__3zHnO .index_brickd-tabs__2zYa0 .rc-tabs-ink-bar {\n  background-color: #333333;\n  height: 2px !important;\n}\n.index_panel-container__3zHnO .index_brickd-tabs__2zYa0 .rc-tabs-nav-operations {\n  display: none !important;\n}\n.index_panel-container__3zHnO .index_brickd-tabs__2zYa0 .rc-tabs-nav-measure-ping-top::before,\n.index_panel-container__3zHnO .index_brickd-tabs__2zYa0 .rc-tabs-nav-wrap-ping-top::before,\n.index_panel-container__3zHnO .index_brickd-tabs__2zYa0 .rc-tabs-nav-measure-ping-bottom::after,\n.index_panel-container__3zHnO .index_brickd-tabs__2zYa0 .rc-tabs-nav-wrap-ping-bottom::after {\n  border: 0 !important;\n}\n.index_panel-container__3zHnO .index_brickd-tabs__2zYa0 .rc-tabs-nav-operations {\n  display: none !important;\n}\n.index_tab-drag-bar__2C0yf {\n  width: 100%;\n  height: 10px;\n  background-color: #0000;\n  cursor: move;\n}\n";
var styles$c = {"rotate180":"index_rotate180__2X1Qn","rotate90":"index_rotate90__3Qtzr","icon-container":"index_icon-container__poIEV","icon-class":"index_icon-class__1FdUt","icon-Menu":"index_icon-Menu__8p5rH","tabs-container":"index_tabs-container__gGfcs","common-input":"index_common-input__2r3fm","panel-container":"index_panel-container__3zHnO","brickd-tabs":"index_brickd-tabs__2zYa0","tab-drag-bar":"index_tab-drag-bar__2C0yf"};
styleInject(css_248z$c);

function BarTabs(props) {
    const { icon, children, className, ...rest } = props;
    const [activeKey, setActiveKey] = useState('1');
    const dragResizeRef = useRef();
    const barButtonRef = useRef();
    const onClick = useCallback((event) => {
        barButtonRef.current.closePanel(event);
    }, []);
    const onTabChange = (key) => {
        setActiveKey(key);
    };
    const onMoveStart = useCallback((event) => {
        event.preventDefault();
        dragResizeRef.current.onMoveStart(event);
    }, []);
    return (React.createElement(BarButton$1, { icon: icon, dragResizeRef: dragResizeRef, ref: barButtonRef },
        React.createElement(DragAndResize$1, Object.assign({ minWidth: 212 }, rest, { onWheel: (event) => event.stopPropagation(), ref: dragResizeRef, className: `${styles$c['panel-container']} ${className}` }),
            React.createElement("div", { onMouseDown: onMoveStart, className: styles$c['tab-drag-bar'] }),
            React.createElement(Tabs, { className: styles$c['brickd-tabs'], style: { border: 0 }, activeKey: activeKey, 
                // tabBarStyle={{ height: 39 }}
                tabBarGutter: 16, tabBarExtraContent: React.createElement(Icon$1, { onClick: onClick, icon: img$e, className: styles$c['icon-container'], iconClass: styles$c['icon-class'] }), onChange: onTabChange }, children))));
}
var BarTabs$1 = memo(BarTabs);

var css_248z$d = ".index_rotate180__MxQIf {\n  transform: rotate(180deg);\n}\n.index_rotate90__14y6C {\n  transform: rotate(90deg);\n}\n.index_icon-container__w6_QP {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 40px;\n  height: 39px;\n  cursor: pointer;\n}\n.index_icon-container__w6_QP .index_icon-class__3eUFW {\n  width: 14px;\n  height: 14px;\n  user-select: none;\n}\n.index_icon-Menu__2wDA6 {\n  width: 45px;\n  height: 35px;\n  border-radius: 8px;\n  background-color: #ffffff;\n  margin-right: 5px;\n  box-shadow: 3px 4px 5px 3px rgba(0, 0, 0, 0.15);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  cursor: pointer;\n}\n.index_icon-Menu__2wDA6 .index_icon-class__3eUFW {\n  width: 20px;\n  height: 20px;\n}\n.index_tabs-container__18vFp .rc-tabs-tab {\n  font-size: 12px;\n  font-weight: bold;\n  color: #aaa;\n}\n.index_tabs-container__18vFp .rc-tabs-tab-active {\n  color: #333;\n}\n.index_tabs-container__18vFp .rc-tabs-ink-bar {\n  background-color: #333333;\n  height: 2px !important;\n}\n.index_tabs-container__18vFp .rc-tabs-nav-operations {\n  display: none !important;\n}\n.index_tabs-container__18vFp .rc-tabs-nav-measure-ping-top::before,\n.index_tabs-container__18vFp .rc-tabs-nav-wrap-ping-top::before,\n.index_tabs-container__18vFp .rc-tabs-nav-measure-ping-bottom::after,\n.index_tabs-container__18vFp .rc-tabs-nav-wrap-ping-bottom::after {\n  border: 0 !important;\n}\n.index_tabs-container__18vFp .rc-tabs-nav-operations {\n  display: none !important;\n}\n.index_common-input__2KjBP {\n  padding: 0;\n  border: none;\n  text-align: left;\n  outline: none;\n  white-space: normal;\n  word-wrap: break-word;\n  word-break: break-all;\n  resize: none;\n  width: 100%;\n  color: rgba(0, 0, 0, 0.8);\n  font-family: PingFangSC-Medium, PingFang SC;\n}\n.index_common-input__2KjBP::placeholder {\n  font-weight: 400;\n  font-family: PingFangSC-Regular, PingFang SC;\n  color: rgba(0, 0, 0, 0.3);\n}\n.index_container__OO8kQ {\n  display: flex;\n  align-items: center;\n  position: relative;\n}\n.index_container__OO8kQ .index_close-icon__2uq6z {\n  width: 12px;\n  height: 12px;\n  margin-left: 3px;\n}\n";
var styles$d = {"rotate180":"index_rotate180__MxQIf","rotate90":"index_rotate90__14y6C","icon-container":"index_icon-container__w6_QP","icon-class":"index_icon-class__3eUFW","icon-Menu":"index_icon-Menu__2wDA6","tabs-container":"index_tabs-container__18vFp","common-input":"index_common-input__2KjBP","container":"index_container__OO8kQ","close-icon":"index_close-icon__2uq6z"};
styleInject(css_248z$d);

function Input(props, ref) {
    const { type, onChange, closeStyle, closeAble = true, className, inputClass, focusClass, defaultValue, addonAfter, addonBefore, value: v, ...rest } = props;
    const [value, setValue] = useState(v || defaultValue);
    const forceRender = useForceRender();
    const isFocusRef = useRef(false);
    useImperativeHandle(ref, () => ({
        setValue,
    }), [setValue]);
    useEffect(() => {
        if (value === undefined) {
            setValue(v);
        }
    }, [v, value, setValue]);
    const change = (event) => {
        const value = event.target.value;
        setValue(value);
        onChange && onChange(value);
    };
    const clean = (event) => {
        event.stopPropagation();
        setValue('');
        onChange && onChange(undefined);
    };
    const onFocus = () => {
        isFocusRef.current = true;
        forceRender();
    };
    const onBlur = () => {
        isFocusRef.current = false;
        setTimeout(forceRender, 200);
    };
    return (React.createElement("div", { className: `${styles$d['container']} ${className} ${isFocusRef.current && focusClass}` },
        !!addonBefore && addonBefore,
        React.createElement("input", Object.assign({ type: type || 'text', className: `${styles$d['common-input']} ${inputClass}`, onBlur: onBlur, onFocus: onFocus }, rest, { onChange: change, value: value })),
        !!addonAfter && addonAfter,
        !!value && isFocusRef.current && closeAble && (React.createElement("img", { src: img$1, style: closeStyle, onClick: clean, className: styles$d['close-icon'] }))));
}
var Input$1 = memo(forwardRef(Input));

var css_248z$e = ".index_rotate180__2wKlb {\n  transform: rotate(180deg);\n}\n.index_rotate90__2_fn8 {\n  transform: rotate(90deg);\n}\n.index_icon-container__C9N0a {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 40px;\n  height: 39px;\n  cursor: pointer;\n}\n.index_icon-container__C9N0a .index_icon-class__2oelJ {\n  width: 14px;\n  height: 14px;\n  user-select: none;\n}\n.index_icon-Menu__1b-W0 {\n  width: 45px;\n  height: 35px;\n  border-radius: 8px;\n  background-color: #ffffff;\n  margin-right: 5px;\n  box-shadow: 3px 4px 5px 3px rgba(0, 0, 0, 0.15);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  cursor: pointer;\n}\n.index_icon-Menu__1b-W0 .index_icon-class__2oelJ {\n  width: 20px;\n  height: 20px;\n}\n.index_tabs-container__2rhwo .rc-tabs-tab {\n  font-size: 12px;\n  font-weight: bold;\n  color: #aaa;\n}\n.index_tabs-container__2rhwo .rc-tabs-tab-active {\n  color: #333;\n}\n.index_tabs-container__2rhwo .rc-tabs-ink-bar {\n  background-color: #333333;\n  height: 2px !important;\n}\n.index_tabs-container__2rhwo .rc-tabs-nav-operations {\n  display: none !important;\n}\n.index_tabs-container__2rhwo .rc-tabs-nav-measure-ping-top::before,\n.index_tabs-container__2rhwo .rc-tabs-nav-wrap-ping-top::before,\n.index_tabs-container__2rhwo .rc-tabs-nav-measure-ping-bottom::after,\n.index_tabs-container__2rhwo .rc-tabs-nav-wrap-ping-bottom::after {\n  border: 0 !important;\n}\n.index_tabs-container__2rhwo .rc-tabs-nav-operations {\n  display: none !important;\n}\n.index_common-input__1nGul {\n  padding: 0;\n  border: none;\n  text-align: left;\n  outline: none;\n  white-space: normal;\n  word-wrap: break-word;\n  word-break: break-all;\n  resize: none;\n  width: 100%;\n  color: rgba(0, 0, 0, 0.8);\n  font-family: PingFangSC-Medium, PingFang SC;\n}\n.index_common-input__1nGul::placeholder {\n  font-weight: 400;\n  font-family: PingFangSC-Regular, PingFang SC;\n  color: rgba(0, 0, 0, 0.3);\n}\n.index_container__1ryNb {\n  display: flex;\n  align-items: center;\n}\n.index_container__1ryNb .index_icon__3cEW3 {\n  font-size: 16px;\n  padding: 3px;\n  cursor: pointer;\n}\n.index_container__1ryNb .index_unit__1AppN {\n  font-size: 12px;\n}\n.index_container__1ryNb .index_input-number__2mPrZ {\n  width: 45px;\n  font-size: 12px;\n  text-align: center;\n  appearance: none;\n  border: none;\n  outline: none;\n  border-bottom: 1px #f2f2f2 solid;\n}\n.index_container__1ryNb .index_input-number__2mPrZ:hover,\n.index_container__1ryNb .index_input-number__2mPrZ:focus {\n  border-bottom: 1px #388bfe solid;\n}\n.index_container__1ryNb .index_input-number__2mPrZ::-webkit-outer-spin-button,\n.index_container__1ryNb .index_input-number__2mPrZ::-webkit-inner-spin-button {\n  -webkit-appearance: none;\n  appearance: none;\n  margin: 0;\n}\n";
var styles$e = {"rotate180":"index_rotate180__2wKlb","rotate90":"index_rotate90__2_fn8","icon-container":"index_icon-container__C9N0a","icon-class":"index_icon-class__2oelJ","icon-Menu":"index_icon-Menu__1b-W0","tabs-container":"index_tabs-container__2rhwo","common-input":"index_common-input__1nGul","container":"index_container__1ryNb","icon":"index_icon__3cEW3","unit":"index_unit__1AppN","input-number":"index_input-number__2mPrZ"};
styleInject(css_248z$e);

function InputNumber(props) {
    const { className, config, value, onChange, ...rest } = props;
    const { unit } = config || {};
    const inputNumberRef = useRef();
    let newValue = value;
    if (typeof value === 'string' && unit) {
        newValue = Number(unit.replace(unit, ''));
    }
    const onChangeValue = (event) => {
        let value = event.target.value;
        if (unit) {
            value = value + unit;
        }
        onChange && onChange(value);
    };
    const add = () => {
        inputNumberRef.current.stepUp(1);
    };
    const minus = () => {
        inputNumberRef.current.stepDown(1);
    };
    return (React.createElement("div", { className: `${styles$e['container']} ${className}` },
        React.createElement("span", { onClick: minus, className: styles$e['icon'] }, "-"),
        React.createElement("input", Object.assign({ ref: inputNumberRef, className: styles$e['input-number'], defaultValue: 0, type: 'number', value: newValue, onChange: onChangeValue }, rest)),
        !!unit && React.createElement("span", { className: styles$e['unit'] }, unit),
        React.createElement("span", { onClick: add, className: styles$e['icon'] }, "+")));
}
var InputNumber$1 = memo(InputNumber);

var css_248z$f = ".index_rotate180__1wQQo {\n  transform: rotate(180deg);\n}\n.index_rotate90__2hJdJ {\n  transform: rotate(90deg);\n}\n.index_icon-container__12UUb {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 40px;\n  height: 39px;\n  cursor: pointer;\n}\n.index_icon-container__12UUb .index_icon-class__2gDMj {\n  width: 14px;\n  height: 14px;\n  user-select: none;\n}\n.index_icon-Menu__GTpM9 {\n  width: 45px;\n  height: 35px;\n  border-radius: 8px;\n  background-color: #ffffff;\n  margin-right: 5px;\n  box-shadow: 3px 4px 5px 3px rgba(0, 0, 0, 0.15);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  cursor: pointer;\n}\n.index_icon-Menu__GTpM9 .index_icon-class__2gDMj {\n  width: 20px;\n  height: 20px;\n}\n.index_tabs-container__1ZCp2 .rc-tabs-tab {\n  font-size: 12px;\n  font-weight: bold;\n  color: #aaa;\n}\n.index_tabs-container__1ZCp2 .rc-tabs-tab-active {\n  color: #333;\n}\n.index_tabs-container__1ZCp2 .rc-tabs-ink-bar {\n  background-color: #333333;\n  height: 2px !important;\n}\n.index_tabs-container__1ZCp2 .rc-tabs-nav-operations {\n  display: none !important;\n}\n.index_tabs-container__1ZCp2 .rc-tabs-nav-measure-ping-top::before,\n.index_tabs-container__1ZCp2 .rc-tabs-nav-wrap-ping-top::before,\n.index_tabs-container__1ZCp2 .rc-tabs-nav-measure-ping-bottom::after,\n.index_tabs-container__1ZCp2 .rc-tabs-nav-wrap-ping-bottom::after {\n  border: 0 !important;\n}\n.index_tabs-container__1ZCp2 .rc-tabs-nav-operations {\n  display: none !important;\n}\n.index_common-input__3VmDq {\n  padding: 0;\n  border: none;\n  text-align: left;\n  outline: none;\n  white-space: normal;\n  word-wrap: break-word;\n  word-break: break-all;\n  resize: none;\n  width: 100%;\n  color: rgba(0, 0, 0, 0.8);\n  font-family: PingFangSC-Medium, PingFang SC;\n}\n.index_common-input__3VmDq::placeholder {\n  font-weight: 400;\n  font-family: PingFangSC-Regular, PingFang SC;\n  color: rgba(0, 0, 0, 0.3);\n}\n.index_menu-container__2w3WT {\n  position: absolute;\n  z-index: 1000;\n  display: flex;\n  flex-direction: column;\n  border-radius: 7px;\n  padding-left: 10px;\n}\n.index_menu-container__2w3WT .index_menu-item__2iEt_ {\n  font-size: 12px;\n  color: #333;\n  height: 30px;\n  display: flex;\n  align-items: center;\n}\n";
var styles$f = {"rotate180":"index_rotate180__1wQQo","rotate90":"index_rotate90__2hJdJ","icon-container":"index_icon-container__12UUb","icon-class":"index_icon-class__2gDMj","icon-Menu":"index_icon-Menu__GTpM9","tabs-container":"index_tabs-container__1ZCp2","common-input":"index_common-input__3VmDq","menu-container":"index_menu-container__2w3WT","menu-item":"index_menu-item__2iEt_"};
styleInject(css_248z$f);

function MenuItem(props) {
    const { menuData: { menuName, onClick }, } = props;
    return (React.createElement("div", { className: styles$f['menu-item'], onClick: onClick || undefined }, menuName));
}
function Menu(props) {
    const { menus } = props;
    return (React.createElement("div", { className: styles$f['menu-container'] }, map(menus, (menuData, index) => (React.createElement(MenuItem, { menuData: menuData, key: index })))));
}
memo(Menu);

var css_248z$g = ".index_radio-item__2zoQW {\n  padding: 3px;\n  text-align: center;\n  border: 1px #bcbcbc solid;\n  border-right: 0px;\n  flex: 1;\n  font-size: 12px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n.index_isSelected__f8zTs {\n  border-color: #388bfe;\n  color: #fff;\n  background-color: #388bfe;\n}\n.index_isLast__1JoYx {\n  border-top-right-radius: 4px;\n  border-bottom-right-radius: 4px;\n  border-right: 1px #bcbcbc solid;\n}\n.index_isFirst__6m65I {\n  border-top-left-radius: 4px;\n  border-bottom-left-radius: 4px;\n}\n.index_radio-group__16YSL {\n  display: flex;\n  width: 100%;\n}\n";
var styles$g = {"radio-item":"index_radio-item__2zoQW","isSelected":"index_isSelected__f8zTs","isLast":"index_isLast__1JoYx","isFirst":"index_isFirst__6m65I","radio-group":"index_radio-group__16YSL"};
styleInject(css_248z$g);

function Radio(props) {
    const { onChange, targetValue, value, selectedStyle, unselectedStyle, isFirst, isLast, ...rest } = props;
    const isSelected = targetValue === value;
    const onClick = () => {
        onChange && onChange(!value || !isSelected ? targetValue : undefined);
    };
    return (React.createElement("span", Object.assign({ onClick: onClick, className: `${styles$g['radio-item']} 
							 ${isFirst && styles$g['isFirst']} 
							 ${isLast && styles$g['isLast']}
							 ${isSelected && styles$g['isSelected']}
							 `, style: isSelected ? selectedStyle : unselectedStyle }, rest), targetValue));
}
function RadioGroup(props) {
    const { radioData, className, ...rest } = props;
    return (React.createElement("div", { className: `${styles$g['radio-group']} ${className}` }, map(radioData, (v, index) => {
        return (React.createElement(Radio, Object.assign({ targetValue: v, isFirst: index === 0, isLast: radioData.length - 1 === index }, rest, { key: v })));
    })));
}
var Radio$1 = memo(RadioGroup);

var css_248z$h = ".index_rotate180__SHQYV {\n  transform: rotate(180deg);\n}\n.index_rotate90__puhbm {\n  transform: rotate(90deg);\n}\n.index_icon-container__YfLyf {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 40px;\n  height: 39px;\n  cursor: pointer;\n}\n.index_icon-container__YfLyf .index_icon-class__1Uwhb {\n  width: 14px;\n  height: 14px;\n  user-select: none;\n}\n.index_icon-Menu__g_ktn {\n  width: 45px;\n  height: 35px;\n  border-radius: 8px;\n  background-color: #ffffff;\n  margin-right: 5px;\n  box-shadow: 3px 4px 5px 3px rgba(0, 0, 0, 0.15);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  cursor: pointer;\n}\n.index_icon-Menu__g_ktn .index_icon-class__1Uwhb {\n  width: 20px;\n  height: 20px;\n}\n.index_tabs-container__1LRSP .rc-tabs-tab {\n  font-size: 12px;\n  font-weight: bold;\n  color: #aaa;\n}\n.index_tabs-container__1LRSP .rc-tabs-tab-active {\n  color: #333;\n}\n.index_tabs-container__1LRSP .rc-tabs-ink-bar {\n  background-color: #333333;\n  height: 2px !important;\n}\n.index_tabs-container__1LRSP .rc-tabs-nav-operations {\n  display: none !important;\n}\n.index_tabs-container__1LRSP .rc-tabs-nav-measure-ping-top::before,\n.index_tabs-container__1LRSP .rc-tabs-nav-wrap-ping-top::before,\n.index_tabs-container__1LRSP .rc-tabs-nav-measure-ping-bottom::after,\n.index_tabs-container__1LRSP .rc-tabs-nav-wrap-ping-bottom::after {\n  border: 0 !important;\n}\n.index_tabs-container__1LRSP .rc-tabs-nav-operations {\n  display: none !important;\n}\n.index_common-input__2miYK {\n  padding: 0;\n  border: none;\n  text-align: left;\n  outline: none;\n  white-space: normal;\n  word-wrap: break-word;\n  word-break: break-all;\n  resize: none;\n  width: 100%;\n  color: rgba(0, 0, 0, 0.8);\n  font-family: PingFangSC-Medium, PingFang SC;\n}\n.index_common-input__2miYK::placeholder {\n  font-weight: 400;\n  font-family: PingFangSC-Regular, PingFang SC;\n  color: rgba(0, 0, 0, 0.3);\n}\n.index_container__3gPgk {\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  border: 1px #f2f2f2 solid;\n  border-radius: 4px;\n  padding-left: 3px;\n}\n.index_container__3gPgk .index_select__1kawk {\n  border: none;\n  outline: none;\n  width: 100%;\n  appearance: none;\n}\n.index_container__3gPgk .index_icon__EhXQk {\n  margin-right: 10px;\n}\n";
var styles$h = {"rotate180":"index_rotate180__SHQYV","rotate90":"index_rotate90__puhbm","icon-container":"index_icon-container__YfLyf","icon-class":"index_icon-class__1Uwhb","icon-Menu":"index_icon-Menu__g_ktn","tabs-container":"index_tabs-container__1LRSP","common-input":"index_common-input__2miYK","container":"index_container__3gPgk","select":"index_select__1kawk","icon":"index_icon__EhXQk"};
styleInject(css_248z$h);

function Select(props) {
    const { enumData, value, className, ...rest } = props;
    return (React.createElement("div", { className: `${styles$h['container']} ${className}` },
        React.createElement("select", Object.assign({ value: value, className: styles$h['select'] }, rest), map(enumData, (data) => (React.createElement("option", { key: data }, data)))),
        React.createElement(Icon$1, { className: styles$h['icon'], icon: img$q })));
}
var Select$1 = memo(Select);

var css_248z$i = ".index_fold-container__2OvWp .index_fold-content__2A9us {\n  display: flex;\n  flex-wrap: wrap;\n}\n.index_fold-container__2OvWp .rc-collapse-content {\n  padding: 0;\n}\n.index_fold-container__2OvWp .rc-collapse-content > .rc-collapse-content-box {\n  margin-bottom: 0;\n  margin-top: 0;\n}\n.index_fold-container__2OvWp .index_fold-panel-header__2xU7U {\n  padding: 0 !important;\n}\n";
var styles$i = {"fold-container":"index_fold-container__2OvWp","fold-content":"index_fold-content__2A9us","fold-panel-header":"index_fold-panel-header__2xU7U"};
styleInject(css_248z$i);

function NCollapse(props) {
    const { categories, header, renderItem, className, panelContentClass, style, headerClass, collapseClass, } = props;
    const [openKeys = [], setOpenKeys] = useState([]);
    const onChange = (keys) => { setOpenKeys(keys); };
    return (React.createElement("div", { style: style, className: `${styles$i['fold-container']} ${className}` },
        React.createElement(Collapse, { className: collapseClass, activeKey: openKeys, style: { border: 0 }, onChange: onChange }, map(categories, (categoryInfo, categoryName) => {
            const isFold = openKeys.includes(categoryName);
            return (React.createElement(Panel, { headerClass: `${styles$i['fold-panel-header']} ${headerClass}`, style: { border: 0, padding: 0 }, header: header(categoryName, isFold), key: categoryName, showArrow: false },
                React.createElement("div", { className: `${styles$i['fold-content']} ${panelContentClass}` }, map(categoryInfo, renderItem))));
        }))));
}
var NCollapse$1 = memo(NCollapse);

var css_248z$j = ".index_rotate180__3lB4a {\n  transform: rotate(180deg);\n}\n.index_rotate90__3Avvx {\n  transform: rotate(90deg);\n}\n.index_icon-container__9YCdY {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 40px;\n  height: 39px;\n  cursor: pointer;\n}\n.index_icon-container__9YCdY .index_icon-class__OxxYI {\n  width: 14px;\n  height: 14px;\n  user-select: none;\n}\n.index_icon-Menu__paUqr {\n  width: 45px;\n  height: 35px;\n  border-radius: 8px;\n  background-color: #ffffff;\n  margin-right: 5px;\n  box-shadow: 3px 4px 5px 3px rgba(0, 0, 0, 0.15);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  cursor: pointer;\n}\n.index_icon-Menu__paUqr .index_icon-class__OxxYI {\n  width: 20px;\n  height: 20px;\n}\n.index_tabs-container__3CWJB .rc-tabs-tab {\n  font-size: 12px;\n  font-weight: bold;\n  color: #aaa;\n}\n.index_tabs-container__3CWJB .rc-tabs-tab-active {\n  color: #333;\n}\n.index_tabs-container__3CWJB .rc-tabs-ink-bar {\n  background-color: #333333;\n  height: 2px !important;\n}\n.index_tabs-container__3CWJB .rc-tabs-nav-operations {\n  display: none !important;\n}\n.index_tabs-container__3CWJB .rc-tabs-nav-measure-ping-top::before,\n.index_tabs-container__3CWJB .rc-tabs-nav-wrap-ping-top::before,\n.index_tabs-container__3CWJB .rc-tabs-nav-measure-ping-bottom::after,\n.index_tabs-container__3CWJB .rc-tabs-nav-wrap-ping-bottom::after {\n  border: 0 !important;\n}\n.index_tabs-container__3CWJB .rc-tabs-nav-operations {\n  display: none !important;\n}\n.index_common-input__1UvAZ {\n  padding: 0;\n  border: none;\n  text-align: left;\n  outline: none;\n  white-space: normal;\n  word-wrap: break-word;\n  word-break: break-all;\n  resize: none;\n  width: 100%;\n  color: rgba(0, 0, 0, 0.8);\n  font-family: PingFangSC-Medium, PingFang SC;\n}\n.index_common-input__1UvAZ::placeholder {\n  font-weight: 400;\n  font-family: PingFangSC-Regular, PingFang SC;\n  color: rgba(0, 0, 0, 0.3);\n}\n.index_form-item-container__2Swz0 {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding-bottom: 10px;\n  padding-left: 10px;\n  padding-right: 10px;\n}\n.index_form-item-container__2Swz0 .index_label__XARKq {\n  font-size: 12px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n.index_form-item-container__2Swz0 .index_title__vXo57 {\n  flex: 1;\n  display: flex;\n  width: 100%;\n  align-items: center;\n  justify-content: space-between;\n}\n.index_form-item-container__2Swz0 .index_icon-none__225qj {\n  display: none;\n  width: 15px;\n  height: 15px;\n}\n.index_form-item-container__2Swz0 .index_icon-none__225qj:hover {\n  background-color: #00000000;\n}\n.index_form-item-container__2Swz0:hover .index_icon-flex__3LAWb {\n  display: flex;\n}\n.index_form-item-container__2Swz0 .index_drop-down__3qUqw {\n  margin-left: 10px;\n}\n.index_form-item-container__2Swz0 .index_handle-container__1wNCx {\n  display: flex;\n  align-items: center;\n}\n";
var styles$j = {"rotate180":"index_rotate180__3lB4a","rotate90":"index_rotate90__3Avvx","icon-container":"index_icon-container__9YCdY","icon-class":"index_icon-class__OxxYI","icon-Menu":"index_icon-Menu__paUqr","tabs-container":"index_tabs-container__3CWJB","common-input":"index_common-input__1UvAZ","form-item-container":"index_form-item-container__2Swz0","label":"index_label__XARKq","title":"index_title__vXo57","icon-none":"index_icon-none__225qj","icon-flex":"index_icon-flex__3LAWb","drop-down":"index_drop-down__3qUqw","handle-container":"index_handle-container__1wNCx"};
styleInject(css_248z$j);

var css_248z$k = ".index_rotate180__1iOuO {\n  transform: rotate(180deg);\n}\n.index_rotate90__32BrI {\n  transform: rotate(90deg);\n}\n.index_icon-container__2YpaK {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 40px;\n  height: 39px;\n  cursor: pointer;\n}\n.index_icon-container__2YpaK .index_icon-class__3BOjp {\n  width: 14px;\n  height: 14px;\n  user-select: none;\n}\n.index_icon-Menu__8FmSt {\n  width: 45px;\n  height: 35px;\n  border-radius: 8px;\n  background-color: #ffffff;\n  margin-right: 5px;\n  box-shadow: 3px 4px 5px 3px rgba(0, 0, 0, 0.15);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  cursor: pointer;\n}\n.index_icon-Menu__8FmSt .index_icon-class__3BOjp {\n  width: 20px;\n  height: 20px;\n}\n.index_tabs-container__1byq8 .rc-tabs-tab {\n  font-size: 12px;\n  font-weight: bold;\n  color: #aaa;\n}\n.index_tabs-container__1byq8 .rc-tabs-tab-active {\n  color: #333;\n}\n.index_tabs-container__1byq8 .rc-tabs-ink-bar {\n  background-color: #333333;\n  height: 2px !important;\n}\n.index_tabs-container__1byq8 .rc-tabs-nav-operations {\n  display: none !important;\n}\n.index_tabs-container__1byq8 .rc-tabs-nav-measure-ping-top::before,\n.index_tabs-container__1byq8 .rc-tabs-nav-wrap-ping-top::before,\n.index_tabs-container__1byq8 .rc-tabs-nav-measure-ping-bottom::after,\n.index_tabs-container__1byq8 .rc-tabs-nav-wrap-ping-bottom::after {\n  border: 0 !important;\n}\n.index_tabs-container__1byq8 .rc-tabs-nav-operations {\n  display: none !important;\n}\n.index_common-input__1N4Qf {\n  padding: 0;\n  border: none;\n  text-align: left;\n  outline: none;\n  white-space: normal;\n  word-wrap: break-word;\n  word-break: break-all;\n  resize: none;\n  width: 100%;\n  color: rgba(0, 0, 0, 0.8);\n  font-family: PingFangSC-Medium, PingFang SC;\n}\n.index_common-input__1N4Qf::placeholder {\n  font-weight: 400;\n  font-family: PingFangSC-Regular, PingFang SC;\n  color: rgba(0, 0, 0, 0.3);\n}\n.index_container__e6Uq9 {\n  display: flex;\n  justify-content: center;\n  position: relative;\n}\n.index_container__e6Uq9 .index_drop-dialog__1kKGH {\n  position: absolute;\n  top: 100%;\n  right: 0;\n  background-color: #fff;\n  display: none;\n  flex-direction: column;\n  box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.2);\n  z-index: 1000;\n  border-radius: 5px;\n  overflow: hidden;\n  padding: 10px 0;\n}\n.index_container__e6Uq9 .index_drop-dialog__1kKGH .index_menu__2aAUe {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 25px;\n  font-size: 13px;\n  padding: 8px 10px;\n  border-bottom: 1px #f2f2f2 solid;\n}\n.index_container__e6Uq9 .index_drop-dialog__1kKGH .index_isLast__g8l77 {\n  border-bottom: 0;\n}\n.index_container__e6Uq9 .index_drop-dialog__1kKGH .index_selected__1lPgp {\n  background-color: #7f7f7f;\n  font-weight: bold;\n}\n.index_container__e6Uq9:hover .index_show-dialog__3xFsa {\n  display: flex;\n}\n";
var styles$k = {"rotate180":"index_rotate180__1iOuO","rotate90":"index_rotate90__32BrI","icon-container":"index_icon-container__2YpaK","icon-class":"index_icon-class__3BOjp","icon-Menu":"index_icon-Menu__8FmSt","tabs-container":"index_tabs-container__1byq8","common-input":"index_common-input__1N4Qf","container":"index_container__e6Uq9","drop-dialog":"index_drop-dialog__1kKGH","menu":"index_menu__2aAUe","isLast":"index_isLast__g8l77","selected":"index_selected__1lPgp","show-dialog":"index_show-dialog__3xFsa"};
styleInject(css_248z$k);

function Dropdown(props) {
    const { children, menus, setMenu, className, ...rest } = props;
    const [selectedMenu, setSelectedMenu] = useState();
    const onSelect = (event, menu) => {
        event.stopPropagation();
        setMenu && setMenu(menu);
        setSelectedMenu(menu);
    };
    return (React.createElement("div", Object.assign({ className: `${styles$k['container']} ${className}` }, rest),
        children,
        React.createElement("div", { className: `${styles$k['drop-dialog']} ${styles$k['show-dialog']}` }, map(menus, (menu, index) => {
            const isSelected = selectedMenu === menu;
            const isLast = menu.length - 1 === index;
            return (React.createElement("div", { onClick: (event) => onSelect(event, menu), key: menu, className: `${styles$k['menu']} ${isSelected && styles$k['selected']} ${isLast && styles$k['isLast']}` }, menu));
        }))));
}
var Dropdown$1 = memo(Dropdown);

function FormItem(props) {
    const { name, isShowLabel = true, renderFormItem, config, key, ...rest } = props;
    const [isExpression, setIsExpression] = useState(false);
    const [menu, setMenu] = useState();
    const { style, renderComponent, menus, isHidden, headerStyle, } = renderFormItem(config, name, isExpression, menu);
    const { label, formItemProps = {} } = config || {};
    return (React.createElement("div", { style: style, className: styles$j['form-item-container'] },
        isShowLabel && (React.createElement("div", { style: headerStyle, className: styles$j['title'] },
            React.createElement("span", { className: styles$j['label'] }, label || name),
            React.createElement("div", { className: styles$j['handle-container'] },
                !isHidden && (React.createElement(Checkbox$1, { uncheckedIcon: img$r, checkedIcon: img$s, onChange: (v) => setIsExpression(v), className: `${styles$j['icon-none']} ${styles$j['icon-flex']}` })),
                !!menus && (React.createElement(Dropdown$1, { className: styles$j['drop-down'], setMenu: setMenu, menus: menus },
                    React.createElement(Icon$1, { icon: img$c })))))),
        React.createElement(Field, Object.assign({ name: name }, rest), (control) => {
            control.setIsExpression = setIsExpression;
            return React.cloneElement(renderComponent, Object.assign(control, formItemProps));
        })));
}
var FormItem$1 = memo(FormItem);

function NForm(props, ref) {
    const { formConfig, renderFormItem, isShowLabel, ...rest } = props;
    return (React.createElement(Form, Object.assign({}, rest, { ref: ref }), map(formConfig, (config, key) => (React.createElement(FormItem$1, { isShowLabel: isShowLabel, renderFormItem: renderFormItem, config: config, key: key, name: key })))));
}
var NForm$1 = memo(forwardRef(NForm));

function createCommonjsModule(fn, basedir, module) {
	return module = {
	  path: basedir,
	  exports: {},
	  require: function (path, base) {
      return commonjsRequire(path, (base === undefined || base === null) ? module.path : base);
    }
	}, fn(module, module.exports), module.exports;
}

function commonjsRequire () {
	throw new Error('Dynamic requires are not currently supported by @rollup/plugin-commonjs');
}

var modeJavascript = createCommonjsModule(function (module, exports) {
  ace.define("ace/mode/doc_comment_highlight_rules", ["require", "exports", "module", "ace/lib/oop", "ace/mode/text_highlight_rules"], function (require, exports, module) {

    var oop = require("../lib/oop");

    var TextHighlightRules = require("./text_highlight_rules").TextHighlightRules;

    var DocCommentHighlightRules = function () {
      this.$rules = {
        "start": [{
          token: "comment.doc.tag",
          regex: "@[\\w\\d_]+" // TODO: fix email addresses

        }, DocCommentHighlightRules.getTagRule(), {
          defaultToken: "comment.doc",
          caseInsensitive: true
        }]
      };
    };

    oop.inherits(DocCommentHighlightRules, TextHighlightRules);

    DocCommentHighlightRules.getTagRule = function (start) {
      return {
        token: "comment.doc.tag.storage.type",
        regex: "\\b(?:TODO|FIXME|XXX|HACK)\\b"
      };
    };

    DocCommentHighlightRules.getStartRule = function (start) {
      return {
        token: "comment.doc",
        regex: "\\/\\*(?=\\*)",
        next: start
      };
    };

    DocCommentHighlightRules.getEndRule = function (start) {
      return {
        token: "comment.doc",
        regex: "\\*\\/",
        next: start
      };
    };

    exports.DocCommentHighlightRules = DocCommentHighlightRules;
  });
  ace.define("ace/mode/javascript_highlight_rules", ["require", "exports", "module", "ace/lib/oop", "ace/mode/doc_comment_highlight_rules", "ace/mode/text_highlight_rules"], function (require, exports, module) {

    var oop = require("../lib/oop");

    var DocCommentHighlightRules = require("./doc_comment_highlight_rules").DocCommentHighlightRules;

    var TextHighlightRules = require("./text_highlight_rules").TextHighlightRules;

    var identifierRe = "[a-zA-Z\\$_\u00a1-\uffff][a-zA-Z\\d\\$_\u00a1-\uffff]*";

    var JavaScriptHighlightRules = function (options) {
      var keywordMapper = this.createKeywordMapper({
        "variable.language": "Array|Boolean|Date|Function|Iterator|Number|Object|RegExp|String|Proxy|" + // Constructors
        "Namespace|QName|XML|XMLList|" + // E4X
        "ArrayBuffer|Float32Array|Float64Array|Int16Array|Int32Array|Int8Array|" + "Uint16Array|Uint32Array|Uint8Array|Uint8ClampedArray|" + "Error|EvalError|InternalError|RangeError|ReferenceError|StopIteration|" + // Errors
        "SyntaxError|TypeError|URIError|" + "decodeURI|decodeURIComponent|encodeURI|encodeURIComponent|eval|isFinite|" + // Non-constructor functions
        "isNaN|parseFloat|parseInt|" + "JSON|Math|" + // Other
        "this|arguments|prototype|window|document",
        "keyword": "const|yield|import|get|set|async|await|" + "break|case|catch|continue|default|delete|do|else|finally|for|function|" + "if|in|of|instanceof|new|return|switch|throw|try|typeof|let|var|while|with|debugger|" + "__parent__|__count__|escape|unescape|with|__proto__|" + "class|enum|extends|super|export|implements|private|public|interface|package|protected|static",
        "storage.type": "const|let|var|function",
        "constant.language": "null|Infinity|NaN|undefined",
        "support.function": "alert",
        "constant.language.boolean": "true|false"
      }, "identifier");
      var kwBeforeRe = "case|do|else|finally|in|instanceof|return|throw|try|typeof|yield|void";
      var escapedRe = "\\\\(?:x[0-9a-fA-F]{2}|" + // hex
      "u[0-9a-fA-F]{4}|" + // unicode
      "u{[0-9a-fA-F]{1,6}}|" + // es6 unicode
      "[0-2][0-7]{0,2}|" + // oct
      "3[0-7][0-7]?|" + // oct
      "[4-7][0-7]?|" + //oct
      ".)";
      this.$rules = {
        "no_regex": [DocCommentHighlightRules.getStartRule("doc-start"), comments("no_regex"), {
          token: "string",
          regex: "'(?=.)",
          next: "qstring"
        }, {
          token: "string",
          regex: '"(?=.)',
          next: "qqstring"
        }, {
          token: "constant.numeric",
          regex: /0(?:[xX][0-9a-fA-F]+|[oO][0-7]+|[bB][01]+)\b/
        }, {
          token: "constant.numeric",
          regex: /(?:\d\d*(?:\.\d*)?|\.\d+)(?:[eE][+-]?\d+\b)?/
        }, {
          token: ["storage.type", "punctuation.operator", "support.function", "punctuation.operator", "entity.name.function", "text", "keyword.operator"],
          regex: "(" + identifierRe + ")(\\.)(prototype)(\\.)(" + identifierRe + ")(\\s*)(=)",
          next: "function_arguments"
        }, {
          token: ["storage.type", "punctuation.operator", "entity.name.function", "text", "keyword.operator", "text", "storage.type", "text", "paren.lparen"],
          regex: "(" + identifierRe + ")(\\.)(" + identifierRe + ")(\\s*)(=)(\\s*)(function)(\\s*)(\\()",
          next: "function_arguments"
        }, {
          token: ["entity.name.function", "text", "keyword.operator", "text", "storage.type", "text", "paren.lparen"],
          regex: "(" + identifierRe + ")(\\s*)(=)(\\s*)(function)(\\s*)(\\()",
          next: "function_arguments"
        }, {
          token: ["storage.type", "punctuation.operator", "entity.name.function", "text", "keyword.operator", "text", "storage.type", "text", "entity.name.function", "text", "paren.lparen"],
          regex: "(" + identifierRe + ")(\\.)(" + identifierRe + ")(\\s*)(=)(\\s*)(function)(\\s+)(\\w+)(\\s*)(\\()",
          next: "function_arguments"
        }, {
          token: ["storage.type", "text", "entity.name.function", "text", "paren.lparen"],
          regex: "(function)(\\s+)(" + identifierRe + ")(\\s*)(\\()",
          next: "function_arguments"
        }, {
          token: ["entity.name.function", "text", "punctuation.operator", "text", "storage.type", "text", "paren.lparen"],
          regex: "(" + identifierRe + ")(\\s*)(:)(\\s*)(function)(\\s*)(\\()",
          next: "function_arguments"
        }, {
          token: ["text", "text", "storage.type", "text", "paren.lparen"],
          regex: "(:)(\\s*)(function)(\\s*)(\\()",
          next: "function_arguments"
        }, {
          token: "keyword",
          regex: "from(?=\\s*('|\"))"
        }, {
          token: "keyword",
          regex: "(?:" + kwBeforeRe + ")\\b",
          next: "start"
        }, {
          token: ["support.constant"],
          regex: /that\b/
        }, {
          token: ["storage.type", "punctuation.operator", "support.function.firebug"],
          regex: /(console)(\.)(warn|info|log|error|time|trace|timeEnd|assert)\b/
        }, {
          token: keywordMapper,
          regex: identifierRe
        }, {
          token: "punctuation.operator",
          regex: /[.](?![.])/,
          next: "property"
        }, {
          token: "storage.type",
          regex: /=>/,
          next: "start"
        }, {
          token: "keyword.operator",
          regex: /--|\+\+|\.{3}|===|==|=|!=|!==|<+=?|>+=?|!|&&|\|\||\?:|[!$%&*+\-~\/^]=?/,
          next: "start"
        }, {
          token: "punctuation.operator",
          regex: /[?:,;.]/,
          next: "start"
        }, {
          token: "paren.lparen",
          regex: /[\[({]/,
          next: "start"
        }, {
          token: "paren.rparen",
          regex: /[\])}]/
        }, {
          token: "comment",
          regex: /^#!.*$/
        }],
        property: [{
          token: "text",
          regex: "\\s+"
        }, {
          token: ["storage.type", "punctuation.operator", "entity.name.function", "text", "keyword.operator", "text", "storage.type", "text", "entity.name.function", "text", "paren.lparen"],
          regex: "(" + identifierRe + ")(\\.)(" + identifierRe + ")(\\s*)(=)(\\s*)(function)(?:(\\s+)(\\w+))?(\\s*)(\\()",
          next: "function_arguments"
        }, {
          token: "punctuation.operator",
          regex: /[.](?![.])/
        }, {
          token: "support.function",
          regex: /(s(?:h(?:ift|ow(?:Mod(?:elessDialog|alDialog)|Help))|croll(?:X|By(?:Pages|Lines)?|Y|To)?|t(?:op|rike)|i(?:n|zeToContent|debar|gnText)|ort|u(?:p|b(?:str(?:ing)?)?)|pli(?:ce|t)|e(?:nd|t(?:Re(?:sizable|questHeader)|M(?:i(?:nutes|lliseconds)|onth)|Seconds|Ho(?:tKeys|urs)|Year|Cursor|Time(?:out)?|Interval|ZOptions|Date|UTC(?:M(?:i(?:nutes|lliseconds)|onth)|Seconds|Hours|Date|FullYear)|FullYear|Active)|arch)|qrt|lice|avePreferences|mall)|h(?:ome|andleEvent)|navigate|c(?:har(?:CodeAt|At)|o(?:s|n(?:cat|textual|firm)|mpile)|eil|lear(?:Timeout|Interval)?|a(?:ptureEvents|ll)|reate(?:StyleSheet|Popup|EventObject))|t(?:o(?:GMTString|S(?:tring|ource)|U(?:TCString|pperCase)|Lo(?:caleString|werCase))|est|a(?:n|int(?:Enabled)?))|i(?:s(?:NaN|Finite)|ndexOf|talics)|d(?:isableExternalCapture|ump|etachEvent)|u(?:n(?:shift|taint|escape|watch)|pdateCommands)|j(?:oin|avaEnabled)|p(?:o(?:p|w)|ush|lugins.refresh|a(?:ddings|rse(?:Int|Float)?)|r(?:int|ompt|eference))|e(?:scape|nableExternalCapture|val|lementFromPoint|x(?:p|ec(?:Script|Command)?))|valueOf|UTC|queryCommand(?:State|Indeterm|Enabled|Value)|f(?:i(?:nd|le(?:ModifiedDate|Size|CreatedDate|UpdatedDate)|xed)|o(?:nt(?:size|color)|rward)|loor|romCharCode)|watch|l(?:ink|o(?:ad|g)|astIndexOf)|a(?:sin|nchor|cos|t(?:tachEvent|ob|an(?:2)?)|pply|lert|b(?:s|ort))|r(?:ou(?:nd|teEvents)|e(?:size(?:By|To)|calc|turnValue|place|verse|l(?:oad|ease(?:Capture|Events)))|andom)|g(?:o|et(?:ResponseHeader|M(?:i(?:nutes|lliseconds)|onth)|Se(?:conds|lection)|Hours|Year|Time(?:zoneOffset)?|Da(?:y|te)|UTC(?:M(?:i(?:nutes|lliseconds)|onth)|Seconds|Hours|Da(?:y|te)|FullYear)|FullYear|A(?:ttention|llResponseHeaders)))|m(?:in|ove(?:B(?:y|elow)|To(?:Absolute)?|Above)|ergeAttributes|a(?:tch|rgins|x))|b(?:toa|ig|o(?:ld|rderWidths)|link|ack))\b(?=\()/
        }, {
          token: "support.function.dom",
          regex: /(s(?:ub(?:stringData|mit)|plitText|e(?:t(?:NamedItem|Attribute(?:Node)?)|lect))|has(?:ChildNodes|Feature)|namedItem|c(?:l(?:ick|o(?:se|neNode))|reate(?:C(?:omment|DATASection|aption)|T(?:Head|extNode|Foot)|DocumentFragment|ProcessingInstruction|E(?:ntityReference|lement)|Attribute))|tabIndex|i(?:nsert(?:Row|Before|Cell|Data)|tem)|open|delete(?:Row|C(?:ell|aption)|T(?:Head|Foot)|Data)|focus|write(?:ln)?|a(?:dd|ppend(?:Child|Data))|re(?:set|place(?:Child|Data)|move(?:NamedItem|Child|Attribute(?:Node)?)?)|get(?:NamedItem|Element(?:sBy(?:Name|TagName|ClassName)|ById)|Attribute(?:Node)?)|blur)\b(?=\()/
        }, {
          token: "support.constant",
          regex: /(s(?:ystemLanguage|cr(?:ipts|ollbars|een(?:X|Y|Top|Left))|t(?:yle(?:Sheets)?|atus(?:Text|bar)?)|ibling(?:Below|Above)|ource|uffixes|e(?:curity(?:Policy)?|l(?:ection|f)))|h(?:istory|ost(?:name)?|as(?:h|Focus))|y|X(?:MLDocument|SLDocument)|n(?:ext|ame(?:space(?:s|URI)|Prop))|M(?:IN_VALUE|AX_VALUE)|c(?:haracterSet|o(?:n(?:structor|trollers)|okieEnabled|lorDepth|mp(?:onents|lete))|urrent|puClass|l(?:i(?:p(?:boardData)?|entInformation)|osed|asses)|alle(?:e|r)|rypto)|t(?:o(?:olbar|p)|ext(?:Transform|Indent|Decoration|Align)|ags)|SQRT(?:1_2|2)|i(?:n(?:ner(?:Height|Width)|put)|ds|gnoreCase)|zIndex|o(?:scpu|n(?:readystatechange|Line)|uter(?:Height|Width)|p(?:sProfile|ener)|ffscreenBuffering)|NEGATIVE_INFINITY|d(?:i(?:splay|alog(?:Height|Top|Width|Left|Arguments)|rectories)|e(?:scription|fault(?:Status|Ch(?:ecked|arset)|View)))|u(?:ser(?:Profile|Language|Agent)|n(?:iqueID|defined)|pdateInterval)|_content|p(?:ixelDepth|ort|ersonalbar|kcs11|l(?:ugins|atform)|a(?:thname|dding(?:Right|Bottom|Top|Left)|rent(?:Window|Layer)?|ge(?:X(?:Offset)?|Y(?:Offset)?))|r(?:o(?:to(?:col|type)|duct(?:Sub)?|mpter)|e(?:vious|fix)))|e(?:n(?:coding|abledPlugin)|x(?:ternal|pando)|mbeds)|v(?:isibility|endor(?:Sub)?|Linkcolor)|URLUnencoded|P(?:I|OSITIVE_INFINITY)|f(?:ilename|o(?:nt(?:Size|Family|Weight)|rmName)|rame(?:s|Element)|gColor)|E|whiteSpace|l(?:i(?:stStyleType|n(?:eHeight|kColor))|o(?:ca(?:tion(?:bar)?|lName)|wsrc)|e(?:ngth|ft(?:Context)?)|a(?:st(?:M(?:odified|atch)|Index|Paren)|yer(?:s|X)|nguage))|a(?:pp(?:MinorVersion|Name|Co(?:deName|re)|Version)|vail(?:Height|Top|Width|Left)|ll|r(?:ity|guments)|Linkcolor|bove)|r(?:ight(?:Context)?|e(?:sponse(?:XML|Text)|adyState))|global|x|m(?:imeTypes|ultiline|enubar|argin(?:Right|Bottom|Top|Left))|L(?:N(?:10|2)|OG(?:10E|2E))|b(?:o(?:ttom|rder(?:Width|RightWidth|BottomWidth|Style|Color|TopWidth|LeftWidth))|ufferDepth|elow|ackground(?:Color|Image)))\b/
        }, {
          token: "identifier",
          regex: identifierRe
        }, {
          regex: "",
          token: "empty",
          next: "no_regex"
        }],
        "start": [DocCommentHighlightRules.getStartRule("doc-start"), comments("start"), {
          token: "string.regexp",
          regex: "\\/",
          next: "regex"
        }, {
          token: "text",
          regex: "\\s+|^$",
          next: "start"
        }, {
          token: "empty",
          regex: "",
          next: "no_regex"
        }],
        "regex": [{
          token: "regexp.keyword.operator",
          regex: "\\\\(?:u[\\da-fA-F]{4}|x[\\da-fA-F]{2}|.)"
        }, {
          token: "string.regexp",
          regex: "/[sxngimy]*",
          next: "no_regex"
        }, {
          token: "invalid",
          regex: /\{\d+\b,?\d*\}[+*]|[+*$^?][+*]|[$^][?]|\?{3,}/
        }, {
          token: "constant.language.escape",
          regex: /\(\?[:=!]|\)|\{\d+\b,?\d*\}|[+*]\?|[()$^+*?.]/
        }, {
          token: "constant.language.delimiter",
          regex: /\|/
        }, {
          token: "constant.language.escape",
          regex: /\[\^?/,
          next: "regex_character_class"
        }, {
          token: "empty",
          regex: "$",
          next: "no_regex"
        }, {
          defaultToken: "string.regexp"
        }],
        "regex_character_class": [{
          token: "regexp.charclass.keyword.operator",
          regex: "\\\\(?:u[\\da-fA-F]{4}|x[\\da-fA-F]{2}|.)"
        }, {
          token: "constant.language.escape",
          regex: "]",
          next: "regex"
        }, {
          token: "constant.language.escape",
          regex: "-"
        }, {
          token: "empty",
          regex: "$",
          next: "no_regex"
        }, {
          defaultToken: "string.regexp.charachterclass"
        }],
        "function_arguments": [{
          token: "variable.parameter",
          regex: identifierRe
        }, {
          token: "punctuation.operator",
          regex: "[, ]+"
        }, {
          token: "punctuation.operator",
          regex: "$"
        }, {
          token: "empty",
          regex: "",
          next: "no_regex"
        }],
        "qqstring": [{
          token: "constant.language.escape",
          regex: escapedRe
        }, {
          token: "string",
          regex: "\\\\$",
          consumeLineEnd: true
        }, {
          token: "string",
          regex: '"|$',
          next: "no_regex"
        }, {
          defaultToken: "string"
        }],
        "qstring": [{
          token: "constant.language.escape",
          regex: escapedRe
        }, {
          token: "string",
          regex: "\\\\$",
          consumeLineEnd: true
        }, {
          token: "string",
          regex: "'|$",
          next: "no_regex"
        }, {
          defaultToken: "string"
        }]
      };

      if (!options || !options.noES6) {
        this.$rules.no_regex.unshift({
          regex: "[{}]",
          onMatch: function (val, state, stack) {
            this.next = val == "{" ? this.nextState : "";

            if (val == "{" && stack.length) {
              stack.unshift("start", state);
            } else if (val == "}" && stack.length) {
              stack.shift();
              this.next = stack.shift();
              if (this.next.indexOf("string") != -1 || this.next.indexOf("jsx") != -1) return "paren.quasi.end";
            }

            return val == "{" ? "paren.lparen" : "paren.rparen";
          },
          nextState: "start"
        }, {
          token: "string.quasi.start",
          regex: /`/,
          push: [{
            token: "constant.language.escape",
            regex: escapedRe
          }, {
            token: "paren.quasi.start",
            regex: /\${/,
            push: "start"
          }, {
            token: "string.quasi.end",
            regex: /`/,
            next: "pop"
          }, {
            defaultToken: "string.quasi"
          }]
        });
        if (!options || options.jsx != false) JSX.call(this);
      }

      this.embedRules(DocCommentHighlightRules, "doc-", [DocCommentHighlightRules.getEndRule("no_regex")]);
      this.normalizeRules();
    };

    oop.inherits(JavaScriptHighlightRules, TextHighlightRules);

    function JSX() {
      var tagRegex = identifierRe.replace("\\d", "\\d\\-");
      var jsxTag = {
        onMatch: function (val, state, stack) {
          var offset = val.charAt(1) == "/" ? 2 : 1;

          if (offset == 1) {
            if (state != this.nextState) stack.unshift(this.next, this.nextState, 0);else stack.unshift(this.next);
            stack[2]++;
          } else if (offset == 2) {
            if (state == this.nextState) {
              stack[1]--;

              if (!stack[1] || stack[1] < 0) {
                stack.shift();
                stack.shift();
              }
            }
          }

          return [{
            type: "meta.tag.punctuation." + (offset == 1 ? "" : "end-") + "tag-open.xml",
            value: val.slice(0, offset)
          }, {
            type: "meta.tag.tag-name.xml",
            value: val.substr(offset)
          }];
        },
        regex: "</?" + tagRegex + "",
        next: "jsxAttributes",
        nextState: "jsx"
      };
      this.$rules.start.unshift(jsxTag);
      var jsxJsRule = {
        regex: "{",
        token: "paren.quasi.start",
        push: "start"
      };
      this.$rules.jsx = [jsxJsRule, jsxTag, {
        include: "reference"
      }, {
        defaultToken: "string"
      }];
      this.$rules.jsxAttributes = [{
        token: "meta.tag.punctuation.tag-close.xml",
        regex: "/?>",
        onMatch: function (value, currentState, stack) {
          if (currentState == stack[0]) stack.shift();

          if (value.length == 2) {
            if (stack[0] == this.nextState) stack[1]--;

            if (!stack[1] || stack[1] < 0) {
              stack.splice(0, 2);
            }
          }

          this.next = stack[0] || "start";
          return [{
            type: this.token,
            value: value
          }];
        },
        nextState: "jsx"
      }, jsxJsRule, comments("jsxAttributes"), {
        token: "entity.other.attribute-name.xml",
        regex: tagRegex
      }, {
        token: "keyword.operator.attribute-equals.xml",
        regex: "="
      }, {
        token: "text.tag-whitespace.xml",
        regex: "\\s+"
      }, {
        token: "string.attribute-value.xml",
        regex: "'",
        stateName: "jsx_attr_q",
        push: [{
          token: "string.attribute-value.xml",
          regex: "'",
          next: "pop"
        }, {
          include: "reference"
        }, {
          defaultToken: "string.attribute-value.xml"
        }]
      }, {
        token: "string.attribute-value.xml",
        regex: '"',
        stateName: "jsx_attr_qq",
        push: [{
          token: "string.attribute-value.xml",
          regex: '"',
          next: "pop"
        }, {
          include: "reference"
        }, {
          defaultToken: "string.attribute-value.xml"
        }]
      }, jsxTag];
      this.$rules.reference = [{
        token: "constant.language.escape.reference.xml",
        regex: "(?:&#[0-9]+;)|(?:&#x[0-9a-fA-F]+;)|(?:&[a-zA-Z0-9_:\\.-]+;)"
      }];
    }

    function comments(next) {
      return [{
        token: "comment",
        regex: /\/\*/,
        next: [DocCommentHighlightRules.getTagRule(), {
          token: "comment",
          regex: "\\*\\/",
          next: next || "pop"
        }, {
          defaultToken: "comment",
          caseInsensitive: true
        }]
      }, {
        token: "comment",
        regex: "\\/\\/",
        next: [DocCommentHighlightRules.getTagRule(), {
          token: "comment",
          regex: "$|^",
          next: next || "pop"
        }, {
          defaultToken: "comment",
          caseInsensitive: true
        }]
      }];
    }

    exports.JavaScriptHighlightRules = JavaScriptHighlightRules;
  });
  ace.define("ace/mode/matching_brace_outdent", ["require", "exports", "module", "ace/range"], function (require, exports, module) {

    var Range = require("../range").Range;

    var MatchingBraceOutdent = function () {};

    (function () {
      this.checkOutdent = function (line, input) {
        if (!/^\s+$/.test(line)) return false;
        return /^\s*\}/.test(input);
      };

      this.autoOutdent = function (doc, row) {
        var line = doc.getLine(row);
        var match = line.match(/^(\s*\})/);
        if (!match) return 0;
        var column = match[1].length;
        var openBracePos = doc.findMatchingBracket({
          row: row,
          column: column
        });
        if (!openBracePos || openBracePos.row == row) return 0;
        var indent = this.$getIndent(doc.getLine(openBracePos.row));
        doc.replace(new Range(row, 0, row, column - 1), indent);
      };

      this.$getIndent = function (line) {
        return line.match(/^\s*/)[0];
      };
    }).call(MatchingBraceOutdent.prototype);
    exports.MatchingBraceOutdent = MatchingBraceOutdent;
  });
  ace.define("ace/mode/folding/cstyle", ["require", "exports", "module", "ace/lib/oop", "ace/range", "ace/mode/folding/fold_mode"], function (require, exports, module) {

    var oop = require("../../lib/oop");

    var Range = require("../../range").Range;

    var BaseFoldMode = require("./fold_mode").FoldMode;

    var FoldMode = exports.FoldMode = function (commentRegex) {
      if (commentRegex) {
        this.foldingStartMarker = new RegExp(this.foldingStartMarker.source.replace(/\|[^|]*?$/, "|" + commentRegex.start));
        this.foldingStopMarker = new RegExp(this.foldingStopMarker.source.replace(/\|[^|]*?$/, "|" + commentRegex.end));
      }
    };

    oop.inherits(FoldMode, BaseFoldMode);
    (function () {
      this.foldingStartMarker = /([\{\[\(])[^\}\]\)]*$|^\s*(\/\*)/;
      this.foldingStopMarker = /^[^\[\{\(]*([\}\]\)])|^[\s\*]*(\*\/)/;
      this.singleLineBlockCommentRe = /^\s*(\/\*).*\*\/\s*$/;
      this.tripleStarBlockCommentRe = /^\s*(\/\*\*\*).*\*\/\s*$/;
      this.startRegionRe = /^\s*(\/\*|\/\/)#?region\b/;
      this._getFoldWidgetBase = this.getFoldWidget;

      this.getFoldWidget = function (session, foldStyle, row) {
        var line = session.getLine(row);

        if (this.singleLineBlockCommentRe.test(line)) {
          if (!this.startRegionRe.test(line) && !this.tripleStarBlockCommentRe.test(line)) return "";
        }

        var fw = this._getFoldWidgetBase(session, foldStyle, row);

        if (!fw && this.startRegionRe.test(line)) return "start"; // lineCommentRegionStart

        return fw;
      };

      this.getFoldWidgetRange = function (session, foldStyle, row, forceMultiline) {
        var line = session.getLine(row);
        if (this.startRegionRe.test(line)) return this.getCommentRegionBlock(session, line, row);
        var match = line.match(this.foldingStartMarker);

        if (match) {
          var i = match.index;
          if (match[1]) return this.openingBracketBlock(session, match[1], row, i);
          var range = session.getCommentFoldRange(row, i + match[0].length, 1);

          if (range && !range.isMultiLine()) {
            if (forceMultiline) {
              range = this.getSectionRange(session, row);
            } else if (foldStyle != "all") range = null;
          }

          return range;
        }

        if (foldStyle === "markbegin") return;
        var match = line.match(this.foldingStopMarker);

        if (match) {
          var i = match.index + match[0].length;
          if (match[1]) return this.closingBracketBlock(session, match[1], row, i);
          return session.getCommentFoldRange(row, i, -1);
        }
      };

      this.getSectionRange = function (session, row) {
        var line = session.getLine(row);
        var startIndent = line.search(/\S/);
        var startRow = row;
        var startColumn = line.length;
        row = row + 1;
        var endRow = row;
        var maxRow = session.getLength();

        while (++row < maxRow) {
          line = session.getLine(row);
          var indent = line.search(/\S/);
          if (indent === -1) continue;
          if (startIndent > indent) break;
          var subRange = this.getFoldWidgetRange(session, "all", row);

          if (subRange) {
            if (subRange.start.row <= startRow) {
              break;
            } else if (subRange.isMultiLine()) {
              row = subRange.end.row;
            } else if (startIndent == indent) {
              break;
            }
          }

          endRow = row;
        }

        return new Range(startRow, startColumn, endRow, session.getLine(endRow).length);
      };

      this.getCommentRegionBlock = function (session, line, row) {
        var startColumn = line.search(/\s*$/);
        var maxRow = session.getLength();
        var startRow = row;
        var re = /^\s*(?:\/\*|\/\/|--)#?(end)?region\b/;
        var depth = 1;

        while (++row < maxRow) {
          line = session.getLine(row);
          var m = re.exec(line);
          if (!m) continue;
          if (m[1]) depth--;else depth++;
          if (!depth) break;
        }

        var endRow = row;

        if (endRow > startRow) {
          return new Range(startRow, startColumn, endRow, line.length);
        }
      };
    }).call(FoldMode.prototype);
  });
  ace.define("ace/mode/javascript", ["require", "exports", "module", "ace/lib/oop", "ace/mode/text", "ace/mode/javascript_highlight_rules", "ace/mode/matching_brace_outdent", "ace/worker/worker_client", "ace/mode/behaviour/cstyle", "ace/mode/folding/cstyle"], function (require, exports, module) {

    var oop = require("../lib/oop");

    var TextMode = require("./text").Mode;

    var JavaScriptHighlightRules = require("./javascript_highlight_rules").JavaScriptHighlightRules;

    var MatchingBraceOutdent = require("./matching_brace_outdent").MatchingBraceOutdent;

    var WorkerClient = require("../worker/worker_client").WorkerClient;

    var CstyleBehaviour = require("./behaviour/cstyle").CstyleBehaviour;

    var CStyleFoldMode = require("./folding/cstyle").FoldMode;

    var Mode = function () {
      this.HighlightRules = JavaScriptHighlightRules;
      this.$outdent = new MatchingBraceOutdent();
      this.$behaviour = new CstyleBehaviour();
      this.foldingRules = new CStyleFoldMode();
    };

    oop.inherits(Mode, TextMode);
    (function () {
      this.lineCommentStart = "//";
      this.blockComment = {
        start: "/*",
        end: "*/"
      };
      this.$quotes = {
        '"': '"',
        "'": "'",
        "`": "`"
      };

      this.getNextLineIndent = function (state, line, tab) {
        var indent = this.$getIndent(line);
        var tokenizedLine = this.getTokenizer().getLineTokens(line, state);
        var tokens = tokenizedLine.tokens;
        var endState = tokenizedLine.state;

        if (tokens.length && tokens[tokens.length - 1].type == "comment") {
          return indent;
        }

        if (state == "start" || state == "no_regex") {
          var match = line.match(/^.*(?:\bcase\b.*:|[\{\(\[])\s*$/);

          if (match) {
            indent += tab;
          }
        } else if (state == "doc-start") {
          if (endState == "start" || endState == "no_regex") {
            return "";
          }

          var match = line.match(/^\s*(\/?)\*/);

          if (match) {
            if (match[1]) {
              indent += " ";
            }

            indent += "* ";
          }
        }

        return indent;
      };

      this.checkOutdent = function (state, line, input) {
        return this.$outdent.checkOutdent(line, input);
      };

      this.autoOutdent = function (state, doc, row) {
        this.$outdent.autoOutdent(doc, row);
      };

      this.createWorker = function (session) {
        var worker = new WorkerClient(["ace"], "ace/mode/javascript_worker", "JavaScriptWorker");
        worker.attachToDocument(session.getDocument());
        worker.on("annotate", function (results) {
          session.setAnnotations(results.data);
        });
        worker.on("terminate", function () {
          session.clearAnnotations();
        });
        return worker;
      };

      this.$id = "ace/mode/javascript";
      this.snippetFileId = "ace/snippets/javascript";
    }).call(Mode.prototype);
    exports.Mode = Mode;
  });

  (function () {
    ace.require(["ace/mode/javascript"], function (m) {
      if ( module) {
        module.exports = m;
      }
    });
  })();
});

var modeJson5 = createCommonjsModule(function (module, exports) {
  ace.define("ace/mode/json_highlight_rules", ["require", "exports", "module", "ace/lib/oop", "ace/mode/text_highlight_rules"], function (require, exports, module) {

    var oop = require("../lib/oop");

    var TextHighlightRules = require("./text_highlight_rules").TextHighlightRules;

    var JsonHighlightRules = function () {
      this.$rules = {
        "start": [{
          token: "variable",
          regex: '["](?:(?:\\\\.)|(?:[^"\\\\]))*?["]\\s*(?=:)'
        }, {
          token: "string",
          regex: '"',
          next: "string"
        }, {
          token: "constant.numeric",
          regex: "0[xX][0-9a-fA-F]+\\b"
        }, {
          token: "constant.numeric",
          regex: "[+-]?\\d+(?:(?:\\.\\d*)?(?:[eE][+-]?\\d+)?)?\\b"
        }, {
          token: "constant.language.boolean",
          regex: "(?:true|false)\\b"
        }, {
          token: "text",
          regex: "['](?:(?:\\\\.)|(?:[^'\\\\]))*?[']"
        }, {
          token: "comment",
          regex: "\\/\\/.*$"
        }, {
          token: "comment.start",
          regex: "\\/\\*",
          next: "comment"
        }, {
          token: "paren.lparen",
          regex: "[[({]"
        }, {
          token: "paren.rparen",
          regex: "[\\])}]"
        }, {
          token: "punctuation.operator",
          regex: /[,]/
        }, {
          token: "text",
          regex: "\\s+"
        }],
        "string": [{
          token: "constant.language.escape",
          regex: /\\(?:x[0-9a-fA-F]{2}|u[0-9a-fA-F]{4}|["\\\/bfnrt])/
        }, {
          token: "string",
          regex: '"|$',
          next: "start"
        }, {
          defaultToken: "string"
        }],
        "comment": [{
          token: "comment.end",
          regex: "\\*\\/",
          next: "start"
        }, {
          defaultToken: "comment"
        }]
      };
    };

    oop.inherits(JsonHighlightRules, TextHighlightRules);
    exports.JsonHighlightRules = JsonHighlightRules;
  });
  ace.define("ace/mode/json5_highlight_rules", ["require", "exports", "module", "ace/lib/oop", "ace/mode/json_highlight_rules"], function (require, exports, module) {

    var oop = require("../lib/oop");

    var JsonHighlightRules = require("./json_highlight_rules").JsonHighlightRules;

    var Json5HighlightRules = function () {
      JsonHighlightRules.call(this);
      var startRules = [{
        token: "variable",
        regex: /[a-zA-Z$_\u00a1-\uffff][\w$\u00a1-\uffff]*\s*(?=:)/
      }, {
        token: "variable",
        regex: /['](?:(?:\\.)|(?:[^'\\]))*?[']\s*(?=:)/
      }, {
        token: "constant.language.boolean",
        regex: /(?:null)\b/
      }, {
        token: "string",
        regex: /'/,
        next: [{
          token: "constant.language.escape",
          regex: /\\(?:x[0-9a-fA-F]{2}|u[0-9a-fA-F]{4}|["\/bfnrt]|$)/,
          consumeLineEnd: true
        }, {
          token: "string",
          regex: /'|$/,
          next: "start"
        }, {
          defaultToken: "string"
        }]
      }, {
        token: "string",
        regex: /"(?![^"]*":)/,
        next: [{
          token: "constant.language.escape",
          regex: /\\(?:x[0-9a-fA-F]{2}|u[0-9a-fA-F]{4}|["\/bfnrt]|$)/,
          consumeLineEnd: true
        }, {
          token: "string",
          regex: /"|$/,
          next: "start"
        }, {
          defaultToken: "string"
        }]
      }, {
        token: "constant.numeric",
        regex: /[+-]?(?:Infinity|NaN)\b/
      }];

      for (var key in this.$rules) this.$rules[key].unshift.apply(this.$rules[key], startRules);

      this.normalizeRules();
    };

    oop.inherits(Json5HighlightRules, JsonHighlightRules);
    exports.Json5HighlightRules = Json5HighlightRules;
  });
  ace.define("ace/mode/matching_brace_outdent", ["require", "exports", "module", "ace/range"], function (require, exports, module) {

    var Range = require("../range").Range;

    var MatchingBraceOutdent = function () {};

    (function () {
      this.checkOutdent = function (line, input) {
        if (!/^\s+$/.test(line)) return false;
        return /^\s*\}/.test(input);
      };

      this.autoOutdent = function (doc, row) {
        var line = doc.getLine(row);
        var match = line.match(/^(\s*\})/);
        if (!match) return 0;
        var column = match[1].length;
        var openBracePos = doc.findMatchingBracket({
          row: row,
          column: column
        });
        if (!openBracePos || openBracePos.row == row) return 0;
        var indent = this.$getIndent(doc.getLine(openBracePos.row));
        doc.replace(new Range(row, 0, row, column - 1), indent);
      };

      this.$getIndent = function (line) {
        return line.match(/^\s*/)[0];
      };
    }).call(MatchingBraceOutdent.prototype);
    exports.MatchingBraceOutdent = MatchingBraceOutdent;
  });
  ace.define("ace/mode/folding/cstyle", ["require", "exports", "module", "ace/lib/oop", "ace/range", "ace/mode/folding/fold_mode"], function (require, exports, module) {

    var oop = require("../../lib/oop");

    var Range = require("../../range").Range;

    var BaseFoldMode = require("./fold_mode").FoldMode;

    var FoldMode = exports.FoldMode = function (commentRegex) {
      if (commentRegex) {
        this.foldingStartMarker = new RegExp(this.foldingStartMarker.source.replace(/\|[^|]*?$/, "|" + commentRegex.start));
        this.foldingStopMarker = new RegExp(this.foldingStopMarker.source.replace(/\|[^|]*?$/, "|" + commentRegex.end));
      }
    };

    oop.inherits(FoldMode, BaseFoldMode);
    (function () {
      this.foldingStartMarker = /([\{\[\(])[^\}\]\)]*$|^\s*(\/\*)/;
      this.foldingStopMarker = /^[^\[\{\(]*([\}\]\)])|^[\s\*]*(\*\/)/;
      this.singleLineBlockCommentRe = /^\s*(\/\*).*\*\/\s*$/;
      this.tripleStarBlockCommentRe = /^\s*(\/\*\*\*).*\*\/\s*$/;
      this.startRegionRe = /^\s*(\/\*|\/\/)#?region\b/;
      this._getFoldWidgetBase = this.getFoldWidget;

      this.getFoldWidget = function (session, foldStyle, row) {
        var line = session.getLine(row);

        if (this.singleLineBlockCommentRe.test(line)) {
          if (!this.startRegionRe.test(line) && !this.tripleStarBlockCommentRe.test(line)) return "";
        }

        var fw = this._getFoldWidgetBase(session, foldStyle, row);

        if (!fw && this.startRegionRe.test(line)) return "start"; // lineCommentRegionStart

        return fw;
      };

      this.getFoldWidgetRange = function (session, foldStyle, row, forceMultiline) {
        var line = session.getLine(row);
        if (this.startRegionRe.test(line)) return this.getCommentRegionBlock(session, line, row);
        var match = line.match(this.foldingStartMarker);

        if (match) {
          var i = match.index;
          if (match[1]) return this.openingBracketBlock(session, match[1], row, i);
          var range = session.getCommentFoldRange(row, i + match[0].length, 1);

          if (range && !range.isMultiLine()) {
            if (forceMultiline) {
              range = this.getSectionRange(session, row);
            } else if (foldStyle != "all") range = null;
          }

          return range;
        }

        if (foldStyle === "markbegin") return;
        var match = line.match(this.foldingStopMarker);

        if (match) {
          var i = match.index + match[0].length;
          if (match[1]) return this.closingBracketBlock(session, match[1], row, i);
          return session.getCommentFoldRange(row, i, -1);
        }
      };

      this.getSectionRange = function (session, row) {
        var line = session.getLine(row);
        var startIndent = line.search(/\S/);
        var startRow = row;
        var startColumn = line.length;
        row = row + 1;
        var endRow = row;
        var maxRow = session.getLength();

        while (++row < maxRow) {
          line = session.getLine(row);
          var indent = line.search(/\S/);
          if (indent === -1) continue;
          if (startIndent > indent) break;
          var subRange = this.getFoldWidgetRange(session, "all", row);

          if (subRange) {
            if (subRange.start.row <= startRow) {
              break;
            } else if (subRange.isMultiLine()) {
              row = subRange.end.row;
            } else if (startIndent == indent) {
              break;
            }
          }

          endRow = row;
        }

        return new Range(startRow, startColumn, endRow, session.getLine(endRow).length);
      };

      this.getCommentRegionBlock = function (session, line, row) {
        var startColumn = line.search(/\s*$/);
        var maxRow = session.getLength();
        var startRow = row;
        var re = /^\s*(?:\/\*|\/\/|--)#?(end)?region\b/;
        var depth = 1;

        while (++row < maxRow) {
          line = session.getLine(row);
          var m = re.exec(line);
          if (!m) continue;
          if (m[1]) depth--;else depth++;
          if (!depth) break;
        }

        var endRow = row;

        if (endRow > startRow) {
          return new Range(startRow, startColumn, endRow, line.length);
        }
      };
    }).call(FoldMode.prototype);
  });
  ace.define("ace/mode/json5", ["require", "exports", "module", "ace/lib/oop", "ace/mode/text", "ace/mode/json5_highlight_rules", "ace/mode/matching_brace_outdent", "ace/mode/behaviour/cstyle", "ace/mode/folding/cstyle"], function (require, exports, module) {

    var oop = require("../lib/oop");

    var TextMode = require("./text").Mode;

    var HighlightRules = require("./json5_highlight_rules").Json5HighlightRules;

    var MatchingBraceOutdent = require("./matching_brace_outdent").MatchingBraceOutdent;

    var CstyleBehaviour = require("./behaviour/cstyle").CstyleBehaviour;

    var CStyleFoldMode = require("./folding/cstyle").FoldMode;

    var Mode = function () {
      this.HighlightRules = HighlightRules;
      this.$outdent = new MatchingBraceOutdent();
      this.$behaviour = new CstyleBehaviour();
      this.foldingRules = new CStyleFoldMode();
    };

    oop.inherits(Mode, TextMode);
    (function () {
      this.lineCommentStart = "//";
      this.blockComment = {
        start: "/*",
        end: "*/"
      };

      this.checkOutdent = function (state, line, input) {
        return this.$outdent.checkOutdent(line, input);
      };

      this.autoOutdent = function (state, doc, row) {
        this.$outdent.autoOutdent(doc, row);
      };

      this.$id = "ace/mode/json5";
    }).call(Mode.prototype);
    exports.Mode = Mode;
  });

  (function () {
    ace.require(["ace/mode/json5"], function (m) {
      if ( module) {
        module.exports = m;
      }
    });
  })();
});

var modeCss = createCommonjsModule(function (module, exports) {
  ace.define("ace/mode/css_highlight_rules", ["require", "exports", "module", "ace/lib/oop", "ace/lib/lang", "ace/mode/text_highlight_rules"], function (require, exports, module) {

    var oop = require("../lib/oop");

    var lang = require("../lib/lang");

    var TextHighlightRules = require("./text_highlight_rules").TextHighlightRules;

    var supportType = exports.supportType = "align-content|align-items|align-self|all|animation|animation-delay|animation-direction|animation-duration|animation-fill-mode|animation-iteration-count|animation-name|animation-play-state|animation-timing-function|backface-visibility|background|background-attachment|background-blend-mode|background-clip|background-color|background-image|background-origin|background-position|background-repeat|background-size|border|border-bottom|border-bottom-color|border-bottom-left-radius|border-bottom-right-radius|border-bottom-style|border-bottom-width|border-collapse|border-color|border-image|border-image-outset|border-image-repeat|border-image-slice|border-image-source|border-image-width|border-left|border-left-color|border-left-style|border-left-width|border-radius|border-right|border-right-color|border-right-style|border-right-width|border-spacing|border-style|border-top|border-top-color|border-top-left-radius|border-top-right-radius|border-top-style|border-top-width|border-width|bottom|box-shadow|box-sizing|caption-side|clear|clip|color|column-count|column-fill|column-gap|column-rule|column-rule-color|column-rule-style|column-rule-width|column-span|column-width|columns|content|counter-increment|counter-reset|cursor|direction|display|empty-cells|filter|flex|flex-basis|flex-direction|flex-flow|flex-grow|flex-shrink|flex-wrap|float|font|font-family|font-size|font-size-adjust|font-stretch|font-style|font-variant|font-weight|hanging-punctuation|height|justify-content|left|letter-spacing|line-height|list-style|list-style-image|list-style-position|list-style-type|margin|margin-bottom|margin-left|margin-right|margin-top|max-height|max-width|max-zoom|min-height|min-width|min-zoom|nav-down|nav-index|nav-left|nav-right|nav-up|opacity|order|outline|outline-color|outline-offset|outline-style|outline-width|overflow|overflow-x|overflow-y|padding|padding-bottom|padding-left|padding-right|padding-top|page-break-after|page-break-before|page-break-inside|perspective|perspective-origin|position|quotes|resize|right|tab-size|table-layout|text-align|text-align-last|text-decoration|text-decoration-color|text-decoration-line|text-decoration-style|text-indent|text-justify|text-overflow|text-shadow|text-transform|top|transform|transform-origin|transform-style|transition|transition-delay|transition-duration|transition-property|transition-timing-function|unicode-bidi|user-select|user-zoom|vertical-align|visibility|white-space|width|word-break|word-spacing|word-wrap|z-index";
    var supportFunction = exports.supportFunction = "rgb|rgba|url|attr|counter|counters";
    var supportConstant = exports.supportConstant = "absolute|after-edge|after|all-scroll|all|alphabetic|always|antialiased|armenian|auto|avoid-column|avoid-page|avoid|balance|baseline|before-edge|before|below|bidi-override|block-line-height|block|bold|bolder|border-box|both|bottom|box|break-all|break-word|capitalize|caps-height|caption|center|central|char|circle|cjk-ideographic|clone|close-quote|col-resize|collapse|column|consider-shifts|contain|content-box|cover|crosshair|cubic-bezier|dashed|decimal-leading-zero|decimal|default|disabled|disc|disregard-shifts|distribute-all-lines|distribute-letter|distribute-space|distribute|dotted|double|e-resize|ease-in|ease-in-out|ease-out|ease|ellipsis|end|exclude-ruby|flex-end|flex-start|fill|fixed|georgian|glyphs|grid-height|groove|hand|hanging|hebrew|help|hidden|hiragana-iroha|hiragana|horizontal|icon|ideograph-alpha|ideograph-numeric|ideograph-parenthesis|ideograph-space|ideographic|inactive|include-ruby|inherit|initial|inline-block|inline-box|inline-line-height|inline-table|inline|inset|inside|inter-ideograph|inter-word|invert|italic|justify|katakana-iroha|katakana|keep-all|last|left|lighter|line-edge|line-through|line|linear|list-item|local|loose|lower-alpha|lower-greek|lower-latin|lower-roman|lowercase|lr-tb|ltr|mathematical|max-height|max-size|medium|menu|message-box|middle|move|n-resize|ne-resize|newspaper|no-change|no-close-quote|no-drop|no-open-quote|no-repeat|none|normal|not-allowed|nowrap|nw-resize|oblique|open-quote|outset|outside|overline|padding-box|page|pointer|pre-line|pre-wrap|pre|preserve-3d|progress|relative|repeat-x|repeat-y|repeat|replaced|reset-size|ridge|right|round|row-resize|rtl|s-resize|scroll|se-resize|separate|slice|small-caps|small-caption|solid|space|square|start|static|status-bar|step-end|step-start|steps|stretch|strict|sub|super|sw-resize|table-caption|table-cell|table-column-group|table-column|table-footer-group|table-header-group|table-row-group|table-row|table|tb-rl|text-after-edge|text-before-edge|text-bottom|text-size|text-top|text|thick|thin|transparent|underline|upper-alpha|upper-latin|upper-roman|uppercase|use-script|vertical-ideographic|vertical-text|visible|w-resize|wait|whitespace|z-index|zero|zoom";
    var supportConstantColor = exports.supportConstantColor = "aliceblue|antiquewhite|aqua|aquamarine|azure|beige|bisque|black|blanchedalmond|blue|blueviolet|brown|burlywood|cadetblue|chartreuse|chocolate|coral|cornflowerblue|cornsilk|crimson|cyan|darkblue|darkcyan|darkgoldenrod|darkgray|darkgreen|darkgrey|darkkhaki|darkmagenta|darkolivegreen|darkorange|darkorchid|darkred|darksalmon|darkseagreen|darkslateblue|darkslategray|darkslategrey|darkturquoise|darkviolet|deeppink|deepskyblue|dimgray|dimgrey|dodgerblue|firebrick|floralwhite|forestgreen|fuchsia|gainsboro|ghostwhite|gold|goldenrod|gray|green|greenyellow|grey|honeydew|hotpink|indianred|indigo|ivory|khaki|lavender|lavenderblush|lawngreen|lemonchiffon|lightblue|lightcoral|lightcyan|lightgoldenrodyellow|lightgray|lightgreen|lightgrey|lightpink|lightsalmon|lightseagreen|lightskyblue|lightslategray|lightslategrey|lightsteelblue|lightyellow|lime|limegreen|linen|magenta|maroon|mediumaquamarine|mediumblue|mediumorchid|mediumpurple|mediumseagreen|mediumslateblue|mediumspringgreen|mediumturquoise|mediumvioletred|midnightblue|mintcream|mistyrose|moccasin|navajowhite|navy|oldlace|olive|olivedrab|orange|orangered|orchid|palegoldenrod|palegreen|paleturquoise|palevioletred|papayawhip|peachpuff|peru|pink|plum|powderblue|purple|rebeccapurple|red|rosybrown|royalblue|saddlebrown|salmon|sandybrown|seagreen|seashell|sienna|silver|skyblue|slateblue|slategray|slategrey|snow|springgreen|steelblue|tan|teal|thistle|tomato|turquoise|violet|wheat|white|whitesmoke|yellow|yellowgreen";
    var supportConstantFonts = exports.supportConstantFonts = "arial|century|comic|courier|cursive|fantasy|garamond|georgia|helvetica|impact|lucida|symbol|system|tahoma|times|trebuchet|utopia|verdana|webdings|sans-serif|serif|monospace";
    var numRe = exports.numRe = "\\-?(?:(?:[0-9]+(?:\\.[0-9]+)?)|(?:\\.[0-9]+))";
    var pseudoElements = exports.pseudoElements = "(\\:+)\\b(after|before|first-letter|first-line|moz-selection|selection)\\b";
    var pseudoClasses = exports.pseudoClasses = "(:)\\b(active|checked|disabled|empty|enabled|first-child|first-of-type|focus|hover|indeterminate|invalid|last-child|last-of-type|link|not|nth-child|nth-last-child|nth-last-of-type|nth-of-type|only-child|only-of-type|required|root|target|valid|visited)\\b";

    var CssHighlightRules = function () {
      var keywordMapper = this.createKeywordMapper({
        "support.function": supportFunction,
        "support.constant": supportConstant,
        "support.type": supportType,
        "support.constant.color": supportConstantColor,
        "support.constant.fonts": supportConstantFonts
      }, "text", true);
      this.$rules = {
        "start": [{
          include: ["strings", "url", "comments"]
        }, {
          token: "paren.lparen",
          regex: "\\{",
          next: "ruleset"
        }, {
          token: "paren.rparen",
          regex: "\\}"
        }, {
          token: "string",
          regex: "@(?!viewport)",
          next: "media"
        }, {
          token: "keyword",
          regex: "#[a-z0-9-_]+"
        }, {
          token: "keyword",
          regex: "%"
        }, {
          token: "variable",
          regex: "\\.[a-z0-9-_]+"
        }, {
          token: "string",
          regex: ":[a-z0-9-_]+"
        }, {
          token: "constant.numeric",
          regex: numRe
        }, {
          token: "constant",
          regex: "[a-z0-9-_]+"
        }, {
          caseInsensitive: true
        }],
        "media": [{
          include: ["strings", "url", "comments"]
        }, {
          token: "paren.lparen",
          regex: "\\{",
          next: "start"
        }, {
          token: "paren.rparen",
          regex: "\\}",
          next: "start"
        }, {
          token: "string",
          regex: ";",
          next: "start"
        }, {
          token: "keyword",
          regex: "(?:media|supports|document|charset|import|namespace|media|supports|document" + "|page|font|keyframes|viewport|counter-style|font-feature-values" + "|swash|ornaments|annotation|stylistic|styleset|character-variant)"
        }],
        "comments": [{
          token: "comment",
          regex: "\\/\\*",
          push: [{
            token: "comment",
            regex: "\\*\\/",
            next: "pop"
          }, {
            defaultToken: "comment"
          }]
        }],
        "ruleset": [{
          regex: "-(webkit|ms|moz|o)-",
          token: "text"
        }, {
          token: "punctuation.operator",
          regex: "[:;]"
        }, {
          token: "paren.rparen",
          regex: "\\}",
          next: "start"
        }, {
          include: ["strings", "url", "comments"]
        }, {
          token: ["constant.numeric", "keyword"],
          regex: "(" + numRe + ")(ch|cm|deg|em|ex|fr|gd|grad|Hz|in|kHz|mm|ms|pc|pt|px|rad|rem|s|turn|vh|vmax|vmin|vm|vw|%)"
        }, {
          token: "constant.numeric",
          regex: numRe
        }, {
          token: "constant.numeric",
          regex: "#[a-f0-9]{6}"
        }, {
          token: "constant.numeric",
          regex: "#[a-f0-9]{3}"
        }, {
          token: ["punctuation", "entity.other.attribute-name.pseudo-element.css"],
          regex: pseudoElements
        }, {
          token: ["punctuation", "entity.other.attribute-name.pseudo-class.css"],
          regex: pseudoClasses
        }, {
          include: "url"
        }, {
          token: keywordMapper,
          regex: "\\-?[a-zA-Z_][a-zA-Z0-9_\\-]*"
        }, {
          caseInsensitive: true
        }],
        url: [{
          token: "support.function",
          regex: "(?:url(:?-prefix)?|domain|regexp)\\(",
          push: [{
            token: "support.function",
            regex: "\\)",
            next: "pop"
          }, {
            defaultToken: "string"
          }]
        }],
        strings: [{
          token: "string.start",
          regex: "'",
          push: [{
            token: "string.end",
            regex: "'|$",
            next: "pop"
          }, {
            include: "escapes"
          }, {
            token: "constant.language.escape",
            regex: /\\$/,
            consumeLineEnd: true
          }, {
            defaultToken: "string"
          }]
        }, {
          token: "string.start",
          regex: '"',
          push: [{
            token: "string.end",
            regex: '"|$',
            next: "pop"
          }, {
            include: "escapes"
          }, {
            token: "constant.language.escape",
            regex: /\\$/,
            consumeLineEnd: true
          }, {
            defaultToken: "string"
          }]
        }],
        escapes: [{
          token: "constant.language.escape",
          regex: /\\([a-fA-F\d]{1,6}|[^a-fA-F\d])/
        }]
      };
      this.normalizeRules();
    };

    oop.inherits(CssHighlightRules, TextHighlightRules);
    exports.CssHighlightRules = CssHighlightRules;
  });
  ace.define("ace/mode/matching_brace_outdent", ["require", "exports", "module", "ace/range"], function (require, exports, module) {

    var Range = require("../range").Range;

    var MatchingBraceOutdent = function () {};

    (function () {
      this.checkOutdent = function (line, input) {
        if (!/^\s+$/.test(line)) return false;
        return /^\s*\}/.test(input);
      };

      this.autoOutdent = function (doc, row) {
        var line = doc.getLine(row);
        var match = line.match(/^(\s*\})/);
        if (!match) return 0;
        var column = match[1].length;
        var openBracePos = doc.findMatchingBracket({
          row: row,
          column: column
        });
        if (!openBracePos || openBracePos.row == row) return 0;
        var indent = this.$getIndent(doc.getLine(openBracePos.row));
        doc.replace(new Range(row, 0, row, column - 1), indent);
      };

      this.$getIndent = function (line) {
        return line.match(/^\s*/)[0];
      };
    }).call(MatchingBraceOutdent.prototype);
    exports.MatchingBraceOutdent = MatchingBraceOutdent;
  });
  ace.define("ace/mode/css_completions", ["require", "exports", "module"], function (require, exports, module) {

    var propertyMap = {
      "background": {
        "#$0": 1
      },
      "background-color": {
        "#$0": 1,
        "transparent": 1,
        "fixed": 1
      },
      "background-image": {
        "url('/$0')": 1
      },
      "background-repeat": {
        "repeat": 1,
        "repeat-x": 1,
        "repeat-y": 1,
        "no-repeat": 1,
        "inherit": 1
      },
      "background-position": {
        "bottom": 2,
        "center": 2,
        "left": 2,
        "right": 2,
        "top": 2,
        "inherit": 2
      },
      "background-attachment": {
        "scroll": 1,
        "fixed": 1
      },
      "background-size": {
        "cover": 1,
        "contain": 1
      },
      "background-clip": {
        "border-box": 1,
        "padding-box": 1,
        "content-box": 1
      },
      "background-origin": {
        "border-box": 1,
        "padding-box": 1,
        "content-box": 1
      },
      "border": {
        "solid $0": 1,
        "dashed $0": 1,
        "dotted $0": 1,
        "#$0": 1
      },
      "border-color": {
        "#$0": 1
      },
      "border-style": {
        "solid": 2,
        "dashed": 2,
        "dotted": 2,
        "double": 2,
        "groove": 2,
        "hidden": 2,
        "inherit": 2,
        "inset": 2,
        "none": 2,
        "outset": 2,
        "ridged": 2
      },
      "border-collapse": {
        "collapse": 1,
        "separate": 1
      },
      "bottom": {
        "px": 1,
        "em": 1,
        "%": 1
      },
      "clear": {
        "left": 1,
        "right": 1,
        "both": 1,
        "none": 1
      },
      "color": {
        "#$0": 1,
        "rgb(#$00,0,0)": 1
      },
      "cursor": {
        "default": 1,
        "pointer": 1,
        "move": 1,
        "text": 1,
        "wait": 1,
        "help": 1,
        "progress": 1,
        "n-resize": 1,
        "ne-resize": 1,
        "e-resize": 1,
        "se-resize": 1,
        "s-resize": 1,
        "sw-resize": 1,
        "w-resize": 1,
        "nw-resize": 1
      },
      "display": {
        "none": 1,
        "block": 1,
        "inline": 1,
        "inline-block": 1,
        "table-cell": 1
      },
      "empty-cells": {
        "show": 1,
        "hide": 1
      },
      "float": {
        "left": 1,
        "right": 1,
        "none": 1
      },
      "font-family": {
        "Arial": 2,
        "Comic Sans MS": 2,
        "Consolas": 2,
        "Courier New": 2,
        "Courier": 2,
        "Georgia": 2,
        "Monospace": 2,
        "Sans-Serif": 2,
        "Segoe UI": 2,
        "Tahoma": 2,
        "Times New Roman": 2,
        "Trebuchet MS": 2,
        "Verdana": 1
      },
      "font-size": {
        "px": 1,
        "em": 1,
        "%": 1
      },
      "font-weight": {
        "bold": 1,
        "normal": 1
      },
      "font-style": {
        "italic": 1,
        "normal": 1
      },
      "font-variant": {
        "normal": 1,
        "small-caps": 1
      },
      "height": {
        "px": 1,
        "em": 1,
        "%": 1
      },
      "left": {
        "px": 1,
        "em": 1,
        "%": 1
      },
      "letter-spacing": {
        "normal": 1
      },
      "line-height": {
        "normal": 1
      },
      "list-style-type": {
        "none": 1,
        "disc": 1,
        "circle": 1,
        "square": 1,
        "decimal": 1,
        "decimal-leading-zero": 1,
        "lower-roman": 1,
        "upper-roman": 1,
        "lower-greek": 1,
        "lower-latin": 1,
        "upper-latin": 1,
        "georgian": 1,
        "lower-alpha": 1,
        "upper-alpha": 1
      },
      "margin": {
        "px": 1,
        "em": 1,
        "%": 1
      },
      "margin-right": {
        "px": 1,
        "em": 1,
        "%": 1
      },
      "margin-left": {
        "px": 1,
        "em": 1,
        "%": 1
      },
      "margin-top": {
        "px": 1,
        "em": 1,
        "%": 1
      },
      "margin-bottom": {
        "px": 1,
        "em": 1,
        "%": 1
      },
      "max-height": {
        "px": 1,
        "em": 1,
        "%": 1
      },
      "max-width": {
        "px": 1,
        "em": 1,
        "%": 1
      },
      "min-height": {
        "px": 1,
        "em": 1,
        "%": 1
      },
      "min-width": {
        "px": 1,
        "em": 1,
        "%": 1
      },
      "overflow": {
        "hidden": 1,
        "visible": 1,
        "auto": 1,
        "scroll": 1
      },
      "overflow-x": {
        "hidden": 1,
        "visible": 1,
        "auto": 1,
        "scroll": 1
      },
      "overflow-y": {
        "hidden": 1,
        "visible": 1,
        "auto": 1,
        "scroll": 1
      },
      "padding": {
        "px": 1,
        "em": 1,
        "%": 1
      },
      "padding-top": {
        "px": 1,
        "em": 1,
        "%": 1
      },
      "padding-right": {
        "px": 1,
        "em": 1,
        "%": 1
      },
      "padding-bottom": {
        "px": 1,
        "em": 1,
        "%": 1
      },
      "padding-left": {
        "px": 1,
        "em": 1,
        "%": 1
      },
      "page-break-after": {
        "auto": 1,
        "always": 1,
        "avoid": 1,
        "left": 1,
        "right": 1
      },
      "page-break-before": {
        "auto": 1,
        "always": 1,
        "avoid": 1,
        "left": 1,
        "right": 1
      },
      "position": {
        "absolute": 1,
        "relative": 1,
        "fixed": 1,
        "static": 1
      },
      "right": {
        "px": 1,
        "em": 1,
        "%": 1
      },
      "table-layout": {
        "fixed": 1,
        "auto": 1
      },
      "text-decoration": {
        "none": 1,
        "underline": 1,
        "line-through": 1,
        "blink": 1
      },
      "text-align": {
        "left": 1,
        "right": 1,
        "center": 1,
        "justify": 1
      },
      "text-transform": {
        "capitalize": 1,
        "uppercase": 1,
        "lowercase": 1,
        "none": 1
      },
      "top": {
        "px": 1,
        "em": 1,
        "%": 1
      },
      "vertical-align": {
        "top": 1,
        "bottom": 1
      },
      "visibility": {
        "hidden": 1,
        "visible": 1
      },
      "white-space": {
        "nowrap": 1,
        "normal": 1,
        "pre": 1,
        "pre-line": 1,
        "pre-wrap": 1
      },
      "width": {
        "px": 1,
        "em": 1,
        "%": 1
      },
      "word-spacing": {
        "normal": 1
      },
      "filter": {
        "alpha(opacity=$0100)": 1
      },
      "text-shadow": {
        "$02px 2px 2px #777": 1
      },
      "text-overflow": {
        "ellipsis-word": 1,
        "clip": 1,
        "ellipsis": 1
      },
      "-moz-border-radius": 1,
      "-moz-border-radius-topright": 1,
      "-moz-border-radius-bottomright": 1,
      "-moz-border-radius-topleft": 1,
      "-moz-border-radius-bottomleft": 1,
      "-webkit-border-radius": 1,
      "-webkit-border-top-right-radius": 1,
      "-webkit-border-top-left-radius": 1,
      "-webkit-border-bottom-right-radius": 1,
      "-webkit-border-bottom-left-radius": 1,
      "-moz-box-shadow": 1,
      "-webkit-box-shadow": 1,
      "transform": {
        "rotate($00deg)": 1,
        "skew($00deg)": 1
      },
      "-moz-transform": {
        "rotate($00deg)": 1,
        "skew($00deg)": 1
      },
      "-webkit-transform": {
        "rotate($00deg)": 1,
        "skew($00deg)": 1
      }
    };

    var CssCompletions = function () {};

    (function () {
      this.completionsDefined = false;

      this.defineCompletions = function () {
        if (document) {
          var style = document.createElement('c').style;

          for (var i in style) {
            if (typeof style[i] !== 'string') continue;
            var name = i.replace(/[A-Z]/g, function (x) {
              return '-' + x.toLowerCase();
            });
            if (!propertyMap.hasOwnProperty(name)) propertyMap[name] = 1;
          }
        }

        this.completionsDefined = true;
      };

      this.getCompletions = function (state, session, pos, prefix) {
        if (!this.completionsDefined) {
          this.defineCompletions();
        }

        if (state === 'ruleset' || session.$mode.$id == "ace/mode/scss") {
          var line = session.getLine(pos.row).substr(0, pos.column);
          var inParens = /\([^)]*$/.test(line);

          if (inParens) {
            line = line.substr(line.lastIndexOf('(') + 1);
          }

          if (/:[^;]+$/.test(line)) {
            /([\w\-]+):[^:]*$/.test(line);
            return this.getPropertyValueCompletions(state, session, pos, prefix);
          } else {
            return this.getPropertyCompletions(state, session, pos, prefix, inParens);
          }
        }

        return [];
      };

      this.getPropertyCompletions = function (state, session, pos, prefix, skipSemicolon) {
        skipSemicolon = skipSemicolon || false;
        var properties = Object.keys(propertyMap);
        return properties.map(function (property) {
          return {
            caption: property,
            snippet: property + ': $0' + (skipSemicolon ? '' : ';'),
            meta: "property",
            score: 1000000
          };
        });
      };

      this.getPropertyValueCompletions = function (state, session, pos, prefix) {
        var line = session.getLine(pos.row).substr(0, pos.column);
        var property = (/([\w\-]+):[^:]*$/.exec(line) || {})[1];
        if (!property) return [];
        var values = [];

        if (property in propertyMap && typeof propertyMap[property] === "object") {
          values = Object.keys(propertyMap[property]);
        }

        return values.map(function (value) {
          return {
            caption: value,
            snippet: value,
            meta: "property value",
            score: 1000000
          };
        });
      };
    }).call(CssCompletions.prototype);
    exports.CssCompletions = CssCompletions;
  });
  ace.define("ace/mode/behaviour/css", ["require", "exports", "module", "ace/lib/oop", "ace/mode/behaviour", "ace/mode/behaviour/cstyle", "ace/token_iterator"], function (require, exports, module) {

    var oop = require("../../lib/oop");

    var Behaviour = require("../behaviour").Behaviour;

    var CstyleBehaviour = require("./cstyle").CstyleBehaviour;

    var TokenIterator = require("../../token_iterator").TokenIterator;

    var CssBehaviour = function () {
      this.inherit(CstyleBehaviour);
      this.add("colon", "insertion", function (state, action, editor, session, text) {
        if (text === ':' && editor.selection.isEmpty()) {
          var cursor = editor.getCursorPosition();
          var iterator = new TokenIterator(session, cursor.row, cursor.column);
          var token = iterator.getCurrentToken();

          if (token && token.value.match(/\s+/)) {
            token = iterator.stepBackward();
          }

          if (token && token.type === 'support.type') {
            var line = session.doc.getLine(cursor.row);
            var rightChar = line.substring(cursor.column, cursor.column + 1);

            if (rightChar === ':') {
              return {
                text: '',
                selection: [1, 1]
              };
            }

            if (/^(\s+[^;]|\s*$)/.test(line.substring(cursor.column))) {
              return {
                text: ':;',
                selection: [1, 1]
              };
            }
          }
        }
      });
      this.add("colon", "deletion", function (state, action, editor, session, range) {
        var selected = session.doc.getTextRange(range);

        if (!range.isMultiLine() && selected === ':') {
          var cursor = editor.getCursorPosition();
          var iterator = new TokenIterator(session, cursor.row, cursor.column);
          var token = iterator.getCurrentToken();

          if (token && token.value.match(/\s+/)) {
            token = iterator.stepBackward();
          }

          if (token && token.type === 'support.type') {
            var line = session.doc.getLine(range.start.row);
            var rightChar = line.substring(range.end.column, range.end.column + 1);

            if (rightChar === ';') {
              range.end.column++;
              return range;
            }
          }
        }
      });
      this.add("semicolon", "insertion", function (state, action, editor, session, text) {
        if (text === ';' && editor.selection.isEmpty()) {
          var cursor = editor.getCursorPosition();
          var line = session.doc.getLine(cursor.row);
          var rightChar = line.substring(cursor.column, cursor.column + 1);

          if (rightChar === ';') {
            return {
              text: '',
              selection: [1, 1]
            };
          }
        }
      });
      this.add("!important", "insertion", function (state, action, editor, session, text) {
        if (text === '!' && editor.selection.isEmpty()) {
          var cursor = editor.getCursorPosition();
          var line = session.doc.getLine(cursor.row);

          if (/^\s*(;|}|$)/.test(line.substring(cursor.column))) {
            return {
              text: '!important',
              selection: [10, 10]
            };
          }
        }
      });
    };

    oop.inherits(CssBehaviour, CstyleBehaviour);
    exports.CssBehaviour = CssBehaviour;
  });
  ace.define("ace/mode/folding/cstyle", ["require", "exports", "module", "ace/lib/oop", "ace/range", "ace/mode/folding/fold_mode"], function (require, exports, module) {

    var oop = require("../../lib/oop");

    var Range = require("../../range").Range;

    var BaseFoldMode = require("./fold_mode").FoldMode;

    var FoldMode = exports.FoldMode = function (commentRegex) {
      if (commentRegex) {
        this.foldingStartMarker = new RegExp(this.foldingStartMarker.source.replace(/\|[^|]*?$/, "|" + commentRegex.start));
        this.foldingStopMarker = new RegExp(this.foldingStopMarker.source.replace(/\|[^|]*?$/, "|" + commentRegex.end));
      }
    };

    oop.inherits(FoldMode, BaseFoldMode);
    (function () {
      this.foldingStartMarker = /([\{\[\(])[^\}\]\)]*$|^\s*(\/\*)/;
      this.foldingStopMarker = /^[^\[\{\(]*([\}\]\)])|^[\s\*]*(\*\/)/;
      this.singleLineBlockCommentRe = /^\s*(\/\*).*\*\/\s*$/;
      this.tripleStarBlockCommentRe = /^\s*(\/\*\*\*).*\*\/\s*$/;
      this.startRegionRe = /^\s*(\/\*|\/\/)#?region\b/;
      this._getFoldWidgetBase = this.getFoldWidget;

      this.getFoldWidget = function (session, foldStyle, row) {
        var line = session.getLine(row);

        if (this.singleLineBlockCommentRe.test(line)) {
          if (!this.startRegionRe.test(line) && !this.tripleStarBlockCommentRe.test(line)) return "";
        }

        var fw = this._getFoldWidgetBase(session, foldStyle, row);

        if (!fw && this.startRegionRe.test(line)) return "start"; // lineCommentRegionStart

        return fw;
      };

      this.getFoldWidgetRange = function (session, foldStyle, row, forceMultiline) {
        var line = session.getLine(row);
        if (this.startRegionRe.test(line)) return this.getCommentRegionBlock(session, line, row);
        var match = line.match(this.foldingStartMarker);

        if (match) {
          var i = match.index;
          if (match[1]) return this.openingBracketBlock(session, match[1], row, i);
          var range = session.getCommentFoldRange(row, i + match[0].length, 1);

          if (range && !range.isMultiLine()) {
            if (forceMultiline) {
              range = this.getSectionRange(session, row);
            } else if (foldStyle != "all") range = null;
          }

          return range;
        }

        if (foldStyle === "markbegin") return;
        var match = line.match(this.foldingStopMarker);

        if (match) {
          var i = match.index + match[0].length;
          if (match[1]) return this.closingBracketBlock(session, match[1], row, i);
          return session.getCommentFoldRange(row, i, -1);
        }
      };

      this.getSectionRange = function (session, row) {
        var line = session.getLine(row);
        var startIndent = line.search(/\S/);
        var startRow = row;
        var startColumn = line.length;
        row = row + 1;
        var endRow = row;
        var maxRow = session.getLength();

        while (++row < maxRow) {
          line = session.getLine(row);
          var indent = line.search(/\S/);
          if (indent === -1) continue;
          if (startIndent > indent) break;
          var subRange = this.getFoldWidgetRange(session, "all", row);

          if (subRange) {
            if (subRange.start.row <= startRow) {
              break;
            } else if (subRange.isMultiLine()) {
              row = subRange.end.row;
            } else if (startIndent == indent) {
              break;
            }
          }

          endRow = row;
        }

        return new Range(startRow, startColumn, endRow, session.getLine(endRow).length);
      };

      this.getCommentRegionBlock = function (session, line, row) {
        var startColumn = line.search(/\s*$/);
        var maxRow = session.getLength();
        var startRow = row;
        var re = /^\s*(?:\/\*|\/\/|--)#?(end)?region\b/;
        var depth = 1;

        while (++row < maxRow) {
          line = session.getLine(row);
          var m = re.exec(line);
          if (!m) continue;
          if (m[1]) depth--;else depth++;
          if (!depth) break;
        }

        var endRow = row;

        if (endRow > startRow) {
          return new Range(startRow, startColumn, endRow, line.length);
        }
      };
    }).call(FoldMode.prototype);
  });
  ace.define("ace/mode/css", ["require", "exports", "module", "ace/lib/oop", "ace/mode/text", "ace/mode/css_highlight_rules", "ace/mode/matching_brace_outdent", "ace/worker/worker_client", "ace/mode/css_completions", "ace/mode/behaviour/css", "ace/mode/folding/cstyle"], function (require, exports, module) {

    var oop = require("../lib/oop");

    var TextMode = require("./text").Mode;

    var CssHighlightRules = require("./css_highlight_rules").CssHighlightRules;

    var MatchingBraceOutdent = require("./matching_brace_outdent").MatchingBraceOutdent;

    var WorkerClient = require("../worker/worker_client").WorkerClient;

    var CssCompletions = require("./css_completions").CssCompletions;

    var CssBehaviour = require("./behaviour/css").CssBehaviour;

    var CStyleFoldMode = require("./folding/cstyle").FoldMode;

    var Mode = function () {
      this.HighlightRules = CssHighlightRules;
      this.$outdent = new MatchingBraceOutdent();
      this.$behaviour = new CssBehaviour();
      this.$completer = new CssCompletions();
      this.foldingRules = new CStyleFoldMode();
    };

    oop.inherits(Mode, TextMode);
    (function () {
      this.foldingRules = "cStyle";
      this.blockComment = {
        start: "/*",
        end: "*/"
      };

      this.getNextLineIndent = function (state, line, tab) {
        var indent = this.$getIndent(line);
        var tokens = this.getTokenizer().getLineTokens(line, state).tokens;

        if (tokens.length && tokens[tokens.length - 1].type == "comment") {
          return indent;
        }

        var match = line.match(/^.*\{\s*$/);

        if (match) {
          indent += tab;
        }

        return indent;
      };

      this.checkOutdent = function (state, line, input) {
        return this.$outdent.checkOutdent(line, input);
      };

      this.autoOutdent = function (state, doc, row) {
        this.$outdent.autoOutdent(doc, row);
      };

      this.getCompletions = function (state, session, pos, prefix) {
        return this.$completer.getCompletions(state, session, pos, prefix);
      };

      this.createWorker = function (session) {
        var worker = new WorkerClient(["ace"], "ace/mode/css_worker", "Worker");
        worker.attachToDocument(session.getDocument());
        worker.on("annotate", function (e) {
          session.setAnnotations(e.data);
        });
        worker.on("terminate", function () {
          session.clearAnnotations();
        });
        return worker;
      };

      this.$id = "ace/mode/css";
      this.snippetFileId = "ace/snippets/css";
    }).call(Mode.prototype);
    exports.Mode = Mode;
  });

  (function () {
    ace.require(["ace/mode/css"], function (m) {
      if ( module) {
        module.exports = m;
      }
    });
  })();
});

var themeMonokai = createCommonjsModule(function (module, exports) {
  ace.define("ace/theme/monokai.css", ["require", "exports", "module"], function (require, exports, module) {
    module.exports = ".ace-monokai .ace_gutter {\n  background: #2F3129;\n  color: #8F908A\n}\n\n.ace-monokai .ace_print-margin {\n  width: 1px;\n  background: #555651\n}\n\n.ace-monokai {\n  background-color: #272822;\n  color: #F8F8F2\n}\n\n.ace-monokai .ace_cursor {\n  color: #F8F8F0\n}\n\n.ace-monokai .ace_marker-layer .ace_selection {\n  background: #49483E\n}\n\n.ace-monokai.ace_multiselect .ace_selection.ace_start {\n  box-shadow: 0 0 3px 0px #272822;\n}\n\n.ace-monokai .ace_marker-layer .ace_step {\n  background: rgb(102, 82, 0)\n}\n\n.ace-monokai .ace_marker-layer .ace_bracket {\n  margin: -1px 0 0 -1px;\n  border: 1px solid #49483E\n}\n\n.ace-monokai .ace_marker-layer .ace_active-line {\n  background: #202020\n}\n\n.ace-monokai .ace_gutter-active-line {\n  background-color: #272727\n}\n\n.ace-monokai .ace_marker-layer .ace_selected-word {\n  border: 1px solid #49483E\n}\n\n.ace-monokai .ace_invisible {\n  color: #52524d\n}\n\n.ace-monokai .ace_entity.ace_name.ace_tag,\n.ace-monokai .ace_keyword,\n.ace-monokai .ace_meta.ace_tag,\n.ace-monokai .ace_storage {\n  color: #F92672\n}\n\n.ace-monokai .ace_punctuation,\n.ace-monokai .ace_punctuation.ace_tag {\n  color: #fff\n}\n\n.ace-monokai .ace_constant.ace_character,\n.ace-monokai .ace_constant.ace_language,\n.ace-monokai .ace_constant.ace_numeric,\n.ace-monokai .ace_constant.ace_other {\n  color: #AE81FF\n}\n\n.ace-monokai .ace_invalid {\n  color: #F8F8F0;\n  background-color: #F92672\n}\n\n.ace-monokai .ace_invalid.ace_deprecated {\n  color: #F8F8F0;\n  background-color: #AE81FF\n}\n\n.ace-monokai .ace_support.ace_constant,\n.ace-monokai .ace_support.ace_function {\n  color: #66D9EF\n}\n\n.ace-monokai .ace_fold {\n  background-color: #A6E22E;\n  border-color: #F8F8F2\n}\n\n.ace-monokai .ace_storage.ace_type,\n.ace-monokai .ace_support.ace_class,\n.ace-monokai .ace_support.ace_type {\n  font-style: italic;\n  color: #66D9EF\n}\n\n.ace-monokai .ace_entity.ace_name.ace_function,\n.ace-monokai .ace_entity.ace_other,\n.ace-monokai .ace_entity.ace_other.ace_attribute-name,\n.ace-monokai .ace_variable {\n  color: #A6E22E\n}\n\n.ace-monokai .ace_variable.ace_parameter {\n  font-style: italic;\n  color: #FD971F\n}\n\n.ace-monokai .ace_string {\n  color: #E6DB74\n}\n\n.ace-monokai .ace_comment {\n  color: #75715E\n}\n\n.ace-monokai .ace_indent-guide {\n  background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAACCAYAAACZgbYnAAAAEklEQVQImWPQ0FD0ZXBzd/wPAAjVAoxeSgNeAAAAAElFTkSuQmCC) right repeat-y\n}\n\n.ace-monokai .ace_indent-guide-active {\n  background: url(\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAACCAYAAACZgbYnAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAIGNIUk0AAHolAACAgwAA+f8AAIDpAAB1MAAA6mAAADqYAAAXb5JfxUYAAAAZSURBVHjaYvj///9/hivKyv8BAAAA//8DACLqBhbvk+/eAAAAAElFTkSuQmCC\") right repeat-y;\n}\n";
  });
  ace.define("ace/theme/monokai", ["require", "exports", "module", "ace/theme/monokai.css", "ace/lib/dom"], function (require, exports, module) {
    exports.isDark = true;
    exports.cssClass = "ace-monokai";
    exports.cssText = require("./monokai.css");

    var dom = require("../lib/dom");

    dom.importCssString(exports.cssText, exports.cssClass, false);
  });

  (function () {
    ace.require(["ace/theme/monokai"], function (m) {
      if ( module) {
        module.exports = m;
      }
    });
  })();
});

var extLanguage_tools = createCommonjsModule(function (module, exports) {
  ace.define("ace/snippets", ["require", "exports", "module", "ace/lib/dom", "ace/lib/oop", "ace/lib/event_emitter", "ace/lib/lang", "ace/range", "ace/range_list", "ace/keyboard/hash_handler", "ace/tokenizer", "ace/clipboard", "ace/editor"], function (require, exports, module) {

    var dom = require("./lib/dom");

    var oop = require("./lib/oop");

    var EventEmitter = require("./lib/event_emitter").EventEmitter;

    var lang = require("./lib/lang");

    var Range = require("./range").Range;

    var RangeList = require("./range_list").RangeList;

    var HashHandler = require("./keyboard/hash_handler").HashHandler;

    var Tokenizer = require("./tokenizer").Tokenizer;

    var clipboard = require("./clipboard");

    var VARIABLES = {
      CURRENT_WORD: function (editor) {
        return editor.session.getTextRange(editor.session.getWordRange());
      },
      SELECTION: function (editor, name, indentation) {
        var text = editor.session.getTextRange();
        if (indentation) return text.replace(/\n\r?([ \t]*\S)/g, "\n" + indentation + "$1");
        return text;
      },
      CURRENT_LINE: function (editor) {
        return editor.session.getLine(editor.getCursorPosition().row);
      },
      PREV_LINE: function (editor) {
        return editor.session.getLine(editor.getCursorPosition().row - 1);
      },
      LINE_INDEX: function (editor) {
        return editor.getCursorPosition().row;
      },
      LINE_NUMBER: function (editor) {
        return editor.getCursorPosition().row + 1;
      },
      SOFT_TABS: function (editor) {
        return editor.session.getUseSoftTabs() ? "YES" : "NO";
      },
      TAB_SIZE: function (editor) {
        return editor.session.getTabSize();
      },
      CLIPBOARD: function (editor) {
        return clipboard.getText && clipboard.getText();
      },
      FILENAME: function (editor) {
        return /[^/\\]*$/.exec(this.FILEPATH(editor))[0];
      },
      FILENAME_BASE: function (editor) {
        return /[^/\\]*$/.exec(this.FILEPATH(editor))[0].replace(/\.[^.]*$/, "");
      },
      DIRECTORY: function (editor) {
        return this.FILEPATH(editor).replace(/[^/\\]*$/, "");
      },
      FILEPATH: function (editor) {
        return "/not implemented.txt";
      },
      WORKSPACE_NAME: function () {
        return "Unknown";
      },
      FULLNAME: function () {
        return "Unknown";
      },
      BLOCK_COMMENT_START: function (editor) {
        var mode = editor.session.$mode || {};
        return mode.blockComment && mode.blockComment.start || "";
      },
      BLOCK_COMMENT_END: function (editor) {
        var mode = editor.session.$mode || {};
        return mode.blockComment && mode.blockComment.end || "";
      },
      LINE_COMMENT: function (editor) {
        var mode = editor.session.$mode || {};
        return mode.lineCommentStart || "";
      },
      CURRENT_YEAR: date.bind(null, {
        year: "numeric"
      }),
      CURRENT_YEAR_SHORT: date.bind(null, {
        year: "2-digit"
      }),
      CURRENT_MONTH: date.bind(null, {
        month: "numeric"
      }),
      CURRENT_MONTH_NAME: date.bind(null, {
        month: "long"
      }),
      CURRENT_MONTH_NAME_SHORT: date.bind(null, {
        month: "short"
      }),
      CURRENT_DATE: date.bind(null, {
        day: "2-digit"
      }),
      CURRENT_DAY_NAME: date.bind(null, {
        weekday: "long"
      }),
      CURRENT_DAY_NAME_SHORT: date.bind(null, {
        weekday: "short"
      }),
      CURRENT_HOUR: date.bind(null, {
        hour: "2-digit",
        hour12: false
      }),
      CURRENT_MINUTE: date.bind(null, {
        minute: "2-digit"
      }),
      CURRENT_SECOND: date.bind(null, {
        second: "2-digit"
      })
    };
    VARIABLES.SELECTED_TEXT = VARIABLES.SELECTION;

    function date(dateFormat) {
      var str = new Date().toLocaleString("en-us", dateFormat);
      return str.length == 1 ? "0" + str : str;
    }

    var SnippetManager = function () {
      this.snippetMap = {};
      this.snippetNameMap = {};
    };

    (function () {
      oop.implement(this, EventEmitter);

      this.getTokenizer = function () {
        return SnippetManager.$tokenizer || this.createTokenizer();
      };

      this.createTokenizer = function () {
        function TabstopToken(str) {
          str = str.substr(1);
          if (/^\d+$/.test(str)) return [{
            tabstopId: parseInt(str, 10)
          }];
          return [{
            text: str
          }];
        }

        function escape(ch) {
          return "(?:[^\\\\" + ch + "]|\\\\.)";
        }

        var formatMatcher = {
          regex: "/(" + escape("/") + "+)/",
          onMatch: function (val, state, stack) {
            var ts = stack[0];
            ts.fmtString = true;
            ts.guard = val.slice(1, -1);
            ts.flag = "";
            return "";
          },
          next: "formatString"
        };
        SnippetManager.$tokenizer = new Tokenizer({
          start: [{
            regex: /\\./,
            onMatch: function (val, state, stack) {
              var ch = val[1];

              if (ch == "}" && stack.length) {
                val = ch;
              } else if ("`$\\".indexOf(ch) != -1) {
                val = ch;
              }

              return [val];
            }
          }, {
            regex: /}/,
            onMatch: function (val, state, stack) {
              return [stack.length ? stack.shift() : val];
            }
          }, {
            regex: /\$(?:\d+|\w+)/,
            onMatch: TabstopToken
          }, {
            regex: /\$\{[\dA-Z_a-z]+/,
            onMatch: function (str, state, stack) {
              var t = TabstopToken(str.substr(1));
              stack.unshift(t[0]);
              return t;
            },
            next: "snippetVar"
          }, {
            regex: /\n/,
            token: "newline",
            merge: false
          }],
          snippetVar: [{
            regex: "\\|" + escape("\\|") + "*\\|",
            onMatch: function (val, state, stack) {
              var choices = val.slice(1, -1).replace(/\\[,|\\]|,/g, function (operator) {
                return operator.length == 2 ? operator[1] : "\x00";
              }).split("\x00").map(function (value) {
                return {
                  value: value
                };
              });
              stack[0].choices = choices;
              return [choices[0]];
            },
            next: "start"
          }, formatMatcher, {
            regex: "([^:}\\\\]|\\\\.)*:?",
            token: "",
            next: "start"
          }],
          formatString: [{
            regex: /:/,
            onMatch: function (val, state, stack) {
              if (stack.length && stack[0].expectElse) {
                stack[0].expectElse = false;
                stack[0].ifEnd = {
                  elseEnd: stack[0]
                };
                return [stack[0].ifEnd];
              }

              return ":";
            }
          }, {
            regex: /\\./,
            onMatch: function (val, state, stack) {
              var ch = val[1];
              if (ch == "}" && stack.length) val = ch;else if ("`$\\".indexOf(ch) != -1) val = ch;else if (ch == "n") val = "\n";else if (ch == "t") val = "\t";else if ("ulULE".indexOf(ch) != -1) val = {
                changeCase: ch,
                local: ch > "a"
              };
              return [val];
            }
          }, {
            regex: "/\\w*}",
            onMatch: function (val, state, stack) {
              var next = stack.shift();
              if (next) next.flag = val.slice(1, -1);
              this.next = next && next.tabstopId ? "start" : "";
              return [next || val];
            },
            next: "start"
          }, {
            regex: /\$(?:\d+|\w+)/,
            onMatch: function (val, state, stack) {
              return [{
                text: val.slice(1)
              }];
            }
          }, {
            regex: /\${\w+/,
            onMatch: function (val, state, stack) {
              var token = {
                text: val.slice(2)
              };
              stack.unshift(token);
              return [token];
            },
            next: "formatStringVar"
          }, {
            regex: /\n/,
            token: "newline",
            merge: false
          }, {
            regex: /}/,
            onMatch: function (val, state, stack) {
              var next = stack.shift();
              this.next = next && next.tabstopId ? "start" : "";
              return [next || val];
            },
            next: "start"
          }],
          formatStringVar: [{
            regex: /:\/\w+}/,
            onMatch: function (val, state, stack) {
              var ts = stack[0];
              ts.formatFunction = val.slice(2, -1);
              return [stack.shift()];
            },
            next: "formatString"
          }, formatMatcher, {
            regex: /:[\?\-+]?/,
            onMatch: function (val, state, stack) {
              if (val[1] == "+") stack[0].ifEnd = stack[0];
              if (val[1] == "?") stack[0].expectElse = true;
            },
            next: "formatString"
          }, {
            regex: "([^:}\\\\]|\\\\.)*:?",
            token: "",
            next: "formatString"
          }]
        });
        return SnippetManager.$tokenizer;
      };

      this.tokenizeTmSnippet = function (str, startState) {
        return this.getTokenizer().getLineTokens(str, startState).tokens.map(function (x) {
          return x.value || x;
        });
      };

      this.getVariableValue = function (editor, name, indentation) {
        if (/^\d+$/.test(name)) return (this.variables.__ || {})[name] || "";
        if (/^[A-Z]\d+$/.test(name)) return (this.variables[name[0] + "__"] || {})[name.substr(1)] || "";
        name = name.replace(/^TM_/, "");
        if (!this.variables.hasOwnProperty(name)) return "";
        var value = this.variables[name];
        if (typeof value == "function") value = this.variables[name](editor, name, indentation);
        return value == null ? "" : value;
      };

      this.variables = VARIABLES;

      this.tmStrFormat = function (str, ch, editor) {
        if (!ch.fmt) return str;
        var flag = ch.flag || "";
        var re = ch.guard;
        re = new RegExp(re, flag.replace(/[^gim]/g, ""));
        var fmtTokens = typeof ch.fmt == "string" ? this.tokenizeTmSnippet(ch.fmt, "formatString") : ch.fmt;

        var _self = this;

        var formatted = str.replace(re, function () {
          var oldArgs = _self.variables.__;
          _self.variables.__ = [].slice.call(arguments);

          var fmtParts = _self.resolveVariables(fmtTokens, editor);

          var gChangeCase = "E";

          for (var i = 0; i < fmtParts.length; i++) {
            var ch = fmtParts[i];

            if (typeof ch == "object") {
              fmtParts[i] = "";

              if (ch.changeCase && ch.local) {
                var next = fmtParts[i + 1];

                if (next && typeof next == "string") {
                  if (ch.changeCase == "u") fmtParts[i] = next[0].toUpperCase();else fmtParts[i] = next[0].toLowerCase();
                  fmtParts[i + 1] = next.substr(1);
                }
              } else if (ch.changeCase) {
                gChangeCase = ch.changeCase;
              }
            } else if (gChangeCase == "U") {
              fmtParts[i] = ch.toUpperCase();
            } else if (gChangeCase == "L") {
              fmtParts[i] = ch.toLowerCase();
            }
          }

          _self.variables.__ = oldArgs;
          return fmtParts.join("");
        });
        return formatted;
      };

      this.tmFormatFunction = function (str, ch, editor) {
        if (ch.formatFunction == "upcase") return str.toUpperCase();
        if (ch.formatFunction == "downcase") return str.toLowerCase();
        return str;
      };

      this.resolveVariables = function (snippet, editor) {
        var result = [];
        var indentation = "";
        var afterNewLine = true;

        for (var i = 0; i < snippet.length; i++) {
          var ch = snippet[i];

          if (typeof ch == "string") {
            result.push(ch);

            if (ch == "\n") {
              afterNewLine = true;
              indentation = "";
            } else if (afterNewLine) {
              indentation = /^\t*/.exec(ch)[0];
              afterNewLine = /\S/.test(ch);
            }

            continue;
          }

          if (!ch) continue;
          afterNewLine = false;

          if (ch.fmtString) {
            var j = snippet.indexOf(ch, i + 1);
            if (j == -1) j = snippet.length;
            ch.fmt = snippet.slice(i + 1, j);
            i = j;
          }

          if (ch.text) {
            var value = this.getVariableValue(editor, ch.text, indentation) + "";
            if (ch.fmtString) value = this.tmStrFormat(value, ch, editor);
            if (ch.formatFunction) value = this.tmFormatFunction(value, ch, editor);

            if (value && !ch.ifEnd) {
              result.push(value);
              gotoNext(ch);
            } else if (!value && ch.ifEnd) {
              gotoNext(ch.ifEnd);
            }
          } else if (ch.elseEnd) {
            gotoNext(ch.elseEnd);
          } else if (ch.tabstopId != null) {
            result.push(ch);
          } else if (ch.changeCase != null) {
            result.push(ch);
          }
        }

        function gotoNext(ch) {
          var i1 = snippet.indexOf(ch, i + 1);
          if (i1 != -1) i = i1;
        }

        return result;
      };

      this.insertSnippetForSelection = function (editor, snippetText) {
        var cursor = editor.getCursorPosition();
        var line = editor.session.getLine(cursor.row);
        var tabString = editor.session.getTabString();
        var indentString = line.match(/^\s*/)[0];
        if (cursor.column < indentString.length) indentString = indentString.slice(0, cursor.column);
        snippetText = snippetText.replace(/\r/g, "");
        var tokens = this.tokenizeTmSnippet(snippetText);
        tokens = this.resolveVariables(tokens, editor);
        tokens = tokens.map(function (x) {
          if (x == "\n") return x + indentString;
          if (typeof x == "string") return x.replace(/\t/g, tabString);
          return x;
        });
        var tabstops = [];
        tokens.forEach(function (p, i) {
          if (typeof p != "object") return;
          var id = p.tabstopId;
          var ts = tabstops[id];

          if (!ts) {
            ts = tabstops[id] = [];
            ts.index = id;
            ts.value = "";
            ts.parents = {};
          }

          if (ts.indexOf(p) !== -1) return;
          if (p.choices && !ts.choices) ts.choices = p.choices;
          ts.push(p);
          var i1 = tokens.indexOf(p, i + 1);
          if (i1 === -1) return;
          var value = tokens.slice(i + 1, i1);
          var isNested = value.some(function (t) {
            return typeof t === "object";
          });

          if (isNested && !ts.value) {
            ts.value = value;
          } else if (value.length && (!ts.value || typeof ts.value !== "string")) {
            ts.value = value.join("");
          }
        });
        tabstops.forEach(function (ts) {
          ts.length = 0;
        });
        var expanding = {};

        function copyValue(val) {
          var copy = [];

          for (var i = 0; i < val.length; i++) {
            var p = val[i];

            if (typeof p == "object") {
              if (expanding[p.tabstopId]) continue;
              var j = val.lastIndexOf(p, i - 1);
              p = copy[j] || {
                tabstopId: p.tabstopId
              };
            }

            copy[i] = p;
          }

          return copy;
        }

        for (var i = 0; i < tokens.length; i++) {
          var p = tokens[i];
          if (typeof p != "object") continue;
          var id = p.tabstopId;
          var ts = tabstops[id];
          var i1 = tokens.indexOf(p, i + 1);

          if (expanding[id]) {
            if (expanding[id] === p) {
              delete expanding[id];
              Object.keys(expanding).forEach(function (parentId) {
                ts.parents[parentId] = true;
              });
            }

            continue;
          }

          expanding[id] = p;
          var value = ts.value;
          if (typeof value !== "string") value = copyValue(value);else if (p.fmt) value = this.tmStrFormat(value, p, editor);
          tokens.splice.apply(tokens, [i + 1, Math.max(0, i1 - i)].concat(value, p));
          if (ts.indexOf(p) === -1) ts.push(p);
        }

        var row = 0,
            column = 0;
        var text = "";
        tokens.forEach(function (t) {
          if (typeof t === "string") {
            var lines = t.split("\n");

            if (lines.length > 1) {
              column = lines[lines.length - 1].length;
              row += lines.length - 1;
            } else column += t.length;

            text += t;
          } else if (t) {
            if (!t.start) t.start = {
              row: row,
              column: column
            };else t.end = {
              row: row,
              column: column
            };
          }
        });
        var range = editor.getSelectionRange();
        var end = editor.session.replace(range, text);
        var tabstopManager = new TabstopManager(editor);
        var selectionId = editor.inVirtualSelectionMode && editor.selection.index;
        tabstopManager.addTabstops(tabstops, range.start, end, selectionId);
      };

      this.insertSnippet = function (editor, snippetText) {
        var self = this;
        if (editor.inVirtualSelectionMode) return self.insertSnippetForSelection(editor, snippetText);
        editor.forEachSelection(function () {
          self.insertSnippetForSelection(editor, snippetText);
        }, null, {
          keepOrder: true
        });
        if (editor.tabstopManager) editor.tabstopManager.tabNext();
      };

      this.$getScope = function (editor) {
        var scope = editor.session.$mode.$id || "";
        scope = scope.split("/").pop();

        if (scope === "html" || scope === "php") {
          if (scope === "php" && !editor.session.$mode.inlinePhp) scope = "html";
          var c = editor.getCursorPosition();
          var state = editor.session.getState(c.row);

          if (typeof state === "object") {
            state = state[0];
          }

          if (state.substring) {
            if (state.substring(0, 3) == "js-") scope = "javascript";else if (state.substring(0, 4) == "css-") scope = "css";else if (state.substring(0, 4) == "php-") scope = "php";
          }
        }

        return scope;
      };

      this.getActiveScopes = function (editor) {
        var scope = this.$getScope(editor);
        var scopes = [scope];
        var snippetMap = this.snippetMap;

        if (snippetMap[scope] && snippetMap[scope].includeScopes) {
          scopes.push.apply(scopes, snippetMap[scope].includeScopes);
        }

        scopes.push("_");
        return scopes;
      };

      this.expandWithTab = function (editor, options) {
        var self = this;
        var result = editor.forEachSelection(function () {
          return self.expandSnippetForSelection(editor, options);
        }, null, {
          keepOrder: true
        });
        if (result && editor.tabstopManager) editor.tabstopManager.tabNext();
        return result;
      };

      this.expandSnippetForSelection = function (editor, options) {
        var cursor = editor.getCursorPosition();
        var line = editor.session.getLine(cursor.row);
        var before = line.substring(0, cursor.column);
        var after = line.substr(cursor.column);
        var snippetMap = this.snippetMap;
        var snippet;
        this.getActiveScopes(editor).some(function (scope) {
          var snippets = snippetMap[scope];
          if (snippets) snippet = this.findMatchingSnippet(snippets, before, after);
          return !!snippet;
        }, this);
        if (!snippet) return false;
        if (options && options.dryRun) return true;
        editor.session.doc.removeInLine(cursor.row, cursor.column - snippet.replaceBefore.length, cursor.column + snippet.replaceAfter.length);
        this.variables.M__ = snippet.matchBefore;
        this.variables.T__ = snippet.matchAfter;
        this.insertSnippetForSelection(editor, snippet.content);
        this.variables.M__ = this.variables.T__ = null;
        return true;
      };

      this.findMatchingSnippet = function (snippetList, before, after) {
        for (var i = snippetList.length; i--;) {
          var s = snippetList[i];
          if (s.startRe && !s.startRe.test(before)) continue;
          if (s.endRe && !s.endRe.test(after)) continue;
          if (!s.startRe && !s.endRe) continue;
          s.matchBefore = s.startRe ? s.startRe.exec(before) : [""];
          s.matchAfter = s.endRe ? s.endRe.exec(after) : [""];
          s.replaceBefore = s.triggerRe ? s.triggerRe.exec(before)[0] : "";
          s.replaceAfter = s.endTriggerRe ? s.endTriggerRe.exec(after)[0] : "";
          return s;
        }
      };

      this.snippetMap = {};
      this.snippetNameMap = {};

      this.register = function (snippets, scope) {
        var snippetMap = this.snippetMap;
        var snippetNameMap = this.snippetNameMap;
        var self = this;
        if (!snippets) snippets = [];

        function wrapRegexp(src) {
          if (src && !/^\^?\(.*\)\$?$|^\\b$/.test(src)) src = "(?:" + src + ")";
          return src || "";
        }

        function guardedRegexp(re, guard, opening) {
          re = wrapRegexp(re);
          guard = wrapRegexp(guard);

          if (opening) {
            re = guard + re;
            if (re && re[re.length - 1] != "$") re = re + "$";
          } else {
            re = re + guard;
            if (re && re[0] != "^") re = "^" + re;
          }

          return new RegExp(re);
        }

        function addSnippet(s) {
          if (!s.scope) s.scope = scope || "_";
          scope = s.scope;

          if (!snippetMap[scope]) {
            snippetMap[scope] = [];
            snippetNameMap[scope] = {};
          }

          var map = snippetNameMap[scope];

          if (s.name) {
            var old = map[s.name];
            if (old) self.unregister(old);
            map[s.name] = s;
          }

          snippetMap[scope].push(s);
          if (s.prefix) s.tabTrigger = s.prefix;
          if (!s.content && s.body) s.content = Array.isArray(s.body) ? s.body.join("\n") : s.body;

          if (s.tabTrigger && !s.trigger) {
            if (!s.guard && /^\w/.test(s.tabTrigger)) s.guard = "\\b";
            s.trigger = lang.escapeRegExp(s.tabTrigger);
          }

          if (!s.trigger && !s.guard && !s.endTrigger && !s.endGuard) return;
          s.startRe = guardedRegexp(s.trigger, s.guard, true);
          s.triggerRe = new RegExp(s.trigger);
          s.endRe = guardedRegexp(s.endTrigger, s.endGuard, true);
          s.endTriggerRe = new RegExp(s.endTrigger);
        }

        if (Array.isArray(snippets)) {
          snippets.forEach(addSnippet);
        } else {
          Object.keys(snippets).forEach(function (key) {
            addSnippet(snippets[key]);
          });
        }

        this._signal("registerSnippets", {
          scope: scope
        });
      };

      this.unregister = function (snippets, scope) {
        var snippetMap = this.snippetMap;
        var snippetNameMap = this.snippetNameMap;

        function removeSnippet(s) {
          var nameMap = snippetNameMap[s.scope || scope];

          if (nameMap && nameMap[s.name]) {
            delete nameMap[s.name];
            var map = snippetMap[s.scope || scope];
            var i = map && map.indexOf(s);
            if (i >= 0) map.splice(i, 1);
          }
        }

        if (snippets.content) removeSnippet(snippets);else if (Array.isArray(snippets)) snippets.forEach(removeSnippet);
      };

      this.parseSnippetFile = function (str) {
        str = str.replace(/\r/g, "");
        var list = [],
            snippet = {};
        var re = /^#.*|^({[\s\S]*})\s*$|^(\S+) (.*)$|^((?:\n*\t.*)+)/gm;
        var m;

        while (m = re.exec(str)) {
          if (m[1]) {
            try {
              snippet = JSON.parse(m[1]);
              list.push(snippet);
            } catch (e) {}
          }

          if (m[4]) {
            snippet.content = m[4].replace(/^\t/gm, "");
            list.push(snippet);
            snippet = {};
          } else {
            var key = m[2],
                val = m[3];

            if (key == "regex") {
              var guardRe = /\/((?:[^\/\\]|\\.)*)|$/g;
              snippet.guard = guardRe.exec(val)[1];
              snippet.trigger = guardRe.exec(val)[1];
              snippet.endTrigger = guardRe.exec(val)[1];
              snippet.endGuard = guardRe.exec(val)[1];
            } else if (key == "snippet") {
              snippet.tabTrigger = val.match(/^\S*/)[0];
              if (!snippet.name) snippet.name = val;
            } else if (key) {
              snippet[key] = val;
            }
          }
        }

        return list;
      };

      this.getSnippetByName = function (name, editor) {
        var snippetMap = this.snippetNameMap;
        var snippet;
        this.getActiveScopes(editor).some(function (scope) {
          var snippets = snippetMap[scope];
          if (snippets) snippet = snippets[name];
          return !!snippet;
        }, this);
        return snippet;
      };
    }).call(SnippetManager.prototype);

    var TabstopManager = function (editor) {
      if (editor.tabstopManager) return editor.tabstopManager;
      editor.tabstopManager = this;
      this.$onChange = this.onChange.bind(this);
      this.$onChangeSelection = lang.delayedCall(this.onChangeSelection.bind(this)).schedule;
      this.$onChangeSession = this.onChangeSession.bind(this);
      this.$onAfterExec = this.onAfterExec.bind(this);
      this.attach(editor);
    };

    (function () {
      this.attach = function (editor) {
        this.index = 0;
        this.ranges = [];
        this.tabstops = [];
        this.$openTabstops = null;
        this.selectedTabstop = null;
        this.editor = editor;
        this.editor.on("change", this.$onChange);
        this.editor.on("changeSelection", this.$onChangeSelection);
        this.editor.on("changeSession", this.$onChangeSession);
        this.editor.commands.on("afterExec", this.$onAfterExec);
        this.editor.keyBinding.addKeyboardHandler(this.keyboardHandler);
      };

      this.detach = function () {
        this.tabstops.forEach(this.removeTabstopMarkers, this);
        this.ranges = null;
        this.tabstops = null;
        this.selectedTabstop = null;
        this.editor.removeListener("change", this.$onChange);
        this.editor.removeListener("changeSelection", this.$onChangeSelection);
        this.editor.removeListener("changeSession", this.$onChangeSession);
        this.editor.commands.removeListener("afterExec", this.$onAfterExec);
        this.editor.keyBinding.removeKeyboardHandler(this.keyboardHandler);
        this.editor.tabstopManager = null;
        this.editor = null;
      };

      this.onChange = function (delta) {
        var isRemove = delta.action[0] == "r";
        var selectedTabstop = this.selectedTabstop || {};
        var parents = selectedTabstop.parents || {};
        var tabstops = (this.tabstops || []).slice();

        for (var i = 0; i < tabstops.length; i++) {
          var ts = tabstops[i];
          var active = ts == selectedTabstop || parents[ts.index];
          ts.rangeList.$bias = active ? 0 : 1;

          if (delta.action == "remove" && ts !== selectedTabstop) {
            var parentActive = ts.parents && ts.parents[selectedTabstop.index];
            var startIndex = ts.rangeList.pointIndex(delta.start, parentActive);
            startIndex = startIndex < 0 ? -startIndex - 1 : startIndex + 1;
            var endIndex = ts.rangeList.pointIndex(delta.end, parentActive);
            endIndex = endIndex < 0 ? -endIndex - 1 : endIndex - 1;
            var toRemove = ts.rangeList.ranges.slice(startIndex, endIndex);

            for (var j = 0; j < toRemove.length; j++) this.removeRange(toRemove[j]);
          }

          ts.rangeList.$onChange(delta);
        }

        var session = this.editor.session;
        if (!this.$inChange && isRemove && session.getLength() == 1 && !session.getValue()) this.detach();
      };

      this.updateLinkedFields = function () {
        var ts = this.selectedTabstop;
        if (!ts || !ts.hasLinkedRanges || !ts.firstNonLinked) return;
        this.$inChange = true;
        var session = this.editor.session;
        var text = session.getTextRange(ts.firstNonLinked);

        for (var i = 0; i < ts.length; i++) {
          var range = ts[i];
          if (!range.linked) continue;
          var original = range.original;
          var fmt = exports.snippetManager.tmStrFormat(text, original, this.editor);
          session.replace(range, fmt);
        }

        this.$inChange = false;
      };

      this.onAfterExec = function (e) {
        if (e.command && !e.command.readOnly) this.updateLinkedFields();
      };

      this.onChangeSelection = function () {
        if (!this.editor) return;
        var lead = this.editor.selection.lead;
        var anchor = this.editor.selection.anchor;
        var isEmpty = this.editor.selection.isEmpty();

        for (var i = 0; i < this.ranges.length; i++) {
          if (this.ranges[i].linked) continue;
          var containsLead = this.ranges[i].contains(lead.row, lead.column);
          var containsAnchor = isEmpty || this.ranges[i].contains(anchor.row, anchor.column);
          if (containsLead && containsAnchor) return;
        }

        this.detach();
      };

      this.onChangeSession = function () {
        this.detach();
      };

      this.tabNext = function (dir) {
        var max = this.tabstops.length;
        var index = this.index + (dir || 1);
        index = Math.min(Math.max(index, 1), max);
        if (index == max) index = 0;
        this.selectTabstop(index);
        if (index === 0) this.detach();
      };

      this.selectTabstop = function (index) {
        this.$openTabstops = null;
        var ts = this.tabstops[this.index];
        if (ts) this.addTabstopMarkers(ts);
        this.index = index;
        ts = this.tabstops[this.index];
        if (!ts || !ts.length) return;
        this.selectedTabstop = ts;
        var range = ts.firstNonLinked || ts;
        if (ts.choices) range.cursor = range.start;

        if (!this.editor.inVirtualSelectionMode) {
          var sel = this.editor.multiSelect;
          sel.toSingleRange(range);

          for (var i = 0; i < ts.length; i++) {
            if (ts.hasLinkedRanges && ts[i].linked) continue;
            sel.addRange(ts[i].clone(), true);
          }
        } else {
          this.editor.selection.fromOrientedRange(range);
        }

        this.editor.keyBinding.addKeyboardHandler(this.keyboardHandler);
        if (this.selectedTabstop && this.selectedTabstop.choices) this.editor.execCommand("startAutocomplete", {
          matches: this.selectedTabstop.choices
        });
      };

      this.addTabstops = function (tabstops, start, end) {
        var useLink = this.useLink || !this.editor.getOption("enableMultiselect");
        if (!this.$openTabstops) this.$openTabstops = [];

        if (!tabstops[0]) {
          var p = Range.fromPoints(end, end);
          moveRelative(p.start, start);
          moveRelative(p.end, start);
          tabstops[0] = [p];
          tabstops[0].index = 0;
        }

        var i = this.index;
        var arg = [i + 1, 0];
        var ranges = this.ranges;
        tabstops.forEach(function (ts, index) {
          var dest = this.$openTabstops[index] || ts;

          for (var i = 0; i < ts.length; i++) {
            var p = ts[i];
            var range = Range.fromPoints(p.start, p.end || p.start);
            movePoint(range.start, start);
            movePoint(range.end, start);
            range.original = p;
            range.tabstop = dest;
            ranges.push(range);
            if (dest != ts) dest.unshift(range);else dest[i] = range;

            if (p.fmtString || dest.firstNonLinked && useLink) {
              range.linked = true;
              dest.hasLinkedRanges = true;
            } else if (!dest.firstNonLinked) dest.firstNonLinked = range;
          }

          if (!dest.firstNonLinked) dest.hasLinkedRanges = false;

          if (dest === ts) {
            arg.push(dest);
            this.$openTabstops[index] = dest;
          }

          this.addTabstopMarkers(dest);
          dest.rangeList = dest.rangeList || new RangeList();
          dest.rangeList.$bias = 0;
          dest.rangeList.addList(dest);
        }, this);

        if (arg.length > 2) {
          if (this.tabstops.length) arg.push(arg.splice(2, 1)[0]);
          this.tabstops.splice.apply(this.tabstops, arg);
        }
      };

      this.addTabstopMarkers = function (ts) {
        var session = this.editor.session;
        ts.forEach(function (range) {
          if (!range.markerId) range.markerId = session.addMarker(range, "ace_snippet-marker", "text");
        });
      };

      this.removeTabstopMarkers = function (ts) {
        var session = this.editor.session;
        ts.forEach(function (range) {
          session.removeMarker(range.markerId);
          range.markerId = null;
        });
      };

      this.removeRange = function (range) {
        var i = range.tabstop.indexOf(range);
        if (i != -1) range.tabstop.splice(i, 1);
        i = this.ranges.indexOf(range);
        if (i != -1) this.ranges.splice(i, 1);
        i = range.tabstop.rangeList.ranges.indexOf(range);
        if (i != -1) range.tabstop.splice(i, 1);
        this.editor.session.removeMarker(range.markerId);

        if (!range.tabstop.length) {
          i = this.tabstops.indexOf(range.tabstop);
          if (i != -1) this.tabstops.splice(i, 1);
          if (!this.tabstops.length) this.detach();
        }
      };

      this.keyboardHandler = new HashHandler();
      this.keyboardHandler.bindKeys({
        "Tab": function (editor) {
          if (exports.snippetManager && exports.snippetManager.expandWithTab(editor)) return;
          editor.tabstopManager.tabNext(1);
          editor.renderer.scrollCursorIntoView();
        },
        "Shift-Tab": function (editor) {
          editor.tabstopManager.tabNext(-1);
          editor.renderer.scrollCursorIntoView();
        },
        "Esc": function (editor) {
          editor.tabstopManager.detach();
        }
      });
    }).call(TabstopManager.prototype);

    var movePoint = function (point, diff) {
      if (point.row == 0) point.column += diff.column;
      point.row += diff.row;
    };

    var moveRelative = function (point, start) {
      if (point.row == start.row) point.column -= start.column;
      point.row -= start.row;
    };

    dom.importCssString("\n.ace_snippet-marker {\n    -moz-box-sizing: border-box;\n    box-sizing: border-box;\n    background: rgba(194, 193, 208, 0.09);\n    border: 1px dotted rgba(211, 208, 235, 0.62);\n    position: absolute;\n}", "snippets.css", false);
    exports.snippetManager = new SnippetManager();

    var Editor = require("./editor").Editor;

    (function () {
      this.insertSnippet = function (content, options) {
        return exports.snippetManager.insertSnippet(this, content, options);
      };

      this.expandSnippet = function (options) {
        return exports.snippetManager.expandWithTab(this, options);
      };
    }).call(Editor.prototype);
  });
  ace.define("ace/autocomplete/popup", ["require", "exports", "module", "ace/virtual_renderer", "ace/editor", "ace/range", "ace/lib/event", "ace/lib/lang", "ace/lib/dom"], function (require, exports, module) {

    var Renderer = require("../virtual_renderer").VirtualRenderer;

    var Editor = require("../editor").Editor;

    var Range = require("../range").Range;

    var event = require("../lib/event");

    var lang = require("../lib/lang");

    var dom = require("../lib/dom");

    var $singleLineEditor = function (el) {
      var renderer = new Renderer(el);
      renderer.$maxLines = 4;
      var editor = new Editor(renderer);
      editor.setHighlightActiveLine(false);
      editor.setShowPrintMargin(false);
      editor.renderer.setShowGutter(false);
      editor.renderer.setHighlightGutterLine(false);
      editor.$mouseHandler.$focusTimeout = 0;
      editor.$highlightTagPending = true;
      return editor;
    };

    var AcePopup = function (parentNode) {
      var el = dom.createElement("div");
      var popup = new $singleLineEditor(el);
      if (parentNode) parentNode.appendChild(el);
      el.style.display = "none";
      popup.renderer.content.style.cursor = "default";
      popup.renderer.setStyle("ace_autocomplete");
      popup.setOption("displayIndentGuides", false);
      popup.setOption("dragDelay", 150);

      var noop = function () {};

      popup.focus = noop;
      popup.$isFocused = true;
      popup.renderer.$cursorLayer.restartTimer = noop;
      popup.renderer.$cursorLayer.element.style.opacity = 0;
      popup.renderer.$maxLines = 8;
      popup.renderer.$keepTextAreaAtCursor = false;
      popup.setHighlightActiveLine(false);
      popup.session.highlight("");
      popup.session.$searchHighlight.clazz = "ace_highlight-marker";
      popup.on("mousedown", function (e) {
        var pos = e.getDocumentPosition();
        popup.selection.moveToPosition(pos);
        selectionMarker.start.row = selectionMarker.end.row = pos.row;
        e.stop();
      });
      var lastMouseEvent;
      var hoverMarker = new Range(-1, 0, -1, Infinity);
      var selectionMarker = new Range(-1, 0, -1, Infinity);
      selectionMarker.id = popup.session.addMarker(selectionMarker, "ace_active-line", "fullLine");

      popup.setSelectOnHover = function (val) {
        if (!val) {
          hoverMarker.id = popup.session.addMarker(hoverMarker, "ace_line-hover", "fullLine");
        } else if (hoverMarker.id) {
          popup.session.removeMarker(hoverMarker.id);
          hoverMarker.id = null;
        }
      };

      popup.setSelectOnHover(false);
      popup.on("mousemove", function (e) {
        if (!lastMouseEvent) {
          lastMouseEvent = e;
          return;
        }

        if (lastMouseEvent.x == e.x && lastMouseEvent.y == e.y) {
          return;
        }

        lastMouseEvent = e;
        lastMouseEvent.scrollTop = popup.renderer.scrollTop;
        var row = lastMouseEvent.getDocumentPosition().row;

        if (hoverMarker.start.row != row) {
          if (!hoverMarker.id) popup.setRow(row);
          setHoverMarker(row);
        }
      });
      popup.renderer.on("beforeRender", function () {
        if (lastMouseEvent && hoverMarker.start.row != -1) {
          lastMouseEvent.$pos = null;
          var row = lastMouseEvent.getDocumentPosition().row;
          if (!hoverMarker.id) popup.setRow(row);
          setHoverMarker(row, true);
        }
      });
      popup.renderer.on("afterRender", function () {
        var row = popup.getRow();
        var t = popup.renderer.$textLayer;
        var selected = t.element.childNodes[row - t.config.firstRow];
        if (selected !== t.selectedNode && t.selectedNode) dom.removeCssClass(t.selectedNode, "ace_selected");
        t.selectedNode = selected;
        if (selected) dom.addCssClass(selected, "ace_selected");
      });

      var hideHoverMarker = function () {
        setHoverMarker(-1);
      };

      var setHoverMarker = function (row, suppressRedraw) {
        if (row !== hoverMarker.start.row) {
          hoverMarker.start.row = hoverMarker.end.row = row;
          if (!suppressRedraw) popup.session._emit("changeBackMarker");

          popup._emit("changeHoverMarker");
        }
      };

      popup.getHoveredRow = function () {
        return hoverMarker.start.row;
      };

      event.addListener(popup.container, "mouseout", hideHoverMarker);
      popup.on("hide", hideHoverMarker);
      popup.on("changeSelection", hideHoverMarker);

      popup.session.doc.getLength = function () {
        return popup.data.length;
      };

      popup.session.doc.getLine = function (i) {
        var data = popup.data[i];
        if (typeof data == "string") return data;
        return data && data.value || "";
      };

      var bgTokenizer = popup.session.bgTokenizer;

      bgTokenizer.$tokenizeRow = function (row) {
        var data = popup.data[row];
        var tokens = [];
        if (!data) return tokens;
        if (typeof data == "string") data = {
          value: data
        };
        var caption = data.caption || data.value || data.name;

        function addToken(value, className) {
          value && tokens.push({
            type: (data.className || "") + (className || ""),
            value: value
          });
        }

        var lower = caption.toLowerCase();
        var filterText = (popup.filterText || "").toLowerCase();
        var lastIndex = 0;
        var lastI = 0;

        for (var i = 0; i <= filterText.length; i++) {
          if (i != lastI && (data.matchMask & 1 << i || i == filterText.length)) {
            var sub = filterText.slice(lastI, i);
            lastI = i;
            var index = lower.indexOf(sub, lastIndex);
            if (index == -1) continue;
            addToken(caption.slice(lastIndex, index), "");
            lastIndex = index + sub.length;
            addToken(caption.slice(index, lastIndex), "completion-highlight");
          }
        }

        addToken(caption.slice(lastIndex, caption.length), "");
        if (data.meta) tokens.push({
          type: "completion-meta",
          value: data.meta
        });
        if (data.message) tokens.push({
          type: "completion-message",
          value: data.message
        });
        return tokens;
      };

      bgTokenizer.$updateOnChange = noop;
      bgTokenizer.start = noop;

      popup.session.$computeWidth = function () {
        return this.screenWidth = 0;
      };

      popup.isOpen = false;
      popup.isTopdown = false;
      popup.autoSelect = true;
      popup.filterText = "";
      popup.data = [];

      popup.setData = function (list, filterText) {
        popup.filterText = filterText || "";
        popup.setValue(lang.stringRepeat("\n", list.length), -1);
        popup.data = list || [];
        popup.setRow(0);
      };

      popup.getData = function (row) {
        return popup.data[row];
      };

      popup.getRow = function () {
        return selectionMarker.start.row;
      };

      popup.setRow = function (line) {
        line = Math.max(this.autoSelect ? 0 : -1, Math.min(this.data.length, line));

        if (selectionMarker.start.row != line) {
          popup.selection.clearSelection();
          selectionMarker.start.row = selectionMarker.end.row = line || 0;

          popup.session._emit("changeBackMarker");

          popup.moveCursorTo(line || 0, 0);
          if (popup.isOpen) popup._signal("select");
        }
      };

      popup.on("changeSelection", function () {
        if (popup.isOpen) popup.setRow(popup.selection.lead.row);
        popup.renderer.scrollCursorIntoView();
      });

      popup.hide = function () {
        this.container.style.display = "none";

        this._signal("hide");

        popup.isOpen = false;
      };

      popup.show = function (pos, lineHeight, topdownOnly) {
        var el = this.container;
        var screenHeight = window.innerHeight;
        var screenWidth = window.innerWidth;
        var renderer = this.renderer;
        var maxH = renderer.$maxLines * lineHeight * 1.4;
        var top = pos.top + this.$borderSize;
        var allowTopdown = top > screenHeight / 2 && !topdownOnly;

        if (allowTopdown && top + lineHeight + maxH > screenHeight) {
          renderer.$maxPixelHeight = top - 2 * this.$borderSize;
          el.style.top = "";
          el.style.bottom = screenHeight - top + "px";
          popup.isTopdown = false;
        } else {
          top += lineHeight;
          renderer.$maxPixelHeight = screenHeight - top - 0.2 * lineHeight;
          el.style.top = top + "px";
          el.style.bottom = "";
          popup.isTopdown = true;
        }

        el.style.display = "";
        var left = pos.left;
        if (left + el.offsetWidth > screenWidth) left = screenWidth - el.offsetWidth;
        el.style.left = left + "px";

        this._signal("show");

        lastMouseEvent = null;
        popup.isOpen = true;
      };

      popup.goTo = function (where) {
        var row = this.getRow();
        var max = this.session.getLength() - 1;

        switch (where) {
          case "up":
            row = row <= 0 ? max : row - 1;
            break;

          case "down":
            row = row >= max ? -1 : row + 1;
            break;

          case "start":
            row = 0;
            break;

          case "end":
            row = max;
            break;
        }

        this.setRow(row);
      };

      popup.getTextLeftOffset = function () {
        return this.$borderSize + this.renderer.$padding + this.$imageSize;
      };

      popup.$imageSize = 0;
      popup.$borderSize = 1;
      return popup;
    };

    dom.importCssString("\n.ace_editor.ace_autocomplete .ace_marker-layer .ace_active-line {\n    background-color: #CAD6FA;\n    z-index: 1;\n}\n.ace_dark.ace_editor.ace_autocomplete .ace_marker-layer .ace_active-line {\n    background-color: #3a674e;\n}\n.ace_editor.ace_autocomplete .ace_line-hover {\n    border: 1px solid #abbffe;\n    margin-top: -1px;\n    background: rgba(233,233,253,0.4);\n    position: absolute;\n    z-index: 2;\n}\n.ace_dark.ace_editor.ace_autocomplete .ace_line-hover {\n    border: 1px solid rgba(109, 150, 13, 0.8);\n    background: rgba(58, 103, 78, 0.62);\n}\n.ace_completion-meta {\n    opacity: 0.5;\n    margin: 0.9em;\n}\n.ace_completion-message {\n    color: blue;\n}\n.ace_editor.ace_autocomplete .ace_completion-highlight{\n    color: #2d69c7;\n}\n.ace_dark.ace_editor.ace_autocomplete .ace_completion-highlight{\n    color: #93ca12;\n}\n.ace_editor.ace_autocomplete {\n    width: 300px;\n    z-index: 200000;\n    border: 1px lightgray solid;\n    position: fixed;\n    box-shadow: 2px 3px 5px rgba(0,0,0,.2);\n    line-height: 1.4;\n    background: #fefefe;\n    color: #111;\n}\n.ace_dark.ace_editor.ace_autocomplete {\n    border: 1px #484747 solid;\n    box-shadow: 2px 3px 5px rgba(0, 0, 0, 0.51);\n    line-height: 1.4;\n    background: #25282c;\n    color: #c1c1c1;\n}", "autocompletion.css", false);
    exports.AcePopup = AcePopup;
    exports.$singleLineEditor = $singleLineEditor;
  });
  ace.define("ace/autocomplete/util", ["require", "exports", "module"], function (require, exports, module) {

    exports.parForEach = function (array, fn, callback) {
      var completed = 0;
      var arLength = array.length;
      if (arLength === 0) callback();

      for (var i = 0; i < arLength; i++) {
        fn(array[i], function (result, err) {
          completed++;
          if (completed === arLength) callback(result, err);
        });
      }
    };

    var ID_REGEX = /[a-zA-Z_0-9\$\-\u00A2-\u2000\u2070-\uFFFF]/;

    exports.retrievePrecedingIdentifier = function (text, pos, regex) {
      regex = regex || ID_REGEX;
      var buf = [];

      for (var i = pos - 1; i >= 0; i--) {
        if (regex.test(text[i])) buf.push(text[i]);else break;
      }

      return buf.reverse().join("");
    };

    exports.retrieveFollowingIdentifier = function (text, pos, regex) {
      regex = regex || ID_REGEX;
      var buf = [];

      for (var i = pos; i < text.length; i++) {
        if (regex.test(text[i])) buf.push(text[i]);else break;
      }

      return buf;
    };

    exports.getCompletionPrefix = function (editor) {
      var pos = editor.getCursorPosition();
      var line = editor.session.getLine(pos.row);
      var prefix;
      editor.completers.forEach(function (completer) {
        if (completer.identifierRegexps) {
          completer.identifierRegexps.forEach(function (identifierRegex) {
            if (!prefix && identifierRegex) prefix = this.retrievePrecedingIdentifier(line, pos.column, identifierRegex);
          }.bind(this));
        }
      }.bind(this));
      return prefix || this.retrievePrecedingIdentifier(line, pos.column);
    };
  });
  ace.define("ace/autocomplete", ["require", "exports", "module", "ace/keyboard/hash_handler", "ace/autocomplete/popup", "ace/autocomplete/util", "ace/lib/lang", "ace/lib/dom", "ace/snippets", "ace/config"], function (require, exports, module) {

    var HashHandler = require("./keyboard/hash_handler").HashHandler;

    var AcePopup = require("./autocomplete/popup").AcePopup;

    var util = require("./autocomplete/util");

    var lang = require("./lib/lang");

    var dom = require("./lib/dom");

    var snippetManager = require("./snippets").snippetManager;

    var config = require("./config");

    var Autocomplete = function () {
      this.autoInsert = false;
      this.autoSelect = true;
      this.exactMatch = false;
      this.gatherCompletionsId = 0;
      this.keyboardHandler = new HashHandler();
      this.keyboardHandler.bindKeys(this.commands);
      this.blurListener = this.blurListener.bind(this);
      this.changeListener = this.changeListener.bind(this);
      this.mousedownListener = this.mousedownListener.bind(this);
      this.mousewheelListener = this.mousewheelListener.bind(this);
      this.changeTimer = lang.delayedCall(function () {
        this.updateCompletions(true);
      }.bind(this));
      this.tooltipTimer = lang.delayedCall(this.updateDocTooltip.bind(this), 50);
    };

    (function () {
      this.$init = function () {
        this.popup = new AcePopup(document.body || document.documentElement);
        this.popup.on("click", function (e) {
          this.insertMatch();
          e.stop();
        }.bind(this));
        this.popup.focus = this.editor.focus.bind(this.editor);
        this.popup.on("show", this.tooltipTimer.bind(null, null));
        this.popup.on("select", this.tooltipTimer.bind(null, null));
        this.popup.on("changeHoverMarker", this.tooltipTimer.bind(null, null));
        return this.popup;
      };

      this.getPopup = function () {
        return this.popup || this.$init();
      };

      this.openPopup = function (editor, prefix, keepPopupPosition) {
        if (!this.popup) this.$init();
        this.popup.autoSelect = this.autoSelect;
        this.popup.setData(this.completions.filtered, this.completions.filterText);
        editor.keyBinding.addKeyboardHandler(this.keyboardHandler);
        var renderer = editor.renderer;
        this.popup.setRow(this.autoSelect ? 0 : -1);

        if (!keepPopupPosition) {
          this.popup.setTheme(editor.getTheme());
          this.popup.setFontSize(editor.getFontSize());
          var lineHeight = renderer.layerConfig.lineHeight;
          var pos = renderer.$cursorLayer.getPixelPosition(this.base, true);
          pos.left -= this.popup.getTextLeftOffset();
          var rect = editor.container.getBoundingClientRect();
          pos.top += rect.top - renderer.layerConfig.offset;
          pos.left += rect.left - editor.renderer.scrollLeft;
          pos.left += renderer.gutterWidth;
          this.popup.show(pos, lineHeight);
        } else if (keepPopupPosition && !prefix) {
          this.detach();
        }

        this.changeTimer.cancel();
      };

      this.detach = function () {
        this.editor.keyBinding.removeKeyboardHandler(this.keyboardHandler);
        this.editor.off("changeSelection", this.changeListener);
        this.editor.off("blur", this.blurListener);
        this.editor.off("mousedown", this.mousedownListener);
        this.editor.off("mousewheel", this.mousewheelListener);
        this.changeTimer.cancel();
        this.hideDocTooltip();
        this.gatherCompletionsId += 1;
        if (this.popup && this.popup.isOpen) this.popup.hide();
        if (this.base) this.base.detach();
        this.activated = false;
        this.completions = this.base = null;
      };

      this.changeListener = function (e) {
        var cursor = this.editor.selection.lead;

        if (cursor.row != this.base.row || cursor.column < this.base.column) {
          this.detach();
        }

        if (this.activated) this.changeTimer.schedule();else this.detach();
      };

      this.blurListener = function (e) {
        var el = document.activeElement;
        var text = this.editor.textInput.getElement();
        var fromTooltip = e.relatedTarget && this.tooltipNode && this.tooltipNode.contains(e.relatedTarget);
        var container = this.popup && this.popup.container;

        if (el != text && el.parentNode != container && !fromTooltip && el != this.tooltipNode && e.relatedTarget != text) {
          this.detach();
        }
      };

      this.mousedownListener = function (e) {
        this.detach();
      };

      this.mousewheelListener = function (e) {
        this.detach();
      };

      this.goTo = function (where) {
        this.popup.goTo(where);
      };

      this.insertMatch = function (data, options) {
        if (!data) data = this.popup.getData(this.popup.getRow());
        if (!data) return false;
        var completions = this.completions;
        this.editor.startOperation({
          command: {
            name: "insertMatch"
          }
        });

        if (data.completer && data.completer.insertMatch) {
          data.completer.insertMatch(this.editor, data);
        } else {
          if (!completions) return false;

          if (completions.filterText) {
            var ranges = this.editor.selection.getAllRanges();

            for (var i = 0, range; range = ranges[i]; i++) {
              range.start.column -= completions.filterText.length;
              this.editor.session.remove(range);
            }
          }

          if (data.snippet) snippetManager.insertSnippet(this.editor, data.snippet);else this.editor.execCommand("insertstring", data.value || data);
        }

        if (this.completions == completions) this.detach();
        this.editor.endOperation();
      };

      this.commands = {
        "Up": function (editor) {
          editor.completer.goTo("up");
        },
        "Down": function (editor) {
          editor.completer.goTo("down");
        },
        "Ctrl-Up|Ctrl-Home": function (editor) {
          editor.completer.goTo("start");
        },
        "Ctrl-Down|Ctrl-End": function (editor) {
          editor.completer.goTo("end");
        },
        "Esc": function (editor) {
          editor.completer.detach();
        },
        "Return": function (editor) {
          return editor.completer.insertMatch();
        },
        "Shift-Return": function (editor) {
          editor.completer.insertMatch(null, {
            deleteSuffix: true
          });
        },
        "Tab": function (editor) {
          var result = editor.completer.insertMatch();
          if (!result && !editor.tabstopManager) editor.completer.goTo("down");else return result;
        },
        "PageUp": function (editor) {
          editor.completer.popup.gotoPageUp();
        },
        "PageDown": function (editor) {
          editor.completer.popup.gotoPageDown();
        }
      };

      this.gatherCompletions = function (editor, callback) {
        var session = editor.getSession();
        var pos = editor.getCursorPosition();
        var prefix = util.getCompletionPrefix(editor);
        this.base = session.doc.createAnchor(pos.row, pos.column - prefix.length);
        this.base.$insertRight = true;
        var matches = [];
        var total = editor.completers.length;
        editor.completers.forEach(function (completer, i) {
          completer.getCompletions(editor, session, pos, prefix, function (err, results) {
            if (!err && results) matches = matches.concat(results);
            callback(null, {
              prefix: util.getCompletionPrefix(editor),
              matches: matches,
              finished: --total === 0
            });
          });
        });
        return true;
      };

      this.showPopup = function (editor, options) {
        if (this.editor) this.detach();
        this.activated = true;
        this.editor = editor;

        if (editor.completer != this) {
          if (editor.completer) editor.completer.detach();
          editor.completer = this;
        }

        editor.on("changeSelection", this.changeListener);
        editor.on("blur", this.blurListener);
        editor.on("mousedown", this.mousedownListener);
        editor.on("mousewheel", this.mousewheelListener);
        this.updateCompletions(false, options);
      };

      this.updateCompletions = function (keepPopupPosition, options) {
        if (keepPopupPosition && this.base && this.completions) {
          var pos = this.editor.getCursorPosition();
          var prefix = this.editor.session.getTextRange({
            start: this.base,
            end: pos
          });
          if (prefix == this.completions.filterText) return;
          this.completions.setFilter(prefix);
          if (!this.completions.filtered.length) return this.detach();
          if (this.completions.filtered.length == 1 && this.completions.filtered[0].value == prefix && !this.completions.filtered[0].snippet) return this.detach();
          this.openPopup(this.editor, prefix, keepPopupPosition);
          return;
        }

        if (options && options.matches) {
          var pos = this.editor.getSelectionRange().start;
          this.base = this.editor.session.doc.createAnchor(pos.row, pos.column);
          this.base.$insertRight = true;
          this.completions = new FilteredList(options.matches);
          return this.openPopup(this.editor, "", keepPopupPosition);
        }

        var _id = this.gatherCompletionsId;

        var detachIfFinished = function (results) {
          if (!results.finished) return;
          return this.detach();
        }.bind(this);

        var processResults = function (results) {
          var prefix = results.prefix;
          var matches = results.matches;
          this.completions = new FilteredList(matches);
          if (this.exactMatch) this.completions.exactMatch = true;
          this.completions.setFilter(prefix);
          var filtered = this.completions.filtered;
          if (!filtered.length) return detachIfFinished(results);
          if (filtered.length == 1 && filtered[0].value == prefix && !filtered[0].snippet) return detachIfFinished(results);
          if (this.autoInsert && filtered.length == 1 && results.finished) return this.insertMatch(filtered[0]);
          this.openPopup(this.editor, prefix, keepPopupPosition);
        }.bind(this);

        var isImmediate = true;
        var immediateResults = null;
        this.gatherCompletions(this.editor, function (err, results) {
          var prefix = results.prefix;
          var matches = results && results.matches;
          if (!matches || !matches.length) return detachIfFinished(results);
          if (prefix.indexOf(results.prefix) !== 0 || _id != this.gatherCompletionsId) return;

          if (isImmediate) {
            immediateResults = results;
            return;
          }

          processResults(results);
        }.bind(this));
        isImmediate = false;

        if (immediateResults) {
          var results = immediateResults;
          immediateResults = null;
          processResults(results);
        }
      };

      this.cancelContextMenu = function () {
        this.editor.$mouseHandler.cancelContextMenu();
      };

      this.updateDocTooltip = function () {
        var popup = this.popup;
        var all = popup.data;
        var selected = all && (all[popup.getHoveredRow()] || all[popup.getRow()]);
        var doc = null;
        if (!selected || !this.editor || !this.popup.isOpen) return this.hideDocTooltip();
        this.editor.completers.some(function (completer) {
          if (completer.getDocTooltip) doc = completer.getDocTooltip(selected);
          return doc;
        });
        if (!doc && typeof selected != "string") doc = selected;
        if (typeof doc == "string") doc = {
          docText: doc
        };
        if (!doc || !(doc.docHTML || doc.docText)) return this.hideDocTooltip();
        this.showDocTooltip(doc);
      };

      this.showDocTooltip = function (item) {
        if (!this.tooltipNode) {
          this.tooltipNode = dom.createElement("div");
          this.tooltipNode.className = "ace_tooltip ace_doc-tooltip";
          this.tooltipNode.style.margin = 0;
          this.tooltipNode.style.pointerEvents = "auto";
          this.tooltipNode.tabIndex = -1;
          this.tooltipNode.onblur = this.blurListener.bind(this);
          this.tooltipNode.onclick = this.onTooltipClick.bind(this);
        }

        var tooltipNode = this.tooltipNode;

        if (item.docHTML) {
          tooltipNode.innerHTML = item.docHTML;
        } else if (item.docText) {
          tooltipNode.textContent = item.docText;
        }

        if (!tooltipNode.parentNode) document.body.appendChild(tooltipNode);
        var popup = this.popup;
        var rect = popup.container.getBoundingClientRect();
        tooltipNode.style.top = popup.container.style.top;
        tooltipNode.style.bottom = popup.container.style.bottom;
        tooltipNode.style.display = "block";

        if (window.innerWidth - rect.right < 320) {
          if (rect.left < 320) {
            if (popup.isTopdown) {
              tooltipNode.style.top = rect.bottom + "px";
              tooltipNode.style.left = rect.left + "px";
              tooltipNode.style.right = "";
              tooltipNode.style.bottom = "";
            } else {
              tooltipNode.style.top = popup.container.offsetTop - tooltipNode.offsetHeight + "px";
              tooltipNode.style.left = rect.left + "px";
              tooltipNode.style.right = "";
              tooltipNode.style.bottom = "";
            }
          } else {
            tooltipNode.style.right = window.innerWidth - rect.left + "px";
            tooltipNode.style.left = "";
          }
        } else {
          tooltipNode.style.left = rect.right + 1 + "px";
          tooltipNode.style.right = "";
        }
      };

      this.hideDocTooltip = function () {
        this.tooltipTimer.cancel();
        if (!this.tooltipNode) return;
        var el = this.tooltipNode;
        if (!this.editor.isFocused() && document.activeElement == el) this.editor.focus();
        this.tooltipNode = null;
        if (el.parentNode) el.parentNode.removeChild(el);
      };

      this.onTooltipClick = function (e) {
        var a = e.target;

        while (a && a != this.tooltipNode) {
          if (a.nodeName == "A" && a.href) {
            a.rel = "noreferrer";
            a.target = "_blank";
            break;
          }

          a = a.parentNode;
        }
      };

      this.destroy = function () {
        this.detach();

        if (this.popup) {
          this.popup.destroy();
          var el = this.popup.container;
          if (el && el.parentNode) el.parentNode.removeChild(el);
        }

        if (this.editor && this.editor.completer == this) this.editor.completer == null;
        this.popup = null;
      };
    }).call(Autocomplete.prototype);

    Autocomplete.for = function (editor) {
      if (editor.completer) {
        return editor.completer;
      }

      if (config.get("sharedPopups")) {
        if (!Autocomplete.$shared) Autocomplete.$sharedInstance = new Autocomplete();
        editor.completer = Autocomplete.$sharedInstance;
      } else {
        editor.completer = new Autocomplete();
        editor.once("destroy", function (e, editor) {
          editor.completer.destroy();
        });
      }

      return editor.completer;
    };

    Autocomplete.startCommand = {
      name: "startAutocomplete",
      exec: function (editor, options) {
        var completer = Autocomplete.for(editor);
        completer.autoInsert = false;
        completer.autoSelect = true;
        completer.showPopup(editor, options);
        completer.cancelContextMenu();
      },
      bindKey: "Ctrl-Space|Ctrl-Shift-Space|Alt-Space"
    };

    var FilteredList = function (array, filterText) {
      this.all = array;
      this.filtered = array;
      this.filterText = filterText || "";
      this.exactMatch = false;
    };

    (function () {
      this.setFilter = function (str) {
        if (str.length > this.filterText && str.lastIndexOf(this.filterText, 0) === 0) var matches = this.filtered;else var matches = this.all;
        this.filterText = str;
        matches = this.filterCompletions(matches, this.filterText);
        matches = matches.sort(function (a, b) {
          return b.exactMatch - a.exactMatch || b.$score - a.$score || (a.caption || a.value).localeCompare(b.caption || b.value);
        });
        var prev = null;
        matches = matches.filter(function (item) {
          var caption = item.snippet || item.caption || item.value;
          if (caption === prev) return false;
          prev = caption;
          return true;
        });
        this.filtered = matches;
      };

      this.filterCompletions = function (items, needle) {
        var results = [];
        var upper = needle.toUpperCase();
        var lower = needle.toLowerCase();

        loop: for (var i = 0, item; item = items[i]; i++) {
          var caption = item.caption || item.value || item.snippet;
          if (!caption) continue;
          var lastIndex = -1;
          var matchMask = 0;
          var penalty = 0;
          var index, distance;

          if (this.exactMatch) {
            if (needle !== caption.substr(0, needle.length)) continue loop;
          } else {
            var fullMatchIndex = caption.toLowerCase().indexOf(lower);

            if (fullMatchIndex > -1) {
              penalty = fullMatchIndex;
            } else {
              for (var j = 0; j < needle.length; j++) {
                var i1 = caption.indexOf(lower[j], lastIndex + 1);
                var i2 = caption.indexOf(upper[j], lastIndex + 1);
                index = i1 >= 0 ? i2 < 0 || i1 < i2 ? i1 : i2 : i2;
                if (index < 0) continue loop;
                distance = index - lastIndex - 1;

                if (distance > 0) {
                  if (lastIndex === -1) penalty += 10;
                  penalty += distance;
                  matchMask = matchMask | 1 << j;
                }

                lastIndex = index;
              }
            }
          }

          item.matchMask = matchMask;
          item.exactMatch = penalty ? 0 : 1;
          item.$score = (item.score || 0) - penalty;
          results.push(item);
        }

        return results;
      };
    }).call(FilteredList.prototype);
    exports.Autocomplete = Autocomplete;
    exports.FilteredList = FilteredList;
  });
  ace.define("ace/autocomplete/text_completer", ["require", "exports", "module", "ace/range"], function (require, exports, module) {
    var Range = require("../range").Range;

    var splitRegex = /[^a-zA-Z_0-9\$\-\u00C0-\u1FFF\u2C00-\uD7FF\w]+/;

    function getWordIndex(doc, pos) {
      var textBefore = doc.getTextRange(Range.fromPoints({
        row: 0,
        column: 0
      }, pos));
      return textBefore.split(splitRegex).length - 1;
    }

    function wordDistance(doc, pos) {
      var prefixPos = getWordIndex(doc, pos);
      var words = doc.getValue().split(splitRegex);
      var wordScores = Object.create(null);
      var currentWord = words[prefixPos];
      words.forEach(function (word, idx) {
        if (!word || word === currentWord) return;
        var distance = Math.abs(prefixPos - idx);
        var score = words.length - distance;

        if (wordScores[word]) {
          wordScores[word] = Math.max(score, wordScores[word]);
        } else {
          wordScores[word] = score;
        }
      });
      return wordScores;
    }

    exports.getCompletions = function (editor, session, pos, prefix, callback) {
      var wordScore = wordDistance(session, pos);
      var wordList = Object.keys(wordScore);
      callback(null, wordList.map(function (word) {
        return {
          caption: word,
          value: word,
          score: wordScore[word],
          meta: "local"
        };
      }));
    };
  });
  ace.define("ace/ext/language_tools", ["require", "exports", "module", "ace/snippets", "ace/autocomplete", "ace/config", "ace/lib/lang", "ace/autocomplete/util", "ace/autocomplete/text_completer", "ace/editor", "ace/config"], function (require, exports, module) {

    var snippetManager = require("../snippets").snippetManager;

    var Autocomplete = require("../autocomplete").Autocomplete;

    var config = require("../config");

    var lang = require("../lib/lang");

    var util = require("../autocomplete/util");

    var textCompleter = require("../autocomplete/text_completer");

    var keyWordCompleter = {
      getCompletions: function (editor, session, pos, prefix, callback) {
        if (session.$mode.completer) {
          return session.$mode.completer.getCompletions(editor, session, pos, prefix, callback);
        }

        var state = editor.session.getState(pos.row);
        var completions = session.$mode.getCompletions(state, session, pos, prefix);
        callback(null, completions);
      }
    };

    var transformSnippetTooltip = function (str) {
      var record = {};
      return str.replace(/\${(\d+)(:(.*?))?}/g, function (_, p1, p2, p3) {
        return record[p1] = p3 || '';
      }).replace(/\$(\d+?)/g, function (_, p1) {
        return record[p1];
      });
    };

    var snippetCompleter = {
      getCompletions: function (editor, session, pos, prefix, callback) {
        var scopes = [];
        var token = session.getTokenAt(pos.row, pos.column);
        if (token && token.type.match(/(tag-name|tag-open|tag-whitespace|attribute-name|attribute-value)\.xml$/)) scopes.push('html-tag');else scopes = snippetManager.getActiveScopes(editor);
        var snippetMap = snippetManager.snippetMap;
        var completions = [];
        scopes.forEach(function (scope) {
          var snippets = snippetMap[scope] || [];

          for (var i = snippets.length; i--;) {
            var s = snippets[i];
            var caption = s.name || s.tabTrigger;
            if (!caption) continue;
            completions.push({
              caption: caption,
              snippet: s.content,
              meta: s.tabTrigger && !s.name ? s.tabTrigger + "\u21E5 " : "snippet",
              type: "snippet"
            });
          }
        }, this);
        callback(null, completions);
      },
      getDocTooltip: function (item) {
        if (item.type == "snippet" && !item.docHTML) {
          item.docHTML = ["<b>", lang.escapeHTML(item.caption), "</b>", "<hr></hr>", lang.escapeHTML(transformSnippetTooltip(item.snippet))].join("");
        }
      }
    };
    var completers = [snippetCompleter, textCompleter, keyWordCompleter];

    exports.setCompleters = function (val) {
      completers.length = 0;
      if (val) completers.push.apply(completers, val);
    };

    exports.addCompleter = function (completer) {
      completers.push(completer);
    };

    exports.textCompleter = textCompleter;
    exports.keyWordCompleter = keyWordCompleter;
    exports.snippetCompleter = snippetCompleter;
    var expandSnippet = {
      name: "expandSnippet",
      exec: function (editor) {
        return snippetManager.expandWithTab(editor);
      },
      bindKey: "Tab"
    };

    var onChangeMode = function (e, editor) {
      loadSnippetsForMode(editor.session.$mode);
    };

    var loadSnippetsForMode = function (mode) {
      if (typeof mode == "string") mode = config.$modes[mode];
      if (!mode) return;
      if (!snippetManager.files) snippetManager.files = {};
      loadSnippetFile(mode.$id, mode.snippetFileId);
      if (mode.modes) mode.modes.forEach(loadSnippetsForMode);
    };

    var loadSnippetFile = function (id, snippetFilePath) {
      if (!snippetFilePath || !id || snippetManager.files[id]) return;
      snippetManager.files[id] = {};
      config.loadModule(snippetFilePath, function (m) {
        if (!m) return;
        snippetManager.files[id] = m;
        if (!m.snippets && m.snippetText) m.snippets = snippetManager.parseSnippetFile(m.snippetText);
        snippetManager.register(m.snippets || [], m.scope);

        if (m.includeScopes) {
          snippetManager.snippetMap[m.scope].includeScopes = m.includeScopes;
          m.includeScopes.forEach(function (x) {
            loadSnippetsForMode("ace/mode/" + x);
          });
        }
      });
    };

    var doLiveAutocomplete = function (e) {
      var editor = e.editor;
      var hasCompleter = editor.completer && editor.completer.activated;

      if (e.command.name === "backspace") {
        if (hasCompleter && !util.getCompletionPrefix(editor)) editor.completer.detach();
      } else if (e.command.name === "insertstring") {
        var prefix = util.getCompletionPrefix(editor);

        if (prefix && !hasCompleter) {
          var completer = Autocomplete.for(editor);
          completer.autoInsert = false;
          completer.showPopup(editor);
        }
      }
    };

    var Editor = require("../editor").Editor;

    require("../config").defineOptions(Editor.prototype, "editor", {
      enableBasicAutocompletion: {
        set: function (val) {
          if (val) {
            if (!this.completers) this.completers = Array.isArray(val) ? val : completers;
            this.commands.addCommand(Autocomplete.startCommand);
          } else {
            this.commands.removeCommand(Autocomplete.startCommand);
          }
        },
        value: false
      },
      enableLiveAutocompletion: {
        set: function (val) {
          if (val) {
            if (!this.completers) this.completers = Array.isArray(val) ? val : completers;
            this.commands.on('afterExec', doLiveAutocomplete);
          } else {
            this.commands.removeListener('afterExec', doLiveAutocomplete);
          }
        },
        value: false
      },
      enableSnippets: {
        set: function (val) {
          if (val) {
            this.commands.addCommand(expandSnippet);
            this.on("changeMode", onChangeMode);
            onChangeMode(null, this);
          } else {
            this.commands.removeCommand(expandSnippet);
            this.off("changeMode", onChangeMode);
          }
        },
        value: false
      }
    });
  });

  (function () {
    ace.require(["ace/ext/language_tools"], function (m) {
      if ( module) {
        module.exports = m;
      }
    });
  })();
});

var css_248z$l = ".index_rotate180__2yZST {\n  transform: rotate(180deg);\n}\n.index_rotate90__1s_cb {\n  transform: rotate(90deg);\n  pointer-events: none;\n  transition: none;\n  cursor: auto;\n}\n.index_icon-container__25agE {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 40px;\n  height: 39px;\n  cursor: pointer;\n}\n.index_icon-container__25agE .index_icon-class__1Ib-G {\n  width: 14px;\n  height: 14px;\n  user-select: none;\n}\n.index_icon-Menu__1dwQA {\n  width: 45px;\n  height: 35px;\n  border-radius: 8px;\n  background-color: #ffffff;\n  margin-right: 5px;\n  box-shadow: 3px 4px 5px 3px rgba(0, 0, 0, 0.15);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  cursor: pointer;\n}\n.index_icon-Menu__1dwQA .index_icon-class__1Ib-G {\n  width: 20px;\n  height: 20px;\n}\n.index_tabs-container__2i5bg .rc-tabs-tab {\n  font-size: 12px;\n  font-weight: bold;\n  color: #aaa;\n}\n.index_tabs-container__2i5bg .rc-tabs-tab-active {\n  color: #333;\n}\n.index_tabs-container__2i5bg .rc-tabs-ink-bar {\n  background-color: #333333;\n  height: 2px !important;\n}\n.index_tabs-container__2i5bg .rc-tabs-nav-operations {\n  display: none !important;\n}\n.index_tabs-container__2i5bg .rc-tabs-nav-measure-ping-top::before,\n.index_tabs-container__2i5bg .rc-tabs-nav-wrap-ping-top::before,\n.index_tabs-container__2i5bg .rc-tabs-nav-measure-ping-bottom::after,\n.index_tabs-container__2i5bg .rc-tabs-nav-wrap-ping-bottom::after {\n  border: 0 !important;\n}\n.index_tabs-container__2i5bg .rc-tabs-nav-operations {\n  display: none !important;\n}\n.index_tabs-container__2i5bg .rc-tabs-nav-measure-ping-left::before,\n.index_tabs-container__2i5bg .rc-tabs-nav-wrap-ping-left::before {\n  border-left-width: 0px;\n}\n.index_common-input__3rvK3 {\n  padding: 0;\n  border: none;\n  text-align: left;\n  outline: none;\n  white-space: normal;\n  word-wrap: break-word;\n  word-break: break-all;\n  resize: none;\n  width: 100%;\n  color: rgba(0, 0, 0, 0.8);\n  font-family: PingFangSC-Medium, PingFang SC;\n}\n.index_common-input__3rvK3::placeholder {\n  font-weight: 400;\n  font-family: PingFangSC-Regular, PingFang SC;\n  color: rgba(0, 0, 0, 0.3);\n}\n.index_container__1z2KV {\n  width: 100%;\n  position: relative;\n}\n.index_container__1z2KV .index_container-editor__dEKhl {\n  font-size: 12px;\n  border-radius: 3px;\n  fontFamily: Fira code, Fira Mono, monospace;\n  width: 100%;\n  max-height: 100px;\n}\n.index_container__1z2KV .index_max-edit-container__1XVtB {\n  display: flex;\n  flex-direction: column;\n  left: calc(100vw - 550px);\n  top: 70px;\n  width: 300px;\n  border-radius: 8px;\n  z-index: 1000;\n  visibility: hidden;\n}\n.index_container__1z2KV .index_icon__1QrSb {\n  width: auto;\n  height: auto;\n  margin-right: 0;\n  background-color: #00000000;\n  position: absolute;\n  cursor: pointer;\n  top: 0;\n  right: 0;\n  z-index: 10;\n}\n.index_container__1z2KV .index_icon-class__1Ib-G {\n  width: 13px;\n  height: 13px;\n}\n";
var styles$l = {"rotate180":"index_rotate180__2yZST","rotate90":"index_rotate90__1s_cb","icon-container":"index_icon-container__25agE","icon-class":"index_icon-class__1Ib-G","icon-Menu":"index_icon-Menu__1dwQA","tabs-container":"index_tabs-container__2i5bg","common-input":"index_common-input__3rvK3","container":"index_container__1z2KV","container-editor":"index_container-editor__dEKhl","max-edit-container":"index_max-edit-container__1XVtB","icon":"index_icon__1QrSb"};
styleInject(css_248z$l);

function CodeEditor(props) {
    const { value, onChange, mode, name } = props;
    const [position, setPosition] = useState({ width: 0, height: 0, top: 0, left: 0 });
    const [isChecked, setIsChecked] = useState(false);
    const dragStatus = useDragChange();
    const [code, setCode] = useState();
    const aceRef = useRef();
    const lockRef = useRef(false);
    useEffect(() => {
        if (value && !lockRef.current) {
            lockRef.current = true;
            const valueResult = typeof value === 'string' ? value : Json5.stringify(value, undefined, 2);
            setCode(valueResult);
        }
    }, [value, setCode]);
    const onCodeChange = (v) => {
        setCode(v);
        switch (mode) {
            case 'json5':
                try {
                    const data = Json5.parse(v);
                    onChange && onChange(data);
                }
                catch (e) {
                    console.error(e);
                }
                break;
        }
    };
    const getOriginPosition = useCallback(() => {
        const { top, width, height, left } = aceRef.current.refEditor.getBoundingClientRect();
        setPosition({ top, width, height, left });
    }, [setPosition]);
    useEffect(() => { getOriginPosition(); }, [dragStatus]);
    useEffect(() => {
        addEventListener('resize', getOriginPosition);
        return () => {
            removeEventListener('resize', getOriginPosition);
        };
    }, [getOriginPosition]);
    return (React.createElement("div", { className: styles$l['container'] },
        React.createElement(AceEditor, { ref: aceRef, value: code, debounceChangePeriod: 100, onChange: isChecked ? undefined : onCodeChange, mode: mode, theme: "monokai", name: "UNIQUE_ID_OF_DIV", style: { width: '100%', maxHeight: 100 }, fontSize: 12, showGutter: false, highlightActiveLine: true, className: styles$l['container-editor'], editorProps: { $blockScrolling: true } }),
        React.createElement(DragResizeBar$1, { uncheckedIcon: img$u, checkedIcon: img$t, iconClass: styles$l['icon-class'], checkboxClass: styles$l['icon'], minWidth: 400, icon: img$d, title: name, onCheckChange: setIsChecked, defaultShow: false, defaultPosition: position, className: styles$l['max-edit-container'] },
            React.createElement(AceEditor, { value: code, debounceChangePeriod: 100, onChange: isChecked ? onCodeChange : undefined, style: { width: '100%', maxHeight: '100%' }, mode: mode, theme: "monokai", name: "UNIQUE_ID_OF_DIV", fontSize: 12, showGutter: true, highlightActiveLine: true, enableLiveAutocompletion: true, className: styles$l['container-editor'], editorProps: { $blockScrolling: true } }))));
}
var CodeEditor$1 = memo(CodeEditor);

var css_248z$m = ".index_rotate180__U59gT {\n  transform: rotate(180deg);\n}\n.index_rotate90__3mxzp {\n  transform: rotate(90deg);\n}\n.index_icon-container__2fgO1 {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 40px;\n  height: 39px;\n  cursor: pointer;\n}\n.index_icon-container__2fgO1 .index_icon-class__-vvDY {\n  width: 14px;\n  height: 14px;\n  user-select: none;\n}\n.index_icon-Menu__1iNYH {\n  width: 45px;\n  height: 35px;\n  border-radius: 8px;\n  background-color: #ffffff;\n  margin-right: 5px;\n  box-shadow: 3px 4px 5px 3px rgba(0, 0, 0, 0.15);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  cursor: pointer;\n}\n.index_icon-Menu__1iNYH .index_icon-class__-vvDY {\n  width: 20px;\n  height: 20px;\n}\n.index_tabs-container__dj7x6 .rc-tabs-tab {\n  font-size: 12px;\n  font-weight: bold;\n  color: #aaa;\n}\n.index_tabs-container__dj7x6 .rc-tabs-tab-active {\n  color: #333;\n}\n.index_tabs-container__dj7x6 .rc-tabs-ink-bar {\n  background-color: #333333;\n  height: 2px !important;\n}\n.index_tabs-container__dj7x6 .rc-tabs-nav-operations {\n  display: none !important;\n}\n.index_tabs-container__dj7x6 .rc-tabs-nav-measure-ping-top::before,\n.index_tabs-container__dj7x6 .rc-tabs-nav-wrap-ping-top::before,\n.index_tabs-container__dj7x6 .rc-tabs-nav-measure-ping-bottom::after,\n.index_tabs-container__dj7x6 .rc-tabs-nav-wrap-ping-bottom::after {\n  border: 0 !important;\n}\n.index_tabs-container__dj7x6 .rc-tabs-nav-operations {\n  display: none !important;\n}\n.index_common-input__ZmyQw {\n  padding: 0;\n  border: none;\n  text-align: left;\n  outline: none;\n  white-space: normal;\n  word-wrap: break-word;\n  word-break: break-all;\n  resize: none;\n  width: 100%;\n  color: rgba(0, 0, 0, 0.8);\n  font-family: PingFangSC-Medium, PingFang SC;\n}\n.index_common-input__ZmyQw::placeholder {\n  font-weight: 400;\n  font-family: PingFangSC-Regular, PingFang SC;\n  color: rgba(0, 0, 0, 0.3);\n}\n.index_container__1zW1Q {\n  display: flex;\n  align-items: center;\n  position: relative;\n}\n";
var styles$m = {"rotate180":"index_rotate180__U59gT","rotate90":"index_rotate90__3mxzp","icon-container":"index_icon-container__2fgO1","icon-class":"index_icon-class__-vvDY","icon-Menu":"index_icon-Menu__1iNYH","tabs-container":"index_tabs-container__dj7x6","common-input":"index_common-input__ZmyQw","container":"index_container__1zW1Q"};
styleInject(css_248z$m);

function Textarea(props, ref) {
    const { onChange, className, focusClass, defaultValue, inputClass, value: v, ...rest } = props;
    const [value, setValue] = useState(v || defaultValue);
    const forceRender = useForceRender();
    const isFocusRef = useRef(false);
    const targetRef = useRef();
    useImperativeHandle(ref, () => ({
        setValue,
    }), [setValue]);
    useEffect(() => {
        if (value === undefined) {
            setValue(v);
        }
        targetRef.current.style.height = targetRef.current.scrollHeight + 'px';
    }, [v, value, setValue]);
    const change = (event) => {
        const target = event.target;
        const value = target.value;
        target.style.height = 'auto';
        target.style.height = target.scrollHeight + 'px';
        setValue(value);
        onChange && onChange(value);
    };
    const onFocus = () => {
        isFocusRef.current = true;
        forceRender();
    };
    const onBlur = () => {
        isFocusRef.current = false;
        setTimeout(forceRender, 200);
    };
    return (React.createElement("div", { className: `${styles$m['container']} ${className} ${isFocusRef.current && focusClass}` },
        React.createElement("textarea", Object.assign({ className: `${styles$m['common-input']} ${inputClass}`, ref: targetRef, onBlur: onBlur, onFocus: onFocus, rows: 1 }, rest, { onChange: change, value: value }))));
}
var Textarea$1 = memo(forwardRef(Textarea));

var css_248z$n = ".index_rotate180__2vyGG {\n  transform: rotate(180deg);\n}\n.index_rotate90__35jIR {\n  transform: rotate(90deg);\n}\n.index_icon-container__1ibkn {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 40px;\n  height: 39px;\n  cursor: pointer;\n}\n.index_icon-container__1ibkn .index_icon-class__274XT {\n  width: 14px;\n  height: 14px;\n  user-select: none;\n}\n.index_icon-Menu__2Yvg8 {\n  width: 45px;\n  height: 35px;\n  border-radius: 8px;\n  background-color: #ffffff;\n  margin-right: 5px;\n  box-shadow: 3px 4px 5px 3px rgba(0, 0, 0, 0.15);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  cursor: pointer;\n}\n.index_icon-Menu__2Yvg8 .index_icon-class__274XT {\n  width: 20px;\n  height: 20px;\n}\n.index_tabs-container__pJkgS .rc-tabs-tab {\n  font-size: 12px;\n  font-weight: bold;\n  color: #aaa;\n}\n.index_tabs-container__pJkgS .rc-tabs-tab-active {\n  color: #333;\n}\n.index_tabs-container__pJkgS .rc-tabs-ink-bar {\n  background-color: #333333;\n  height: 2px !important;\n}\n.index_tabs-container__pJkgS .rc-tabs-nav-operations {\n  display: none !important;\n}\n.index_tabs-container__pJkgS .rc-tabs-nav-measure-ping-top::before,\n.index_tabs-container__pJkgS .rc-tabs-nav-wrap-ping-top::before,\n.index_tabs-container__pJkgS .rc-tabs-nav-measure-ping-bottom::after,\n.index_tabs-container__pJkgS .rc-tabs-nav-wrap-ping-bottom::after {\n  border: 0 !important;\n}\n.index_tabs-container__pJkgS .rc-tabs-nav-operations {\n  display: none !important;\n}\n.index_common-input__2RCmr {\n  padding: 0;\n  border: none;\n  text-align: left;\n  outline: none;\n  white-space: normal;\n  word-wrap: break-word;\n  word-break: break-all;\n  resize: none;\n  width: 100%;\n  color: rgba(0, 0, 0, 0.8);\n  font-family: PingFangSC-Medium, PingFang SC;\n}\n.index_common-input__2RCmr::placeholder {\n  font-weight: 400;\n  font-family: PingFangSC-Regular, PingFang SC;\n  color: rgba(0, 0, 0, 0.3);\n}\n.index_container__1EV1j {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n}\n.index_container__1EV1j .index_switch__31tYG {\n  width: 30px;\n  height: 15px;\n}\n.index_container__1EV1j .index_input-container__2l62O {\n  border-bottom: 1px #f2f2f2 solid;\n  width: 100%;\n  font-size: 12px;\n}\n.index_container__1EV1j .index_input-container__2l62O:hover {\n  border-bottom-color: #388bfe;\n}\n.index_container__1EV1j .index_focus-class__ZZevn {\n  border-bottom-color: #388bfe;\n}\n.index_container__1EV1j .rc-switch-checked:after {\n  left: 15px;\n}\n.index_container__1EV1j .rc-switch:after {\n  width: 11px;\n  height: 11px;\n}\n";
var styles$n = {"rotate180":"index_rotate180__2vyGG","rotate90":"index_rotate90__35jIR","icon-container":"index_icon-container__1ibkn","icon-class":"index_icon-class__274XT","icon-Menu":"index_icon-Menu__2Yvg8","tabs-container":"index_tabs-container__pJkgS","common-input":"index_common-input__2RCmr","container":"index_container__1EV1j","switch":"index_switch__31tYG","input-container":"index_input-container__2l62O","focus-class":"index_focus-class__ZZevn"};
styleInject(css_248z$n);

const handleValue = (value, childPropsConfig) => {
    const newChildPropsConfig = { ...childPropsConfig };
    each(value, (v, k) => {
        if (!newChildPropsConfig[k]) {
            switch (typeof v) {
                case 'string':
                    newChildPropsConfig[k] = { type: PROPS_TYPES$1.string };
                    break;
                case 'number':
                    newChildPropsConfig[k] = { type: PROPS_TYPES$1.number };
                    break;
                case 'boolean':
                    newChildPropsConfig[k] = { type: PROPS_TYPES$1.boolean };
                    break;
                case 'object':
                    if (Array.isArray(v)) {
                        let type = null;
                        for (const childV of v) {
                            const childType = typeof childV;
                            if (childType === 'string' && (!type || type === PROPS_TYPES$1.stringArray)) {
                                type = PROPS_TYPES$1.stringArray;
                            }
                            else if (childType === 'number' && (!type || type === PROPS_TYPES$1.numberArray)) {
                                type = PROPS_TYPES$1.numberArray;
                            }
                            else {
                                type = PROPS_TYPES$1.object;
                                break;
                            }
                        }
                        newChildPropsConfig[k] = { type };
                    }
                    else {
                        newChildPropsConfig[k] = { type: PROPS_TYPES$1.object };
                    }
            }
        }
    });
    return newChildPropsConfig;
};
function ObjectValue(props) {
    const { childPropsConfig, value, onChange, ...rest } = props;
    const onValuesChange = (changedValues, values) => {
        onChange && onChange(values);
    };
    if (!childPropsConfig || isEmpty(childPropsConfig)) {
        return React.createElement(CodeEditor$1, Object.assign({ value: value, onChange: onChange }, rest));
    }
    return (React.createElement(ScaffoldForm$1, { defaultFormData: value, className: styles$n['container'], formConfig: handleValue(value, childPropsConfig), onValuesChange: onValuesChange }));
}
var ObjectValue$1 = memo(ObjectValue);

var css_248z$o = ".index_container__3Sx1s {\n  width: 100%;\n}\n.index_container__3Sx1s .index_content-wrapper__3gacw {\n  display: flex;\n  overflow: scroll;\n}\n";
var styles$o = {"container":"index_container__3Sx1s","content-wrapper":"index_content-wrapper__3gacw"};
styleInject(css_248z$o);

var css_248z$p = ".index_rotate180__xsX1K {\n  transform: rotate(180deg);\n}\n.index_rotate90__395Fz {\n  transform: rotate(90deg);\n}\n.index_icon-container__2pLvg {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 40px;\n  height: 39px;\n  cursor: pointer;\n}\n.index_icon-container__2pLvg .index_icon-class__3V4AJ {\n  width: 14px;\n  height: 14px;\n  user-select: none;\n}\n.index_icon-Menu__2-aZB {\n  width: 45px;\n  height: 35px;\n  border-radius: 8px;\n  background-color: #ffffff;\n  margin-right: 5px;\n  box-shadow: 3px 4px 5px 3px rgba(0, 0, 0, 0.15);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  cursor: pointer;\n}\n.index_icon-Menu__2-aZB .index_icon-class__3V4AJ {\n  width: 20px;\n  height: 20px;\n}\n.index_tabs-container__MFfR- .rc-tabs-tab {\n  font-size: 12px;\n  font-weight: bold;\n  color: #aaa;\n}\n.index_tabs-container__MFfR- .rc-tabs-tab-active {\n  color: #333;\n}\n.index_tabs-container__MFfR- .rc-tabs-ink-bar {\n  background-color: #333333;\n  height: 2px !important;\n}\n.index_tabs-container__MFfR- .rc-tabs-nav-operations {\n  display: none !important;\n}\n.index_tabs-container__MFfR- .rc-tabs-nav-measure-ping-top::before,\n.index_tabs-container__MFfR- .rc-tabs-nav-wrap-ping-top::before,\n.index_tabs-container__MFfR- .rc-tabs-nav-measure-ping-bottom::after,\n.index_tabs-container__MFfR- .rc-tabs-nav-wrap-ping-bottom::after {\n  border: 0 !important;\n}\n.index_tabs-container__MFfR- .rc-tabs-nav-operations {\n  display: none !important;\n}\n.index_common-input__x04tC {\n  padding: 0;\n  border: none;\n  text-align: left;\n  outline: none;\n  white-space: normal;\n  word-wrap: break-word;\n  word-break: break-all;\n  resize: none;\n  width: 100%;\n  color: rgba(0, 0, 0, 0.8);\n  font-family: PingFangSC-Medium, PingFang SC;\n}\n.index_common-input__x04tC::placeholder {\n  font-weight: 400;\n  font-family: PingFangSC-Regular, PingFang SC;\n  color: rgba(0, 0, 0, 0.3);\n}\n.index_container__2slFr {\n  display: flex;\n}\n.index_container__2slFr .index_sort-item__3y6yi {\n  position: relative;\n  display: flex;\n  align-items: center;\n  color: #333333;\n  font-size: 12px;\n  border-radius: 3px;\n  margin-left: 2px;\n  margin-right: 2px;\n  background-color: #f5f5f5;\n  padding: 2px 15px 2px 2px;\n  margin-top: 5px;\n}\n.index_container__2slFr .index_sort-item__3y6yi .index_close__2bhxw {\n  font-size: 12px;\n  color: #bcbcbc;\n  position: absolute;\n  right: 3px;\n}\n.index_container__2slFr .index_sort-item__3y6yi .index_close__2bhxw:hover {\n  color: #333333;\n}\n";
var styles$p = {"rotate180":"index_rotate180__xsX1K","rotate90":"index_rotate90__395Fz","icon-container":"index_icon-container__2pLvg","icon-class":"index_icon-class__3V4AJ","icon-Menu":"index_icon-Menu__2-aZB","tabs-container":"index_tabs-container__MFfR-","common-input":"index_common-input__x04tC","container":"index_container__2slFr","sort-item":"index_sort-item__3y6yi","close":"index_close__2bhxw"};
styleInject(css_248z$p);

function SortItem$2(props) {
    const { value, onDeleteItem, index } = props;
    const onClick = useCallback((event) => {
        event.stopPropagation();
        onDeleteItem(value, index);
    }, []);
    return (React.createElement("div", { className: styles$p['sort-item'], id: value },
        value,
        React.createElement("span", { className: styles$p['close'], onClick: onClick }, "x")));
}
function SortableTags(props, ref) {
    const { sortData, onSortChange, className, extra, onDeleteItem, ...rest } = props;
    const onSortData = (sortKeys) => {
        const index = sortKeys.indexOf('extra-item');
        sortKeys.splice(index, 1);
        onSortChange && onSortChange(sortKeys);
    };
    const onDelete = useCallback((value, index) => {
        onDeleteItem && onDeleteItem(value, index);
        let newSortData = [...sortData];
        if (newSortData.length > 1) {
            newSortData.splice(index, 1);
        }
        else {
            newSortData = undefined;
        }
        onSortChange && onSortChange(newSortData);
    }, [sortData]);
    return (React.createElement(ReactSortable, Object.assign({ ref: ref, className: `${styles$p['container']} ${className}`, options: {
            group: { name: 'nested' },
            animation: 200,
            dataIdAttr: 'id',
            ghostClass: styles$p['item-background'],
            swapThreshold: 0.5,
        }, onChange: onSortData }, rest),
        map(sortData, (item, index) => {
            return React.createElement(SortItem$2, { onDeleteItem: onDelete, value: item, index: index, key: `${item}-${index}` });
        }),
        !!extra && extra));
}
var SortableTags$1 = memo(forwardRef(SortableTags));

function ObjectArray(props) {
    const { childPropsConfig, value, onChange } = props;
    const [sortData, setSortData] = useState([]);
    // const [key, setKey] = useState<string>();
    const onTagClick = (key) => {
        // setKey(key);
        // childPropsConfigRef.current.find((item)=>item.id===key);
        // setConfig(key);
    };
    const addItem = () => {
        setSortData([]);
    };
    let newValue = value;
    if (!value) {
        newValue = [{}];
    }
    const onChangeData = (v, index) => {
        onChange && onChange([v]);
    };
    return (React.createElement("div", { className: styles$o['container'] },
        React.createElement(SortableTags$1, { sortData: sortData, extra: React.createElement("div", { onClick: addItem, className: styles$o['add'] }, "+"), onTagClick: onTagClick }),
        React.createElement("div", { className: styles$o['content-wrapper'] }, map(newValue, (v, index) => React.createElement(ObjectValue$1, { value: v, onChange: (v) => onChangeData(v), childPropsConfig: childPropsConfig, key: index })))));
}
var index = memo(ObjectArray);

var css_248z$q = ".index_rotate180__XjrOu {\n  transform: rotate(180deg);\n}\n.index_rotate90__2LZv- {\n  transform: rotate(90deg);\n}\n.index_icon-container__1XpGx {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 40px;\n  height: 39px;\n  cursor: pointer;\n}\n.index_icon-container__1XpGx .index_icon-class__Tdvo_ {\n  width: 14px;\n  height: 14px;\n  user-select: none;\n}\n.index_icon-Menu__2JXK7 {\n  width: 45px;\n  height: 35px;\n  border-radius: 8px;\n  background-color: #ffffff;\n  margin-right: 5px;\n  box-shadow: 3px 4px 5px 3px rgba(0, 0, 0, 0.15);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  cursor: pointer;\n}\n.index_icon-Menu__2JXK7 .index_icon-class__Tdvo_ {\n  width: 20px;\n  height: 20px;\n}\n.index_tabs-container__2UP1s .rc-tabs-tab {\n  font-size: 12px;\n  font-weight: bold;\n  color: #aaa;\n}\n.index_tabs-container__2UP1s .rc-tabs-tab-active {\n  color: #333;\n}\n.index_tabs-container__2UP1s .rc-tabs-ink-bar {\n  background-color: #333333;\n  height: 2px !important;\n}\n.index_tabs-container__2UP1s .rc-tabs-nav-operations {\n  display: none !important;\n}\n.index_tabs-container__2UP1s .rc-tabs-nav-measure-ping-top::before,\n.index_tabs-container__2UP1s .rc-tabs-nav-wrap-ping-top::before,\n.index_tabs-container__2UP1s .rc-tabs-nav-measure-ping-bottom::after,\n.index_tabs-container__2UP1s .rc-tabs-nav-wrap-ping-bottom::after {\n  border: 0 !important;\n}\n.index_tabs-container__2UP1s .rc-tabs-nav-operations {\n  display: none !important;\n}\n.index_common-input__VFw76 {\n  padding: 0;\n  border: none;\n  text-align: left;\n  outline: none;\n  white-space: normal;\n  word-wrap: break-word;\n  word-break: break-all;\n  resize: none;\n  width: 100%;\n  color: rgba(0, 0, 0, 0.8);\n  font-family: PingFangSC-Medium, PingFang SC;\n}\n.index_common-input__VFw76::placeholder {\n  font-weight: 400;\n  font-family: PingFangSC-Regular, PingFang SC;\n  color: rgba(0, 0, 0, 0.3);\n}\n.index_sort-tags__3FCrP {\n  display: flex;\n  flex-wrap: wrap;\n  border-bottom: 1px #f2f2f2 solid;\n  width: 100%;\n  font-size: 12px;\n  padding-bottom: 3px;\n}\n.index_sort-tags__3FCrP:hover {\n  border-bottom-color: #388bfe;\n}\n.index_sort-tags__3FCrP .index_common-input__VFw76 {\n  width: 100%;\n  min-width: 4.1px;\n}\n.index_sort-tags__3FCrP .index_extra__pafEF {\n  padding-top: 3px;\n}\n.index_focus-class__2C-Na {\n  border-bottom-color: #388bfe;\n}\n";
var styles$q = {"rotate180":"index_rotate180__XjrOu","rotate90":"index_rotate90__2LZv-","icon-container":"index_icon-container__1XpGx","icon-class":"index_icon-class__Tdvo_","icon-Menu":"index_icon-Menu__2JXK7","tabs-container":"index_tabs-container__2UP1s","common-input":"index_common-input__VFw76","sort-tags":"index_sort-tags__3FCrP","extra":"index_extra__pafEF","focus-class":"index_focus-class__2C-Na"};
styleInject(css_248z$q);

function CommonArray(props) {
    const { value = [], onChange, isNumber, maxLength } = props;
    const forceRender = useForceRender();
    const [inputValue, setInputValue] = useState();
    const isFocusRef = useRef(false);
    const inputContainerRef = useRef();
    const inputRef = useRef();
    const change = (event) => {
        const value = event.target.value;
        if (isNumber && !/\d+/.test(value)) {
            return setInputValue('');
        }
        setInputValue(value);
        inputContainerRef.current.style.width = value.length * 7 + 'px';
    };
    const onSortChange = (newSortData) => {
        onChange && onChange(newSortData);
    };
    const onFocus = () => {
        isFocusRef.current = true;
        forceRender();
    };
    const onBlur = () => {
        isFocusRef.current = false;
        setInputValue('');
        value.length > 0 && (inputContainerRef.current.style.display = 'none');
    };
    const onKeyDown = (event) => {
        event.stopPropagation();
        const { key } = event;
        if (key === 'Enter') {
            if (inputValue) {
                if (maxLength && value.length === maxLength) {
                    value.pop();
                }
                onChange && onChange([...value, inputValue]);
                setInputValue('');
            }
        }
        else if (key === 'Backspace') {
            if (!inputValue) {
                value.pop();
                onChange && onChange([...value]);
            }
        }
    };
    const onContainerFocus = () => {
        inputContainerRef.current.style.display = 'flex';
        inputRef.current.focus();
    };
    return (React.createElement(SortableTags$1, { sortData: value, onClick: onContainerFocus, onSortChange: onSortChange, className: `${styles$q['sort-tags']} ${isFocusRef.current && styles$q['focus-class']}`, extra: React.createElement("div", { ref: inputContainerRef, draggable: false, id: 'extra-item', className: styles$q['extra'], style: { width: 5 } },
            React.createElement("input", { ref: inputRef, className: styles$q['common-input'], onBlur: onBlur, onFocus: onFocus, onChange: change, onKeyDown: onKeyDown, value: inputValue })) }));
}
var CommonArray$1 = memo(CommonArray);

var css_248z$r = ".index_rotate180__cie7c {\n  transform: rotate(180deg);\n}\n.index_rotate90__3oLUL {\n  transform: rotate(90deg);\n}\n.index_icon-container__2Aen4 {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 40px;\n  height: 39px;\n  cursor: pointer;\n}\n.index_icon-container__2Aen4 .index_icon-class__2hviQ {\n  width: 14px;\n  height: 14px;\n  user-select: none;\n}\n.index_icon-Menu__CcJfA {\n  width: 45px;\n  height: 35px;\n  border-radius: 8px;\n  background-color: #ffffff;\n  margin-right: 5px;\n  box-shadow: 3px 4px 5px 3px rgba(0, 0, 0, 0.15);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  cursor: pointer;\n}\n.index_icon-Menu__CcJfA .index_icon-class__2hviQ {\n  width: 20px;\n  height: 20px;\n}\n.index_tabs-container__1RmTs .rc-tabs-tab {\n  font-size: 12px;\n  font-weight: bold;\n  color: #aaa;\n}\n.index_tabs-container__1RmTs .rc-tabs-tab-active {\n  color: #333;\n}\n.index_tabs-container__1RmTs .rc-tabs-ink-bar {\n  background-color: #333333;\n  height: 2px !important;\n}\n.index_tabs-container__1RmTs .rc-tabs-nav-operations {\n  display: none !important;\n}\n.index_tabs-container__1RmTs .rc-tabs-nav-measure-ping-top::before,\n.index_tabs-container__1RmTs .rc-tabs-nav-wrap-ping-top::before,\n.index_tabs-container__1RmTs .rc-tabs-nav-measure-ping-bottom::after,\n.index_tabs-container__1RmTs .rc-tabs-nav-wrap-ping-bottom::after {\n  border: 0 !important;\n}\n.index_tabs-container__1RmTs .rc-tabs-nav-operations {\n  display: none !important;\n}\n.index_common-input__GkEyN {\n  padding: 0;\n  border: none;\n  text-align: left;\n  outline: none;\n  white-space: normal;\n  word-wrap: break-word;\n  word-break: break-all;\n  resize: none;\n  width: 100%;\n  color: rgba(0, 0, 0, 0.8);\n  font-family: PingFangSC-Medium, PingFang SC;\n}\n.index_common-input__GkEyN::placeholder {\n  font-weight: 400;\n  font-family: PingFangSC-Regular, PingFang SC;\n  color: rgba(0, 0, 0, 0.3);\n}\n.index_select__3H6GV {\n  font-size: 12px;\n  height: 25px;\n}\n.index_select__3H6GV:hover,\n.index_select__3H6GV:focus {\n  border: 1px #388bfe solid;\n  width: 100%;\n}\n";
var styles$r = {"rotate180":"index_rotate180__cie7c","rotate90":"index_rotate90__3oLUL","icon-container":"index_icon-container__2Aen4","icon-class":"index_icon-class__2hviQ","icon-Menu":"index_icon-Menu__CcJfA","tabs-container":"index_tabs-container__1RmTs","common-input":"index_common-input__GkEyN","select":"index_select__3H6GV"};
styleInject(css_248z$r);

const Enum = forwardRef(function Component(props) {
    const { enumData, ...rest } = props;
    if (enumData.length > 3) {
        return (React.createElement(Select$1, Object.assign({ className: styles$r['select'], enumData: enumData }, rest)));
    }
    return React.createElement(Radio$1, Object.assign({ radioData: enumData }, rest));
});
var Enum$1 = memo(Enum, propsAreEqual);

var css_248z$s = ".index_rotate180__wfkjy {\n  transform: rotate(180deg);\n}\n.index_rotate90__3FiWs {\n  transform: rotate(90deg);\n}\n.index_icon-container___y4UE {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 40px;\n  height: 39px;\n  cursor: pointer;\n}\n.index_icon-container___y4UE .index_icon-class__2pVjj {\n  width: 14px;\n  height: 14px;\n  user-select: none;\n}\n.index_icon-Menu__1kZl5 {\n  width: 45px;\n  height: 35px;\n  border-radius: 8px;\n  background-color: #ffffff;\n  margin-right: 5px;\n  box-shadow: 3px 4px 5px 3px rgba(0, 0, 0, 0.15);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  cursor: pointer;\n}\n.index_icon-Menu__1kZl5 .index_icon-class__2pVjj {\n  width: 20px;\n  height: 20px;\n}\n.index_tabs-container__14jCm .rc-tabs-tab {\n  font-size: 12px;\n  font-weight: bold;\n  color: #aaa;\n}\n.index_tabs-container__14jCm .rc-tabs-tab-active {\n  color: #333;\n}\n.index_tabs-container__14jCm .rc-tabs-ink-bar {\n  background-color: #333333;\n  height: 2px !important;\n}\n.index_tabs-container__14jCm .rc-tabs-nav-operations {\n  display: none !important;\n}\n.index_tabs-container__14jCm .rc-tabs-nav-measure-ping-top::before,\n.index_tabs-container__14jCm .rc-tabs-nav-wrap-ping-top::before,\n.index_tabs-container__14jCm .rc-tabs-nav-measure-ping-bottom::after,\n.index_tabs-container__14jCm .rc-tabs-nav-wrap-ping-bottom::after {\n  border: 0 !important;\n}\n.index_tabs-container__14jCm .rc-tabs-nav-operations {\n  display: none !important;\n}\n.index_common-input__JU5Bx {\n  padding: 0;\n  border: none;\n  text-align: left;\n  outline: none;\n  white-space: normal;\n  word-wrap: break-word;\n  word-break: break-all;\n  resize: none;\n  width: 100%;\n  color: rgba(0, 0, 0, 0.8);\n  font-family: PingFangSC-Medium, PingFang SC;\n}\n.index_common-input__JU5Bx::placeholder {\n  font-weight: 400;\n  font-family: PingFangSC-Regular, PingFang SC;\n  color: rgba(0, 0, 0, 0.3);\n}\n.index_container__18Ov8 {\n  position: relative;\n  width: 100%;\n}\n.index_input-container__1NHYb {\n  border-bottom: 1px #f2f2f2 solid;\n  width: 100%;\n  font-size: 12px;\n}\n.index_input-container__1NHYb:hover {\n  border-bottom-color: #388bfe;\n}\n.index_focus-class__3ZYf4 {\n  border-bottom-color: #388bfe;\n}\n.index_inputClass__2nWp7 {\n  text-align: center;\n  width: 100%;\n}\n.index_select-container__1fQy5 {\n  position: absolute;\n  display: none;\n  flex-direction: row;\n  top: 26px;\n  width: 100%;\n  -webkit-box-shadow: 0 0.1em 0.5em 0 rgba(0, 0, 0, 0.28);\n  box-shadow: 0 0.1em 0.5em 0 rgba(0, 0, 0, 0.28);\n  border-radius: 5px;\n}\n.index_select-container__1fQy5 .index_item-container__qM6-J {\n  display: flex;\n  flex: 1;\n  flex-direction: column;\n  border-right-width: 1px;\n  border-color: #f2f2f2;\n  border-right-style: solid;\n}\n.index_select-container__1fQy5 .index_item-container__qM6-J .index_item__zrZMM {\n  height: 30px;\n  display: flex;\n  align-items: center;\n  padding-left: 10px;\n  border-bottom-width: 1px;\n  border-color: #f2f2f2;\n  border-bottom-style: solid;\n}\n";
var styles$s = {"rotate180":"index_rotate180__wfkjy","rotate90":"index_rotate90__3FiWs","icon-container":"index_icon-container___y4UE","icon-class":"index_icon-class__2pVjj","icon-Menu":"index_icon-Menu__1kZl5","tabs-container":"index_tabs-container__14jCm","common-input":"index_common-input__JU5Bx","container":"index_container__18Ov8","input-container":"index_input-container__1NHYb","focus-class":"index_focus-class__3ZYf4","inputClass":"index_inputClass__2nWp7","select-container":"index_select-container__1fQy5","item-container":"index_item-container__qM6-J","item":"index_item__zrZMM"};
styleInject(css_248z$s);

function SelectTree(props) {
    const { data = {}, onChange } = props;
    const selectKeys = useRef([]);
    const [keys, setKeys] = useState([Object.keys(data)]);
    const onSelect = (k, index) => {
        selectKeys.current[index] = k;
        console.log('onSelect>>>>>>>>>', selectKeys.current);
        // selectKeys.current.splice(index);
        const path = [...selectKeys.current].join('.');
        onChange && onChange(path);
        console.log('nextData1>>>>>>', data, path, selectKeys.current);
        const nextData = get(data, path);
        const newKeys = [...keys];
        if (typeof nextData === 'object') {
            newKeys[index + 1] = Object.keys(nextData);
            console.log('nextData3>>>>>>', newKeys);
            // newKeys.splice(index+1);
            console.log('nextData2>>>>>>', newKeys);
            setKeys(newKeys);
        }
    };
    return React.createElement("div", { className: styles$s['select-container'] }, map(keys, (ks, index) => {
        return React.createElement("div", { className: styles$s['item-container'] }, map(ks, (k) => React.createElement("div", { className: styles$s['item'], onClick: () => onSelect(k, index) }, k)));
    }));
}

function Expression(props) {
    const { onChange, value } = props;
    const onInputChange = (v) => {
        onChange && onChange(v ? `\${${v}}` : undefined);
    };
    let newValue = '';
    if (expressionRex.test(value)) {
        newValue = value.replace('${', '');
        newValue = newValue.replace('}', '');
    }
    const onSelectTreeChange = (path) => {
    };
    return (React.createElement("div", { className: styles$s['container'] },
        React.createElement(Input$1, { onChange: onInputChange, value: newValue, placeholder: '请输入js表达式', closeAble: false, addonBefore: React.createElement("span", null, '{{'), addonAfter: React.createElement("span", null, '}}'), className: styles$s['input-container'], focusClass: styles$s['focus-class'], inputClass: styles$s['inputClass'], type: 'text' }),
        React.createElement(SelectTree, { data: { 1: { 2: 5 }, 3: { 6: 7 } }, onChange: onSelectTreeChange })));
}
var Expression$1 = memo(Expression);

function ButtonWrapper(props) {
    const { panelKeys, ...rest } = props;
    const parentRef = useRef();
    useActiveParent(panelKeys, parentRef);
    return React.createElement("div", Object.assign({ ref: parentRef }, rest));
}

var css_248z$t = ".index_rotate180__2en_n {\n  transform: rotate(180deg);\n}\n.index_rotate90__1lMgP {\n  transform: rotate(90deg);\n  pointer-events: none;\n  transition: none;\n  cursor: auto;\n}\n.index_icon-container__373gP {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 40px;\n  height: 39px;\n  cursor: pointer;\n}\n.index_icon-container__373gP .index_icon-class__1bLqS {\n  width: 14px;\n  height: 14px;\n  user-select: none;\n}\n.index_icon-Menu__26FFO {\n  width: 45px;\n  height: 35px;\n  border-radius: 8px;\n  background-color: #ffffff;\n  margin-right: 5px;\n  box-shadow: 3px 4px 5px 3px rgba(0, 0, 0, 0.15);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  cursor: pointer;\n}\n.index_icon-Menu__26FFO .index_icon-class__1bLqS {\n  width: 20px;\n  height: 20px;\n}\n.index_tabs-container__1oHoN .rc-tabs-tab {\n  font-size: 12px;\n  font-weight: bold;\n  color: #aaa;\n}\n.index_tabs-container__1oHoN .rc-tabs-tab-active {\n  color: #333;\n}\n.index_tabs-container__1oHoN .rc-tabs-ink-bar {\n  background-color: #333333;\n  height: 2px !important;\n}\n.index_tabs-container__1oHoN .rc-tabs-nav-operations {\n  display: none !important;\n}\n.index_tabs-container__1oHoN .rc-tabs-nav-measure-ping-top::before,\n.index_tabs-container__1oHoN .rc-tabs-nav-wrap-ping-top::before,\n.index_tabs-container__1oHoN .rc-tabs-nav-measure-ping-bottom::after,\n.index_tabs-container__1oHoN .rc-tabs-nav-wrap-ping-bottom::after {\n  border: 0 !important;\n}\n.index_tabs-container__1oHoN .rc-tabs-nav-operations {\n  display: none !important;\n}\n.index_tabs-container__1oHoN .rc-tabs-nav-measure-ping-left::before,\n.index_tabs-container__1oHoN .rc-tabs-nav-wrap-ping-left::before {\n  border-left-width: 0px;\n}\n.index_common-input__1ekfA {\n  padding: 0;\n  border: none;\n  text-align: left;\n  outline: none;\n  white-space: normal;\n  word-wrap: break-word;\n  word-break: break-all;\n  resize: none;\n  width: 100%;\n  color: rgba(0, 0, 0, 0.8);\n  font-family: PingFangSC-Medium, PingFang SC;\n}\n.index_common-input__1ekfA::placeholder {\n  font-weight: 400;\n  font-family: PingFangSC-Regular, PingFang SC;\n  color: rgba(0, 0, 0, 0.3);\n}\n.index_container__3bjXd {\n  border-top: 1px #f2f2f2 solid;\n  display: flex;\n  flex-direction: column;\n  padding-top: 10px;\n  height: calc(100vh - 210px);\n  overflow: auto;\n}\n.index_container__3bjXd .index_switch__2K-xn {\n  width: 30px;\n  height: 15px;\n}\n.index_container__3bjXd .index_input-container__1ggHl {\n  margin-top: 5px;\n  border-bottom: 1px #f2f2f2 solid;\n  width: 100%;\n  font-size: 12px;\n}\n.index_container__3bjXd .index_input-container__1ggHl:hover {\n  border-bottom-color: #388bfe;\n}\n.index_container__3bjXd .index_focus-class__gTQHh {\n  border-bottom-color: #388bfe;\n}\n.index_container__3bjXd .rc-switch-checked:after {\n  left: 15px;\n}\n.index_container__3bjXd .rc-switch:after {\n  width: 11px;\n  height: 11px;\n}\n.index_empty__31Eum {\n  border-top: 1px #f2f2f2 solid;\n  display: flex;\n  font-size: 13px;\n  justify-content: center;\n  padding-top: 100px;\n}\n";
var styles$t = {"rotate180":"index_rotate180__2en_n","rotate90":"index_rotate90__1lMgP","icon-container":"index_icon-container__373gP","icon-class":"index_icon-class__1bLqS","icon-Menu":"index_icon-Menu__26FFO","tabs-container":"index_tabs-container__1oHoN","common-input":"index_common-input__1ekfA","container":"index_container__3bjXd","switch":"index_switch__2K-xn","input-container":"index_input-container__1ggHl","focus-class":"index_focus-class__gTQHh","empty":"index_empty__31Eum"};
styleInject(css_248z$t);

function PropItem(props) {
    const { isExpression, menu, config, setIsExpression, name, ...rest } = props;
    const { enumData, type, childPropsConfig } = config || {};
    let switchCase = menu || type;
    const { value } = props;
    useEffect(() => {
        if (expressionRex.test(value)) {
            setIsExpression(true);
        }
    }, [setIsExpression, value]);
    if (Array.isArray(type) && !menu) {
        if (value) {
            switchCase = getValueType(value);
        }
        else {
            switchCase = type[0];
        }
    }
    let renderComponent = React.createElement(Expression$1, Object.assign({}, rest));
    if (isExpression)
        return renderComponent;
    switch (switchCase) {
        case PROPS_TYPES$1.boolean:
            renderComponent = React.createElement(Switch, Object.assign({}, rest, { checked: value, className: styles$t['switch'] }));
            break;
        case PROPS_TYPES$1.number:
            renderComponent = React.createElement(InputNumber$1, Object.assign({ config: config }, rest));
            break;
        case PROPS_TYPES$1.string:
            renderComponent = (React.createElement(Textarea$1, Object.assign({ className: styles$t['input-container'], focusClass: styles$t['focus-class'] }, rest)));
            break;
        case PROPS_TYPES$1.stringArray:
            renderComponent = React.createElement(CommonArray$1, Object.assign({}, rest));
            break;
        case PROPS_TYPES$1.numberArray:
            renderComponent = React.createElement(CommonArray$1, Object.assign({ isNumber: true }, rest));
            break;
        case PROPS_TYPES$1.enum:
            renderComponent = React.createElement(Enum$1, Object.assign({ enumData: enumData }, rest));
            break;
        case PROPS_TYPES$1.object:
            renderComponent = (React.createElement(ObjectValue$1, Object.assign({ childPropsConfig: childPropsConfig }, rest)));
            break;
        // case PROPS_TYPES.objectArray:
        //   renderComponent = (
        //     <ObjectArray childPropsConfig={childPropsConfig} {...rest} />
        //   );
        //   break;
        default:
            renderComponent = React.createElement(CodeEditor$1, Object.assign({ name: name }, rest));
    }
    return renderComponent;
}
var PropItem$1 = memo(PropItem);

function ScaffoldForm(props) {
    const nFormRef = useRef();
    const { defaultFormData, onValuesChange, tip, formConfig, lockKey } = props;
    const prevLockKey = usePrevious(lockKey);
    if (prevLockKey !== lockKey && nFormRef.current) {
        nFormRef.current.resetFields();
    }
    useEffect(() => {
        if (nFormRef.current && defaultFormData) {
            nFormRef.current.setFieldsValue(defaultFormData);
        }
    }, [defaultFormData]);
    const renderFormItem = useCallback((config, key, isExpression, menu) => {
        const { type } = config;
        const menus = Array.isArray(type) && type;
        const subStyle = { justifyContent: 'flex-end', height: 32 };
        let style = { flexDirection: 'column', alignItems: 'flex-start' };
        const borderStyle = { flexDirection: 'column', alignItems: 'flex-start' };
        const renderComponent = React.createElement(PropItem$1, { config: config, isExpression: isExpression, menu: menu });
        let headerStyle = {};
        if (isExpression)
            return { style, renderComponent };
        if (!Array.isArray(type)) {
            switch (type) {
                case PROPS_TYPES$1.boolean:
                case PROPS_TYPES$1.number:
                    style = subStyle;
                    headerStyle = { overflow: 'hidden', marginRight: 10 };
                    break;
                case PROPS_TYPES$1.object:
                case PROPS_TYPES$1.objectArray:
                case PROPS_TYPES$1.enum:
                    style = borderStyle;
                    headerStyle = { marginBottom: 5 };
                    break;
                // headerStyle={marginBottom:5};
            }
        }
        else {
            style = borderStyle;
        }
        return { style, renderComponent, menus, headerStyle };
    }, []);
    const onChange = (changedValues, values) => {
        onValuesChange && onValuesChange(changedValues, values);
    };
    return tip ? React.createElement("div", { className: styles$t['empty'] }, tip) : React.createElement(NForm$1, { className: styles$t['container'], renderFormItem: renderFormItem, onValuesChange: onChange, ref: nFormRef, formConfig: formConfig });
}
var ScaffoldForm$1 = memo(ScaffoldForm);

function TopLeftButtons() {
    // const [isDragMove,setIsDragMove]=useState<boolean>();
    const PANEL_KEYS = ['Layers'];
    return (React.createElement(ButtonWrapper, { panelKeys: PANEL_KEYS, className: styles$2['top-left-bar'] },
        React.createElement(Layers$1, null),
        React.createElement(Icon$1, { icon: img$g, className: styles$2['icon-Menu'], iconClass: styles$2['icon-class'] }),
        React.createElement(Icon$1, { icon: img$f, className: styles$2['icon-Menu'], iconClass: styles$2['icon-class'] })));
}
var TopLeftButtons$1 = memo(TopLeftButtons);

var css_248z$u = ".index_container__3SPNN {\n  position: absolute;\n  bottom: 10px;\n  display: flex;\n  align-items: center;\n  height: 39px;\n  border-radius: 25px;\n  background-color: #fff;\n  box-shadow: 3px 4px 5px 3px rgba(0, 0, 0, 0.15);\n  padding-left: 10px;\n  padding-right: 10px;\n}\n.index_container__3SPNN .index_icon-container__1N712 {\n  padding-left: 10px;\n  padding-right: 10px;\n  cursor: pointer;\n}\n.index_container__3SPNN .index_icon-container__1N712 .index_icon-class__nmiFj {\n  width: 20px;\n  height: 20px;\n}\n.index_container__3SPNN .index_divider__KSIyV {\n  height: 25px;\n  width: 1px;\n  background-color: #333;\n}\n";
var styles$u = {"container":"index_container__3SPNN","icon-container":"index_icon-container__1N712","icon-class":"index_icon-class__nmiFj","divider":"index_divider__KSIyV"};
styleInject(css_248z$u);

function UndoRedo(props) {
    const { isUndo } = props;
    const { undo: undoData, redo: redoData } = useSelector(['undo', 'redo'], (prevState, nextState) => {
        const { undo, redo } = nextState;
        if (isUndo) {
            return !isEqual(undo, prevState.undo);
        }
        return !isEqual(redo, prevState.redo);
    });
    const isAble = isUndo ? !!undoData.length : !!redoData.length;
    const onClick = useCallback((event) => {
        event.stopPropagation();
        if (isAble) {
            isUndo ? undo() : redo();
        }
    }, [isAble]);
    return (React.createElement(Icon$1, { className: styles$u['icon-container'], iconClass: styles$u['icon-class'], icon: isUndo ? img$l : img$k, onClick: onClick }));
}
var UndoRedo$1 = memo(UndoRedo);

function Zoom(props) {
    const { type = '11' } = props;
    const { setZoomState, getZoomState } = useZoom();
    let icon = img$o;
    if (type === 'in') {
        icon = img$m;
    }
    else if (type === 'out') {
        icon = img$n;
    }
    const onClick = useCallback((event) => {
        event.stopPropagation();
        let { scale } = getZoomState();
        if (type === 'in') {
            scale += 0.05;
        }
        else if (type === 'out') {
            scale -= 0.05;
        }
        else {
            scale = 1;
        }
        setZoomState({ scale: scale || 0 });
    }, []);
    return (React.createElement(Icon$1, { className: styles$u['icon-container'], iconClass: styles$u['icon-class'], icon: icon, onClick: onClick }));
}
var Zoom$1 = memo(Zoom);

function MidBottomButtons() {
    return (React.createElement("div", { className: styles$u['container'] },
        React.createElement(UndoRedo$1, { isUndo: true }),
        React.createElement(UndoRedo$1, null),
        React.createElement("div", { className: styles$u['divider'] }),
        React.createElement(Zoom$1, { type: 'out' }),
        React.createElement(Zoom$1, null),
        React.createElement(Zoom$1, { type: 'in' }),
        React.createElement("div", { className: styles$u['divider'] }),
        React.createElement(Icon$1, { className: styles$u['icon-container'], iconClass: styles$u['icon-class'], icon: img$b }),
        React.createElement(Icon$1, { className: styles$u['icon-container'], iconClass: styles$u['icon-class'], icon: img$p })));
}
var MidBottomButtons$1 = memo(MidBottomButtons);

var css_248z$v = ".index_bottom-left-bar__3asO8 {\n  position: fixed;\n  display: flex;\n  bottom: 10px;\n  left: 20px;\n  z-index: 0;\n}\n";
var styles$v = {"bottom-left-bar":"index_bottom-left-bar__3asO8"};
styleInject(css_248z$v);

var css_248z$w = ".index_rotate180__31vJp {\n  transform: rotate(180deg);\n}\n.index_rotate90__GwFiU {\n  transform: rotate(90deg);\n  pointer-events: none;\n  transition: none;\n  cursor: auto;\n}\n.index_icon-container__2hJq3 {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 40px;\n  height: 39px;\n  cursor: pointer;\n}\n.index_icon-container__2hJq3 .index_icon-class__1ukt0 {\n  width: 14px;\n  height: 14px;\n  user-select: none;\n}\n.index_icon-Menu__19lxK {\n  width: 45px;\n  height: 35px;\n  border-radius: 8px;\n  background-color: #ffffff;\n  margin-right: 5px;\n  box-shadow: 3px 4px 5px 3px rgba(0, 0, 0, 0.15);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  cursor: pointer;\n}\n.index_icon-Menu__19lxK .index_icon-class__1ukt0 {\n  width: 20px;\n  height: 20px;\n}\n.index_tabs-container__z5rkE .rc-tabs-tab {\n  font-size: 12px;\n  font-weight: bold;\n  color: #aaa;\n}\n.index_tabs-container__z5rkE .rc-tabs-tab-active {\n  color: #333;\n}\n.index_tabs-container__z5rkE .rc-tabs-ink-bar {\n  background-color: #333333;\n  height: 2px !important;\n}\n.index_tabs-container__z5rkE .rc-tabs-nav-operations {\n  display: none !important;\n}\n.index_tabs-container__z5rkE .rc-tabs-nav-measure-ping-top::before,\n.index_tabs-container__z5rkE .rc-tabs-nav-wrap-ping-top::before,\n.index_tabs-container__z5rkE .rc-tabs-nav-measure-ping-bottom::after,\n.index_tabs-container__z5rkE .rc-tabs-nav-wrap-ping-bottom::after {\n  border: 0 !important;\n}\n.index_tabs-container__z5rkE .rc-tabs-nav-operations {\n  display: none !important;\n}\n.index_tabs-container__z5rkE .rc-tabs-nav-measure-ping-left::before,\n.index_tabs-container__z5rkE .rc-tabs-nav-wrap-ping-left::before {\n  border-left-width: 0px;\n}\n.index_common-input__1rNdm {\n  padding: 0;\n  border: none;\n  text-align: left;\n  outline: none;\n  white-space: normal;\n  word-wrap: break-word;\n  word-break: break-all;\n  resize: none;\n  width: 100%;\n  color: rgba(0, 0, 0, 0.8);\n  font-family: PingFangSC-Medium, PingFang SC;\n}\n.index_common-input__1rNdm::placeholder {\n  font-weight: 400;\n  font-family: PingFangSC-Regular, PingFang SC;\n  color: rgba(0, 0, 0, 0.3);\n}\n.index_left-container__3pX13 {\n  left: 10px;\n  background-color: white;\n}\n.index_drag-container__16U-1 {\n  position: relative;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 60px;\n  height: 60px;\n  padding: 5px;\n  margin: 5px;\n  border-radius: 4px;\n  overflow: hidden;\n  background: #f2f2f2;\n  transition: all 500ms;\n}\n.index_drag-container__16U-1 .index_hidden-drag-name__13m_L {\n  visibility: hidden;\n  position: absolute;\n  bottom: 0;\n  font-size: 12px;\n  color: #333333;\n}\n.index_drag-container__16U-1:hover .index_drag-name__t458l {\n  visibility: visible;\n  position: absolute;\n  bottom: 0;\n  font-size: 12px;\n  color: #333333;\n}\n.index_drag-container__16U-1 .index_list-drag-container__1vQQp {\n  display: flex;\n  justify-content: center;\n  flex-direction: column;\n  align-items: center;\n  overflow: hidden;\n  height: 100%;\n  width: 100%;\n}\n.index_drag-container__16U-1 .index_list-drag-container__1vQQp .index_item__3f_nl {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 200%;\n  height: 200%;\n  transform: scale(0.5);\n  cursor: pointer;\n}\n.index_list-container__3aAjS {\n  display: flex;\n  width: 100%;\n  align-items: center;\n  padding-top: 3px;\n  padding-bottom: 3px;\n  padding-left: 5px;\n  transition: all 800ms;\n}\n.index_list-container__3aAjS .index_drag-name__t458l {\n  font-size: 12px;\n  color: #333333;\n  margin-left: 16px;\n}\n.index_list-container__3aAjS .index_list-drag-container__1vQQp {\n  display: flex;\n  justify-content: center;\n  flex-direction: column;\n  align-items: center;\n  width: 28px;\n  height: 28px;\n  border-radius: 4px;\n  border: 1px solid transparent;\n  overflow: hidden;\n  background: #f2f2f2;\n}\n.index_list-container__3aAjS .index_list-drag-container__1vQQp .index_item__3f_nl {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 200%;\n  height: 200%;\n  transform-origin: center;\n  transform: scale(0.25);\n  cursor: pointer;\n}\n.index_container__U3NKo {\n  display: flex;\n  flex: 1;\n  overflow: auto;\n  flex-direction: column;\n}\n.index_result-container__2qH-p {\n  overflow: auto;\n  background: #fff;\n  height: calc(100vh - 160px);\n}\n.index_result-container__2qH-p .index_item-container__QHJHq {\n  display: flex;\n  overflow: auto;\n  flex-wrap: wrap;\n}\n.index_fold-container__1EY4D {\n  display: flex;\n  overflow: auto;\n  background: #fff;\n  height: calc(100vh - 160px);\n}\n.index_fold-container__1EY4D .index_collapse-class__nHL5c {\n  background-color: white;\n}\n.index_fold-container__1EY4D .index_fold-container-title__1q1rh {\n  padding-top: 5px;\n  text-align: center;\n}\n.index_fold-container__1EY4D .index_fold-content__ZOjFW {\n  margin-right: 1px;\n  display: flex;\n  flex-wrap: wrap;\n}\n.index_fold-container__1EY4D .index_fold-header__2fPAF {\n  display: flex;\n  width: 100%;\n  align-items: center;\n  flex-direction: row;\n  height: 30px;\n  color: #333;\n  font-size: 12px;\n}\n.index_placeholder-item__3gujM {\n  display: flex;\n  width: 100%;\n  height: 100%;\n  justify-content: center;\n  align-items: center;\n  color: white;\n}\n.index_placeholder-item__3gujM img {\n  width: 100%;\n  height: 100%;\n}\n.index_result-container__2qH-p {\n  overflow: auto;\n  background: #fff;\n  height: calc(100vh - 160px);\n}\n.index_result-container__2qH-p .index_item-container__QHJHq {\n  display: flex;\n  overflow: auto;\n  flex-wrap: wrap;\n}\n";
var styles$w = {"rotate180":"index_rotate180__31vJp","rotate90":"index_rotate90__GwFiU","icon-container":"index_icon-container__2hJq3","icon-class":"index_icon-class__1ukt0","icon-Menu":"index_icon-Menu__19lxK","tabs-container":"index_tabs-container__z5rkE","common-input":"index_common-input__1rNdm","left-container":"index_left-container__3pX13","drag-container":"index_drag-container__16U-1","hidden-drag-name":"index_hidden-drag-name__13m_L","drag-name":"index_drag-name__t458l","list-drag-container":"index_list-drag-container__1vQQp","item":"index_item__3f_nl","list-container":"index_list-container__3aAjS","container":"index_container__U3NKo","result-container":"index_result-container__2qH-p","item-container":"index_item-container__QHJHq","fold-container":"index_fold-container__1EY4D","collapse-class":"index_collapse-class__nHL5c","fold-container-title":"index_fold-container-title__1q1rh","fold-content":"index_fold-content__ZOjFW","fold-header":"index_fold-header__2fPAF","placeholder-item":"index_placeholder-item__3gujM"};
styleInject(css_248z$w);

var css_248z$x = ".index_rotate180__sNIpZ {\n  transform: rotate(180deg);\n}\n.index_rotate90__2tNSz {\n  transform: rotate(90deg);\n  pointer-events: none;\n  transition: none;\n  cursor: auto;\n}\n.index_icon-container__w1NR6 {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 40px;\n  height: 39px;\n  cursor: pointer;\n}\n.index_icon-container__w1NR6 .index_icon-class__2303F {\n  width: 14px;\n  height: 14px;\n  user-select: none;\n}\n.index_icon-Menu__2Bgt0 {\n  width: 45px;\n  height: 35px;\n  border-radius: 8px;\n  background-color: #ffffff;\n  margin-right: 5px;\n  box-shadow: 3px 4px 5px 3px rgba(0, 0, 0, 0.15);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  cursor: pointer;\n}\n.index_icon-Menu__2Bgt0 .index_icon-class__2303F {\n  width: 20px;\n  height: 20px;\n}\n.index_tabs-container__2-P4g .rc-tabs-tab {\n  font-size: 12px;\n  font-weight: bold;\n  color: #aaa;\n}\n.index_tabs-container__2-P4g .rc-tabs-tab-active {\n  color: #333;\n}\n.index_tabs-container__2-P4g .rc-tabs-ink-bar {\n  background-color: #333333;\n  height: 2px !important;\n}\n.index_tabs-container__2-P4g .rc-tabs-nav-operations {\n  display: none !important;\n}\n.index_tabs-container__2-P4g .rc-tabs-nav-measure-ping-top::before,\n.index_tabs-container__2-P4g .rc-tabs-nav-wrap-ping-top::before,\n.index_tabs-container__2-P4g .rc-tabs-nav-measure-ping-bottom::after,\n.index_tabs-container__2-P4g .rc-tabs-nav-wrap-ping-bottom::after {\n  border: 0 !important;\n}\n.index_tabs-container__2-P4g .rc-tabs-nav-operations {\n  display: none !important;\n}\n.index_tabs-container__2-P4g .rc-tabs-nav-measure-ping-left::before,\n.index_tabs-container__2-P4g .rc-tabs-nav-wrap-ping-left::before {\n  border-left-width: 0px;\n}\n.index_common-input__2Cjvc {\n  padding: 0;\n  border: none;\n  text-align: left;\n  outline: none;\n  white-space: normal;\n  word-wrap: break-word;\n  word-break: break-all;\n  resize: none;\n  width: 100%;\n  color: rgba(0, 0, 0, 0.8);\n  font-family: PingFangSC-Medium, PingFang SC;\n}\n.index_common-input__2Cjvc::placeholder {\n  font-weight: 400;\n  font-family: PingFangSC-Regular, PingFang SC;\n  color: rgba(0, 0, 0, 0.3);\n}\n.index_search-container__1k_xz {\n  display: flex;\n  width: 100%;\n  height: 32px;\n  align-items: center;\n  border-width: 1px 0px;\n  border-style: solid;\n  border-color: #f2f2f2;\n  padding: 0px 8px 0px 17px;\n}\n.index_search-container__1k_xz .index_icon__4rWXr {\n  width: 12px;\n  height: 12px;\n}\n.index_search-container__1k_xz .index_search-input__20PG5 {\n  margin-left: 8px;\n  font-size: 12px;\n  color: #333333;\n  user-select: text;\n  width: 100%;\n}\n";
var styles$x = {"rotate180":"index_rotate180__sNIpZ","rotate90":"index_rotate90__2tNSz","icon-container":"index_icon-container__w1NR6","icon-class":"index_icon-class__2303F","icon-Menu":"index_icon-Menu__2Bgt0","tabs-container":"index_tabs-container__2-P4g","common-input":"index_common-input__2Cjvc","search-container":"index_search-container__1k_xz","icon":"index_icon__4rWXr","search-input":"index_search-input__20PG5"};
styleInject(css_248z$x);

const SearchContext = createContext(false);
function SearchBar(props) {
    const { children, ...rest } = props;
    const [isChecked, setIsChecked] = useState(false);
    const onCheckedChange = (v) => {
        setIsChecked(v);
    };
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: styles$x['search-container'] },
            React.createElement("img", { src: img$4, className: styles$x['icon'] }),
            React.createElement(Input$1, Object.assign({ placeholder: '搜索', className: styles$x['search-input'] }, rest)),
            React.createElement(Checkbox$1, { onChange: onCheckedChange })),
        React.createElement(SearchContext.Provider, { value: isChecked }, children)));
}
var SearchBar$1 = memo(SearchBar);

const defaultColors = [
    '#5237D8',
    '#46BD6F',
    '#AF4A86',
    '#FF8C00',
    '#EE3A8C',
    '#8470FF',
    '#FFD700',
    '#7D26CD',
    '#7FFFD4',
    '#008B8B',
];
/**
 * 拖拽组件
 * 组件拖拽时会将其携带的组件名称传入 store
 * @param props
 * @constructor
 */
function DragAbleItem(props) {
    const { dragSource, dragSource: { defaultProps, componentName }, img, desc, } = props;
    const isChecked = useContext(SearchContext);
    const randomIndex = useRef(Math.floor(Math.random() * 10)).current;
    function renderDragComponent() {
        if (!defaultProps) {
            return (React.createElement("div", { style: { backgroundColor: defaultColors[randomIndex] }, className: styles$w['placeholder-item'] }, img ? (React.createElement("img", { className: styles$w['item-img'], alt: "", src: img })) : (componentName)));
        }
        return createElement(get(getBrickdConfig().componentsMap, componentName, componentName), defaultProps);
    }
    return (React.createElement("div", { className: isChecked ? styles$w['list-container'] : styles$w['drag-container'] },
        React.createElement("div", { className: styles$w['list-drag-container'] },
            React.createElement("div", { draggable: true, onDragStart: (event) => {
                    event.stopPropagation();
                    setDragSource(dragSource);
                }, className: styles$w['item'] }, renderDragComponent())),
        React.createElement("span", { className: `${styles$w['hidden-drag-name']} ${styles$w['drag-name']}` }, desc || componentName)));
}
var DragAbleItem$1 = memo(DragAbleItem, () => true);

/**
 * 渲染拖拽item
 */
function renderDragItem(componentInfos, componentName) {
    if (componentInfos) {
        return map(componentInfos, (info, index) => {
            const { props, img, desc } = info;
            return (React.createElement(DragAbleItem$1, { key: componentName + index, img: img, desc: desc, dragSource: { componentName, defaultProps: props } }));
        });
    }
    return React.createElement(DragAbleItem$1, { key: componentName, dragSource: { componentName } });
}
function SearchResult(props, ref) {
    const { componentsCategory, style } = props;
    const [searchResult, setSearchResult] = useState();
    useImperativeHandle(ref, () => ({
        changeSearch,
    }));
    const changeSearch = (v) => {
        const result = {};
        each(componentsCategory, (categoryInfo) => {
            each(categoryInfo, (componentInfo, componentName) => {
                if (componentName.includes(v)) {
                    result[componentName] = componentInfo;
                }
                else {
                    each(componentInfo, (info) => {
                        const { desc } = info;
                        if (desc && desc.includes(v)) {
                            if (!result[componentName]) {
                                result[componentName] = [info];
                            }
                            else {
                                result[componentName].push(info);
                            }
                        }
                    });
                }
            });
        });
        setSearchResult(result);
    };
    return (React.createElement("div", { style: style, className: styles$w['result-container'] },
        React.createElement("div", { className: styles$w['item-container'] }, map(searchResult, renderDragItem))));
}
var SearchResult$1 = memo(forwardRef(SearchResult));

/**
 * 渲染折叠Header
 */
function renderHeader(categoryName, isFold) {
    return (React.createElement("div", { className: styles$w['fold-header'] },
        React.createElement("img", { src: img, className: isFold ? styles$w.rotate90 : '', style: {
                marginLeft: '5px',
                marginRight: '5px',
                transition: 'all 0.2s',
            } }),
        React.createElement("span", null, categoryName)));
}
function BrickPreview(props) {
    const { componentsCategory } = props;
    const searchRef = useRef();
    const [isShowSearch, setIsShowSearch] = useState(false);
    /**
     * 搜搜指定组件
     */
    const onChange = useCallback((value) => {
        if (value) {
            if (!isShowSearch) {
                setIsShowSearch(true);
            }
            searchRef.current.changeSearch(value);
        }
        else if (isShowSearch) {
            setIsShowSearch(false);
        }
    }, [setIsShowSearch, isShowSearch]);
    return (React.createElement("div", { className: styles$w['container'] },
        React.createElement(SearchBar$1, { onChange: onChange },
            React.createElement(NCollapse$1, { style: { display: !isShowSearch ? 'flex' : 'none' }, className: styles$w['fold-container'], collapseClass: styles$w['collapse-class'], header: renderHeader, renderItem: renderDragItem, categories: componentsCategory }),
            React.createElement(SearchResult$1, { componentsCategory: componentsCategory, ref: searchRef, style: { display: isShowSearch ? 'block' : 'none' } }))));
}
var BrickPreview$1 = memo(BrickPreview);

var css_248z$y = ".index_rotate180__2JRx6 {\n  transform: rotate(180deg);\n}\n.index_rotate90__Uview {\n  transform: rotate(90deg);\n  pointer-events: none;\n  transition: none;\n  cursor: auto;\n}\n.index_icon-container__K-t0Y {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 40px;\n  height: 39px;\n  cursor: pointer;\n}\n.index_icon-container__K-t0Y .index_icon-class__1b6Us {\n  width: 14px;\n  height: 14px;\n  user-select: none;\n}\n.index_icon-Menu__1gmgm {\n  width: 45px;\n  height: 35px;\n  border-radius: 8px;\n  background-color: #ffffff;\n  margin-right: 5px;\n  box-shadow: 3px 4px 5px 3px rgba(0, 0, 0, 0.15);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  cursor: pointer;\n}\n.index_icon-Menu__1gmgm .index_icon-class__1b6Us {\n  width: 20px;\n  height: 20px;\n}\n.index_tabs-container__SBjVe .rc-tabs-tab {\n  font-size: 12px;\n  font-weight: bold;\n  color: #aaa;\n}\n.index_tabs-container__SBjVe .rc-tabs-tab-active {\n  color: #333;\n}\n.index_tabs-container__SBjVe .rc-tabs-ink-bar {\n  background-color: #333333;\n  height: 2px !important;\n}\n.index_tabs-container__SBjVe .rc-tabs-nav-operations {\n  display: none !important;\n}\n.index_tabs-container__SBjVe .rc-tabs-nav-measure-ping-top::before,\n.index_tabs-container__SBjVe .rc-tabs-nav-wrap-ping-top::before,\n.index_tabs-container__SBjVe .rc-tabs-nav-measure-ping-bottom::after,\n.index_tabs-container__SBjVe .rc-tabs-nav-wrap-ping-bottom::after {\n  border: 0 !important;\n}\n.index_tabs-container__SBjVe .rc-tabs-nav-operations {\n  display: none !important;\n}\n.index_tabs-container__SBjVe .rc-tabs-nav-measure-ping-left::before,\n.index_tabs-container__SBjVe .rc-tabs-nav-wrap-ping-left::before {\n  border-left-width: 0px;\n}\n.index_common-input__1UMZL {\n  padding: 0;\n  border: none;\n  text-align: left;\n  outline: none;\n  white-space: normal;\n  word-wrap: break-word;\n  word-break: break-all;\n  resize: none;\n  width: 100%;\n  color: rgba(0, 0, 0, 0.8);\n  font-family: PingFangSC-Medium, PingFang SC;\n}\n.index_common-input__1UMZL::placeholder {\n  font-weight: 400;\n  font-family: PingFangSC-Regular, PingFang SC;\n  color: rgba(0, 0, 0, 0.3);\n}\n.index_left-container__1Jm69 {\n  left: 10px;\n  background-color: white;\n}\n.index_drag-container__Ltcf- {\n  position: relative;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 60px;\n  height: 60px;\n  padding: 5px;\n  margin: 5px;\n  border-radius: 4px;\n  overflow: hidden;\n  background: #f2f2f2;\n  transition: all 500ms;\n}\n.index_drag-container__Ltcf- .index_hidden-drag-name__1EMAd {\n  visibility: hidden;\n  position: absolute;\n  bottom: 0;\n  font-size: 12px;\n  color: #333333;\n}\n.index_drag-container__Ltcf-:hover .index_drag-name__1teCe {\n  visibility: visible;\n  position: absolute;\n  bottom: 0;\n  font-size: 12px;\n  color: #333333;\n}\n.index_drag-container__Ltcf- .index_list-drag-container__25FWr {\n  display: flex;\n  justify-content: center;\n  flex-direction: column;\n  align-items: center;\n  overflow: hidden;\n  height: 100%;\n  width: 100%;\n}\n.index_drag-container__Ltcf- .index_list-drag-container__25FWr .index_item__Ippct {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 200%;\n  height: 200%;\n  transform: scale(0.5);\n  cursor: pointer;\n}\n.index_list-container__3AoJi {\n  display: flex;\n  width: 100%;\n  align-items: center;\n  padding-top: 3px;\n  padding-bottom: 3px;\n  padding-left: 5px;\n  transition: all 800ms;\n}\n.index_list-container__3AoJi .index_drag-name__1teCe {\n  font-size: 12px;\n  color: #333333;\n  margin-left: 16px;\n}\n.index_list-container__3AoJi .index_list-drag-container__25FWr {\n  display: flex;\n  justify-content: center;\n  flex-direction: column;\n  align-items: center;\n  width: 28px;\n  height: 28px;\n  border-radius: 4px;\n  border: 1px solid transparent;\n  overflow: hidden;\n  background: #f2f2f2;\n}\n.index_list-container__3AoJi .index_list-drag-container__25FWr .index_item__Ippct {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 200%;\n  height: 200%;\n  transform-origin: center;\n  transform: scale(0.25);\n  cursor: pointer;\n}\n.index_template-container__3jJgP {\n  display: flex;\n  flex: 1;\n  overflow: auto;\n  flex-direction: column;\n}\n.index_result-container__3Jw5p {\n  overflow: auto;\n  background: #fff;\n  height: calc(100vh - 160px);\n}\n.index_result-container__3Jw5p .index_item-container__r8cTF {\n  display: flex;\n  overflow: auto;\n  flex-wrap: wrap;\n}\n";
var styles$y = {"rotate180":"index_rotate180__2JRx6","rotate90":"index_rotate90__Uview","icon-container":"index_icon-container__K-t0Y","icon-class":"index_icon-class__1b6Us","icon-Menu":"index_icon-Menu__1gmgm","tabs-container":"index_tabs-container__SBjVe","common-input":"index_common-input__1UMZL","left-container":"index_left-container__1Jm69","drag-container":"index_drag-container__Ltcf-","hidden-drag-name":"index_hidden-drag-name__1EMAd","drag-name":"index_drag-name__1teCe","list-drag-container":"index_list-drag-container__25FWr","item":"index_item__Ippct","list-container":"index_list-container__3AoJi","template-container":"index_template-container__3jJgP","result-container":"index_result-container__3Jw5p","item-container":"index_item-container__r8cTF"};
styleInject(css_248z$y);

/**
 * 拖拽组件
 * 组件拖拽时会将其携带的组件名称传入 store
 * @param props
 * @constructor
 */
function DragAbleItem$2(props) {
    const { item } = props;
    const { template, img, desc } = item;
    const isChecked = useContext(SearchContext);
    return (React.createElement("div", { className: isChecked ? styles$y['list-container'] : styles$y['drag-container'] },
        React.createElement("div", { className: styles$y['list-drag-container'] },
            React.createElement("div", { draggable: true, onDragStart: () => setDragSource({ template }), className: styles$y['item'] },
                React.createElement("img", { alt: desc, src: img, style: { width: '100%', height: '100%' } }))),
        React.createElement("span", { className: `${styles$y['hidden-drag-name']} ${styles$y['drag-name']}` }, desc)));
}
var DragAbleItem$3 = memo(DragAbleItem$2, () => true);

function renderDragItem$1(item) {
    const { id } = item;
    return React.createElement(DragAbleItem$3, { key: id, item: item });
}
const initData = [
    {
        desc: '哈哈哈',
        id: '1',
        img: 'https://img1.baidu.com/it/u=453001413,951045025&fm=224&fmt=auto&gp=0.jpg',
        template: {
            0: {
                componentName: 'img',
                props: {
                    src: 'https://img1.baidu.com/it/u=453001413,951045025&fm=224&fmt=auto&gp=0.jpg',
                },
            },
        },
    },
    {
        desc: '呵呵呵',
        id: '2',
        img: 'https://t7.baidu.com/it/u=3930750564,2979238085&fm=193&f=GIF',
        template: {
            0: {
                componentName: 'img',
                props: {
                    src: 'https://t7.baidu.com/it/u=3930750564,2979238085&fm=193&f=GIF',
                },
            },
        },
    },
    {
        desc: '嘿嘿嘿',
        id: '3',
        img: 'https://t7.baidu.com/it/u=3522949495,3570538969&fm=193&f=GIF',
        template: {
            0: {
                componentName: 'img',
                props: {
                    src: 'https://t7.baidu.com/it/u=3522949495,3570538969&fm=193&f=GIF',
                },
            },
        },
    },
    {
        desc: '啦啦啦',
        id: '4',
        img: 'https://t7.baidu.com/it/u=2878377037,2986969897&fm=193&f=GIF',
        template: {
            0: {
                componentName: 'img',
                props: {
                    src: 'https://t7.baidu.com/it/u=2878377037,2986969897&fm=193&f=GIF',
                },
            },
        },
    },
    {
        desc: '嚯嚯嚯',
        id: '5',
        img: 'https://t7.baidu.com/it/u=3038817810,32670274&fm=193&f=GIF',
        template: {
            0: {
                componentName: 'img',
                props: {
                    src: 'https://t7.baidu.com/it/u=3038817810,32670274&fm=193&f=GIF',
                },
            },
        },
    },
];
// export interface BrickTemplatesPropsType {}
function BrickTemplates() {
    const [data, setData] = useState(initData);
    /**
     * 搜搜指定组件
     */
    const onChange = useCallback(() => {
        setData([]);
    }, [data, setData]);
    return (React.createElement("div", { className: styles$y['template-container'] },
        React.createElement(SearchBar$1, { onChange: onChange },
            React.createElement("div", { className: styles$y['result-container'] },
                React.createElement("div", { className: styles$y['item-container'] }, map(data, renderDragItem$1))))));
}
var BrickTemplates$1 = memo(BrickTemplates);

var css_248z$z = ".index_rotate180__31_qn {\n  transform: rotate(180deg);\n}\n.index_rotate90__1XCzJ {\n  transform: rotate(90deg);\n  pointer-events: none;\n  transition: none;\n  cursor: auto;\n}\n.index_icon-container__vjVUN {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 40px;\n  height: 39px;\n  cursor: pointer;\n}\n.index_icon-container__vjVUN .index_icon-class__27Cms {\n  width: 14px;\n  height: 14px;\n  user-select: none;\n}\n.index_icon-Menu__1pJkD {\n  width: 45px;\n  height: 35px;\n  border-radius: 8px;\n  background-color: #ffffff;\n  margin-right: 5px;\n  box-shadow: 3px 4px 5px 3px rgba(0, 0, 0, 0.15);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  cursor: pointer;\n}\n.index_icon-Menu__1pJkD .index_icon-class__27Cms {\n  width: 20px;\n  height: 20px;\n}\n.index_tabs-container__2GxmR .rc-tabs-tab {\n  font-size: 12px;\n  font-weight: bold;\n  color: #aaa;\n}\n.index_tabs-container__2GxmR .rc-tabs-tab-active {\n  color: #333;\n}\n.index_tabs-container__2GxmR .rc-tabs-ink-bar {\n  background-color: #333333;\n  height: 2px !important;\n}\n.index_tabs-container__2GxmR .rc-tabs-nav-operations {\n  display: none !important;\n}\n.index_tabs-container__2GxmR .rc-tabs-nav-measure-ping-top::before,\n.index_tabs-container__2GxmR .rc-tabs-nav-wrap-ping-top::before,\n.index_tabs-container__2GxmR .rc-tabs-nav-measure-ping-bottom::after,\n.index_tabs-container__2GxmR .rc-tabs-nav-wrap-ping-bottom::after {\n  border: 0 !important;\n}\n.index_tabs-container__2GxmR .rc-tabs-nav-operations {\n  display: none !important;\n}\n.index_tabs-container__2GxmR .rc-tabs-nav-measure-ping-left::before,\n.index_tabs-container__2GxmR .rc-tabs-nav-wrap-ping-left::before {\n  border-left-width: 0px;\n}\n.index_common-input__3WopL {\n  padding: 0;\n  border: none;\n  text-align: left;\n  outline: none;\n  white-space: normal;\n  word-wrap: break-word;\n  word-break: break-all;\n  resize: none;\n  width: 100%;\n  color: rgba(0, 0, 0, 0.8);\n  font-family: PingFangSC-Medium, PingFang SC;\n}\n.index_common-input__3WopL::placeholder {\n  font-weight: 400;\n  font-family: PingFangSC-Regular, PingFang SC;\n  color: rgba(0, 0, 0, 0.3);\n}\n.index_left-container__1z739 {\n  left: 10px;\n  background-color: white;\n}\n.index_drag-container__dEHz0 {\n  position: relative;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 60px;\n  height: 60px;\n  padding: 5px;\n  margin: 5px;\n  border-radius: 4px;\n  overflow: hidden;\n  background: #f2f2f2;\n  transition: all 500ms;\n}\n.index_drag-container__dEHz0 .index_hidden-drag-name__38JFT {\n  visibility: hidden;\n  position: absolute;\n  bottom: 0;\n  font-size: 12px;\n  color: #333333;\n}\n.index_drag-container__dEHz0:hover .index_drag-name__1p83X {\n  visibility: visible;\n  position: absolute;\n  bottom: 0;\n  font-size: 12px;\n  color: #333333;\n}\n.index_drag-container__dEHz0 .index_list-drag-container__2e8n6 {\n  display: flex;\n  justify-content: center;\n  flex-direction: column;\n  align-items: center;\n  overflow: hidden;\n  height: 100%;\n  width: 100%;\n}\n.index_drag-container__dEHz0 .index_list-drag-container__2e8n6 .index_item__fRAIK {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 200%;\n  height: 200%;\n  transform: scale(0.5);\n  cursor: pointer;\n}\n.index_list-container__16cvC {\n  display: flex;\n  width: 100%;\n  align-items: center;\n  padding-top: 3px;\n  padding-bottom: 3px;\n  padding-left: 5px;\n  transition: all 800ms;\n}\n.index_list-container__16cvC .index_drag-name__1p83X {\n  font-size: 12px;\n  color: #333333;\n  margin-left: 16px;\n}\n.index_list-container__16cvC .index_list-drag-container__2e8n6 {\n  display: flex;\n  justify-content: center;\n  flex-direction: column;\n  align-items: center;\n  width: 28px;\n  height: 28px;\n  border-radius: 4px;\n  border: 1px solid transparent;\n  overflow: hidden;\n  background: #f2f2f2;\n}\n.index_list-container__16cvC .index_list-drag-container__2e8n6 .index_item__fRAIK {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 200%;\n  height: 200%;\n  transform-origin: center;\n  transform: scale(0.25);\n  cursor: pointer;\n}\n";
var styles$z = {"rotate180":"index_rotate180__31_qn","rotate90":"index_rotate90__1XCzJ","icon-container":"index_icon-container__vjVUN","icon-class":"index_icon-class__27Cms","icon-Menu":"index_icon-Menu__1pJkD","tabs-container":"index_tabs-container__2GxmR","common-input":"index_common-input__3WopL","left-container":"index_left-container__1z739","drag-container":"index_drag-container__dEHz0","hidden-drag-name":"index_hidden-drag-name__38JFT","drag-name":"index_drag-name__1p83X","list-drag-container":"index_list-drag-container__2e8n6","item":"index_item__fRAIK","list-container":"index_list-container__16cvC"};
styleInject(css_248z$z);

function Bricks(props) {
    const { componentsCategory } = props;
    return (React.createElement(BarTabs$1, { activeKey: 'Bricks', icon: img$h, className: styles$z['left-container'] },
        React.createElement(TabPane, { tab: '组件', key: '1' },
            React.createElement(BrickPreview$1, { componentsCategory: componentsCategory })),
        React.createElement(TabPane, { tab: '模板', key: '2' },
            React.createElement(BrickTemplates$1, null))));
}
var Bricks$1 = memo(Bricks);

var css_248z$A = ".index_rotate180__143Yh {\n  transform: rotate(180deg);\n}\n.index_rotate90__2FZaQ {\n  transform: rotate(90deg);\n  pointer-events: none;\n  transition: none;\n  cursor: auto;\n}\n.index_icon-container__LgO_N {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 40px;\n  height: 39px;\n  cursor: pointer;\n}\n.index_icon-container__LgO_N .index_icon-class__2PWCL {\n  width: 14px;\n  height: 14px;\n  user-select: none;\n}\n.index_icon-Menu__3356b {\n  width: 45px;\n  height: 35px;\n  border-radius: 8px;\n  background-color: #ffffff;\n  margin-right: 5px;\n  box-shadow: 3px 4px 5px 3px rgba(0, 0, 0, 0.15);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  cursor: pointer;\n}\n.index_icon-Menu__3356b .index_icon-class__2PWCL {\n  width: 20px;\n  height: 20px;\n}\n.index_tabs-container__cpcDs .rc-tabs-tab {\n  font-size: 12px;\n  font-weight: bold;\n  color: #aaa;\n}\n.index_tabs-container__cpcDs .rc-tabs-tab-active {\n  color: #333;\n}\n.index_tabs-container__cpcDs .rc-tabs-ink-bar {\n  background-color: #333333;\n  height: 2px !important;\n}\n.index_tabs-container__cpcDs .rc-tabs-nav-operations {\n  display: none !important;\n}\n.index_tabs-container__cpcDs .rc-tabs-nav-measure-ping-top::before,\n.index_tabs-container__cpcDs .rc-tabs-nav-wrap-ping-top::before,\n.index_tabs-container__cpcDs .rc-tabs-nav-measure-ping-bottom::after,\n.index_tabs-container__cpcDs .rc-tabs-nav-wrap-ping-bottom::after {\n  border: 0 !important;\n}\n.index_tabs-container__cpcDs .rc-tabs-nav-operations {\n  display: none !important;\n}\n.index_tabs-container__cpcDs .rc-tabs-nav-measure-ping-left::before,\n.index_tabs-container__cpcDs .rc-tabs-nav-wrap-ping-left::before {\n  border-left-width: 0px;\n}\n.index_common-input__3Vrfc {\n  padding: 0;\n  border: none;\n  text-align: left;\n  outline: none;\n  white-space: normal;\n  word-wrap: break-word;\n  word-break: break-all;\n  resize: none;\n  width: 100%;\n  color: rgba(0, 0, 0, 0.8);\n  font-family: PingFangSC-Medium, PingFang SC;\n}\n.index_common-input__3Vrfc::placeholder {\n  font-weight: 400;\n  font-family: PingFangSC-Regular, PingFang SC;\n  color: rgba(0, 0, 0, 0.3);\n}\n.index_right-container__3vDvC {\n  left: calc(100vw - 225px);\n}\n";
var styles$A = {"rotate180":"index_rotate180__143Yh","rotate90":"index_rotate90__2FZaQ","icon-container":"index_icon-container__LgO_N","icon-class":"index_icon-class__2PWCL","icon-Menu":"index_icon-Menu__3356b","tabs-container":"index_tabs-container__cpcDs","common-input":"index_common-input__3Vrfc","right-container":"index_right-container__3vDvC"};
styleInject(css_248z$A);

const controlUpdate = (prevState, nextState) => {
    const { selectedInfo, pageConfig } = prevState;
    const { selectedKey } = selectedInfo || {};
    const props = get(pageConfig, `${selectedKey}.props`);
    return (nextState.selectedInfo !== selectedInfo ||
        props !== get(nextState.pageConfig, `${selectedKey}.props`));
};
function Props({ isCommon }) {
    const { selectedInfo, pageConfig } = useSelector(['selectedInfo', 'pageConfig'], controlUpdate);
    const { selectedKey } = selectedInfo || {};
    const { componentName, props, childNodes } = get(pageConfig, selectedKey, {});
    const { propsConfig } = getComponentConfig(componentName);
    const { firstConfig, secondConfig } = useMemo(() => splitPropsConfig(propsConfig, childNodes), [propsConfig, childNodes]);
    const formConfig = isCommon ? firstConfig : secondConfig;
    const onValuesChange = (changedValues) => {
        changeProps({ isMerge: true, props: changedValues });
    };
    let tip = null;
    if (!componentName || isEmpty(formConfig)) {
        tip = '请选中任意组件进行属性操作';
        if (componentName && isEmpty(formConfig)) {
            tip = '该组件暂未有可操作的属性';
        }
    }
    return (React.createElement(ScaffoldForm$1, { defaultFormData: props, lockKey: selectedKey, tip: tip, onValuesChange: onValuesChange, formConfig: formConfig }));
}
var Props$1 = memo(Props);

const seniorConfigs = {
    layoutMode: {
        label: '布局模式',
        type: PROPS_TYPES.enum,
        enumData: ['flow', 'free'],
    },
    state: {
        label: '状态定义',
        type: PROPS_TYPES.object,
        formItemProps: {
            mode: 'json5',
        },
    },
    isStateDomain: {
        type: PROPS_TYPES.boolean,
    },
    propFields: {
        type: PROPS_TYPES.stringArray,
    },
    condition: {
        type: PROPS_TYPES.string,
    },
    loop: {
        type: PROPS_TYPES.objectArray,
        formItemProps: {
            mode: 'json5',
        },
    },
    api: {
        type: PROPS_TYPES.objectArray,
        formItemProps: {
            mode: 'json5',
        },
    },
};

const controlUpdate$1 = (prevState, nextState) => {
    const { selectedInfo, pageConfig } = prevState;
    const { selectedKey } = selectedInfo || {};
    return (nextState.selectedInfo !== selectedInfo ||
        pageConfig[selectedKey] !== nextState.pageConfig[selectedKey]);
};
function Senior() {
    const { selectedInfo, pageConfig } = useSelector(['selectedInfo', 'pageConfig'], controlUpdate$1);
    const { selectedKey } = selectedInfo || {};
    const { componentName, childNodes, props, ...rest } = get(pageConfig, selectedKey, {});
    const onValuesChange = (changedValues, values) => {
        changeSeniorProps({ props: values });
    };
    return (React.createElement(ScaffoldForm$1, { lockKey: selectedKey, defaultFormData: rest, tip: !componentName && '请选中任意组件进行属性操作', onValuesChange: onValuesChange, formConfig: seniorConfigs }));
}
var Senior$1 = memo(Senior);

// interface BrickDesignRightProps {}
function Scaffold() {
    return (React.createElement(BarTabs$1, { activeKey: 'Scaffold', icon: img$i, className: styles$A['right-container'] },
        React.createElement(TabPane, { tab: '属性', key: '1' },
            React.createElement(Props$1, { isCommon: true })),
        React.createElement(TabPane, { tab: '高级', key: '2' },
            React.createElement(Senior$1, null)),
        React.createElement(TabPane, { tab: '方法', key: '3' },
            React.createElement(Props$1, null))));
}
var Scaffold$1 = memo(Scaffold);

var css_248z$B = ".index_rotate180__jYBaT {\n  transform: rotate(180deg);\n}\n.index_rotate90__2OC5e {\n  transform: rotate(90deg);\n  pointer-events: none;\n  transition: none;\n  cursor: auto;\n}\n.index_icon-container__3xMMi {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 40px;\n  height: 39px;\n  cursor: pointer;\n}\n.index_icon-container__3xMMi .index_icon-class__2glXS {\n  width: 14px;\n  height: 14px;\n  user-select: none;\n}\n.index_icon-Menu__14DBi {\n  width: 45px;\n  height: 35px;\n  border-radius: 8px;\n  background-color: #ffffff;\n  margin-right: 5px;\n  box-shadow: 3px 4px 5px 3px rgba(0, 0, 0, 0.15);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  cursor: pointer;\n}\n.index_icon-Menu__14DBi .index_icon-class__2glXS {\n  width: 20px;\n  height: 20px;\n}\n.index_tabs-container__I-Kk2 .rc-tabs-tab {\n  font-size: 12px;\n  font-weight: bold;\n  color: #aaa;\n}\n.index_tabs-container__I-Kk2 .rc-tabs-tab-active {\n  color: #333;\n}\n.index_tabs-container__I-Kk2 .rc-tabs-ink-bar {\n  background-color: #333333;\n  height: 2px !important;\n}\n.index_tabs-container__I-Kk2 .rc-tabs-nav-operations {\n  display: none !important;\n}\n.index_tabs-container__I-Kk2 .rc-tabs-nav-measure-ping-top::before,\n.index_tabs-container__I-Kk2 .rc-tabs-nav-wrap-ping-top::before,\n.index_tabs-container__I-Kk2 .rc-tabs-nav-measure-ping-bottom::after,\n.index_tabs-container__I-Kk2 .rc-tabs-nav-wrap-ping-bottom::after {\n  border: 0 !important;\n}\n.index_tabs-container__I-Kk2 .rc-tabs-nav-operations {\n  display: none !important;\n}\n.index_tabs-container__I-Kk2 .rc-tabs-nav-measure-ping-left::before,\n.index_tabs-container__I-Kk2 .rc-tabs-nav-wrap-ping-left::before {\n  border-left-width: 0px;\n}\n.index_common-input__36SPU {\n  padding: 0;\n  border: none;\n  text-align: left;\n  outline: none;\n  white-space: normal;\n  word-wrap: break-word;\n  word-break: break-all;\n  resize: none;\n  width: 100%;\n  color: rgba(0, 0, 0, 0.8);\n  font-family: PingFangSC-Medium, PingFang SC;\n}\n.index_common-input__36SPU::placeholder {\n  font-weight: 400;\n  font-family: PingFangSC-Regular, PingFang SC;\n  color: rgba(0, 0, 0, 0.3);\n}\n.index_container__1sMlz {\n  display: flex;\n  flex-direction: column;\n  top: 70px;\n  left: 235px;\n  width: 300px;\n  min-height: 400px;\n  max-height: calc(100vh - 160px);\n  border-radius: 8px;\n}\n.index_container__1sMlz .index_tabs__FPmm4 {\n  padding-left: 10px;\n}\n.index_container__1sMlz .rc-tabs-tab {\n  font-size: 12px;\n  font-weight: bold;\n  color: #aaa;\n}\n.index_container__1sMlz .rc-tabs-tab-active {\n  color: #333;\n}\n.index_container__1sMlz .rc-tabs-ink-bar {\n  background-color: #333333;\n  height: 2px !important;\n}\n.index_container__1sMlz .rc-tabs-nav-operations {\n  display: none !important;\n}\n.index_container__1sMlz .rc-tabs-nav-measure-ping-top::before,\n.index_container__1sMlz .rc-tabs-nav-wrap-ping-top::before,\n.index_container__1sMlz .rc-tabs-nav-measure-ping-bottom::after,\n.index_container__1sMlz .rc-tabs-nav-wrap-ping-bottom::after {\n  border: 0 !important;\n}\n.index_container__1sMlz .rc-tabs-nav-operations {\n  display: none !important;\n}\n.index_container__1sMlz .rc-tabs-nav-measure-ping-left::before,\n.index_container__1sMlz .rc-tabs-nav-wrap-ping-left::before {\n  border-left-width: 0px;\n}\n.index_container__1sMlz .rc-tabs-ink-bar {\n  background-color: #333333;\n  height: 0 !important;\n}\n.index_container__1sMlz .rc-tabs-content {\n  height: 100%;\n}\n.index_style-header__RNebT {\n  display: flex;\n  align-items: center;\n  font-size: 12px;\n  height: 30px;\n}\n.index_form-container__1tRVZ {\n  display: flex;\n  height: 100%;\n}\n.index_form-container__1tRVZ .index_collapse-container__3fUEG {\n  background-color: #f7f7f7;\n  width: 100%;\n}\n.index_form-container__1tRVZ .index_collapse-container__3fUEG .index_collapse-class__1Zaym {\n  padding-left: 10px;\n}\n.index_form-container__1tRVZ .index_collapse-container__3fUEG .index_collapse-header__3Xdc3 {\n  background-color: #00000000;\n}\n";
var styles$B = {"rotate180":"index_rotate180__jYBaT","rotate90":"index_rotate90__2OC5e","icon-container":"index_icon-container__3xMMi","icon-class":"index_icon-class__2glXS","icon-Menu":"index_icon-Menu__14DBi","tabs-container":"index_tabs-container__I-Kk2","common-input":"index_common-input__36SPU","container":"index_container__1sMlz","tabs":"index_tabs__FPmm4","style-header":"index_style-header__RNebT","form-container":"index_form-container__1tRVZ","collapse-container":"index_collapse-container__3fUEG","collapse-class":"index_collapse-class__1Zaym","collapse-header":"index_collapse-header__3Xdc3"};
styleInject(css_248z$B);

var STYLE_TYPES;
(function (STYLE_TYPES) {
    STYLE_TYPES["object"] = "object";
    STYLE_TYPES["objectArray"] = "objectArray";
    STYLE_TYPES["function"] = "function";
    STYLE_TYPES["number"] = "number";
    STYLE_TYPES["numberArray"] = "numberArray";
    STYLE_TYPES["string"] = "string";
    STYLE_TYPES["stringArray"] = "stringArray";
    STYLE_TYPES["enum"] = "enum";
    STYLE_TYPES["json"] = "json";
    STYLE_TYPES["boolean"] = "boolean";
})(STYLE_TYPES || (STYLE_TYPES = {}));
const styleCategory = {
    Layout: {
        display: {
            type: STYLE_TYPES.enum,
            values: ['flex', 'inline', 'block', 'inline-block', 'none'],
        },
        flexDirection: {
            type: STYLE_TYPES.enum,
            values: ['row', 'row-reverse', 'column', 'column-reverse'],
        },
        justifyContent: {
            type: STYLE_TYPES.enum,
            values: [
                'flex-start',
                'flex-end',
                'center',
                'space-between',
                'space-around',
            ],
        },
        alignItems: {
            type: STYLE_TYPES.enum,
            values: ['flex-start', 'flex-end', 'center', 'baseline', 'stretch'],
        },
        flexWrap: {
            type: STYLE_TYPES.enum,
            values: ['nowrap', 'wrap', 'wrap-reverse'],
        },
    },
    'Edge Distance': {},
};

function renderItem(props, name) {
    const { ...rest } = props;
    return (React.createElement(Field, Object.assign({}, rest),
        React.createElement("div", null, name)));
}
function renderHeader$1(category, isFold) {
    return React.createElement("div", { className: styles$B['style-header'] }, category);
}
function StylePanel(props) {
    const { style } = props;
    return (React.createElement(Form, { className: styles$B['form-container'], initialValues: style },
        React.createElement(NCollapse$1, { collapseClass: styles$B['collapse-class'], headerClass: styles$B['collapse-header'], className: styles$B['collapse-container'], header: renderHeader$1, renderItem: renderItem, categories: styleCategory })));
}
var StylePanel$1 = memo(StylePanel);

// import { getCssClassProps } from '../../utils';
// const defaultCss={
// 	className: {
// 		type: PROPS_TYPES.cssClass,
// 	},
// 	style:{
// 		type: PROPS_TYPES.style,
// 	},
// };
function Styles() {
    const { selectedInfo } = useSelector(['selectedInfo']);
    const selectedKey = get(selectedInfo, 'selectedKey');
    const { pageConfig } = getSelector([
        'pageConfig',
    ]);
    const { props } = get(pageConfig, selectedKey) || {};
    // const {propsConfig}=getComponentConfig(componentName);
    // const [activeKey,setActiveKey]=useState();
    // let cssClassConfig= getCssClassProps(propsConfig);
    // cssClassConfig={...cssClassConfig,...defaultCss};
    // const onTabChange=(key)=>{
    // 	setActiveKey(key);
    // };
    return (React.createElement(DragResizeBar$1, { title: 'Styles', className: styles$B['container'], minWidth: 400, minHeight: 700, defaultShow: true, barStyle: { borderBottom: '1px #f2f2f2 solid' }, icon: img$j, style: { visibility: 'hidden' } },
        React.createElement(StylePanel$1, { style: get(props, 'style') })));
}
var Styles$1 = memo(Styles);

function BottomLeftButtons(props) {
    const { componentsCategory } = props;
    const PANEL_KEYS = ['Bricks', 'Scaffold', 'Styles'];
    return (React.createElement(ButtonWrapper, { panelKeys: PANEL_KEYS, className: styles$v['bottom-left-bar'] },
        React.createElement(Bricks$1, { componentsCategory: componentsCategory }),
        React.createElement(Scaffold$1, null),
        React.createElement(Styles$1, null)));
}
var BottomLeftButtons$1 = memo(BottomLeftButtons);

var css_248z$C = ".index_rotate180__3U1mQ {\n  transform: rotate(180deg);\n}\n.index_rotate90__2cjFr {\n  transform: rotate(90deg);\n  pointer-events: none;\n  transition: none;\n  cursor: auto;\n}\n.index_icon-container__1rr9x {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 40px;\n  height: 39px;\n  cursor: pointer;\n}\n.index_icon-container__1rr9x .index_icon-class__S73j2 {\n  width: 14px;\n  height: 14px;\n  user-select: none;\n}\n.index_icon-Menu__2FNMU {\n  width: 45px;\n  height: 35px;\n  border-radius: 8px;\n  background-color: #ffffff;\n  margin-right: 5px;\n  box-shadow: 3px 4px 5px 3px rgba(0, 0, 0, 0.15);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  cursor: pointer;\n}\n.index_icon-Menu__2FNMU .index_icon-class__S73j2 {\n  width: 20px;\n  height: 20px;\n}\n.index_tabs-container__3jqr8 .rc-tabs-tab {\n  font-size: 12px;\n  font-weight: bold;\n  color: #aaa;\n}\n.index_tabs-container__3jqr8 .rc-tabs-tab-active {\n  color: #333;\n}\n.index_tabs-container__3jqr8 .rc-tabs-ink-bar {\n  background-color: #333333;\n  height: 2px !important;\n}\n.index_tabs-container__3jqr8 .rc-tabs-nav-operations {\n  display: none !important;\n}\n.index_tabs-container__3jqr8 .rc-tabs-nav-measure-ping-top::before,\n.index_tabs-container__3jqr8 .rc-tabs-nav-wrap-ping-top::before,\n.index_tabs-container__3jqr8 .rc-tabs-nav-measure-ping-bottom::after,\n.index_tabs-container__3jqr8 .rc-tabs-nav-wrap-ping-bottom::after {\n  border: 0 !important;\n}\n.index_tabs-container__3jqr8 .rc-tabs-nav-operations {\n  display: none !important;\n}\n.index_tabs-container__3jqr8 .rc-tabs-nav-measure-ping-left::before,\n.index_tabs-container__3jqr8 .rc-tabs-nav-wrap-ping-left::before {\n  border-left-width: 0px;\n}\n.index_common-input__21d5n {\n  padding: 0;\n  border: none;\n  text-align: left;\n  outline: none;\n  white-space: normal;\n  word-wrap: break-word;\n  word-break: break-all;\n  resize: none;\n  width: 100%;\n  color: rgba(0, 0, 0, 0.8);\n  font-family: PingFangSC-Medium, PingFang SC;\n}\n.index_common-input__21d5n::placeholder {\n  font-weight: 400;\n  font-family: PingFangSC-Regular, PingFang SC;\n  color: rgba(0, 0, 0, 0.3);\n}\n.index_brickd-canvas__viYmM {\n  position: fixed;\n  width: 100%;\n  height: 100%;\n  background-color: #f7f7f7;\n}\n";
var styles$C = {"rotate180":"index_rotate180__3U1mQ","rotate90":"index_rotate90__2cjFr","icon-container":"index_icon-container__1rr9x","icon-class":"index_icon-class__S73j2","icon-Menu":"index_icon-Menu__2FNMU","tabs-container":"index_tabs-container__3jqr8","common-input":"index_common-input__21d5n","brickd-canvas":"index_brickd-canvas__viYmM"};
styleInject(css_248z$C);

var css_248z$D = ".index_menu-container__3w3Y0 {\n  display: flex;\n  flex-direction: column;\n  width: 212px;\n  height: 200px;\n  max-height: calc(100vh - 150px);\n  border-radius: 8px;\n  z-index: 1000;\n  background-color: white;\n  box-shadow: -2px 4px 5px 3px rgba(0, 0, 0, 0.15);\n}\n";
var styles$D = {"menu-container":"index_menu-container__3w3Y0"};
styleInject(css_248z$D);

function Menus() {
    const { selectedInfo } = useSelector(['selectedInfo']);
    const { getOperateState } = useOperate();
    const dragResizeRef = useRef();
    const { selectedKey } = selectedInfo || {};
    useEffect(() => {
        const { contentWindow } = getIframe() || {};
        if (contentWindow) {
            contentWindow.oncontextmenu = (e) => {
                e.preventDefault();
                const { selectedNode } = getOperateState();
                if (selectedNode) {
                    const { clientX, clientY } = e;
                    dragResizeRef.current.target.style.cssText = `top:${clientY}px;left:${clientX}px;visibility:visible;transition:all 500ms;`;
                }
            };
        }
    }, []);
    return React.createElement(DragAndResize$1, { title: selectedKey, className: styles$D['menu-container'], style: { visibility: 'hidden' }, ref: dragResizeRef },
        React.createElement("div", null));
}

require('rc-tabs/assets/index.css');
require('rc-collapse/assets/index.css');
require('rc-switch/assets/index.css');
const users = [
    {
        id: 2,
        img: 'https://gimg2.baidu.com/image_search/src=http%3A%2F%2Fpic3.zhimg.com%2F50%2Fv2-6f1c492cbdfe3c24aae44e935a796d5a_hd.jpg&refer=http%3A%2F%2Fpic3.zhimg.com&app=2002&size=f9999,10000&q=a80&n=0&g=0n&fmt=jpeg?sec=1627221393&t=d5b06091574cfeaad248f24803a57a07',
    },
    {
        id: 3,
        img: 'https://gimg2.baidu.com/image_search/src=http%3A%2F%2Fpic3.zhimg.com%2F50%2Fv2-c524149a6e4126baf8a64cecf8eb2db3_hd.jpg&refer=http%3A%2F%2Fpic3.zhimg.com&app=2002&size=f9999,10000&q=a80&n=0&g=0n&fmt=jpeg?sec=1627221393&t=9ac7e22f4cdc72d517bb2804904e107a',
    },
    {
        id: 4,
        img: 'https://gimg2.baidu.com/image_search/src=http%3A%2F%2Fpic1.zhimg.com%2F50%2Fv2-aa340e100936dca90213630e308a772e_hd.jpg&refer=http%3A%2F%2Fpic1.zhimg.com&app=2002&size=f9999,10000&q=a80&n=0&g=0n&fmt=jpeg?sec=1627221393&t=ca756de7e3f9e5d1932e2f22e96af75d',
    },
];
function BrickEdifice(props) {
    const { componentsCategory, config, warn, customReducer, initBrickdState, ...rest } = props;
    const zoomStore = useRef(new BrickStore({ scale: 0.5 })).current;
    useEffect(() => {
        initBrickdState && initPageBrickdState(initBrickdState);
    }, []);
    return (React.createElement(PanelActive, null,
        React.createElement(ZoomProvider, { value: zoomStore },
            React.createElement(BrickProvider, { config: config, warn: warn, customReducer: customReducer },
                React.createElement(BrickDesignCanvas, Object.assign({ className: styles$C['brickd-canvas'], zoomStore: zoomStore }, rest),
                    React.createElement(Menus, null),
                    React.createElement(Users$1, { users: users }),
                    React.createElement(TopLeftButtons$1, null),
                    React.createElement(MidBottomButtons$1, null),
                    React.createElement(BottomLeftButtons$1, { componentsCategory: componentsCategory }))))));
}
var index$1 = memo(BrickEdifice);

export { index$1 as BrickEdifice, ButtonWrapper, CommonArray$1 as CommonArray, Enum$1 as Enum, Expression$1 as Expression, index as ObjectArray, ObjectValue$1 as ObjectValue, ScaffoldForm$1 as ScaffoldForm, renderDragItem };
